//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class EsraPipingAPIClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    getAllCurrentApplications(): Observable<ApplicationViewModel[]> {
        let url_ = this.baseUrl + "/Application/GetAllCurrent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationViewModel[]>;
        }));
    }

    protected processGetAllCurrentApplications(response: HttpResponseBase): Observable<ApplicationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param numberOfResults (optional) 
     * @param searchQuery (optional) 
     * @param showAll (optional) 
     * @return OK
     */
    getAllApplicationsPaged(pageNumber?: number | undefined, numberOfResults?: number | undefined, searchQuery?: string | undefined, showAll?: boolean | undefined): Observable<ApplicationViewModel[]> {
        let url_ = this.baseUrl + "/Application/GetAllPaged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' cannot be null.");
        else if (numberOfResults !== undefined)
            url_ += "numberOfResults=" + encodeURIComponent("" + numberOfResults) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApplicationsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApplicationsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationViewModel[]>;
        }));
    }

    protected processGetAllApplicationsPaged(response: HttpResponseBase): Observable<ApplicationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createApplication(body?: ApplicationViewModel | undefined): Observable<ApplicationViewModel> {
        let url_ = this.baseUrl + "/Application/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationViewModel>;
        }));
    }

    protected processCreateApplication(response: HttpResponseBase): Observable<ApplicationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateApplication(body?: ApplicationViewModel | undefined): Observable<ApplicationViewModel> {
        let url_ = this.baseUrl + "/Application/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationViewModel>;
        }));
    }

    protected processUpdateApplication(response: HttpResponseBase): Observable<ApplicationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = ApplicationViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    toggleApplicationStatus(applicationId: string): Observable<ApplicationViewModel> {
        let url_ = this.baseUrl + "/Application/ToggleStatus/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleApplicationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleApplicationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationViewModel>;
        }));
    }

    protected processToggleApplicationStatus(response: HttpResponseBase): Observable<ApplicationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deleteApplication(applicationId: string): Observable<void> {
        let url_ = this.baseUrl + "/Application/Delete/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCurrentBranchTables(): Observable<BranchTableViewModel[]> {
        let url_ = this.baseUrl + "/BranchTable/GetAllCurrentBranchTables";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentBranchTables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentBranchTables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableViewModel[]>;
        }));
    }

    protected processGetAllCurrentBranchTables(response: HttpResponseBase): Observable<BranchTableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchTableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param searchQuery (optional) 
     * @return OK
     */
    getCurrentBranchTablesByPageNumberAndNumberOfResults(pageNumber: number, numberOfResults: number, searchQuery?: string | undefined): Observable<SearchResponse_1OfBranchTableViewModel> {
        let url_ = this.baseUrl + "/BranchTable/GetCurrentBranchTablesByPageNumberAndNumberOfResults/{pageNumber}/{numberOfResults}?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined.");
        url_ = url_.replace("{pageNumber}", encodeURIComponent("" + pageNumber));
        if (numberOfResults === undefined || numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' must be defined.");
        url_ = url_.replace("{numberOfResults}", encodeURIComponent("" + numberOfResults));
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentBranchTablesByPageNumberAndNumberOfResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentBranchTablesByPageNumberAndNumberOfResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse_1OfBranchTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse_1OfBranchTableViewModel>;
        }));
    }

    protected processGetCurrentBranchTablesByPageNumberAndNumberOfResults(response: HttpResponseBase): Observable<SearchResponse_1OfBranchTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse_1OfBranchTableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param searchQuery (optional) 
     * @return OK
     */
    getBranchTableMetaByPageNumberAndNumberOfResults(pageNumber: number, numberOfResults: number, searchQuery?: string | undefined): Observable<SearchResponse_1OfBranchTableViewModel> {
        let url_ = this.baseUrl + "/BranchTable/GetBranchTablesMetaByPageNumberAndNumberOfResults/{pageNumber}/{numberOfResults}?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined.");
        url_ = url_.replace("{pageNumber}", encodeURIComponent("" + pageNumber));
        if (numberOfResults === undefined || numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' must be defined.");
        url_ = url_.replace("{numberOfResults}", encodeURIComponent("" + numberOfResults));
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchTableMetaByPageNumberAndNumberOfResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchTableMetaByPageNumberAndNumberOfResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse_1OfBranchTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse_1OfBranchTableViewModel>;
        }));
    }

    protected processGetBranchTableMetaByPageNumberAndNumberOfResults(response: HttpResponseBase): Observable<SearchResponse_1OfBranchTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse_1OfBranchTableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllBranchSizeOptions(): Observable<number[]> {
        let url_ = this.baseUrl + "/BranchTable/GetAllBranchSizeOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchSizeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchSizeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllBranchSizeOptions(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllHeaderSizeOptions(): Observable<number[]> {
        let url_ = this.baseUrl + "/BranchTable/GetAllHeaderSizeOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHeaderSizeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHeaderSizeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllHeaderSizeOptions(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllUniqueBranchTableCodes(): Observable<BranchTableCodeViewModel[]> {
        let url_ = this.baseUrl + "/BranchTable/GetAllUniqueBranchTableCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUniqueBranchTableCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUniqueBranchTableCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableCodeViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableCodeViewModel[]>;
        }));
    }

    protected processGetAllUniqueBranchTableCodes(response: HttpResponseBase): Observable<BranchTableCodeViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchTableCodeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getBranchTableViewModelById(branchTableId: string): Observable<BranchTableViewModel> {
        let url_ = this.baseUrl + "/BranchTable/GetBranchTableViewModelById/{branchTableId}";
        if (branchTableId === undefined || branchTableId === null)
            throw new Error("The parameter 'branchTableId' must be defined.");
        url_ = url_.replace("{branchTableId}", encodeURIComponent("" + branchTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchTableViewModelById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchTableViewModelById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableViewModel>;
        }));
    }

    protected processGetBranchTableViewModelById(response: HttpResponseBase): Observable<BranchTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchTableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getBranchTableViewModelByPipeClassId(pipeClassId: string): Observable<BranchTableViewModel[]> {
        let url_ = this.baseUrl + "/BranchTable/GetBranchTableViewModelByPipeClassId/{pipeClassId}";
        if (pipeClassId === undefined || pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' must be defined.");
        url_ = url_.replace("{pipeClassId}", encodeURIComponent("" + pipeClassId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchTableViewModelByPipeClassId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchTableViewModelByPipeClassId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableViewModel[]>;
        }));
    }

    protected processGetBranchTableViewModelByPipeClassId(response: HttpResponseBase): Observable<BranchTableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchTableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createBranchTable(body?: BranchTableViewModel | undefined): Observable<BranchTableViewModel> {
        let url_ = this.baseUrl + "/BranchTable/CreateBranchTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBranchTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBranchTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableViewModel>;
        }));
    }

    protected processCreateBranchTable(response: HttpResponseBase): Observable<BranchTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchTableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new Branch Table with the provided changes.
     * @param body (optional) 
     * @return Accepted
     */
    updateBranchTable(body?: BranchTableViewModel | undefined): Observable<BranchTableViewModel> {
        let url_ = this.baseUrl + "/BranchTable/UpdateBranchTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBranchTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBranchTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableViewModel>;
        }));
    }

    protected processUpdateBranchTable(response: HttpResponseBase): Observable<BranchTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = BranchTableViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    archiveBranchTable(branchTableId: string): Observable<BranchTableViewModel> {
        let url_ = this.baseUrl + "/BranchTable/archive/{branchTableId}";
        if (branchTableId === undefined || branchTableId === null)
            throw new Error("The parameter 'branchTableId' must be defined.");
        url_ = url_.replace("{branchTableId}", encodeURIComponent("" + branchTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveBranchTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveBranchTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableViewModel>;
        }));
    }

    protected processArchiveBranchTable(response: HttpResponseBase): Observable<BranchTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchTableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param body (optional) 
     * @return OK
     */
    toggleIsActiveBranchTables(isActive?: boolean | undefined, body?: string[] | undefined): Observable<BranchTableViewModel[]> {
        let url_ = this.baseUrl + "/BranchTable/ToggleIsActiveBranchTables?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleIsActiveBranchTables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleIsActiveBranchTables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableViewModel[]>;
        }));
    }

    protected processToggleIsActiveBranchTables(response: HttpResponseBase): Observable<BranchTableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchTableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBranchTableFreeTextNote(branchTableId: string, pipeClassId: string, body?: string | undefined): Observable<BranchTableViewModel> {
        let url_ = this.baseUrl + "/BranchTable/UpdateBranchTableFreeTextNote/{branchTableId}/{pipeClassId}";
        if (branchTableId === undefined || branchTableId === null)
            throw new Error("The parameter 'branchTableId' must be defined.");
        url_ = url_.replace("{branchTableId}", encodeURIComponent("" + branchTableId));
        if (pipeClassId === undefined || pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' must be defined.");
        url_ = url_.replace("{pipeClassId}", encodeURIComponent("" + pipeClassId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBranchTableFreeTextNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBranchTableFreeTextNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableViewModel>;
        }));
    }

    protected processUpdateBranchTableFreeTextNote(response: HttpResponseBase): Observable<BranchTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchTableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    removeBranchTableFreeTextNote(branchTableId: string, pipeClassId: string): Observable<BranchTableViewModel> {
        let url_ = this.baseUrl + "/BranchTable/RemoveBranchTableFreeTextNote/{branchTableId}/{pipeClassId}";
        if (branchTableId === undefined || branchTableId === null)
            throw new Error("The parameter 'branchTableId' must be defined.");
        url_ = url_.replace("{branchTableId}", encodeURIComponent("" + branchTableId));
        if (pipeClassId === undefined || pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' must be defined.");
        url_ = url_.replace("{pipeClassId}", encodeURIComponent("" + pipeClassId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveBranchTableFreeTextNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveBranchTableFreeTextNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableViewModel>;
        }));
    }

    protected processRemoveBranchTableFreeTextNote(response: HttpResponseBase): Observable<BranchTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = BranchTableViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getFreeTextNote(branchTableId: string, pipeClassId: string): Observable<string> {
        let url_ = this.baseUrl + "/BranchTable/FreeTextNote/{branchTableId}/{pipeClassId}";
        if (branchTableId === undefined || branchTableId === null)
            throw new Error("The parameter 'branchTableId' must be defined.");
        url_ = url_.replace("{branchTableId}", encodeURIComponent("" + branchTableId));
        if (pipeClassId === undefined || pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' must be defined.");
        url_ = url_.replace("{pipeClassId}", encodeURIComponent("" + pipeClassId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFreeTextNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFreeTextNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFreeTextNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates if a Branch Table is current and returns latest version if not
     * @return OK
     */
    validateAndGetLatestBranchTable(branchTableId: string): Observable<BranchTableValidationResult> {
        let url_ = this.baseUrl + "/BranchTable/ValidateAndGetLatest/{branchTableId}";
        if (branchTableId === undefined || branchTableId === null)
            throw new Error("The parameter 'branchTableId' must be defined.");
        url_ = url_.replace("{branchTableId}", encodeURIComponent("" + branchTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAndGetLatestBranchTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAndGetLatestBranchTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableValidationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableValidationResult>;
        }));
    }

    protected processValidateAndGetLatestBranchTable(response: HttpResponseBase): Observable<BranchTableValidationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchTableValidationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCurrentBranchTableCodes(): Observable<BranchTableCodeViewModel[]> {
        let url_ = this.baseUrl + "/BranchTableCode/GetAllCurrentBranchTableCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentBranchTableCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentBranchTableCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableCodeViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableCodeViewModel[]>;
        }));
    }

    protected processGetAllCurrentBranchTableCodes(response: HttpResponseBase): Observable<BranchTableCodeViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchTableCodeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getBranchTableCode(code: string): Observable<BranchTableCodeViewModel> {
        let url_ = this.baseUrl + "/BranchTableCode/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchTableCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchTableCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableCodeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableCodeViewModel>;
        }));
    }

    protected processGetBranchTableCode(response: HttpResponseBase): Observable<BranchTableCodeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchTableCodeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createBranchTableCode(body?: BranchTableCodeViewModel | undefined): Observable<BranchTableCodeViewModel> {
        let url_ = this.baseUrl + "/BranchTableCode/CreateBranchTableCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBranchTableCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBranchTableCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableCodeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableCodeViewModel>;
        }));
    }

    protected processCreateBranchTableCode(response: HttpResponseBase): Observable<BranchTableCodeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = BranchTableCodeViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBranchTableCode(body?: BranchTableCodeViewModel | undefined): Observable<BranchTableCodeViewModel> {
        let url_ = this.baseUrl + "/BranchTableCode/UpdateBranchTableCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBranchTableCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBranchTableCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableCodeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableCodeViewModel>;
        }));
    }

    protected processUpdateBranchTableCode(response: HttpResponseBase): Observable<BranchTableCodeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchTableCodeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    archiveBranchTableCode(branchTableCodeId: string): Observable<BranchTableCodeViewModel> {
        let url_ = this.baseUrl + "/BranchTableCode/archive/{branchTableCodeId}";
        if (branchTableCodeId === undefined || branchTableCodeId === null)
            throw new Error("The parameter 'branchTableCodeId' must be defined.");
        url_ = url_.replace("{branchTableCodeId}", encodeURIComponent("" + branchTableCodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveBranchTableCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveBranchTableCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableCodeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableCodeViewModel>;
        }));
    }

    protected processArchiveBranchTableCode(response: HttpResponseBase): Observable<BranchTableCodeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchTableCodeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param body (optional) 
     * @return OK
     */
    toggleIsActiveBranchTableCode(isActive?: boolean | undefined, body?: string[] | undefined): Observable<BranchTableCodeViewModel[]> {
        let url_ = this.baseUrl + "/BranchTableCode/ToggleIsActiveBranchTableCode?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleIsActiveBranchTableCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleIsActiveBranchTableCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTableCodeViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTableCodeViewModel[]>;
        }));
    }

    protected processToggleIsActiveBranchTableCode(response: HttpResponseBase): Observable<BranchTableCodeViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchTableCodeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllBusinessUnits(): Observable<string[]> {
        let url_ = this.baseUrl + "/BusinessUnit/GetAllBusinessUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBusinessUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBusinessUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllBusinessUnits(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCurrentBusinessUnits(): Observable<BusinessUnitViewModel[]> {
        let url_ = this.baseUrl + "/BusinessUnit/GetAllCurrent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentBusinessUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentBusinessUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessUnitViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessUnitViewModel[]>;
        }));
    }

    protected processGetAllCurrentBusinessUnits(response: HttpResponseBase): Observable<BusinessUnitViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessUnitViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param numberOfResults (optional) 
     * @param searchQuery (optional) 
     * @param showAll (optional) 
     * @return OK
     */
    getAllBusinessUnitsPaged(pageNumber?: number | undefined, numberOfResults?: number | undefined, searchQuery?: string | undefined, showAll?: boolean | undefined): Observable<BusinessUnitViewModel[]> {
        let url_ = this.baseUrl + "/BusinessUnit/GetAllPaged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' cannot be null.");
        else if (numberOfResults !== undefined)
            url_ += "numberOfResults=" + encodeURIComponent("" + numberOfResults) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBusinessUnitsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBusinessUnitsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessUnitViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessUnitViewModel[]>;
        }));
    }

    protected processGetAllBusinessUnitsPaged(response: HttpResponseBase): Observable<BusinessUnitViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessUnitViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createBusinessUnit(body?: BusinessUnitViewModel | undefined): Observable<BusinessUnitViewModel> {
        let url_ = this.baseUrl + "/BusinessUnit/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBusinessUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBusinessUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessUnitViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessUnitViewModel>;
        }));
    }

    protected processCreateBusinessUnit(response: HttpResponseBase): Observable<BusinessUnitViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessUnitViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateBusinessUnit(body?: BusinessUnitViewModel | undefined): Observable<BusinessUnitViewModel> {
        let url_ = this.baseUrl + "/BusinessUnit/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBusinessUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBusinessUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessUnitViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessUnitViewModel>;
        }));
    }

    protected processUpdateBusinessUnit(response: HttpResponseBase): Observable<BusinessUnitViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = BusinessUnitViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    toggleBusinessUnitStatus(businessUnitId: string): Observable<BusinessUnitViewModel> {
        let url_ = this.baseUrl + "/BusinessUnit/ToggleStatus/{businessUnitId}";
        if (businessUnitId === undefined || businessUnitId === null)
            throw new Error("The parameter 'businessUnitId' must be defined.");
        url_ = url_.replace("{businessUnitId}", encodeURIComponent("" + businessUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleBusinessUnitStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleBusinessUnitStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessUnitViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessUnitViewModel>;
        }));
    }

    protected processToggleBusinessUnitStatus(response: HttpResponseBase): Observable<BusinessUnitViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessUnitViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deleteBusinessUnit(businessUnitId: string): Observable<void> {
        let url_ = this.baseUrl + "/BusinessUnit/Delete/{businessUnitId}";
        if (businessUnitId === undefined || businessUnitId === null)
            throw new Error("The parameter 'businessUnitId' must be defined.");
        url_ = url_.replace("{businessUnitId}", encodeURIComponent("" + businessUnitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBusinessUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBusinessUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBusinessUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get comments by query parameters
     * @param pipeClassId (optional) 
     * @param revisionId (optional) 
     * @param contextType (optional) 
     * @return OK
     */
    getComments(pipeClassId?: string | undefined, revisionId?: number | undefined, contextType?: string | undefined): Observable<CommentViewModel[]> {
        let url_ = this.baseUrl + "/api/Comments?";
        if (pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' cannot be null.");
        else if (pipeClassId !== undefined)
            url_ += "PipeClassId=" + encodeURIComponent("" + pipeClassId) + "&";
        if (revisionId === null)
            throw new Error("The parameter 'revisionId' cannot be null.");
        else if (revisionId !== undefined)
            url_ += "RevisionId=" + encodeURIComponent("" + revisionId) + "&";
        if (contextType === null)
            throw new Error("The parameter 'contextType' cannot be null.");
        else if (contextType !== undefined)
            url_ += "ContextType=" + encodeURIComponent("" + contextType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentViewModel[]>;
        }));
    }

    protected processGetComments(response: HttpResponseBase): Observable<CommentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a single root comment
     * @param body (optional) 
     * @return Created
     */
    createComment(body?: CreateCommentRequest | undefined): Observable<CommentViewModel> {
        let url_ = this.baseUrl + "/api/Comments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentViewModel>;
        }));
    }

    protected processCreateComment(response: HttpResponseBase): Observable<CommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CommentViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save all comments for a context (replaces existing) - MAIN OPERATION
     * @param body (optional) 
     * @return OK
     */
    saveComments(body?: SaveCommentsRequest | undefined): Observable<CommentViewModel[]> {
        let url_ = this.baseUrl + "/api/Comments/save-bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentViewModel[]>;
        }));
    }

    protected processSaveComments(response: HttpResponseBase): Observable<CommentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a reply to a root comment. Replying to a reply is not allowed.
     * @param body (optional) 
     * @return Created
     */
    addReply(parentCommentId: string, body?: AddReplyRequest | undefined): Observable<CommentViewModel> {
        let url_ = this.baseUrl + "/api/Comments/{parentCommentId}/reply";
        if (parentCommentId === undefined || parentCommentId === null)
            throw new Error("The parameter 'parentCommentId' must be defined.");
        url_ = url_.replace("{parentCommentId}", encodeURIComponent("" + parentCommentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentViewModel>;
        }));
    }

    protected processAddReply(response: HttpResponseBase): Observable<CommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CommentViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the content of your own comment
     * @param body (optional) 
     * @return OK
     */
    updateComment(commentId: string, body?: UpdateCommentRequest | undefined): Observable<CommentViewModel> {
        let url_ = this.baseUrl + "/api/Comments/{commentId}";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentViewModel>;
        }));
    }

    protected processUpdateComment(response: HttpResponseBase): Observable<CommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete your own comment (only if it has no replies)
     * @return Accepted
     */
    deleteComment(commentId: string): Observable<CommentViewModel> {
        let url_ = this.baseUrl + "/api/Comments/{commentId}";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentViewModel>;
        }));
    }

    protected processDeleteComment(response: HttpResponseBase): Observable<CommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CommentViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get comment count by parameters
     * @param pipeClassId (optional) 
     * @param revisionId (optional) 
     * @param contextType (optional) 
     * @return OK
     */
    getCommentCount(pipeClassId?: string | undefined, revisionId?: number | undefined, contextType?: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Comments/count?";
        if (pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' cannot be null.");
        else if (pipeClassId !== undefined)
            url_ += "pipeClassId=" + encodeURIComponent("" + pipeClassId) + "&";
        if (revisionId === null)
            throw new Error("The parameter 'revisionId' cannot be null.");
        else if (revisionId !== undefined)
            url_ += "revisionId=" + encodeURIComponent("" + revisionId) + "&";
        if (contextType === null)
            throw new Error("The parameter 'contextType' cannot be null.");
        else if (contextType !== undefined)
            url_ += "contextType=" + encodeURIComponent("" + contextType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCommentCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the resolution status of a comment (Open / Adopted / Closed)
     * @param body (optional) 
     * @return OK
     */
    updateCommentResolutionStatus(commentId: string, body?: UpdateCommentResolutionStatusRequest | undefined): Observable<CommentViewModel> {
        let url_ = this.baseUrl + "/api/Comments/{commentId}/resolution-status";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommentResolutionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommentResolutionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentViewModel>;
        }));
    }

    protected processUpdateCommentResolutionStatus(response: HttpResponseBase): Observable<CommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns true if a revision has at least one Pending comment, blocking publish
     * @param revisionId (optional) 
     * @return OK
     */
    hasPendingComments(revisionId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Comments/has-pending?";
        if (revisionId === null)
            throw new Error("The parameter 'revisionId' cannot be null.");
        else if (revisionId !== undefined)
            url_ += "revisionId=" + encodeURIComponent("" + revisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasPendingComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasPendingComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasPendingComments(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCurrentCommonNotes(): Observable<CommonNoteViewModel[]> {
        let url_ = this.baseUrl + "/CommonNote/GetAllCurrentCommonNotes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentCommonNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentCommonNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNoteViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNoteViewModel[]>;
        }));
    }

    protected processGetAllCurrentCommonNotes(response: HttpResponseBase): Observable<CommonNoteViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonNoteViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param currentPage (optional) 
     * @param activeAndInactiveNotes (optional) 
     * @return OK
     */
    getAllCurrentCommonNotesWithReferenceInfo(pageSize?: number | undefined, currentPage?: number | undefined, activeAndInactiveNotes?: boolean | undefined): Observable<CommonNoteViewModel[]> {
        let url_ = this.baseUrl + "/CommonNote/GetAllCurrentCommonNotesWithReferenceInfo?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (currentPage === null)
            throw new Error("The parameter 'currentPage' cannot be null.");
        else if (currentPage !== undefined)
            url_ += "currentPage=" + encodeURIComponent("" + currentPage) + "&";
        if (activeAndInactiveNotes === null)
            throw new Error("The parameter 'activeAndInactiveNotes' cannot be null.");
        else if (activeAndInactiveNotes !== undefined)
            url_ += "activeAndInactiveNotes=" + encodeURIComponent("" + activeAndInactiveNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentCommonNotesWithReferenceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentCommonNotesWithReferenceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNoteViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNoteViewModel[]>;
        }));
    }

    protected processGetAllCurrentCommonNotesWithReferenceInfo(response: HttpResponseBase): Observable<CommonNoteViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonNoteViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activeAndInactiveNotes (optional) 
     * @return OK
     */
    getCommonNoteCount(activeAndInactiveNotes?: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/CommonNote/GetCommonNoteCount?";
        if (activeAndInactiveNotes === null)
            throw new Error("The parameter 'activeAndInactiveNotes' cannot be null.");
        else if (activeAndInactiveNotes !== undefined)
            url_ += "activeAndInactiveNotes=" + encodeURIComponent("" + activeAndInactiveNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommonNoteCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommonNoteCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCommonNoteCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCommonNotesForPipeClassByPipeClassId(pipeClassId: string): Observable<CommonNoteViewModel[]> {
        let url_ = this.baseUrl + "/CommonNote/GetAllCommonNotesForPipeClass/{pipeClassId}";
        if (pipeClassId === undefined || pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' must be defined.");
        url_ = url_.replace("{pipeClassId}", encodeURIComponent("" + pipeClassId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommonNotesForPipeClassByPipeClassId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommonNotesForPipeClassByPipeClassId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNoteViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNoteViewModel[]>;
        }));
    }

    protected processGetAllCommonNotesForPipeClassByPipeClassId(response: HttpResponseBase): Observable<CommonNoteViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonNoteViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param nameOrDesc (optional) 
     * @param pageSize (optional) 
     * @param currentPage (optional) 
     * @param activeAndInactiveNotes (optional) 
     * @return OK
     */
    searchCurrentCommonNotes(nameOrDesc?: string | undefined, pageSize?: number | undefined, currentPage?: number | undefined, activeAndInactiveNotes?: boolean | undefined): Observable<CommonNoteViewModel[]> {
        let url_ = this.baseUrl + "/CommonNote/SearchCurrentCommonNotes?";
        if (nameOrDesc === null)
            throw new Error("The parameter 'nameOrDesc' cannot be null.");
        else if (nameOrDesc !== undefined)
            url_ += "nameOrDesc=" + encodeURIComponent("" + nameOrDesc) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (currentPage === null)
            throw new Error("The parameter 'currentPage' cannot be null.");
        else if (currentPage !== undefined)
            url_ += "currentPage=" + encodeURIComponent("" + currentPage) + "&";
        if (activeAndInactiveNotes === null)
            throw new Error("The parameter 'activeAndInactiveNotes' cannot be null.");
        else if (activeAndInactiveNotes !== undefined)
            url_ += "activeAndInactiveNotes=" + encodeURIComponent("" + activeAndInactiveNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCurrentCommonNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCurrentCommonNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNoteViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNoteViewModel[]>;
        }));
    }

    protected processSearchCurrentCommonNotes(response: HttpResponseBase): Observable<CommonNoteViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonNoteViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activeAndInactiveNotes (optional) 
     * @return OK
     */
    getCurrentCommonNoteCount(activeAndInactiveNotes?: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/CommonNote/GetCurrentCommonNoteCount?";
        if (activeAndInactiveNotes === null)
            throw new Error("The parameter 'activeAndInactiveNotes' cannot be null.");
        else if (activeAndInactiveNotes !== undefined)
            url_ += "activeAndInactiveNotes=" + encodeURIComponent("" + activeAndInactiveNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentCommonNoteCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentCommonNoteCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCurrentCommonNoteCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCommonNote(body?: CommonNoteViewModel | undefined): Observable<CommonNoteViewModel> {
        let url_ = this.baseUrl + "/CommonNote/CreateCommonNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCommonNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCommonNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNoteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNoteViewModel>;
        }));
    }

    protected processCreateCommonNote(response: HttpResponseBase): Observable<CommonNoteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonNoteViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    createNewCommonNoteVersion(body?: CommonNoteViewModel | undefined): Observable<CommonNoteViewModel> {
        let url_ = this.baseUrl + "/CommonNote/CreateNewCommonNoteVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewCommonNoteVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewCommonNoteVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNoteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNoteViewModel>;
        }));
    }

    protected processCreateNewCommonNoteVersion(response: HttpResponseBase): Observable<CommonNoteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = CommonNoteViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param body (optional) 
     * @return OK
     */
    toggleIsActiveCommonNotes(isActive?: boolean | undefined, body?: string[] | undefined): Observable<CommonNoteViewModel[]> {
        let url_ = this.baseUrl + "/CommonNote/ToggleIsActiveCommonNotes?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleIsActiveCommonNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleIsActiveCommonNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNoteViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNoteViewModel[]>;
        }));
    }

    protected processToggleIsActiveCommonNotes(response: HttpResponseBase): Observable<CommonNoteViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommonNoteViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    archiveCommonNote(commonNoteId: string): Observable<CommonNoteViewModel> {
        let url_ = this.baseUrl + "/CommonNote/archive/{commonNoteId}";
        if (commonNoteId === undefined || commonNoteId === null)
            throw new Error("The parameter 'commonNoteId' must be defined.");
        url_ = url_.replace("{commonNoteId}", encodeURIComponent("" + commonNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveCommonNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveCommonNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonNoteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonNoteViewModel>;
        }));
    }

    protected processArchiveCommonNote(response: HttpResponseBase): Observable<CommonNoteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonNoteViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateAllComponentCodes(): Observable<ComponentViewModel[]> {
        let url_ = this.baseUrl + "/Component/UpdateAllComponentCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllComponentCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllComponentCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentViewModel[]>;
        }));
    }

    protected processUpdateAllComponentCodes(response: HttpResponseBase): Observable<ComponentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param searchQuery (optional) 
     * @return OK
     */
    getAllComponentsPaged(pageNumber: number, numberOfResults: number, searchQuery?: string | undefined): Observable<SearchResponse_1OfComponentViewModel> {
        let url_ = this.baseUrl + "/Component/GetAllComponentsPaged/{pageNumber}/{numberOfResults}?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined.");
        url_ = url_.replace("{pageNumber}", encodeURIComponent("" + pageNumber));
        if (numberOfResults === undefined || numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' must be defined.");
        url_ = url_.replace("{numberOfResults}", encodeURIComponent("" + numberOfResults));
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllComponentsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllComponentsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse_1OfComponentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse_1OfComponentViewModel>;
        }));
    }

    protected processGetAllComponentsPaged(response: HttpResponseBase): Observable<SearchResponse_1OfComponentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse_1OfComponentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getComponentsByType(type: string): Observable<ComponentViewModel[]> {
        let url_ = this.baseUrl + "/Component/GetComponentsByType/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComponentsByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComponentsByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentViewModel[]>;
        }));
    }

    protected processGetComponentsByType(response: HttpResponseBase): Observable<ComponentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    getComponentPropertiesById(componentId: string): Observable<ComponentPropertyViewModel[]> {
        let url_ = this.baseUrl + "/Component/GetPropertiesByComponentId/{componentId}";
        if (componentId === undefined || componentId === null)
            throw new Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComponentPropertiesById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComponentPropertiesById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentPropertyViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentPropertyViewModel[]>;
        }));
    }

    protected processGetComponentPropertiesById(response: HttpResponseBase): Observable<ComponentPropertyViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData202)) {
                result202 = [] as any;
                for (let item of resultData202)
                    result202!.push(ComponentPropertyViewModel.fromJS(item));
            }
            else {
                result202 = <any>null;
            }
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupName (optional) 
     * @return OK
     */
    getGroupPropertiesByGroupName(groupName?: string | undefined): Observable<ComponentGroupPropertiesViewModel> {
        let url_ = this.baseUrl + "/Component/GetGroupPropertiesByGroupName?";
        if (groupName === null)
            throw new Error("The parameter 'groupName' cannot be null.");
        else if (groupName !== undefined)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupPropertiesByGroupName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupPropertiesByGroupName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentGroupPropertiesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentGroupPropertiesViewModel>;
        }));
    }

    protected processGetGroupPropertiesByGroupName(response: HttpResponseBase): Observable<ComponentGroupPropertiesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentGroupPropertiesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupName (optional) 
     * @return OK
     */
    getAllComponentTypesByGroupName(groupName?: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/Component/GetAllComponentTypesByGroupName?";
        if (groupName === null)
            throw new Error("The parameter 'groupName' cannot be null.");
        else if (groupName !== undefined)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllComponentTypesByGroupName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllComponentTypesByGroupName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllComponentTypesByGroupName(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fetchNonValves (optional) 
     * @param fetchValves (optional) 
     * @return OK
     */
    getComponentTypes(fetchNonValves?: boolean | undefined, fetchValves?: boolean | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/Component/GetComponentTypes?";
        if (fetchNonValves === null)
            throw new Error("The parameter 'fetchNonValves' cannot be null.");
        else if (fetchNonValves !== undefined)
            url_ += "fetchNonValves=" + encodeURIComponent("" + fetchNonValves) + "&";
        if (fetchValves === null)
            throw new Error("The parameter 'fetchValves' cannot be null.");
        else if (fetchValves !== undefined)
            url_ += "fetchValves=" + encodeURIComponent("" + fetchValves) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComponentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComponentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetComponentTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    componentGroups(): Observable<string[]> {
        let url_ = this.baseUrl + "/Component/ComponentGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComponentGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComponentGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processComponentGroups(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    componentGroupsWithId(): Observable<ComponentGroupViewModel[]> {
        let url_ = this.baseUrl + "/Component/ComponentGroupsWithId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComponentGroupsWithId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComponentGroupsWithId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentGroupViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentGroupViewModel[]>;
        }));
    }

    protected processComponentGroupsWithId(response: HttpResponseBase): Observable<ComponentGroupViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentGroupViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createComponent(body?: ComponentViewModel | undefined): Observable<ComponentViewModel> {
        let url_ = this.baseUrl + "/Component/CreateComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentViewModel>;
        }));
    }

    protected processCreateComponent(response: HttpResponseBase): Observable<ComponentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateComponent(body?: ComponentViewModel | undefined): Observable<ComponentViewModel> {
        let url_ = this.baseUrl + "/Component/UpdateComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentViewModel>;
        }));
    }

    protected processUpdateComponent(response: HttpResponseBase): Observable<ComponentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getComponentById(componentId: string): Observable<ComponentViewModel> {
        let url_ = this.baseUrl + "/Component/GetComponentById/{componentId}";
        if (componentId === undefined || componentId === null)
            throw new Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComponentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComponentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentViewModel>;
        }));
    }

    protected processGetComponentById(response: HttpResponseBase): Observable<ComponentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Accepted
     */
    archiveComponent(componentId: string): Observable<ComponentViewModel> {
        let url_ = this.baseUrl + "/Component/archive/{componentId}";
        if (componentId === undefined || componentId === null)
            throw new Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentViewModel>;
        }));
    }

    protected processArchiveComponent(response: HttpResponseBase): Observable<ComponentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = ComponentViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRootRevisionFromComponent(componentId: string): Observable<SimpleRevisionViewModel> {
        let url_ = this.baseUrl + "/Component/GetRootRevisionFromComponent/{componentId}";
        if (componentId === undefined || componentId === null)
            throw new Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRootRevisionFromComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRootRevisionFromComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleRevisionViewModel>;
        }));
    }

    protected processGetRootRevisionFromComponent(response: HttpResponseBase): Observable<SimpleRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    exportComponentCatalog(): Observable<void> {
        let url_ = this.baseUrl + "/Component/ExportComponentCatalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportComponentCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportComponentCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportComponentCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param componentId (optional) 
     * @param newStatus (optional) 
     * @return OK
     */
    updateComponentStatus(componentId?: string | undefined, newStatus?: boolean | undefined): Observable<ComponentViewModel> {
        let url_ = this.baseUrl + "/Component/updateComponentStatus?";
        if (componentId === null)
            throw new Error("The parameter 'componentId' cannot be null.");
        else if (componentId !== undefined)
            url_ += "componentId=" + encodeURIComponent("" + componentId) + "&";
        if (newStatus === null)
            throw new Error("The parameter 'newStatus' cannot be null.");
        else if (newStatus !== undefined)
            url_ += "newStatus=" + encodeURIComponent("" + newStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComponentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComponentStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentViewModel>;
        }));
    }

    protected processUpdateComponentStatus(response: HttpResponseBase): Observable<ComponentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 429) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateComponentCode(body?: ComponentViewModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Component/GenerateComponentCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateComponentCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateComponentCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateComponentCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    generateComponentCodeById(componentId: string): Observable<string> {
        let url_ = this.baseUrl + "/Component/GenerateComponentCode/{componentId}";
        if (componentId === undefined || componentId === null)
            throw new Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateComponentCodeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateComponentCodeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateComponentCodeById(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateComponentCode(body?: ComponentViewModel | undefined): Observable<ComponentCodeValidationResponse> {
        let url_ = this.baseUrl + "/Component/ValidateComponentCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateComponentCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateComponentCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentCodeValidationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentCodeValidationResponse>;
        }));
    }

    protected processValidateComponentCode(response: HttpResponseBase): Observable<ComponentCodeValidationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentCodeValidationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupName (optional) 
     * @return OK
     */
    getDescriptionsByGroup(groupName?: string | undefined): Observable<ComponentPropertyViewModel[]> {
        let url_ = this.baseUrl + "/Component/GetDescriptionsByGroup?";
        if (groupName === null)
            throw new Error("The parameter 'groupName' cannot be null.");
        else if (groupName !== undefined)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDescriptionsByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDescriptionsByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentPropertyViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentPropertyViewModel[]>;
        }));
    }

    protected processGetDescriptionsByGroup(response: HttpResponseBase): Observable<ComponentPropertyViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentPropertyViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns validation results for components, classifying each as current, superseded (with latest version), or indeterminate
     * @param body (optional) 
     * @return OK
     */
    validateAndGetLatestComponents(body?: string[] | undefined): Observable<ComponentValidationResult[]> {
        let url_ = this.baseUrl + "/Component/ValidateAndGetLatest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAndGetLatestComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAndGetLatestComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentValidationResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentValidationResult[]>;
        }));
    }

    protected processValidateAndGetLatestComponents(response: HttpResponseBase): Observable<ComponentValidationResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentValidationResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param showAll (optional) 
     * @param body (optional) 
     * @return OK
     */
    componentCatalogSearch(showAll?: boolean | undefined, body?: SearchRequest | undefined): Observable<SearchResponse_1OfComponentCatalogSearchViewModel> {
        let url_ = this.baseUrl + "/ComponentCatalogSearch/search?";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComponentCatalogSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComponentCatalogSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse_1OfComponentCatalogSearchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse_1OfComponentCatalogSearchViewModel>;
        }));
    }

    protected processComponentCatalogSearch(response: HttpResponseBase): Observable<SearchResponse_1OfComponentCatalogSearchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse_1OfComponentCatalogSearchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param componentGroupName (optional) 
     * @param attributeName (optional) 
     * @param fetchNonValves (optional) 
     * @param fetchValves (optional) 
     * @param componentPropertyName (optional) 
     * @param activeOnly (optional) 
     * @return OK
     */
    getAllComponentProperties(componentGroupName?: string | undefined, attributeName?: string | undefined, fetchNonValves?: boolean | undefined, fetchValves?: boolean | undefined, componentPropertyName?: string | undefined, activeOnly?: boolean | undefined): Observable<ComponentPropertyViewModel[]> {
        let url_ = this.baseUrl + "/api/ComponentProperty/GetAllComponentProperties?";
        if (componentGroupName === null)
            throw new Error("The parameter 'componentGroupName' cannot be null.");
        else if (componentGroupName !== undefined)
            url_ += "componentGroupName=" + encodeURIComponent("" + componentGroupName) + "&";
        if (attributeName === null)
            throw new Error("The parameter 'attributeName' cannot be null.");
        else if (attributeName !== undefined)
            url_ += "attributeName=" + encodeURIComponent("" + attributeName) + "&";
        if (fetchNonValves === null)
            throw new Error("The parameter 'fetchNonValves' cannot be null.");
        else if (fetchNonValves !== undefined)
            url_ += "fetchNonValves=" + encodeURIComponent("" + fetchNonValves) + "&";
        if (fetchValves === null)
            throw new Error("The parameter 'fetchValves' cannot be null.");
        else if (fetchValves !== undefined)
            url_ += "fetchValves=" + encodeURIComponent("" + fetchValves) + "&";
        if (componentPropertyName === null)
            throw new Error("The parameter 'componentPropertyName' cannot be null.");
        else if (componentPropertyName !== undefined)
            url_ += "componentPropertyName=" + encodeURIComponent("" + componentPropertyName) + "&";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllComponentProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllComponentProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentPropertyViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentPropertyViewModel[]>;
        }));
    }

    protected processGetAllComponentProperties(response: HttpResponseBase): Observable<ComponentPropertyViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentPropertyViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllValvesComponentProperties(): Observable<ValveComponentPropertyViewModel[]> {
        let url_ = this.baseUrl + "/api/ComponentProperty/GetAllValvesComponentProperties";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllValvesComponentProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllValvesComponentProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveComponentPropertyViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveComponentPropertyViewModel[]>;
        }));
    }

    protected processGetAllValvesComponentProperties(response: HttpResponseBase): Observable<ValveComponentPropertyViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveComponentPropertyViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllComponentPropertyNames(): Observable<Tuple_2OfStringAndString[]> {
        let url_ = this.baseUrl + "/api/ComponentProperty/GetAllComponentPropertyNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllComponentPropertyNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllComponentPropertyNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tuple_2OfStringAndString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tuple_2OfStringAndString[]>;
        }));
    }

    protected processGetAllComponentPropertyNames(response: HttpResponseBase): Observable<Tuple_2OfStringAndString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tuple_2OfStringAndString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupName (optional) 
     * @return OK
     */
    getAttributeNamesByGroup(groupName?: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/ComponentProperty/GetAttributeNamesByGroup?";
        if (groupName === null)
            throw new Error("The parameter 'groupName' cannot be null.");
        else if (groupName !== undefined)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttributeNamesByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttributeNamesByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAttributeNamesByGroup(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns all component properties without their related components
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getPaginatedComponentProperties(pageIndex?: number | undefined, pageSize?: number | undefined): Observable<SearchResponse_1OfComponentPropertyViewModel> {
        let url_ = this.baseUrl + "/api/ComponentProperty/GetPaginatedComponentProperties?";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginatedComponentProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginatedComponentProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse_1OfComponentPropertyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse_1OfComponentPropertyViewModel>;
        }));
    }

    protected processGetPaginatedComponentProperties(response: HttpResponseBase): Observable<SearchResponse_1OfComponentPropertyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse_1OfComponentPropertyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns any component property that matches the GUID provided.
     * @return OK
     */
    getComponentProperty(componentPropertyId: string): Observable<ComponentPropertyViewModel> {
        let url_ = this.baseUrl + "/api/ComponentProperty/{componentPropertyId}";
        if (componentPropertyId === undefined || componentPropertyId === null)
            throw new Error("The parameter 'componentPropertyId' must be defined.");
        url_ = url_.replace("{componentPropertyId}", encodeURIComponent("" + componentPropertyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComponentProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComponentProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentPropertyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentPropertyViewModel>;
        }));
    }

    protected processGetComponentProperty(response: HttpResponseBase): Observable<ComponentPropertyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentPropertyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createComponentProperty(body?: ComponentPropertyViewModel | undefined): Observable<ComponentPropertyViewModel> {
        let url_ = this.baseUrl + "/api/ComponentProperty/CreateComponentProperty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateComponentProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComponentProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentPropertyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentPropertyViewModel>;
        }));
    }

    protected processCreateComponentProperty(response: HttpResponseBase): Observable<ComponentPropertyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentPropertyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ComponentPropertyViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateComponentProperty(body?: ComponentPropertyViewModel | undefined): Observable<ComponentPropertyViewModel> {
        let url_ = this.baseUrl + "/api/ComponentProperty/UpdateComponentProperty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComponentProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComponentProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentPropertyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentPropertyViewModel>;
        }));
    }

    protected processUpdateComponentProperty(response: HttpResponseBase): Observable<ComponentPropertyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentPropertyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setComponentPropertyStatus(componentPropertyId: string, body?: boolean | undefined): Observable<ComponentPropertyViewModel> {
        let url_ = this.baseUrl + "/api/ComponentProperty/SetComponentPropertyStatus/{componentPropertyId}";
        if (componentPropertyId === undefined || componentPropertyId === null)
            throw new Error("The parameter 'componentPropertyId' must be defined.");
        url_ = url_.replace("{componentPropertyId}", encodeURIComponent("" + componentPropertyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetComponentPropertyStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetComponentPropertyStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentPropertyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentPropertyViewModel>;
        }));
    }

    protected processSetComponentPropertyStatus(response: HttpResponseBase): Observable<ComponentPropertyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentPropertyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns distinct values for a specified property name
     * @param propertyName (optional) 
     * @return OK
     */
    getDistinctPropertyValues(propertyName?: string | undefined): Observable<PipeClassPropertyViewModel[]> {
        let url_ = this.baseUrl + "/api/ComponentProperty/GetDistinctPropertyValues?";
        if (propertyName === null)
            throw new Error("The parameter 'propertyName' cannot be null.");
        else if (propertyName !== undefined)
            url_ += "propertyName=" + encodeURIComponent("" + propertyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistinctPropertyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistinctPropertyValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassPropertyViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassPropertyViewModel[]>;
        }));
    }

    protected processGetDistinctPropertyValues(response: HttpResponseBase): Observable<PipeClassPropertyViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipeClassPropertyViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns distinct active values for a property name from the PipeClass summary property dictionary
     * @param propertyName (optional) 
     * @return OK
     */
    getDistinctActiveValues(propertyName?: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/ComponentProperty/GetDistinctActiveValues?";
        if (propertyName === null)
            throw new Error("The parameter 'propertyName' cannot be null.");
        else if (propertyName !== undefined)
            url_ += "propertyName=" + encodeURIComponent("" + propertyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistinctActiveValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistinctActiveValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetDistinctActiveValues(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param originalValue (optional) 
     * @param mappedValue (optional) 
     * @param pipingObjectType (optional) 
     * @param mappingFieldType (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param sortDescending (optional) 
     * @return OK
     */
    getConsolidationMappings(originalValue?: string | undefined, mappedValue?: string | undefined, pipingObjectType?: PipingObjectType | undefined, mappingFieldType?: ConsolidationMappingFieldType | undefined, pageNumber?: number | undefined, pageSize?: number | undefined, sortBy?: string | undefined, sortDescending?: boolean | undefined): Observable<PagedResultViewModel_1OfConsolidationMappingViewModel> {
        let url_ = this.baseUrl + "/api/consolidation-mappings?";
        if (originalValue === null)
            throw new Error("The parameter 'originalValue' cannot be null.");
        else if (originalValue !== undefined)
            url_ += "originalValue=" + encodeURIComponent("" + originalValue) + "&";
        if (mappedValue === null)
            throw new Error("The parameter 'mappedValue' cannot be null.");
        else if (mappedValue !== undefined)
            url_ += "mappedValue=" + encodeURIComponent("" + mappedValue) + "&";
        if (pipingObjectType === null)
            throw new Error("The parameter 'pipingObjectType' cannot be null.");
        else if (pipingObjectType !== undefined)
            url_ += "pipingObjectType=" + encodeURIComponent("" + pipingObjectType) + "&";
        if (mappingFieldType === null)
            throw new Error("The parameter 'mappingFieldType' cannot be null.");
        else if (mappingFieldType !== undefined)
            url_ += "mappingFieldType=" + encodeURIComponent("" + mappingFieldType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsolidationMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsolidationMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultViewModel_1OfConsolidationMappingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultViewModel_1OfConsolidationMappingViewModel>;
        }));
    }

    protected processGetConsolidationMappings(response: HttpResponseBase): Observable<PagedResultViewModel_1OfConsolidationMappingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultViewModel_1OfConsolidationMappingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createConsolidationMapping(body?: ConsolidationMappingViewModel | undefined): Observable<ConsolidationMappingViewModel> {
        let url_ = this.baseUrl + "/api/consolidation-mappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConsolidationMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConsolidationMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsolidationMappingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsolidationMappingViewModel>;
        }));
    }

    protected processCreateConsolidationMapping(response: HttpResponseBase): Observable<ConsolidationMappingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsolidationMappingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getConsolidationMappingById(id: string): Observable<ConsolidationMappingViewModel> {
        let url_ = this.baseUrl + "/api/consolidation-mappings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsolidationMappingById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsolidationMappingById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsolidationMappingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsolidationMappingViewModel>;
        }));
    }

    protected processGetConsolidationMappingById(response: HttpResponseBase): Observable<ConsolidationMappingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsolidationMappingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateConsolidationMapping(id: string, body?: ConsolidationMappingViewModel | undefined): Observable<ConsolidationMappingViewModel> {
        let url_ = this.baseUrl + "/api/consolidation-mappings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsolidationMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsolidationMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsolidationMappingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsolidationMappingViewModel>;
        }));
    }

    protected processUpdateConsolidationMapping(response: HttpResponseBase): Observable<ConsolidationMappingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsolidationMappingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deleteConsolidationMapping(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/consolidation-mappings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsolidationMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsolidationMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsolidationMapping(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCommonNotes(searchText?: string | undefined, showAll?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/common-notes/export?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCommonNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCommonNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportCommonNotes(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportServices(searchText?: string | undefined, showAll?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/services/export?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportServices(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportServiceDetails(searchText?: string | undefined, showAll?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/service-details/export?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportServiceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportServiceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportServiceDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPressureTemperature(searchText?: string | undefined, showAll?: boolean | undefined, sortColumn?: string | undefined, sortDirection?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/pressure-temperature/export?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPressureTemperature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPressureTemperature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportPressureTemperature(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportBranchTables(searchText?: string | undefined, showAll?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/branch-tables/export?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBranchTables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBranchTables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportBranchTables(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportBranchTableCodes(searchText?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/branch-table-codes/export?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBranchTableCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBranchTableCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportBranchTableCodes(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportComponentCatalogByType(body?: SearchRequest | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/component-catalog/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportComponentCatalogByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportComponentCatalogByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportComponentCatalogByType(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportComponentProperties(group?: string | undefined, type?: string | undefined, searchText?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/component-properties/export?";
        if (group === null)
            throw new Error("The parameter 'group' cannot be null.");
        else if (group !== undefined)
            url_ += "group=" + encodeURIComponent("" + group) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportComponentProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportComponentProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportComponentProperties(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportValveProperties(group?: string | undefined, type?: string | undefined, searchText?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/valve-properties/export?";
        if (group === null)
            throw new Error("The parameter 'group' cannot be null.");
        else if (group !== undefined)
            url_ += "group=" + encodeURIComponent("" + group) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportValveProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportValveProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportValveProperties(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportApplications(searchText?: string | undefined, showAll?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/applications/export?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportApplications(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportBusinessUnits(searchText?: string | undefined, showAll?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/business-units/export?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBusinessUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBusinessUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportBusinessUnits(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportSpecifications(searchText?: string | undefined, showAll?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/specifications/export?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSpecifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSpecifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportSpecifications(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPipeClassSummaryProperties(propertyName?: string | undefined, searchText?: string | undefined, showAll?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/piping/dictionaries/pipe-class-summary-properties/export?";
        if (propertyName === null)
            throw new Error("The parameter 'propertyName' cannot be null.");
        else if (propertyName !== undefined)
            url_ += "propertyName=" + encodeURIComponent("" + propertyName) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPipeClassSummaryProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPipeClassSummaryProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportPipeClassSummaryProperties(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEsra1DocumentByRecordId(type: string, recordId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Document/esra1/{type}/{recordId}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEsra1DocumentByRecordId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEsra1DocumentByRecordId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetEsra1DocumentByRecordId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDocumentUploadDiagnostics(): Observable<DocumentUploadDiagnosticsViewModel> {
        let url_ = this.baseUrl + "/api/Document/esra1/uploads/diagnostics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentUploadDiagnostics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentUploadDiagnostics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentUploadDiagnosticsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentUploadDiagnosticsViewModel>;
        }));
    }

    protected processGetDocumentUploadDiagnostics(response: HttpResponseBase): Observable<DocumentUploadDiagnosticsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentUploadDiagnosticsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cleanupStatus (optional) 
     * @param cleanupReason (optional) 
     * @param jobId (optional) 
     * @param uploadedFileId (optional) 
     * @param eligibleOnly (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getDocumentCleanup(cleanupStatus?: DocumentCleanupStatus | undefined, cleanupReason?: DocumentCleanupReason | undefined, jobId?: string | undefined, uploadedFileId?: string | undefined, eligibleOnly?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<DocumentCleanupPageViewModel> {
        let url_ = this.baseUrl + "/api/Document/esra1/uploads/cleanup?";
        if (cleanupStatus === null)
            throw new Error("The parameter 'cleanupStatus' cannot be null.");
        else if (cleanupStatus !== undefined)
            url_ += "cleanupStatus=" + encodeURIComponent("" + cleanupStatus) + "&";
        if (cleanupReason === null)
            throw new Error("The parameter 'cleanupReason' cannot be null.");
        else if (cleanupReason !== undefined)
            url_ += "cleanupReason=" + encodeURIComponent("" + cleanupReason) + "&";
        if (jobId === null)
            throw new Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (uploadedFileId === null)
            throw new Error("The parameter 'uploadedFileId' cannot be null.");
        else if (uploadedFileId !== undefined)
            url_ += "uploadedFileId=" + encodeURIComponent("" + uploadedFileId) + "&";
        if (eligibleOnly === null)
            throw new Error("The parameter 'eligibleOnly' cannot be null.");
        else if (eligibleOnly !== undefined)
            url_ += "eligibleOnly=" + encodeURIComponent("" + eligibleOnly) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentCleanup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentCleanup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentCleanupPageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentCleanupPageViewModel>;
        }));
    }

    protected processGetDocumentCleanup(response: HttpResponseBase): Observable<DocumentCleanupPageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentCleanupPageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    probeDocumentUploadQueue(): Observable<DocumentUploadProbeResultViewModel> {
        let url_ = this.baseUrl + "/api/Document/esra1/uploads/diagnostics/probe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProbeDocumentUploadQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProbeDocumentUploadQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentUploadProbeResultViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentUploadProbeResultViewModel>;
        }));
    }

    protected processProbeDocumentUploadQueue(response: HttpResponseBase): Observable<DocumentUploadProbeResultViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentUploadProbeResultViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param indexFile (optional) 
     * @return OK
     */
    createDocumentUpload(type: ShareLinkClass, indexFile?: FileParameter | undefined): Observable<DocumentUploadPreviewViewModel> {
        let url_ = this.baseUrl + "/api/Document/esra1/{type}/uploads";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (indexFile === null || indexFile === undefined)
            throw new Error("The parameter 'indexFile' cannot be null.");
        else
            content_.append("IndexFile", indexFile.data, indexFile.fileName ? indexFile.fileName : "IndexFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDocumentUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDocumentUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentUploadPreviewViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentUploadPreviewViewModel>;
        }));
    }

    protected processCreateDocumentUpload(response: HttpResponseBase): Observable<DocumentUploadPreviewViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentUploadPreviewViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDocumentUpload(jobId: string): Observable<DocumentUploadPreviewViewModel> {
        let url_ = this.baseUrl + "/api/Document/esra1/uploads/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentUploadPreviewViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentUploadPreviewViewModel>;
        }));
    }

    protected processGetDocumentUpload(response: HttpResponseBase): Observable<DocumentUploadPreviewViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentUploadPreviewViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload does not exist, expired, was discarded, or belongs to another user. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    discardDocumentUpload(jobId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Document/esra1/uploads/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDiscardDocumentUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDiscardDocumentUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDiscardDocumentUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload does not exist, expired, was discarded, or belongs to another user. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload can no longer be changed, or was changed at the same time. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param indexFile (optional) 
     * @return OK
     */
    replaceDocumentUploadIndexFile(jobId: string, indexFile?: FileParameter | undefined): Observable<DocumentUploadPreviewViewModel> {
        let url_ = this.baseUrl + "/api/Document/esra1/uploads/{jobId}/index-file";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (indexFile === null || indexFile === undefined)
            throw new Error("The parameter 'indexFile' cannot be null.");
        else
            content_.append("IndexFile", indexFile.data, indexFile.fileName ? indexFile.fileName : "IndexFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceDocumentUploadIndexFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceDocumentUploadIndexFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentUploadPreviewViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentUploadPreviewViewModel>;
        }));
    }

    protected processReplaceDocumentUploadIndexFile(response: HttpResponseBase): Observable<DocumentUploadPreviewViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentUploadPreviewViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload does not exist, expired, was discarded, or belongs to another user. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload can no longer be changed, or was changed at the same time. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDocumentUploadRows(jobId: string, body?: UpdateDocumentIndexRowsRequest | undefined): Observable<DocumentUploadUpdateViewModel> {
        let url_ = this.baseUrl + "/api/Document/esra1/uploads/{jobId}/rows";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentUploadRows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentUploadRows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentUploadUpdateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentUploadUpdateViewModel>;
        }));
    }

    protected processUpdateDocumentUploadRows(response: HttpResponseBase): Observable<DocumentUploadUpdateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentUploadUpdateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload does not exist, expired, was discarded, or belongs to another user. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload can no longer be changed, or was changed at the same time. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documents (optional) 
     * @return OK
     */
    addDocumentUploadDocuments(jobId: string, documents?: FileParameter[] | undefined): Observable<DocumentUploadUpdateViewModel> {
        let url_ = this.baseUrl + "/api/Document/esra1/uploads/{jobId}/documents";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.data, item_.fileName ? item_.fileName : "Documents") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentUploadDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentUploadDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentUploadUpdateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentUploadUpdateViewModel>;
        }));
    }

    protected processAddDocumentUploadDocuments(response: HttpResponseBase): Observable<DocumentUploadUpdateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentUploadUpdateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload does not exist, expired, was discarded, or belongs to another user. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload can no longer be changed, or was changed at the same time. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileName (optional) 
     * @return OK
     */
    removeDocumentUploadDocument(jobId: string, fileName?: string | undefined): Observable<DocumentUploadUpdateViewModel> {
        let url_ = this.baseUrl + "/api/Document/esra1/uploads/{jobId}/documents?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDocumentUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDocumentUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentUploadUpdateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentUploadUpdateViewModel>;
        }));
    }

    protected processRemoveDocumentUploadDocument(response: HttpResponseBase): Observable<DocumentUploadUpdateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentUploadUpdateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload does not exist, expired, was discarded, or belongs to another user. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload can no longer be changed, or was changed at the same time. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    commitDocumentUpload(jobId: string, body?: DocumentUploadCommitRequest | undefined): Observable<DocumentUploadCommitResultViewModel> {
        let url_ = this.baseUrl + "/api/Document/esra1/uploads/{jobId}/commit";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommitDocumentUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommitDocumentUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentUploadCommitResultViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentUploadCommitResultViewModel>;
        }));
    }

    protected processCommitDocumentUpload(response: HttpResponseBase): Observable<DocumentUploadCommitResultViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentUploadCommitResultViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("The upload does not exist, expired, was discarded, or belongs to another user. The body is a text message.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = DocumentUploadCommitFailureViewModel.fromJS(resultData409);
            return throwException("The records were not created; the body explains why.", status, _responseText, _headers, result409);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentIndexTemplate(type: ShareLinkClass): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Document/esra1/{type}/template";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentIndexTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentIndexTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDocumentIndexTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPipeClassToExcel(pipeClassId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/exportToExcel/{pipeClassId}";
        if (pipeClassId === undefined || pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' must be defined.");
        url_ = url_.replace("{pipeClassId}", encodeURIComponent("" + pipeClassId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPipeClassToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPipeClassToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportPipeClassToExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPipeClassToPdf(pipeClassId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/exportToPdf/pipeclass/{pipeClassId}";
        if (pipeClassId === undefined || pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' must be defined.");
        url_ = url_.replace("{pipeClassId}", encodeURIComponent("" + pipeClassId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPipeClassToPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPipeClassToPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportPipeClassToPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportValveToPdf(valveId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/exportToPdf/valve/{valveId}";
        if (valveId === undefined || valveId === null)
            throw new Error("The parameter 'valveId' must be defined.");
        url_ = url_.replace("{valveId}", encodeURIComponent("" + valveId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportValveToPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportValveToPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportValveToPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportValveToExcel(valveId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/exportToExcel/valve/{valveId}";
        if (valveId === undefined || valveId === null)
            throw new Error("The parameter 'valveId' must be defined.");
        url_ = url_.replace("{valveId}", encodeURIComponent("" + valveId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportValveToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportValveToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportValveToExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportServiceDetailsDictionaryToExcel(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/exportServiceDetailsDictionary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportServiceDetailsDictionaryToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportServiceDetailsDictionaryToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportServiceDetailsDictionaryToExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportServicesDictionaryToExcel(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/exportServicesDictionary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportServicesDictionaryToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportServicesDictionaryToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportServicesDictionaryToExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCommonNotesDictionaryToExcel(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/exportCommonNotesDictionary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCommonNotesDictionaryToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCommonNotesDictionaryToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportCommonNotesDictionaryToExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportBranchTableCodesDictionaryToExcel(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/exportBranchTableCodesDictionary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBranchTableCodesDictionaryToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBranchTableCodesDictionaryToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportBranchTableCodesDictionaryToExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportComponentCatalogDictionaryToExcel(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/exportComponentCatalogDictionary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportComponentCatalogDictionaryToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportComponentCatalogDictionaryToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportComponentCatalogDictionaryToExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPressureTemperatureTablesToExcel(body?: string[] | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/exportToPressureTemperatureTablesToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPressureTemperatureTablesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPressureTemperatureTablesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportPressureTemperatureTablesToExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportBranchTablesToExcel(body?: string[] | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/exportBranchTablesToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBranchTablesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBranchTablesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportBranchTablesToExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEnvironmentalIndicatorData(): Observable<EnvironmentIndicatorViewModel> {
        let url_ = this.baseUrl + "/api/Indicator/getEnvironmentalIndicatorData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnvironmentalIndicatorData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnvironmentalIndicatorData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnvironmentIndicatorViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnvironmentIndicatorViewModel>;
        }));
    }

    protected processGetEnvironmentalIndicatorData(response: HttpResponseBase): Observable<EnvironmentIndicatorViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnvironmentIndicatorViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeNonCurrent (optional) 
     * @param body (optional) 
     * @return OK
     */
    pdfSearchPipingAndValves(includeNonCurrent?: boolean | undefined, body?: SearchRequest | undefined): Observable<SearchResponse_1OfPipingSearchResultViewModel> {
        let url_ = this.baseUrl + "/api/PdfPipeSearch/search?";
        if (includeNonCurrent === null)
            throw new Error("The parameter 'includeNonCurrent' cannot be null.");
        else if (includeNonCurrent !== undefined)
            url_ += "includeNonCurrent=" + encodeURIComponent("" + includeNonCurrent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPdfSearchPipingAndValves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPdfSearchPipingAndValves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse_1OfPipingSearchResultViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse_1OfPipingSearchResultViewModel>;
        }));
    }

    protected processPdfSearchPipingAndValves(response: HttpResponseBase): Observable<SearchResponse_1OfPipingSearchResultViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse_1OfPipingSearchResultViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPdfPipingFiltersByObjectType(objectType: PipingObjectType): Observable<PipingSearchFilterModel[]> {
        let url_ = this.baseUrl + "/api/PdfPipingFilters/filtersByObjectType/{objectType}";
        if (objectType === undefined || objectType === null)
            throw new Error("The parameter 'objectType' must be defined.");
        url_ = url_.replace("{objectType}", encodeURIComponent("" + objectType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfPipingFiltersByObjectType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfPipingFiltersByObjectType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipingSearchFilterModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipingSearchFilterModel[]>;
        }));
    }

    protected processGetPdfPipingFiltersByObjectType(response: HttpResponseBase): Observable<PipingSearchFilterModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipingSearchFilterModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPipeClassByPipeClassId(pipeClassId: string): Observable<PipeClassViewModel> {
        let url_ = this.baseUrl + "/api/PipeClass/{pipeClassId}";
        if (pipeClassId === undefined || pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' must be defined.");
        url_ = url_.replace("{pipeClassId}", encodeURIComponent("" + pipeClassId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipeClassByPipeClassId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipeClassByPipeClassId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassViewModel>;
        }));
    }

    protected processGetPipeClassByPipeClassId(response: HttpResponseBase): Observable<PipeClassViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PipeClassViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    pipeClassShareLink(pipeClassId: string): Observable<ShareLinkResponse> {
        let url_ = this.baseUrl + "/api/PipeClass/ShareLink/{pipeClassId}";
        if (pipeClassId === undefined || pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' must be defined.");
        url_ = url_.replace("{pipeClassId}", encodeURIComponent("" + pipeClassId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPipeClassShareLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPipeClassShareLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareLinkResponse>;
        }));
    }

    protected processPipeClassShareLink(response: HttpResponseBase): Observable<ShareLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShareLinkResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    pipeClassPdfShareLink(recordId: string): Observable<ShareLinkResponse> {
        let url_ = this.baseUrl + "/api/PipeClass/PdfShareLink/{recordId}";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPipeClassPdfShareLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPipeClassPdfShareLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareLinkResponse>;
        }));
    }

    protected processPipeClassPdfShareLink(response: HttpResponseBase): Observable<ShareLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShareLinkResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessUnit (optional) 
     * @return OK
     */
    getPipeClassByName(pipeClassName: string, businessUnit?: string | undefined): Observable<PipeClassViewModel> {
        let url_ = this.baseUrl + "/api/PipeClass/{pipeClassName}?";
        if (pipeClassName === undefined || pipeClassName === null)
            throw new Error("The parameter 'pipeClassName' must be defined.");
        url_ = url_.replace("{pipeClassName}", encodeURIComponent("" + pipeClassName));
        if (businessUnit === null)
            throw new Error("The parameter 'businessUnit' cannot be null.");
        else if (businessUnit !== undefined)
            url_ += "businessUnit=" + encodeURIComponent("" + businessUnit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipeClassByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipeClassByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassViewModel>;
        }));
    }

    protected processGetPipeClassByName(response: HttpResponseBase): Observable<PipeClassViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PipeClassViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPipeClassesByCommonNoteId(commonNoteId: string): Observable<PipeClassViewModel[]> {
        let url_ = this.baseUrl + "/api/PipeClass/GetActivePipeClassesFromCommonNoteId/{commonNoteId}";
        if (commonNoteId === undefined || commonNoteId === null)
            throw new Error("The parameter 'commonNoteId' must be defined.");
        url_ = url_.replace("{commonNoteId}", encodeURIComponent("" + commonNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipeClassesByCommonNoteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipeClassesByCommonNoteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassViewModel[]>;
        }));
    }

    protected processGetPipeClassesByCommonNoteId(response: HttpResponseBase): Observable<PipeClassViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipeClassViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPipeClassesByServiceId(serviceId: string): Observable<PipeClassViewModel[]> {
        let url_ = this.baseUrl + "/api/PipeClass/GetActivePipeClassesFromServiceId/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipeClassesByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipeClassesByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassViewModel[]>;
        }));
    }

    protected processGetPipeClassesByServiceId(response: HttpResponseBase): Observable<PipeClassViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipeClassViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPipeClassesByServiceDetailId(serviceDetailId: string): Observable<PipeClassViewModel[]> {
        let url_ = this.baseUrl + "/api/PipeClass/GetActivePipeClassesFromServiceDetailId/{serviceDetailId}";
        if (serviceDetailId === undefined || serviceDetailId === null)
            throw new Error("The parameter 'serviceDetailId' must be defined.");
        url_ = url_.replace("{serviceDetailId}", encodeURIComponent("" + serviceDetailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipeClassesByServiceDetailId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipeClassesByServiceDetailId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassViewModel[]>;
        }));
    }

    protected processGetPipeClassesByServiceDetailId(response: HttpResponseBase): Observable<PipeClassViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipeClassViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPipeClassesByBranchTableId(branchTableId: string): Observable<PipeClassViewModel[]> {
        let url_ = this.baseUrl + "/api/PipeClass/GetActivePipeClassesFromBranchTableId/{branchTableId}";
        if (branchTableId === undefined || branchTableId === null)
            throw new Error("The parameter 'branchTableId' must be defined.");
        url_ = url_.replace("{branchTableId}", encodeURIComponent("" + branchTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipeClassesByBranchTableId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipeClassesByBranchTableId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassViewModel[]>;
        }));
    }

    protected processGetPipeClassesByBranchTableId(response: HttpResponseBase): Observable<PipeClassViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipeClassViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPipeClassesByPressureTemperatureTableId(pressureTemperatureTableId: string): Observable<PipeClassViewModel[]> {
        let url_ = this.baseUrl + "/api/PipeClass/GetActivePipeClassesFromPressureTemperatureTableId/{pressureTemperatureTableId}";
        if (pressureTemperatureTableId === undefined || pressureTemperatureTableId === null)
            throw new Error("The parameter 'pressureTemperatureTableId' must be defined.");
        url_ = url_.replace("{pressureTemperatureTableId}", encodeURIComponent("" + pressureTemperatureTableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipeClassesByPressureTemperatureTableId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipeClassesByPressureTemperatureTableId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassViewModel[]>;
        }));
    }

    protected processGetPipeClassesByPressureTemperatureTableId(response: HttpResponseBase): Observable<PipeClassViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipeClassViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRelatedPipeClassesByComponentId(componentId: string): Observable<PipeClassViewModel[]> {
        let url_ = this.baseUrl + "/api/PipeClass/GetRelatedPipeClassesByComponentId/{componentId}";
        if (componentId === undefined || componentId === null)
            throw new Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelatedPipeClassesByComponentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatedPipeClassesByComponentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassViewModel[]>;
        }));
    }

    protected processGetRelatedPipeClassesByComponentId(response: HttpResponseBase): Observable<PipeClassViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipeClassViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing pipe class
     * @param body (optional) 
     * @return OK
     */
    updatePipeClass(body?: PipeClassViewModel | undefined): Observable<PipeClassViewModel> {
        let url_ = this.baseUrl + "/api/PipeClass/UpdatePipeClass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePipeClass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePipeClass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassViewModel>;
        }));
    }

    protected processUpdatePipeClass(response: HttpResponseBase): Observable<PipeClassViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PipeClassViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new pipe class from scratch
     * @param body (optional) 
     * @return OK
     */
    createPipeClass(body?: CreatePipeClassRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/PipeClass/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePipeClass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePipeClass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreatePipeClass(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retire a pipe class
     * @param body (optional) 
     * @return OK
     */
    retirePipeClass(pipeClassId: string, body?: RetirePipeClassRequest | undefined): Observable<SimpleRevisionViewModel> {
        let url_ = this.baseUrl + "/api/PipeClass/{pipeClassId}/retire";
        if (pipeClassId === undefined || pipeClassId === null)
            throw new Error("The parameter 'pipeClassId' must be defined.");
        url_ = url_.replace("{pipeClassId}", encodeURIComponent("" + pipeClassId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetirePipeClass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetirePipeClass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleRevisionViewModel>;
        }));
    }

    protected processRetirePipeClass(response: HttpResponseBase): Observable<SimpleRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns distinct DesignCode values for frontend filters
     * @return OK
     */
    getDistinctDesignCodes(): Observable<DesignCodeViewModel[]> {
        let url_ = this.baseUrl + "/api/PipeClass/GetDistinctDesignCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistinctDesignCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistinctDesignCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignCodeViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignCodeViewModel[]>;
        }));
    }

    protected processGetDistinctDesignCodes(response: HttpResponseBase): Observable<DesignCodeViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DesignCodeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check pipe class name availability before cloning
     * @param name (optional) 
     * @param businessUnit (optional) 
     * @param application (optional) 
     * @return OK
     */
    checkPipeClassNameAvailability(name?: string | undefined, businessUnit?: string | undefined, application?: string | undefined): Observable<PipeClassNameAvailabilityViewModel> {
        let url_ = this.baseUrl + "/api/PipeClass/CheckNameAvailability?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (businessUnit === null)
            throw new Error("The parameter 'businessUnit' cannot be null.");
        else if (businessUnit !== undefined)
            url_ += "businessUnit=" + encodeURIComponent("" + businessUnit) + "&";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPipeClassNameAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPipeClassNameAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassNameAvailabilityViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassNameAvailabilityViewModel>;
        }));
    }

    protected processCheckPipeClassNameAvailability(response: HttpResponseBase): Observable<PipeClassNameAvailabilityViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PipeClassNameAvailabilityViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Clone an existing pipe class as a new Draft
     * @param body (optional) 
     * @return OK
     */
    cloneDraftPipeClass(body?: CloneDraftPipeClassRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/PipeClass/CloneDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneDraftPipeClass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneDraftPipeClass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCloneDraftPipeClass(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPipeClassSummaryPropertyDictionaryById(id: string): Observable<PipeClassSummaryPropertyDictionaryViewModel> {
        let url_ = this.baseUrl + "/PipeClassSummaryPropertyDictionary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipeClassSummaryPropertyDictionaryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipeClassSummaryPropertyDictionaryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassSummaryPropertyDictionaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassSummaryPropertyDictionaryViewModel>;
        }));
    }

    protected processGetPipeClassSummaryPropertyDictionaryById(response: HttpResponseBase): Observable<PipeClassSummaryPropertyDictionaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PipeClassSummaryPropertyDictionaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param propertyName (optional) 
     * @param searchQuery (optional) 
     * @param pageNumber (optional) 
     * @param numberOfResults (optional) 
     * @param showAll (optional) 
     * @return OK
     */
    getAllPipeClassSummaryPropertyDictionaryPaged(propertyName?: string | undefined, searchQuery?: string | undefined, pageNumber?: number | undefined, numberOfResults?: number | undefined, showAll?: boolean | undefined): Observable<PipeClassSummaryPropertyDictionaryViewModel[]> {
        let url_ = this.baseUrl + "/PipeClassSummaryPropertyDictionary/GetAllPaged?";
        if (propertyName === null)
            throw new Error("The parameter 'propertyName' cannot be null.");
        else if (propertyName !== undefined)
            url_ += "propertyName=" + encodeURIComponent("" + propertyName) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' cannot be null.");
        else if (numberOfResults !== undefined)
            url_ += "numberOfResults=" + encodeURIComponent("" + numberOfResults) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPipeClassSummaryPropertyDictionaryPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPipeClassSummaryPropertyDictionaryPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassSummaryPropertyDictionaryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassSummaryPropertyDictionaryViewModel[]>;
        }));
    }

    protected processGetAllPipeClassSummaryPropertyDictionaryPaged(response: HttpResponseBase): Observable<PipeClassSummaryPropertyDictionaryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipeClassSummaryPropertyDictionaryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param propertyName (optional) 
     * @param value (optional) 
     * @return Created
     */
    createPipeClassSummaryPropertyDictionary(propertyName?: string | undefined, value?: string | undefined): Observable<PipeClassSummaryPropertyDictionaryViewModel> {
        let url_ = this.baseUrl + "/PipeClassSummaryPropertyDictionary/Create?";
        if (propertyName === null)
            throw new Error("The parameter 'propertyName' cannot be null.");
        else if (propertyName !== undefined)
            url_ += "propertyName=" + encodeURIComponent("" + propertyName) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePipeClassSummaryPropertyDictionary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePipeClassSummaryPropertyDictionary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassSummaryPropertyDictionaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassSummaryPropertyDictionaryViewModel>;
        }));
    }

    protected processCreatePipeClassSummaryPropertyDictionary(response: HttpResponseBase): Observable<PipeClassSummaryPropertyDictionaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PipeClassSummaryPropertyDictionaryViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    togglePipeClassSummaryPropertyDictionaryStatus(id: string): Observable<PipeClassSummaryPropertyDictionaryViewModel> {
        let url_ = this.baseUrl + "/PipeClassSummaryPropertyDictionary/ToggleStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTogglePipeClassSummaryPropertyDictionaryStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTogglePipeClassSummaryPropertyDictionaryStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipeClassSummaryPropertyDictionaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipeClassSummaryPropertyDictionaryViewModel>;
        }));
    }

    protected processTogglePipeClassSummaryPropertyDictionaryStatus(response: HttpResponseBase): Observable<PipeClassSummaryPropertyDictionaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PipeClassSummaryPropertyDictionaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeNonCurrent (optional) 
     * @param body (optional) 
     * @return OK
     */
    searchPipingAndValves(includeNonCurrent?: boolean | undefined, body?: SearchRequest | undefined): Observable<PipingSearchResponse_1OfPipingSearchResultViewModel> {
        let url_ = this.baseUrl + "/api/PipeSearch/search?";
        if (includeNonCurrent === null)
            throw new Error("The parameter 'includeNonCurrent' cannot be null.");
        else if (includeNonCurrent !== undefined)
            url_ += "includeNonCurrent=" + encodeURIComponent("" + includeNonCurrent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPipingAndValves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPipingAndValves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipingSearchResponse_1OfPipingSearchResultViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipingSearchResponse_1OfPipingSearchResultViewModel>;
        }));
    }

    protected processSearchPipingAndValves(response: HttpResponseBase): Observable<PipingSearchResponse_1OfPipingSearchResultViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PipingSearchResponse_1OfPipingSearchResultViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPipingFilters(): Observable<PipingSearchFilterViewModel[]> {
        let url_ = this.baseUrl + "/api/PipingFilters/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipingFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipingFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipingSearchFilterViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipingSearchFilterViewModel[]>;
        }));
    }

    protected processGetPipingFilters(response: HttpResponseBase): Observable<PipingSearchFilterViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipingSearchFilterViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPressureTemperatureTableByName(tableName: string): Observable<PressureTemperatureTableViewModel> {
        let url_ = this.baseUrl + "/PressureTemperatureTable/GetPressureTemperatureTableByTableName/{tableName}";
        if (tableName === undefined || tableName === null)
            throw new Error("The parameter 'tableName' must be defined.");
        url_ = url_.replace("{tableName}", encodeURIComponent("" + tableName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPressureTemperatureTableByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPressureTemperatureTableByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressureTemperatureTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressureTemperatureTableViewModel>;
        }));
    }

    protected processGetPressureTemperatureTableByName(response: HttpResponseBase): Observable<PressureTemperatureTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PressureTemperatureTableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param numberResults (optional) 
     * @param sortDirection (optional) 
     * @param searchQuery (optional) 
     * @param showActiveOnly (optional) 
     * @return OK
     */
    getPaginatedPressureTemperatureTables(pageNumber?: number | undefined, numberResults?: number | undefined, sortDirection?: string | undefined, searchQuery?: string | undefined, showActiveOnly?: boolean | undefined): Observable<SearchResponse_1OfPressureTemperatureTableViewModel> {
        let url_ = this.baseUrl + "/PressureTemperatureTable/GetPaginatedPressureTemperatureTables?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (numberResults === null)
            throw new Error("The parameter 'numberResults' cannot be null.");
        else if (numberResults !== undefined)
            url_ += "numberResults=" + encodeURIComponent("" + numberResults) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (showActiveOnly === null)
            throw new Error("The parameter 'showActiveOnly' cannot be null.");
        else if (showActiveOnly !== undefined)
            url_ += "showActiveOnly=" + encodeURIComponent("" + showActiveOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginatedPressureTemperatureTables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginatedPressureTemperatureTables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse_1OfPressureTemperatureTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse_1OfPressureTemperatureTableViewModel>;
        }));
    }

    protected processGetPaginatedPressureTemperatureTables(response: HttpResponseBase): Observable<SearchResponse_1OfPressureTemperatureTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse_1OfPressureTemperatureTableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPressureTemperatureTable(body?: PressureTemperatureTableViewModel | undefined): Observable<PressureTemperatureTableViewModel> {
        let url_ = this.baseUrl + "/PressureTemperatureTable/CreatePressureTemperatureTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePressureTemperatureTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePressureTemperatureTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressureTemperatureTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressureTemperatureTableViewModel>;
        }));
    }

    protected processCreatePressureTemperatureTable(response: HttpResponseBase): Observable<PressureTemperatureTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PressureTemperatureTableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updatePressureTemperatureTable(body?: PressureTemperatureTableViewModel | undefined): Observable<PressureTemperatureTableViewModel> {
        let url_ = this.baseUrl + "/PressureTemperatureTable/UpdatePressureTemperatureTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePressureTemperatureTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePressureTemperatureTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressureTemperatureTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressureTemperatureTableViewModel>;
        }));
    }

    protected processUpdatePressureTemperatureTable(response: HttpResponseBase): Observable<PressureTemperatureTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = PressureTemperatureTableViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param body (optional) 
     * @return OK
     */
    toggleIsActivePTTable(isActive?: boolean | undefined, body?: string[] | undefined): Observable<PressureTemperatureTableViewModel[]> {
        let url_ = this.baseUrl + "/PressureTemperatureTable/ToggleIsActivePTTable?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleIsActivePTTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleIsActivePTTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressureTemperatureTableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressureTemperatureTableViewModel[]>;
        }));
    }

    protected processToggleIsActivePTTable(response: HttpResponseBase): Observable<PressureTemperatureTableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PressureTemperatureTableViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    archivePressureTemperatureTable(tableId: string): Observable<PressureTemperatureTableViewModel> {
        let url_ = this.baseUrl + "/PressureTemperatureTable/archive/{tableId}";
        if (tableId === undefined || tableId === null)
            throw new Error("The parameter 'tableId' must be defined.");
        url_ = url_.replace("{tableId}", encodeURIComponent("" + tableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchivePressureTemperatureTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchivePressureTemperatureTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressureTemperatureTableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressureTemperatureTableViewModel>;
        }));
    }

    protected processArchivePressureTemperatureTable(response: HttpResponseBase): Observable<PressureTemperatureTableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PressureTemperatureTableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates if a PTT is current and returns latest version if not
     * @return OK
     */
    validateAndGetLatestPressureTemperatureTable(tableId: string): Observable<PressureTemperatureTableValidationResult> {
        let url_ = this.baseUrl + "/PressureTemperatureTable/ValidateAndGetLatest/{tableId}";
        if (tableId === undefined || tableId === null)
            throw new Error("The parameter 'tableId' must be defined.");
        url_ = url_.replace("{tableId}", encodeURIComponent("" + tableId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAndGetLatestPressureTemperatureTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAndGetLatestPressureTemperatureTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressureTemperatureTableValidationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressureTemperatureTableValidationResult>;
        }));
    }

    protected processValidateAndGetLatestPressureTemperatureTable(response: HttpResponseBase): Observable<PressureTemperatureTableValidationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PressureTemperatureTableValidationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Individual revisions are not populated by this endpoint.
     * @return OK
     */
    listReleases(): Observable<ReleaseForDashboardViewModel[]> {
        let url_ = this.baseUrl + "/Release/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListReleases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListReleases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseForDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseForDashboardViewModel[]>;
        }));
    }

    protected processListReleases(response: HttpResponseBase): Observable<ReleaseForDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReleaseForDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the full detail of a release including all object groups with their chosen actions and per-role approval states.
     * @return OK
     */
    getReleaseById(id: string): Observable<ReleaseDetailViewModel> {
        let url_ = this.baseUrl + "/Release/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReleaseById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReleaseById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseDetailViewModel>;
        }));
    }

    protected processGetReleaseById(response: HttpResponseBase): Observable<ReleaseDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseDetailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove a DRAFT release when the current user is the author.
     * @return No Content
     */
    removeReleaseById(id: string): Observable<void> {
        let url_ = this.baseUrl + "/Release/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveReleaseById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveReleaseById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveReleaseById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save the release object group actions (release as-is / retire / revise) for a DRAFT release.
     * @param body (optional) 
     * @return OK
     */
    saveReleaseById(id: string, body?: ReleaseDetailViewModel | undefined): Observable<ReleaseDetailViewModel> {
        let url_ = this.baseUrl + "/Release/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveReleaseById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveReleaseById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseDetailViewModel>;
        }));
    }

    protected processSaveReleaseById(response: HttpResponseBase): Observable<ReleaseDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseDetailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Immediately save the action for a single release object group within a DRAFT release.
     * @param body (optional) 
     * @return OK
     */
    saveReleaseObjectGroup(id: string, objectGroupId: string, body?: ReleaseObjectGroupViewModel | undefined): Observable<ReleaseObjectGroupViewModel> {
        let url_ = this.baseUrl + "/Release/{id}/object-groups/{objectGroupId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (objectGroupId === undefined || objectGroupId === null)
            throw new Error("The parameter 'objectGroupId' must be defined.");
        url_ = url_.replace("{objectGroupId}", encodeURIComponent("" + objectGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveReleaseObjectGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveReleaseObjectGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseObjectGroupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseObjectGroupViewModel>;
        }));
    }

    protected processSaveReleaseObjectGroup(response: HttpResponseBase): Observable<ReleaseObjectGroupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseObjectGroupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all dropdown options for the Create Release wizard (Business Units, Applications, Specifications).
     * @return OK
     */
    getWizardOptions(): Observable<CreateReleaseWizardOptionsViewModel> {
        let url_ = this.baseUrl + "/Release/wizard/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWizardOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWizardOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateReleaseWizardOptionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateReleaseWizardOptionsViewModel>;
        }));
    }

    protected processGetWizardOptions(response: HttpResponseBase): Observable<CreateReleaseWizardOptionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateReleaseWizardOptionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get filtered Valve releases for linked release dropdown by business unit and application.
     * @param businessUnitId (optional) 
     * @param applicationId (optional) 
     * @return OK
     */
    getValveReleasesForDropdown(businessUnitId?: string | undefined, applicationId?: string | undefined): Observable<ValveReleaseLookupViewModel[]> {
        let url_ = this.baseUrl + "/Release/wizard/valve-releases?";
        if (businessUnitId === null)
            throw new Error("The parameter 'businessUnitId' cannot be null.");
        else if (businessUnitId !== undefined)
            url_ += "businessUnitId=" + encodeURIComponent("" + businessUnitId) + "&";
        if (applicationId === null)
            throw new Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValveReleasesForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValveReleasesForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveReleaseLookupViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveReleaseLookupViewModel[]>;
        }));
    }

    protected processGetValveReleasesForDropdown(response: HttpResponseBase): Observable<ValveReleaseLookupViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveReleaseLookupViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get DRAFT Valve releases filtered by business unit name and application name. Used to populate the release selector when creating or cloning a valve.
     * @param businessUnitName (optional) 
     * @param applicationName (optional) 
     * @return OK
     */
    getValveReleasesForValveCreation(businessUnitName?: string | undefined, applicationName?: string | undefined): Observable<ValveReleaseLookupViewModel[]> {
        let url_ = this.baseUrl + "/Release/valve-releases/by-names?";
        if (businessUnitName === null)
            throw new Error("The parameter 'businessUnitName' cannot be null.");
        else if (businessUnitName !== undefined)
            url_ += "businessUnitName=" + encodeURIComponent("" + businessUnitName) + "&";
        if (applicationName === null)
            throw new Error("The parameter 'applicationName' cannot be null.");
        else if (applicationName !== undefined)
            url_ += "applicationName=" + encodeURIComponent("" + applicationName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValveReleasesForValveCreation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValveReleasesForValveCreation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveReleaseLookupViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveReleaseLookupViewModel[]>;
        }));
    }

    protected processGetValveReleasesForValveCreation(response: HttpResponseBase): Observable<ValveReleaseLookupViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveReleaseLookupViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get DRAFT Pipe Class releases filtered by business unit name and application name. Used to populate the release selector when creating a pipe class from scratch.
     * @param businessUnitName (optional) 
     * @param applicationName (optional) 
     * @return OK
     */
    getPipeClassReleasesForCreation(businessUnitName?: string | undefined, applicationName?: string | undefined): Observable<ValveReleaseLookupViewModel[]> {
        let url_ = this.baseUrl + "/Release/pipe-class-releases/by-names?";
        if (businessUnitName === null)
            throw new Error("The parameter 'businessUnitName' cannot be null.");
        else if (businessUnitName !== undefined)
            url_ += "businessUnitName=" + encodeURIComponent("" + businessUnitName) + "&";
        if (applicationName === null)
            throw new Error("The parameter 'applicationName' cannot be null.");
        else if (applicationName !== undefined)
            url_ += "applicationName=" + encodeURIComponent("" + applicationName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipeClassReleasesForCreation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipeClassReleasesForCreation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveReleaseLookupViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveReleaseLookupViewModel[]>;
        }));
    }

    protected processGetPipeClassReleasesForCreation(response: HttpResponseBase): Observable<ValveReleaseLookupViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveReleaseLookupViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new Release with initial Revision from the wizard data.
     * @param body (optional) 
     * @return Created
     */
    createReleaseFromWizard(body?: CreateReleaseWizardViewModel | undefined): Observable<ReleaseForDashboardViewModel> {
        let url_ = this.baseUrl + "/Release/wizard/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReleaseFromWizard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReleaseFromWizard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseForDashboardViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseForDashboardViewModel>;
        }));
    }

    protected processCreateReleaseFromWizard(response: HttpResponseBase): Observable<ReleaseForDashboardViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ReleaseForDashboardViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add one or more pipe classes to a DRAFT release.
     * @param body (optional) 
     * @return OK
     */
    addPipeClassesToRelease(id: string, body?: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Release/{id}/pipeClasses/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPipeClassesToRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPipeClassesToRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddPipeClassesToRelease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add one or more valves to a DRAFT release.
     * @param body (optional) 
     * @return OK
     */
    addValvesToRelease(id: string, body?: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Release/{id}/valves/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddValvesToRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddValvesToRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddValvesToRelease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove one or more pipe classes from a DRAFT release.
     * @param body (optional) 
     * @return OK
     */
    removePipeClassesFromRelease(id: string, body?: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Release/{id}/pipeClasses/remove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePipeClassesFromRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePipeClassesFromRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemovePipeClassesFromRelease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove one or more valves from a DRAFT release.
     * @param body (optional) 
     * @return OK
     */
    removeValvesFromRelease(id: string, body?: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Release/{id}/valves/remove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveValvesFromRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveValvesFromRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveValvesFromRelease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Replace all non-author roles on a DRAFT release and sync to per-object approval rows.
     * @param body (optional) 
     * @return OK
     */
    updateReleaseMembers(id: string, body?: RoleViewModel[] | undefined): Observable<RoleViewModel[]> {
        let url_ = this.baseUrl + "/Release/{id}/members";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReleaseMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReleaseMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel[]>;
        }));
    }

    protected processUpdateReleaseMembers(response: HttpResponseBase): Observable<RoleViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releaseToExcel(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Release/{id}/excel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReleaseToExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeReleaseStatus(id: string, body?: ReleaseStatus | undefined): Observable<ReleaseDetailViewModel> {
        let url_ = this.baseUrl + "/Release/{id}/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeReleaseStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeReleaseStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseDetailViewModel>;
        }));
    }

    protected processChangeReleaseStatus(response: HttpResponseBase): Observable<ReleaseDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseDetailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : _responseText;
                result501 = resultData501 !== undefined ? resultData501 : <any>null;
    
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all comments for a release, as a nested tree of root comments and replies.
     * @param releaseId (optional) 
     * @return OK
     */
    getComments2(releaseId?: string | undefined): Observable<ReleaseCommentViewModel[]> {
        let url_ = this.baseUrl + "/api/ReleaseComments?";
        if (releaseId === null)
            throw new Error("The parameter 'releaseId' cannot be null.");
        else if (releaseId !== undefined)
            url_ += "releaseId=" + encodeURIComponent("" + releaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComments2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComments2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseCommentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseCommentViewModel[]>;
        }));
    }

    protected processGetComments2(response: HttpResponseBase): Observable<ReleaseCommentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReleaseCommentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a single root comment on a release.
     * @param body (optional) 
     * @return Created
     */
    createComment2(body?: CreateReleaseCommentRequest | undefined): Observable<ReleaseCommentViewModel> {
        let url_ = this.baseUrl + "/api/ReleaseComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateComment2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComment2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseCommentViewModel>;
        }));
    }

    protected processCreateComment2(response: HttpResponseBase): Observable<ReleaseCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ReleaseCommentViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the total number of comments for a release.
     * @param releaseId (optional) 
     * @return OK
     */
    getCommentCount2(releaseId?: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/ReleaseComments/count?";
        if (releaseId === null)
            throw new Error("The parameter 'releaseId' cannot be null.");
        else if (releaseId !== undefined)
            url_ += "releaseId=" + encodeURIComponent("" + releaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentCount2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentCount2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCommentCount2(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a reply to a root comment. Replying to a reply is not allowed.
     * @param body (optional) 
     * @return Created
     */
    addReply2(parentCommentId: string, body?: AddReleaseCommentReplyRequest | undefined): Observable<ReleaseCommentViewModel> {
        let url_ = this.baseUrl + "/api/ReleaseComments/{parentCommentId}/reply";
        if (parentCommentId === undefined || parentCommentId === null)
            throw new Error("The parameter 'parentCommentId' must be defined.");
        url_ = url_.replace("{parentCommentId}", encodeURIComponent("" + parentCommentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReply2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReply2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseCommentViewModel>;
        }));
    }

    protected processAddReply2(response: HttpResponseBase): Observable<ReleaseCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ReleaseCommentViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the content of your own comment.
     * @param body (optional) 
     * @return OK
     */
    updateComment2(commentId: string, body?: UpdateReleaseCommentRequest | undefined): Observable<ReleaseCommentViewModel> {
        let url_ = this.baseUrl + "/api/ReleaseComments/{commentId}";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComment2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComment2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseCommentViewModel>;
        }));
    }

    protected processUpdateComment2(response: HttpResponseBase): Observable<ReleaseCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseCommentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete your own comment. Comments with replies cannot be deleted.
     * @return OK
     */
    deleteComment2(commentId: string): Observable<ReleaseCommentViewModel> {
        let url_ = this.baseUrl + "/api/ReleaseComments/{commentId}";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComment2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComment2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseCommentViewModel>;
        }));
    }

    protected processDeleteComment2(response: HttpResponseBase): Observable<ReleaseCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseCommentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the resolution status of a comment (any participant of the release).
     * @param body (optional) 
     * @return OK
     */
    updateResolutionStatus(commentId: string, body?: UpdateReleaseCommentResolutionStatusRequest | undefined): Observable<ReleaseCommentViewModel> {
        let url_ = this.baseUrl + "/api/ReleaseComments/{commentId}/resolution-status";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateResolutionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateResolutionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseCommentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseCommentViewModel>;
        }));
    }

    protected processUpdateResolutionStatus(response: HttpResponseBase): Observable<ReleaseCommentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseCommentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the tab-badge summary for all Final System Checks sections. Used to drive badge indicators and the global Publish button state.
     * @return OK
     */
    getSummary(releaseId: string): Observable<ReleaseFinalChecksSummaryDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseFinalChecksSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseFinalChecksSummaryDto>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<ReleaseFinalChecksSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseFinalChecksSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get full Valve Status section: validation status for every valve referenced by pipe classes in the release.
     * @return OK
     */
    getValveStatus(releaseId: string): Observable<ValveStatusValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/valve-status";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValveStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValveStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveStatusValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveStatusValidationDto>;
        }));
    }

    protected processGetValveStatus(response: HttpResponseBase): Observable<ValveStatusValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveStatusValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export the Valve Status section to an Excel file, one row per pipe-class occurrence of each valve.
     */
    exportValveStatus(releaseId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/valve-status/excel";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportValveStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportValveStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportValveStatus(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the selected valves to their latest published revision across every pipe class being revised in the release. Per-pipe-class overrides and common notes are carried over to the new version.
     * @param body (optional) 
     * @return OK
     */
    updateValvesToLatestVersion(releaseId: string, body?: ValveVersionUpdateRequestDto | undefined): Observable<ValveVersionUpdateResultDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/valve-status/update-to-latest";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateValvesToLatestVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateValvesToLatestVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveVersionUpdateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveVersionUpdateResultDto>;
        }));
    }

    protected processUpdateValvesToLatestVersion(response: HttpResponseBase): Observable<ValveVersionUpdateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveVersionUpdateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Re-enable a valve whose catalog components were disabled. Requires the same dictionary-write permission used to disable them.
     * @param body (optional) 
     * @return OK
     */
    enableValve(releaseId: string, body?: ValveActivationRequestDto | undefined): Observable<ValveStatusValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/valve-status/enable";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableValve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableValve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveStatusValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveStatusValidationDto>;
        }));
    }

    protected processEnableValve(response: HttpResponseBase): Observable<ValveStatusValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveStatusValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Turn the release-wide 'proceed without updates' acknowledgement on or off. When on, every draft / disabled / superseded valve counts as acknowledged and no longer blocks publishing.
     * @param body (optional) 
     * @return OK
     */
    setProceedWithoutUpdates(releaseId: string, body?: ValveProceedWithoutUpdatesRequestDto | undefined): Observable<ValveStatusValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/valve-status/proceed-without-updates";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProceedWithoutUpdates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProceedWithoutUpdates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveStatusValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveStatusValidationDto>;
        }));
    }

    protected processSetProceedWithoutUpdates(response: HttpResponseBase): Observable<ValveStatusValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveStatusValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Valve Description discrepancies only (old vs new short description differences), grouped by pipe-class action.
     * @return OK
     */
    getValveDescriptions(releaseId: string): Observable<ValveDescriptionValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/valve-descriptions";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValveDescriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValveDescriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveDescriptionValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveDescriptionValidationDto>;
        }));
    }

    protected processGetValveDescriptions(response: HttpResponseBase): Observable<ValveDescriptionValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveDescriptionValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export the Valve Description Update Final System Checks section to Excel.
     */
    exportValveDescriptions(releaseId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/valve-descriptions/excel";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportValveDescriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportValveDescriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportValveDescriptions(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save the user's read-only choice (KeepCurrent / UseGenerated) for one or more pipe-class occurrences of a valve description mismatch.
     * @param body (optional) 
     * @return OK
     */
    saveValveDescriptionChoice(releaseId: string, body?: ValveDescriptionChoiceRequestDto | undefined): Observable<ValveDescriptionValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/valve-descriptions/choose";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveValveDescriptionChoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveValveDescriptionChoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveDescriptionValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveDescriptionValidationDto>;
        }));
    }

    protected processSaveValveDescriptionChoice(response: HttpResponseBase): Observable<ValveDescriptionValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveDescriptionValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Apply KeepCurrent or UseGenerated to every unresolved Valve Description conflict in the release.
     * @param body (optional) 
     * @return OK
     */
    saveAllValveDescriptionChoices(releaseId: string, body?: ValveDescriptionBulkChoiceRequestDto | undefined): Observable<ValveDescriptionValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/valve-descriptions/choose-all";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAllValveDescriptionChoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAllValveDescriptionChoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveDescriptionValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveDescriptionValidationDto>;
        }));
    }

    protected processSaveAllValveDescriptionChoices(response: HttpResponseBase): Observable<ValveDescriptionValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveDescriptionValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get full Inactive Components section: all inactive components found in pipe-class clones of this release.
     * @return OK
     */
    getInactiveComponents(releaseId: string): Observable<InactiveComponentsValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/inactive-components";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInactiveComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInactiveComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InactiveComponentsValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InactiveComponentsValidationDto>;
        }));
    }

    protected processGetInactiveComponents(response: HttpResponseBase): Observable<InactiveComponentsValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InactiveComponentsValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export the Inactive Components section to an Excel file, one row per pipe-class occurrence of each inactive component.
     */
    exportInactiveComponents(releaseId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/inactive-components/excel";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInactiveComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInactiveComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportInactiveComponents(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Turn the release-wide Inactive Components acknowledgement on or off. When on, every pending inactive component is acknowledged and no longer blocks publishing; it takes precedence over all component actions.
     * @param body (optional) 
     * @return OK
     */
    setInactiveComponentsProceedWithoutUpdates(releaseId: string, body?: InactiveComponentProceedWithoutUpdatesRequestDto | undefined): Observable<InactiveComponentsValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/inactive-components/proceed-without-updates";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetInactiveComponentsProceedWithoutUpdates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetInactiveComponentsProceedWithoutUpdates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InactiveComponentsValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InactiveComponentsValidationDto>;
        }));
    }

    protected processSetInactiveComponentsProceedWithoutUpdates(response: HttpResponseBase): Observable<InactiveComponentsValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InactiveComponentsValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Record Release As Is for every selected inactive component across the release's Revise pipe-class clones.
     * @param body (optional) 
     * @return OK
     */
    bulkReleaseInactiveComponentsAsIs(releaseId: string, body?: BulkInactiveComponentRequestDto | undefined): Observable<InactiveComponentsValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/inactive-components/bulk-release-as-is";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkReleaseInactiveComponentsAsIs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkReleaseInactiveComponentsAsIs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InactiveComponentsValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InactiveComponentsValidationDto>;
        }));
    }

    protected processBulkReleaseInactiveComponentsAsIs(response: HttpResponseBase): Observable<InactiveComponentsValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InactiveComponentsValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reactivate every selected inactive component and record an Activated decision for this release.
     * @param body (optional) 
     * @return OK
     */
    bulkActivateInactiveComponents(releaseId: string, body?: BulkInactiveComponentRequestDto | undefined): Observable<InactiveComponentsValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/inactive-components/bulk-activate";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkActivateInactiveComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkActivateInactiveComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InactiveComponentsValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InactiveComponentsValidationDto>;
        }));
    }

    protected processBulkActivateInactiveComponents(response: HttpResponseBase): Observable<InactiveComponentsValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InactiveComponentsValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove every selected inactive component from the release's Revise pipe-class clones, then clean up its release-specific logs and decisions.
     * @param body (optional) 
     * @return OK
     */
    bulkRemoveInactiveComponents(releaseId: string, body?: BulkInactiveComponentRequestDto | undefined): Observable<InactiveComponentsValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/inactive-components/bulk-remove";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkRemoveInactiveComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkRemoveInactiveComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InactiveComponentsValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InactiveComponentsValidationDto>;
        }));
    }

    protected processBulkRemoveInactiveComponents(response: HttpResponseBase): Observable<InactiveComponentsValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InactiveComponentsValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove one inactive component from every Revise pipe-class clone in the release and clean up release-specific logs and decisions.
     * @param body (optional) 
     * @return OK
     */
    removeInactiveComponent(releaseId: string, body?: ComponentRemovalRequestDto | undefined): Observable<InactiveComponentsValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/inactive-components/remove";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveInactiveComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveInactiveComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InactiveComponentsValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InactiveComponentsValidationDto>;
        }));
    }

    protected processRemoveInactiveComponent(response: HttpResponseBase): Observable<InactiveComponentsValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InactiveComponentsValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Replace an inactive component with an active one across every pipe-class clone occurrence in the release. Writes an audit log entry per occurrence.
     * @param body (optional) 
     * @return OK
     */
    replaceInactiveComponent(releaseId: string, body?: ComponentReplacementRequestDto | undefined): Observable<InactiveComponentGroupDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/inactive-components/replace";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceInactiveComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceInactiveComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InactiveComponentGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InactiveComponentGroupDto>;
        }));
    }

    protected processReplaceInactiveComponent(response: HttpResponseBase): Observable<InactiveComponentGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InactiveComponentGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reactivate an inactive component. Applies release-wide (AC7) and is reflected in the validation summary as Activated.
     * @param body (optional) 
     * @return OK
     */
    activateInactiveComponent(releaseId: string, body?: ComponentActivationRequestDto | undefined): Observable<InactiveComponentGroupDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/inactive-components/activate";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateInactiveComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateInactiveComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InactiveComponentGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InactiveComponentGroupDto>;
        }));
    }

    protected processActivateInactiveComponent(response: HttpResponseBase): Observable<InactiveComponentGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InactiveComponentGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Record the decision to release an inactive component as-is, without replacing or activating it. Applies release-wide (AC7).
     * @param body (optional) 
     * @return OK
     */
    releaseInactiveComponentAsIs(releaseId: string, body?: ComponentReleaseAsIsRequestDto | undefined): Observable<InactiveComponentGroupDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/inactive-components/release-as-is";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseInactiveComponentAsIs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseInactiveComponentAsIs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InactiveComponentGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InactiveComponentGroupDto>;
        }));
    }

    protected processReleaseInactiveComponentAsIs(response: HttpResponseBase): Observable<InactiveComponentGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InactiveComponentGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get full Piping Class Status section: pipe-class clones grouped by release action (ReleaseAsIs, Retired).
     * @return OK
     */
    getPipingClassStatus(releaseId: string): Observable<PipingClassStatusValidationDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/piping-class-status";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPipingClassStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipingClassStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipingClassStatusValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipingClassStatusValidationDto>;
        }));
    }

    protected processGetPipingClassStatus(response: HttpResponseBase): Observable<PipingClassStatusValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PipingClassStatusValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the current Release Attributes (Name, Revision, Description) for the final review tab.
     * @return OK
     */
    getReleaseAttributes(releaseId: string): Observable<ReleaseAttributesDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/attributes";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReleaseAttributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReleaseAttributes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseAttributesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseAttributesDto>;
        }));
    }

    protected processGetReleaseAttributes(response: HttpResponseBase): Observable<ReleaseAttributesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseAttributesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save Release Attribute edits (Name, Revision, Description). Intended for auto-save before publishing.
     * @param body (optional) 
     * @return OK
     */
    saveReleaseAttributes(releaseId: string, body?: ReleaseAttributesDto | undefined): Observable<ReleaseAttributesDto> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/attributes";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveReleaseAttributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveReleaseAttributes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseAttributesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseAttributesDto>;
        }));
    }

    protected processSaveReleaseAttributes(response: HttpResponseBase): Observable<ReleaseAttributesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseAttributesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Record that the user has explicitly acknowledged a UserOverridable validation warning. Stored as a ReleaseValidationOverride row.
     * @param body (optional) 
     * @return No Content
     */
    acknowledgeValidationItem(releaseId: string, body?: AcknowledgeValidationItemDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/release/{releaseId}/final-checks/acknowledge";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgeValidationItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgeValidationItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcknowledgeValidationItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Execute the final release. Saves attribute edits, re-runs all validations, and publishes the release when clean. Returns 409 with a blocking summary if issues remain.
     * @param body (optional) 
     * @return No Content
     */
    publishRelease(releaseId: string, body?: ExecuteReleaseRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/release/{releaseId}/publish";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublishRelease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ReleaseFinalChecksSummaryDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all revisions
     * @return Get all revisions
     */
    getAllRevisions(): Observable<SimpleRevisionViewModel[]> {
        let url_ = this.baseUrl + "/Revision/GetAllRevisions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRevisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRevisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleRevisionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleRevisionViewModel[]>;
        }));
    }

    protected processGetAllRevisions(response: HttpResponseBase): Observable<SimpleRevisionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleRevisionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUnpublishedRevisions(): Observable<PipingRevisionViewModel[]> {
        let url_ = this.baseUrl + "/Revision/GetUnpublishedRevisions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnpublishedRevisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnpublishedRevisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipingRevisionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipingRevisionViewModel[]>;
        }));
    }

    protected processGetUnpublishedRevisions(response: HttpResponseBase): Observable<PipingRevisionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipingRevisionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    readRevision(revisionId: number): Observable<SimpleRevisionViewModel> {
        let url_ = this.baseUrl + "/Revision/ReadRevision/{revisionId}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleRevisionViewModel>;
        }));
    }

    protected processReadRevision(response: HttpResponseBase): Observable<SimpleRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new revision for valve and/or pipes
     * @param body (optional) 
     * @return Created
     */
    createRevision(body?: RevisionCreateViewModel | undefined): Observable<SimpleRevisionViewModel[]> {
        let url_ = this.baseUrl + "/Revision/CreateRevision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleRevisionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleRevisionViewModel[]>;
        }));
    }

    protected processCreateRevision(response: HttpResponseBase): Observable<SimpleRevisionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(SimpleRevisionViewModel.fromJS(item));
            }
            else {
                result201 = <any>null;
            }
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param status (optional) 
     * @param objectId (optional) 
     * @param revisionSuffix (optional) 
     * @param description (optional) 
     * @return OK
     */
    changeRevisionStatus(revisionId: number, status?: RevisionStatus | undefined, objectId?: string | undefined, revisionSuffix?: string | undefined, description?: string | undefined): Observable<SimpleRevisionViewModel> {
        let url_ = this.baseUrl + "/Revision/{revisionId}/ChangeRevisionStatus?";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (objectId === null)
            throw new Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        if (revisionSuffix === null)
            throw new Error("The parameter 'revisionSuffix' cannot be null.");
        else if (revisionSuffix !== undefined)
            url_ += "revisionSuffix=" + encodeURIComponent("" + revisionSuffix) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeRevisionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeRevisionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleRevisionViewModel>;
        }));
    }

    protected processChangeRevisionStatus(response: HttpResponseBase): Observable<SimpleRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteRevision(revisionId: number): Observable<SimpleRevisionViewModel> {
        let url_ = this.baseUrl + "/Revision/DeleteRevision/{revisionId}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleRevisionViewModel>;
        }));
    }

    protected processDeleteRevision(response: HttpResponseBase): Observable<SimpleRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    publishRevision(revisionId: number): Observable<SimpleRevisionViewModel> {
        let url_ = this.baseUrl + "/Revision/PublishRevision/{revisionId}";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleRevisionViewModel>;
        }));
    }

    protected processPublishRevision(response: HttpResponseBase): Observable<SimpleRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleRevisionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    publishTechModRelease(body?: ReleaseViewModel | undefined): Observable<ReleaseViewModel> {
        let url_ = this.baseUrl + "/Revision/PublishTechMod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishTechModRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishTechModRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseViewModel>;
        }));
    }

    protected processPublishTechModRelease(response: HttpResponseBase): Observable<ReleaseViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateRevisionMembers(revisionId: number, body?: RoleViewModel[] | undefined): Observable<PipingRevisionViewModel> {
        let url_ = this.baseUrl + "/Revision/{revisionId}/updatemembers";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRevisionMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRevisionMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipingRevisionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipingRevisionViewModel>;
        }));
    }

    protected processUpdateRevisionMembers(response: HttpResponseBase): Observable<PipingRevisionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = PipingRevisionViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get members for a revision. For initial-release revisions, pass objectId to filter results to a single pipe class or valve.
     * @param objectId (optional) 
     * @return OK
     */
    getRevisionMembers(revisionId: number, objectId?: string | undefined): Observable<RoleViewModel[]> {
        let url_ = this.baseUrl + "/Revision/{revisionId}/members?";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (objectId === null)
            throw new Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevisionMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevisionMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel[]>;
        }));
    }

    protected processGetRevisionMembers(response: HttpResponseBase): Observable<RoleViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param objectId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateReviewerApproval(revisionId: number, objectId?: string | undefined, body?: ApprovalState | undefined): Observable<RoleViewModel[]> {
        let url_ = this.baseUrl + "/Revision/{revisionId}/approval?";
        if (revisionId === undefined || revisionId === null)
            throw new Error("The parameter 'revisionId' must be defined.");
        url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
        if (objectId === null)
            throw new Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel[]>;
        }));
    }

    protected processUpdateReviewerApproval(response: HttpResponseBase): Observable<RoleViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCurrentServices(): Observable<ServiceViewModel[]> {
        let url_ = this.baseUrl + "/Service/GetCurrentActive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceViewModel[]>;
        }));
    }

    protected processGetAllCurrentServices(response: HttpResponseBase): Observable<ServiceViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param numberOfResults (optional) 
     * @param searchQuery (optional) 
     * @return OK
     */
    getAllCurrentServicesPaged(pageNumber?: number | undefined, numberOfResults?: number | undefined, searchQuery?: string | undefined): Observable<ServiceViewModel[]> {
        let url_ = this.baseUrl + "/Service/GetAllCurrentPaged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' cannot be null.");
        else if (numberOfResults !== undefined)
            url_ += "numberOfResults=" + encodeURIComponent("" + numberOfResults) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentServicesPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentServicesPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceViewModel[]>;
        }));
    }

    protected processGetAllCurrentServicesPaged(response: HttpResponseBase): Observable<ServiceViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createService(body?: ServiceViewModel | undefined): Observable<ServiceViewModel> {
        let url_ = this.baseUrl + "/Service/CreateService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceViewModel>;
        }));
    }

    protected processCreateService(response: HttpResponseBase): Observable<ServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param body (optional) 
     * @return OK
     */
    toggleIsActiveService(isActive?: boolean | undefined, body?: string[] | undefined): Observable<ServiceViewModel[]> {
        let url_ = this.baseUrl + "/Service/ToggleIsActiveService?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleIsActiveService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleIsActiveService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceViewModel[]>;
        }));
    }

    protected processToggleIsActiveService(response: HttpResponseBase): Observable<ServiceViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateService(body?: ServiceViewModel | undefined): Observable<ServiceViewModel> {
        let url_ = this.baseUrl + "/Service/UpdateService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceViewModel>;
        }));
    }

    protected processUpdateService(response: HttpResponseBase): Observable<ServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = ServiceViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    archiveService(serviceId: string): Observable<ServiceViewModel> {
        let url_ = this.baseUrl + "/Service/archive/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceViewModel>;
        }));
    }

    protected processArchiveService(response: HttpResponseBase): Observable<ServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCurrentServiceDetails(): Observable<ServiceDetailViewModel[]> {
        let url_ = this.baseUrl + "/ServiceDetail/GetAllCurrent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentServiceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentServiceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDetailViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDetailViewModel[]>;
        }));
    }

    protected processGetAllCurrentServiceDetails(response: HttpResponseBase): Observable<ServiceDetailViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDetailViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param numberOfResults (optional) 
     * @param searchQuery (optional) 
     * @return OK
     */
    getAllCurrentServiceDetailsPaged(pageNumber?: number | undefined, numberOfResults?: number | undefined, searchQuery?: string | undefined): Observable<ServiceDetailViewModel[]> {
        let url_ = this.baseUrl + "/ServiceDetail/GetAllCurrentPaged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' cannot be null.");
        else if (numberOfResults !== undefined)
            url_ += "numberOfResults=" + encodeURIComponent("" + numberOfResults) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentServiceDetailsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentServiceDetailsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDetailViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDetailViewModel[]>;
        }));
    }

    protected processGetAllCurrentServiceDetailsPaged(response: HttpResponseBase): Observable<ServiceDetailViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDetailViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createServiceDetail(body?: ServiceDetailViewModel | undefined): Observable<ServiceDetailViewModel> {
        let url_ = this.baseUrl + "/ServiceDetail/CreateServiceDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateServiceDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateServiceDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDetailViewModel>;
        }));
    }

    protected processCreateServiceDetail(response: HttpResponseBase): Observable<ServiceDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ServiceDetailViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateServiceDetail(body?: ServiceDetailViewModel | undefined): Observable<ServiceDetailViewModel> {
        let url_ = this.baseUrl + "/ServiceDetail/UpdateServiceDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateServiceDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateServiceDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDetailViewModel>;
        }));
    }

    protected processUpdateServiceDetail(response: HttpResponseBase): Observable<ServiceDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = ServiceDetailViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    archiveServiceDetail(serviceDetailId: string): Observable<ServiceDetailViewModel> {
        let url_ = this.baseUrl + "/ServiceDetail/archive/{serviceDetailId}";
        if (serviceDetailId === undefined || serviceDetailId === null)
            throw new Error("The parameter 'serviceDetailId' must be defined.");
        url_ = url_.replace("{serviceDetailId}", encodeURIComponent("" + serviceDetailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveServiceDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveServiceDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDetailViewModel>;
        }));
    }

    protected processArchiveServiceDetail(response: HttpResponseBase): Observable<ServiceDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDetailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param body (optional) 
     * @return OK
     */
    toggleIsActiveServiceDetail(isActive?: boolean | undefined, body?: string[] | undefined): Observable<ServiceDetailViewModel[]> {
        let url_ = this.baseUrl + "/ServiceDetail/ToggleIsActiveServiceDetail?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleIsActiveServiceDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleIsActiveServiceDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDetailViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDetailViewModel[]>;
        }));
    }

    protected processToggleIsActiveServiceDetail(response: HttpResponseBase): Observable<ServiceDetailViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDetailViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shareLink (optional) 
     * @return OK
     */
    resolveShareLink(shareLink?: string | undefined): Observable<ResolveShareLinkResponse> {
        let url_ = this.baseUrl + "/api/ShareLinkResolve/resolve?";
        if (shareLink === null)
            throw new Error("The parameter 'shareLink' cannot be null.");
        else if (shareLink !== undefined)
            url_ += "shareLink=" + encodeURIComponent("" + shareLink) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveShareLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveShareLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolveShareLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolveShareLinkResponse>;
        }));
    }

    protected processResolveShareLink(response: HttpResponseBase): Observable<ResolveShareLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResolveShareLinkResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCurrentSpecifications(): Observable<SpecificationViewModel[]> {
        let url_ = this.baseUrl + "/Specification/GetAllCurrent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentSpecifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentSpecifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecificationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecificationViewModel[]>;
        }));
    }

    protected processGetAllCurrentSpecifications(response: HttpResponseBase): Observable<SpecificationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecificationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param numberOfResults (optional) 
     * @param searchQuery (optional) 
     * @param showAll (optional) 
     * @return OK
     */
    getAllSpecificationsPaged(pageNumber?: number | undefined, numberOfResults?: number | undefined, searchQuery?: string | undefined, showAll?: boolean | undefined): Observable<SpecificationViewModel[]> {
        let url_ = this.baseUrl + "/Specification/GetAllPaged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' cannot be null.");
        else if (numberOfResults !== undefined)
            url_ += "numberOfResults=" + encodeURIComponent("" + numberOfResults) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSpecificationsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSpecificationsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecificationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecificationViewModel[]>;
        }));
    }

    protected processGetAllSpecificationsPaged(response: HttpResponseBase): Observable<SpecificationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecificationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSpecification(body?: SpecificationViewModel | undefined): Observable<SpecificationViewModel> {
        let url_ = this.baseUrl + "/Specification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSpecification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSpecification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecificationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecificationViewModel>;
        }));
    }

    protected processCreateSpecification(response: HttpResponseBase): Observable<SpecificationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpecificationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    updateSpecification(body?: SpecificationViewModel | undefined): Observable<SpecificationViewModel> {
        let url_ = this.baseUrl + "/Specification/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSpecification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSpecification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecificationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecificationViewModel>;
        }));
    }

    protected processUpdateSpecification(response: HttpResponseBase): Observable<SpecificationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = SpecificationViewModel.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    toggleSpecificationStatus(specificationId: string): Observable<SpecificationViewModel> {
        let url_ = this.baseUrl + "/Specification/ToggleStatus/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleSpecificationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleSpecificationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecificationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecificationViewModel>;
        }));
    }

    protected processToggleSpecificationStatus(response: HttpResponseBase): Observable<SpecificationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpecificationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deleteSpecification(specificationId: string): Observable<void> {
        let url_ = this.baseUrl + "/Specification/Delete/{specificationId}";
        if (specificationId === undefined || specificationId === null)
            throw new Error("The parameter 'specificationId' must be defined.");
        url_ = url_.replace("{specificationId}", encodeURIComponent("" + specificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSpecification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSpecification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSpecification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessUnitId (optional) 
     * @param applicationId (optional) 
     * @param type (optional) 
     * @return OK
     */
    getSpecificationsForReleaseFilter(businessUnitId?: string | undefined, applicationId?: string | undefined, type?: SpecificationType | undefined): Observable<SpecificationViewModel[]> {
        let url_ = this.baseUrl + "/Specification/GetForReleaseFilter?";
        if (businessUnitId === null)
            throw new Error("The parameter 'businessUnitId' cannot be null.");
        else if (businessUnitId !== undefined)
            url_ += "businessUnitId=" + encodeURIComponent("" + businessUnitId) + "&";
        if (applicationId === null)
            throw new Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecificationsForReleaseFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecificationsForReleaseFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecificationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecificationViewModel[]>;
        }));
    }

    protected processGetSpecificationsForReleaseFilter(response: HttpResponseBase): Observable<SpecificationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecificationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    listUsers(): Observable<UserViewModel[]> {
        let url_ = this.baseUrl + "/api/User/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel[]>;
        }));
    }

    protected processListUsers(response: HttpResponseBase): Observable<UserViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    exportAllUsersToExcel(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/User/exportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAllUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAllUsersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportAllUsersToExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    reconcileUserOids(): Observable<UserOidReconciliationViewModel[]> {
        let url_ = this.baseUrl + "/api/User/reconcileOids";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReconcileUserOids(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReconcileUserOids(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOidReconciliationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOidReconciliationViewModel[]>;
        }));
    }

    protected processReconcileUserOids(response: HttpResponseBase): Observable<UserOidReconciliationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserOidReconciliationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUserById(id: string): Observable<UserDetailsViewModel> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDetailsViewModel>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UserDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserById(id: string, body?: UpdateUserBusinessUnitAccessRequest | undefined): Observable<UserDetailsViewModel> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDetailsViewModel>;
        }));
    }

    protected processUpdateUserById(response: HttpResponseBase): Observable<UserDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : _responseText;
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUserByIdAndUpdateFromGraph(id: string): Observable<User> {
        let url_ = this.baseUrl + "/api/User/{id}/updateFromGraph";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserByIdAndUpdateFromGraph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByIdAndUpdateFromGraph(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processGetUserByIdAndUpdateFromGraph(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateAllUsersFromGraph(): Observable<void> {
        let url_ = this.baseUrl + "/api/User/updateAllFromGraph";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllUsersFromGraph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllUsersFromGraph(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllUsersFromGraph(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addUser(body?: string[] | undefined): Observable<User> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getValveViewModelById(valveId: string): Observable<ValveViewModel> {
        let url_ = this.baseUrl + "/GetValveViewModelById/{valveId}";
        if (valveId === undefined || valveId === null)
            throw new Error("The parameter 'valveId' must be defined.");
        url_ = url_.replace("{valveId}", encodeURIComponent("" + valveId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValveViewModelById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValveViewModelById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveViewModel>;
        }));
    }

    protected processGetValveViewModelById(response: HttpResponseBase): Observable<ValveViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    getValveViewModelsByIds(ids?: string[] | undefined): Observable<ValveViewModel[]> {
        let url_ = this.baseUrl + "/GetValveViewModelsByIds?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValveViewModelsByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValveViewModelsByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveViewModel[]>;
        }));
    }

    protected processGetValveViewModelsByIds(response: HttpResponseBase): Observable<ValveViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    valveShareLink(valveId: string): Observable<ShareLinkResponse> {
        let url_ = this.baseUrl + "/Valve/ShareLink/{valveId}";
        if (valveId === undefined || valveId === null)
            throw new Error("The parameter 'valveId' must be defined.");
        url_ = url_.replace("{valveId}", encodeURIComponent("" + valveId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValveShareLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValveShareLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareLinkResponse>;
        }));
    }

    protected processValveShareLink(response: HttpResponseBase): Observable<ShareLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShareLinkResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    valvePdfShareLink(recordId: string): Observable<ShareLinkResponse> {
        let url_ = this.baseUrl + "/Valve/PdfShareLink/{recordId}";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValvePdfShareLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValvePdfShareLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareLinkResponse>;
        }));
    }

    protected processValvePdfShareLink(response: HttpResponseBase): Observable<ShareLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShareLinkResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getBusinessUnitsForValveTag(tag: string): Observable<string[]> {
        let url_ = this.baseUrl + "/ValveTagExists/{tag}";
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessUnitsForValveTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessUnitsForValveTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetBusinessUnitsForValveTag(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllValveApplications(): Observable<string[]> {
        let url_ = this.baseUrl + "/Valve/GetAllValveApplications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllValveApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllValveApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllValveApplications(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getValveViewModelByTag(valveTag: string): Observable<ValveViewModel> {
        let url_ = this.baseUrl + "/GetValveViewModelByTag/{valveTag}";
        if (valveTag === undefined || valveTag === null)
            throw new Error("The parameter 'valveTag' must be defined.");
        url_ = url_.replace("{valveTag}", encodeURIComponent("" + valveTag));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValveViewModelByTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValveViewModelByTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveViewModel>;
        }));
    }

    protected processGetValveViewModelByTag(response: HttpResponseBase): Observable<ValveViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllValves(): Observable<ValveViewModel[]> {
        let url_ = this.baseUrl + "/GetAllValves";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllValves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllValves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveViewModel[]>;
        }));
    }

    protected processGetAllValves(response: HttpResponseBase): Observable<ValveViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPublishedRevisionableValves(): Observable<ValveViewModel[]> {
        let url_ = this.baseUrl + "/Valve/GetPublishedRevisionableValves";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublishedRevisionableValves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublishedRevisionableValves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveViewModel[]>;
        }));
    }

    protected processGetPublishedRevisionableValves(response: HttpResponseBase): Observable<ValveViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getValvesByPageNumberAndNumberOfResults(pageNumber: number, numberOfResults: number): Observable<SearchResponse_1OfValveViewModel> {
        let url_ = this.baseUrl + "/GetAllValvesByPageNumberAndNumberOfResults/{pageNumber}/{numberOfResults}";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined.");
        url_ = url_.replace("{pageNumber}", encodeURIComponent("" + pageNumber));
        if (numberOfResults === undefined || numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' must be defined.");
        url_ = url_.replace("{numberOfResults}", encodeURIComponent("" + numberOfResults));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValvesByPageNumberAndNumberOfResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValvesByPageNumberAndNumberOfResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse_1OfValveViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse_1OfValveViewModel>;
        }));
    }

    protected processGetValvesByPageNumberAndNumberOfResults(response: HttpResponseBase): Observable<SearchResponse_1OfValveViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse_1OfValveViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createValve(body?: ValveViewModel | undefined): Observable<ValveViewModel> {
        let url_ = this.baseUrl + "/Valve/CreateValve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateValve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateValve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveViewModel>;
        }));
    }

    protected processCreateValve(response: HttpResponseBase): Observable<ValveViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateValveFromDictionary(body?: ValveViewModel | undefined): Observable<ValveViewModel> {
        let url_ = this.baseUrl + "/Valve/UpdateValveFromDictionary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateValveFromDictionary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateValveFromDictionary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveViewModel>;
        }));
    }

    protected processUpdateValveFromDictionary(response: HttpResponseBase): Observable<ValveViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateValve(body?: ValveViewModel | undefined): Observable<ValveViewModel> {
        let url_ = this.baseUrl + "/Valve/UpdateValve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateValve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateValve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveViewModel>;
        }));
    }

    protected processUpdateValve(response: HttpResponseBase): Observable<ValveViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    archiveValve(valveId: string): Observable<ValveViewModel> {
        let url_ = this.baseUrl + "/Valve/archive/{valveId}";
        if (valveId === undefined || valveId === null)
            throw new Error("The parameter 'valveId' must be defined.");
        url_ = url_.replace("{valveId}", encodeURIComponent("" + valveId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveValve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveValve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveViewModel>;
        }));
    }

    protected processArchiveValve(response: HttpResponseBase): Observable<ValveViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    cloneValve(valveId: string): Observable<ValveViewModel> {
        let url_ = this.baseUrl + "/Valve/CloneValve/{valveId}";
        if (valveId === undefined || valveId === null)
            throw new Error("The parameter 'valveId' must be defined.");
        url_ = url_.replace("{valveId}", encodeURIComponent("" + valveId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneValve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneValve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveViewModel>;
        }));
    }

    protected processCloneValve(response: HttpResponseBase): Observable<ValveViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValveViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cloneValveWithDetails(body?: CloneValveWithDetailsRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Valve/CloneWithDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneValveWithDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneValveWithDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCloneValveWithDetails(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cloneDraftValve(body?: CloneDraftValveRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Valve/CloneDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneDraftValve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneDraftValve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCloneDraftValve(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Conflict", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createValveFromRequest(body?: CreateValveRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Valve/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateValveFromRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateValveFromRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateValveFromRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateValveShortDescription(body?: ValveViewModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Valve/GetValveShortDescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateValveShortDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateValveShortDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateValveShortDescription(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAll(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Valve/DownloadAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/zip"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkVerify(file?: FileParameter | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Valve/BulkVerify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkVerify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBulkVerify(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkUpload(file?: FileParameter | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Valve/BulkUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBulkUpload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns validation results for valves, classifying each as current, superseded (with latest version), or indeterminate
     * @param body (optional) 
     * @return OK
     */
    validateAndGetLatestValves(body?: string[] | undefined): Observable<ValveValidationResult[]> {
        let url_ = this.baseUrl + "/Valve/ValidateAndGetLatest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAndGetLatestValves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAndGetLatestValves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValveValidationResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValveValidationResult[]>;
        }));
    }

    protected processValidateAndGetLatestValves(response: HttpResponseBase): Observable<ValveValidationResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValveValidationResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMyWorkspace(): Observable<any[]> {
        let url_ = this.baseUrl + "/api/WeldingWorkspace/myworkspace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processGetMyWorkspace(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMyWorkspace2(): Observable<PipingRevisionViewModel[]> {
        let url_ = this.baseUrl + "/api/Workspace/myworkspace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyWorkspace2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyWorkspace2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipingRevisionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipingRevisionViewModel[]>;
        }));
    }

    protected processGetMyWorkspace2(response: HttpResponseBase): Observable<PipingRevisionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PipingRevisionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWorkspace(): Observable<WorkspaceViewModel> {
        let url_ = this.baseUrl + "/api/Workspace/GetWorkspace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceViewModel>;
        }));
    }

    protected processGetWorkspace(response: HttpResponseBase): Observable<WorkspaceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addPipeClassesToWorkspace(body?: string[] | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Workspace/AddPipeClassesToWorkspace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPipeClassesToWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPipeClassesToWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processAddPipeClassesToWorkspace(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    removePipeClassesFromWorkspace(body?: string[] | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Workspace/RemovePipeClassesFromWorkspace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePipeClassesFromWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePipeClassesFromWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processRemovePipeClassesFromWorkspace(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addSearchRequestPipeAndValveClassesToWorkspace(body?: SearchRequest | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Workspace/AddPipeClassesToWorkspaceWithSearchResults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSearchRequestPipeAndValveClassesToWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSearchRequestPipeAndValveClassesToWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processAddSearchRequestPipeAndValveClassesToWorkspace(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class EsraSearchFilterModel implements IEsraSearchFilterModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;

    constructor(data?: IEsraSearchFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterDisplayName = _data["filterDisplayName"];
            this.filterPropertyName = _data["filterPropertyName"];
            this.filterType = _data["filterType"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
        }
    }

    static fromJS(data: any): EsraSearchFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new EsraSearchFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterDisplayName"] = this.filterDisplayName;
        data["filterPropertyName"] = this.filterPropertyName;
        data["filterType"] = this.filterType;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        return data;
    }
}

export interface IEsraSearchFilterModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
}

export enum FilterType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class FilterableProperty implements IFilterableProperty {
    displayName?: string | undefined;
    propertyName?: string | undefined;
    filterOptions?: string[] | undefined;
    filterType?: FilterType;

    constructor(data?: IFilterableProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.propertyName = _data["propertyName"];
            if (Array.isArray(_data["filterOptions"])) {
                this.filterOptions = [] as any;
                for (let item of _data["filterOptions"])
                    this.filterOptions!.push(item);
            }
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): FilterableProperty {
        data = typeof data === 'object' ? data : {};
        let result = new FilterableProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["propertyName"] = this.propertyName;
        if (Array.isArray(this.filterOptions)) {
            data["filterOptions"] = [];
            for (let item of this.filterOptions)
                data["filterOptions"].push(item);
        }
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IFilterableProperty {
    displayName?: string | undefined;
    propertyName?: string | undefined;
    filterOptions?: string[] | undefined;
    filterType?: FilterType;
}

export class SearchRequest implements ISearchRequest {
    page?: number;
    perPage?: number;
    mainSearch?: string | undefined;
    filters?: FilterableProperty[] | undefined;
    orderBy?: string | undefined;
    highlightMatches?: boolean;

    constructor(data?: ISearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.perPage = _data["perPage"];
            this.mainSearch = _data["mainSearch"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterableProperty.fromJS(item));
            }
            this.orderBy = _data["orderBy"];
            this.highlightMatches = _data["highlightMatches"];
        }
    }

    static fromJS(data: any): SearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["perPage"] = this.perPage;
        data["mainSearch"] = this.mainSearch;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["orderBy"] = this.orderBy;
        data["highlightMatches"] = this.highlightMatches;
        return data;
    }
}

export interface ISearchRequest {
    page?: number;
    perPage?: number;
    mainSearch?: string | undefined;
    filters?: FilterableProperty[] | undefined;
    orderBy?: string | undefined;
    highlightMatches?: boolean;
}

export class SearchResponse_1OfBranchTableViewModel implements ISearchResponse_1OfBranchTableViewModel {
    totalResults?: number;
    results?: BranchTableViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;

    constructor(data?: ISearchResponse_1OfBranchTableViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BranchTableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["searchFilters"])) {
                this.searchFilters = [] as any;
                for (let item of _data["searchFilters"])
                    this.searchFilters!.push(EsraSearchFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse_1OfBranchTableViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse_1OfBranchTableViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.searchFilters)) {
            data["searchFilters"] = [];
            for (let item of this.searchFilters)
                data["searchFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponse_1OfBranchTableViewModel {
    totalResults?: number;
    results?: BranchTableViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;
}

export class SearchResponse_1OfComponentCatalogSearchViewModel implements ISearchResponse_1OfComponentCatalogSearchViewModel {
    totalResults?: number;
    results?: ComponentCatalogSearchViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;

    constructor(data?: ISearchResponse_1OfComponentCatalogSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ComponentCatalogSearchViewModel.fromJS(item));
            }
            if (Array.isArray(_data["searchFilters"])) {
                this.searchFilters = [] as any;
                for (let item of _data["searchFilters"])
                    this.searchFilters!.push(EsraSearchFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse_1OfComponentCatalogSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse_1OfComponentCatalogSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.searchFilters)) {
            data["searchFilters"] = [];
            for (let item of this.searchFilters)
                data["searchFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponse_1OfComponentCatalogSearchViewModel {
    totalResults?: number;
    results?: ComponentCatalogSearchViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;
}

export class SearchResponse_1OfComponentPropertyViewModel implements ISearchResponse_1OfComponentPropertyViewModel {
    totalResults?: number;
    results?: ComponentPropertyViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;

    constructor(data?: ISearchResponse_1OfComponentPropertyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ComponentPropertyViewModel.fromJS(item));
            }
            if (Array.isArray(_data["searchFilters"])) {
                this.searchFilters = [] as any;
                for (let item of _data["searchFilters"])
                    this.searchFilters!.push(EsraSearchFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse_1OfComponentPropertyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse_1OfComponentPropertyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.searchFilters)) {
            data["searchFilters"] = [];
            for (let item of this.searchFilters)
                data["searchFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponse_1OfComponentPropertyViewModel {
    totalResults?: number;
    results?: ComponentPropertyViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;
}

export class SearchResponse_1OfComponentViewModel implements ISearchResponse_1OfComponentViewModel {
    totalResults?: number;
    results?: ComponentViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;

    constructor(data?: ISearchResponse_1OfComponentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ComponentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["searchFilters"])) {
                this.searchFilters = [] as any;
                for (let item of _data["searchFilters"])
                    this.searchFilters!.push(EsraSearchFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse_1OfComponentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse_1OfComponentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.searchFilters)) {
            data["searchFilters"] = [];
            for (let item of this.searchFilters)
                data["searchFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponse_1OfComponentViewModel {
    totalResults?: number;
    results?: ComponentViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;
}

export class SearchResponse_1OfPipingSearchResultViewModel implements ISearchResponse_1OfPipingSearchResultViewModel {
    totalResults?: number;
    results?: PipingSearchResultViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;

    constructor(data?: ISearchResponse_1OfPipingSearchResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PipingSearchResultViewModel.fromJS(item));
            }
            if (Array.isArray(_data["searchFilters"])) {
                this.searchFilters = [] as any;
                for (let item of _data["searchFilters"])
                    this.searchFilters!.push(EsraSearchFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse_1OfPipingSearchResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse_1OfPipingSearchResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.searchFilters)) {
            data["searchFilters"] = [];
            for (let item of this.searchFilters)
                data["searchFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponse_1OfPipingSearchResultViewModel {
    totalResults?: number;
    results?: PipingSearchResultViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;
}

export class SearchResponse_1OfPressureTemperatureTableViewModel implements ISearchResponse_1OfPressureTemperatureTableViewModel {
    totalResults?: number;
    results?: PressureTemperatureTableViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;

    constructor(data?: ISearchResponse_1OfPressureTemperatureTableViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PressureTemperatureTableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["searchFilters"])) {
                this.searchFilters = [] as any;
                for (let item of _data["searchFilters"])
                    this.searchFilters!.push(EsraSearchFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse_1OfPressureTemperatureTableViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse_1OfPressureTemperatureTableViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.searchFilters)) {
            data["searchFilters"] = [];
            for (let item of this.searchFilters)
                data["searchFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponse_1OfPressureTemperatureTableViewModel {
    totalResults?: number;
    results?: PressureTemperatureTableViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;
}

export class SearchResponse_1OfValveViewModel implements ISearchResponse_1OfValveViewModel {
    totalResults?: number;
    results?: ValveViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;

    constructor(data?: ISearchResponse_1OfValveViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ValveViewModel.fromJS(item));
            }
            if (Array.isArray(_data["searchFilters"])) {
                this.searchFilters = [] as any;
                for (let item of _data["searchFilters"])
                    this.searchFilters!.push(EsraSearchFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse_1OfValveViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse_1OfValveViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.searchFilters)) {
            data["searchFilters"] = [];
            for (let item of this.searchFilters)
                data["searchFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponse_1OfValveViewModel {
    totalResults?: number;
    results?: ValveViewModel[] | undefined;
    searchFilters?: EsraSearchFilterModel[] | undefined;
}

export enum ConsolidationMappingFieldType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
}

export enum PipingFilterCategory {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum PipingObjectType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum ReleaseStatus {
    DRAFT = 0,
    REVIEW = 1,
    APPROVAL = 2,
    PUBLISHED = 3,
    RETIRED = 100,
    REJECTED = 101,
}

export enum RevisionStatus {
    DRAFT = 0,
    REVIEW = 1,
    APPROVAL = 2,
    PUBLISHED = 3,
    REVIEW_WITH_REJECTIONS = 10,
    REVIEW_WITH_PENDING_COMMENTS = 11,
    APPROVAL_WITH_PENDING_COMMENTS = 12,
    RETIRED = 100,
    REJECTED = 101,
}

export class EnvironmentIndicatorViewModel implements IEnvironmentIndicatorViewModel {
    azureSearchPath?: string | undefined;
    version?: string | undefined;
    versionInfo?: VersionInfo;

    constructor(data?: IEnvironmentIndicatorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.azureSearchPath = _data["azureSearchPath"];
            this.version = _data["version"];
            this.versionInfo = _data["versionInfo"] ? VersionInfo.fromJS(_data["versionInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EnvironmentIndicatorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentIndicatorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["azureSearchPath"] = this.azureSearchPath;
        data["version"] = this.version;
        data["versionInfo"] = this.versionInfo ? this.versionInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEnvironmentIndicatorViewModel {
    azureSearchPath?: string | undefined;
    version?: string | undefined;
    versionInfo?: VersionInfo;
}

export class ResolveShareLinkResponse implements IResolveShareLinkResponse {
    shareLinkClass?: ShareLinkClass;
    objectId?: string;

    constructor(data?: IResolveShareLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shareLinkClass = _data["shareLinkClass"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): ResolveShareLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveShareLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shareLinkClass"] = this.shareLinkClass;
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IResolveShareLinkResponse {
    shareLinkClass?: ShareLinkClass;
    objectId?: string;
}

export enum ShareLinkClass {
    PipeClass = 0,
    Valve = 1,
    PdfPipeClass = 2,
    PdfValve = 3,
}

export class ShareLinkResponse implements IShareLinkResponse {
    relativeUrl?: string | undefined;

    constructor(data?: IShareLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relativeUrl = _data["relativeUrl"];
        }
    }

    static fromJS(data: any): ShareLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShareLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relativeUrl"] = this.relativeUrl;
        return data;
    }
}

export interface IShareLinkResponse {
    relativeUrl?: string | undefined;
}

export class VersionInfo implements IVersionInfo {
    version?: string | undefined;
    commitHash?: string | undefined;
    commitDate?: string | undefined;
    assemblyName?: string | undefined;

    constructor(data?: IVersionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.commitHash = _data["commitHash"];
            this.commitDate = _data["commitDate"];
            this.assemblyName = _data["assemblyName"];
        }
    }

    static fromJS(data: any): VersionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VersionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["commitHash"] = this.commitHash;
        data["commitDate"] = this.commitDate;
        data["assemblyName"] = this.assemblyName;
        return data;
    }
}

export interface IVersionInfo {
    version?: string | undefined;
    commitHash?: string | undefined;
    commitDate?: string | undefined;
    assemblyName?: string | undefined;
}

export class ComponentCodeValidationResponse implements IComponentCodeValidationResponse {
    componentCode?: string | undefined;
    isUnique?: boolean;
    existsAsInactive?: boolean;
    inactiveComponentId?: string | undefined;
    message?: string | undefined;

    constructor(data?: IComponentCodeValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentCode = _data["componentCode"];
            this.isUnique = _data["isUnique"];
            this.existsAsInactive = _data["existsAsInactive"];
            this.inactiveComponentId = _data["inactiveComponentId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ComponentCodeValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentCodeValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentCode"] = this.componentCode;
        data["isUnique"] = this.isUnique;
        data["existsAsInactive"] = this.existsAsInactive;
        data["inactiveComponentId"] = this.inactiveComponentId;
        data["message"] = this.message;
        return data;
    }
}

export interface IComponentCodeValidationResponse {
    componentCode?: string | undefined;
    isUnique?: boolean;
    existsAsInactive?: boolean;
    inactiveComponentId?: string | undefined;
    message?: string | undefined;
}

export enum BranchTableNoteType {
    _0 = 0,
}

export enum ComponentPropertyDataType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum DocumentCleanupReason {
    UserReplacedFile = 1,
    UserRemovedFile = 2,
    UserDiscardedJob = 3,
    UnrecoverableJobFailure = 4,
}

export enum DocumentCleanupStatus {
    None = 0,
    PendingRetention = 1,
    Ready = 2,
    InProgress = 3,
    RetryableFailed = 4,
    Completed = 5,
    Preserved = 6,
}

export enum InactiveComponentResolutionAction {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum InitialRevisionType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum ParentFileType {
    _0 = 0,
}

export enum PressureTemperatureTableNoteType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum ProcessStatus {
    _0 = 0,
    _10 = 10,
    _20 = 20,
    _25 = 25,
    _30 = 30,
    _40 = 40,
    _100 = 100,
    __1 = -1,
}

export enum ReleaseComponent {
    _0 = 0,
    _1 = 1,
}

export enum ReleaseSelectedObject {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum SpecificationType {
    _0 = 0,
    _1 = 1,
}

export enum UploadedFileModule {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum ValidationSeverity {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum ValveDescriptionChoiceOption {
    _0 = 0,
    _1 = 1,
}

export class Application implements IApplication {
    id?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    isActive?: boolean;
    updated?: Date;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;

    constructor(data?: IApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.isActive = _data["isActive"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.fromRevisionNonPipeClassId = _data["fromRevisionNonPipeClassId"];
            this.fromRevisionNonPipeClass = _data["fromRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["fromRevisionNonPipeClass"]) : <any>undefined;
            this.toRevisionNonPipeClassId = _data["toRevisionNonPipeClassId"];
            this.toRevisionNonPipeClass = _data["toRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["toRevisionNonPipeClass"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Application {
        data = typeof data === 'object' ? data : {};
        let result = new Application();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["isActive"] = this.isActive;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["fromRevisionNonPipeClassId"] = this.fromRevisionNonPipeClassId;
        data["fromRevisionNonPipeClass"] = this.fromRevisionNonPipeClass ? this.fromRevisionNonPipeClass.toJSON() : <any>undefined;
        data["toRevisionNonPipeClassId"] = this.toRevisionNonPipeClassId;
        data["toRevisionNonPipeClass"] = this.toRevisionNonPipeClass ? this.toRevisionNonPipeClass.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApplication {
    id?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    isActive?: boolean;
    updated?: Date;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
}

export enum ApprovalState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class BranchTable implements IBranchTable {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
    cells?: BranchTableCell[] | undefined;
    commonNotes?: CommonNote[] | undefined;
    branchTablePipeClasses?: BranchTablePipeClass[] | undefined;
    fromRevisionNonPipeClassId?: number;
    toRevisionNonPipeClassId?: number;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClass?: RevisionNonPipeClass;

    constructor(data?: IBranchTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(BranchTableCell.fromJS(item));
            }
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNote.fromJS(item));
            }
            if (Array.isArray(_data["branchTablePipeClasses"])) {
                this.branchTablePipeClasses = [] as any;
                for (let item of _data["branchTablePipeClasses"])
                    this.branchTablePipeClasses!.push(BranchTablePipeClass.fromJS(item));
            }
            this.fromRevisionNonPipeClassId = _data["fromRevisionNonPipeClassId"];
            this.toRevisionNonPipeClassId = _data["toRevisionNonPipeClassId"];
            this.fromRevisionNonPipeClass = _data["fromRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["fromRevisionNonPipeClass"]) : <any>undefined;
            this.toRevisionNonPipeClass = _data["toRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["toRevisionNonPipeClass"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchTable {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item.toJSON());
        }
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.branchTablePipeClasses)) {
            data["branchTablePipeClasses"] = [];
            for (let item of this.branchTablePipeClasses)
                data["branchTablePipeClasses"].push(item.toJSON());
        }
        data["fromRevisionNonPipeClassId"] = this.fromRevisionNonPipeClassId;
        data["toRevisionNonPipeClassId"] = this.toRevisionNonPipeClassId;
        data["fromRevisionNonPipeClass"] = this.fromRevisionNonPipeClass ? this.fromRevisionNonPipeClass.toJSON() : <any>undefined;
        data["toRevisionNonPipeClass"] = this.toRevisionNonPipeClass ? this.toRevisionNonPipeClass.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBranchTable {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
    cells?: BranchTableCell[] | undefined;
    commonNotes?: CommonNote[] | undefined;
    branchTablePipeClasses?: BranchTablePipeClass[] | undefined;
    fromRevisionNonPipeClassId?: number;
    toRevisionNonPipeClassId?: number;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
}

export class BranchTableCell implements IBranchTableCell {
    id?: string;
    branchTableId?: string;
    branchTable?: BranchTable;
    branchSize?: number;
    headerSize?: number;
    branchTableCode?: BranchTableCode[] | undefined;

    constructor(data?: IBranchTableCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchTableId = _data["branchTableId"];
            this.branchTable = _data["branchTable"] ? BranchTable.fromJS(_data["branchTable"]) : <any>undefined;
            this.branchSize = _data["branchSize"];
            this.headerSize = _data["headerSize"];
            if (Array.isArray(_data["branchTableCode"])) {
                this.branchTableCode = [] as any;
                for (let item of _data["branchTableCode"])
                    this.branchTableCode!.push(BranchTableCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchTableCell {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTableCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branchTableId"] = this.branchTableId;
        data["branchTable"] = this.branchTable ? this.branchTable.toJSON() : <any>undefined;
        data["branchSize"] = this.branchSize;
        data["headerSize"] = this.headerSize;
        if (Array.isArray(this.branchTableCode)) {
            data["branchTableCode"] = [];
            for (let item of this.branchTableCode)
                data["branchTableCode"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchTableCell {
    id?: string;
    branchTableId?: string;
    branchTable?: BranchTable;
    branchSize?: number;
    headerSize?: number;
    branchTableCode?: BranchTableCode[] | undefined;
}

export class BranchTableCode implements IBranchTableCode {
    id?: string;
    code?: string | undefined;
    description?: string | undefined;
    fromRevisionNonPipeClassId?: number;
    toRevisionNonPipeClassId?: number;
    isActive?: boolean;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    businessUnit?: BusinessUnit;
    branchTableCells?: BranchTableCell[] | undefined;
    branchTableLegends?: BranchTableLegend[] | undefined;
    branchTableDictionaryLegends?: BranchTableDictionaryLegend[] | undefined;

    constructor(data?: IBranchTableCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.fromRevisionNonPipeClassId = _data["fromRevisionNonPipeClassId"];
            this.toRevisionNonPipeClassId = _data["toRevisionNonPipeClassId"];
            this.isActive = _data["isActive"];
            this.fromRevisionNonPipeClass = _data["fromRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["fromRevisionNonPipeClass"]) : <any>undefined;
            this.toRevisionNonPipeClass = _data["toRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["toRevisionNonPipeClass"]) : <any>undefined;
            this.businessUnit = _data["businessUnit"] ? BusinessUnit.fromJS(_data["businessUnit"]) : <any>undefined;
            if (Array.isArray(_data["branchTableCells"])) {
                this.branchTableCells = [] as any;
                for (let item of _data["branchTableCells"])
                    this.branchTableCells!.push(BranchTableCell.fromJS(item));
            }
            if (Array.isArray(_data["branchTableLegends"])) {
                this.branchTableLegends = [] as any;
                for (let item of _data["branchTableLegends"])
                    this.branchTableLegends!.push(BranchTableLegend.fromJS(item));
            }
            if (Array.isArray(_data["branchTableDictionaryLegends"])) {
                this.branchTableDictionaryLegends = [] as any;
                for (let item of _data["branchTableDictionaryLegends"])
                    this.branchTableDictionaryLegends!.push(BranchTableDictionaryLegend.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchTableCode {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTableCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["fromRevisionNonPipeClassId"] = this.fromRevisionNonPipeClassId;
        data["toRevisionNonPipeClassId"] = this.toRevisionNonPipeClassId;
        data["isActive"] = this.isActive;
        data["fromRevisionNonPipeClass"] = this.fromRevisionNonPipeClass ? this.fromRevisionNonPipeClass.toJSON() : <any>undefined;
        data["toRevisionNonPipeClass"] = this.toRevisionNonPipeClass ? this.toRevisionNonPipeClass.toJSON() : <any>undefined;
        data["businessUnit"] = this.businessUnit ? this.businessUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.branchTableCells)) {
            data["branchTableCells"] = [];
            for (let item of this.branchTableCells)
                data["branchTableCells"].push(item.toJSON());
        }
        if (Array.isArray(this.branchTableLegends)) {
            data["branchTableLegends"] = [];
            for (let item of this.branchTableLegends)
                data["branchTableLegends"].push(item.toJSON());
        }
        if (Array.isArray(this.branchTableDictionaryLegends)) {
            data["branchTableDictionaryLegends"] = [];
            for (let item of this.branchTableDictionaryLegends)
                data["branchTableDictionaryLegends"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchTableCode {
    id?: string;
    code?: string | undefined;
    description?: string | undefined;
    fromRevisionNonPipeClassId?: number;
    toRevisionNonPipeClassId?: number;
    isActive?: boolean;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    businessUnit?: BusinessUnit;
    branchTableCells?: BranchTableCell[] | undefined;
    branchTableLegends?: BranchTableLegend[] | undefined;
    branchTableDictionaryLegends?: BranchTableDictionaryLegend[] | undefined;
}

export class BranchTableDictionaryLegend implements IBranchTableDictionaryLegend {
    branchTableCodesId?: string;
    commonNotesId?: string;
    branchTableId?: string;
    branchTable?: BranchTable;
    branchTableCode?: BranchTableCode;
    commonNotes?: CommonNote;

    constructor(data?: IBranchTableDictionaryLegend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchTableCodesId = _data["branchTableCodesId"];
            this.commonNotesId = _data["commonNotesId"];
            this.branchTableId = _data["branchTableId"];
            this.branchTable = _data["branchTable"] ? BranchTable.fromJS(_data["branchTable"]) : <any>undefined;
            this.branchTableCode = _data["branchTableCode"] ? BranchTableCode.fromJS(_data["branchTableCode"]) : <any>undefined;
            this.commonNotes = _data["commonNotes"] ? CommonNote.fromJS(_data["commonNotes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchTableDictionaryLegend {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTableDictionaryLegend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchTableCodesId"] = this.branchTableCodesId;
        data["commonNotesId"] = this.commonNotesId;
        data["branchTableId"] = this.branchTableId;
        data["branchTable"] = this.branchTable ? this.branchTable.toJSON() : <any>undefined;
        data["branchTableCode"] = this.branchTableCode ? this.branchTableCode.toJSON() : <any>undefined;
        data["commonNotes"] = this.commonNotes ? this.commonNotes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBranchTableDictionaryLegend {
    branchTableCodesId?: string;
    commonNotesId?: string;
    branchTableId?: string;
    branchTable?: BranchTable;
    branchTableCode?: BranchTableCode;
    commonNotes?: CommonNote;
}

export class BranchTableLegend implements IBranchTableLegend {
    branchTableCodesId?: string;
    commonNotesId?: string;
    branchTableId?: string;
    pipeclassId?: string;
    branchTable?: BranchTable;
    branchTableCode?: BranchTableCode;
    commonNotes?: CommonNote;

    constructor(data?: IBranchTableLegend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchTableCodesId = _data["branchTableCodesId"];
            this.commonNotesId = _data["commonNotesId"];
            this.branchTableId = _data["branchTableId"];
            this.pipeclassId = _data["pipeclassId"];
            this.branchTable = _data["branchTable"] ? BranchTable.fromJS(_data["branchTable"]) : <any>undefined;
            this.branchTableCode = _data["branchTableCode"] ? BranchTableCode.fromJS(_data["branchTableCode"]) : <any>undefined;
            this.commonNotes = _data["commonNotes"] ? CommonNote.fromJS(_data["commonNotes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchTableLegend {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTableLegend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchTableCodesId"] = this.branchTableCodesId;
        data["commonNotesId"] = this.commonNotesId;
        data["branchTableId"] = this.branchTableId;
        data["pipeclassId"] = this.pipeclassId;
        data["branchTable"] = this.branchTable ? this.branchTable.toJSON() : <any>undefined;
        data["branchTableCode"] = this.branchTableCode ? this.branchTableCode.toJSON() : <any>undefined;
        data["commonNotes"] = this.commonNotes ? this.commonNotes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBranchTableLegend {
    branchTableCodesId?: string;
    commonNotesId?: string;
    branchTableId?: string;
    pipeclassId?: string;
    branchTable?: BranchTable;
    branchTableCode?: BranchTableCode;
    commonNotes?: CommonNote;
}

export class BranchTablePipeClass implements IBranchTablePipeClass {
    id?: string;
    branchTableId?: string;
    branchTable?: BranchTable;
    pipeClassId?: string;
    pipeClass?: PipeClass;
    freeTextNote?: string | undefined;
    commonNotes?: CommonNote[] | undefined;
    branchTablePipeClassNotes?: BranchTablePipeClassNote[] | undefined;
    lastUpdatedRevisionId?: number | undefined;
    lastUpdatedRevision?: Revision;

    constructor(data?: IBranchTablePipeClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchTableId = _data["branchTableId"];
            this.branchTable = _data["branchTable"] ? BranchTable.fromJS(_data["branchTable"]) : <any>undefined;
            this.pipeClassId = _data["pipeClassId"];
            this.pipeClass = _data["pipeClass"] ? PipeClass.fromJS(_data["pipeClass"]) : <any>undefined;
            this.freeTextNote = _data["freeTextNote"];
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNote.fromJS(item));
            }
            if (Array.isArray(_data["branchTablePipeClassNotes"])) {
                this.branchTablePipeClassNotes = [] as any;
                for (let item of _data["branchTablePipeClassNotes"])
                    this.branchTablePipeClassNotes!.push(BranchTablePipeClassNote.fromJS(item));
            }
            this.lastUpdatedRevisionId = _data["lastUpdatedRevisionId"];
            this.lastUpdatedRevision = _data["lastUpdatedRevision"] ? Revision.fromJS(_data["lastUpdatedRevision"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchTablePipeClass {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTablePipeClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branchTableId"] = this.branchTableId;
        data["branchTable"] = this.branchTable ? this.branchTable.toJSON() : <any>undefined;
        data["pipeClassId"] = this.pipeClassId;
        data["pipeClass"] = this.pipeClass ? this.pipeClass.toJSON() : <any>undefined;
        data["freeTextNote"] = this.freeTextNote;
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.branchTablePipeClassNotes)) {
            data["branchTablePipeClassNotes"] = [];
            for (let item of this.branchTablePipeClassNotes)
                data["branchTablePipeClassNotes"].push(item.toJSON());
        }
        data["lastUpdatedRevisionId"] = this.lastUpdatedRevisionId;
        data["lastUpdatedRevision"] = this.lastUpdatedRevision ? this.lastUpdatedRevision.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBranchTablePipeClass {
    id?: string;
    branchTableId?: string;
    branchTable?: BranchTable;
    pipeClassId?: string;
    pipeClass?: PipeClass;
    freeTextNote?: string | undefined;
    commonNotes?: CommonNote[] | undefined;
    branchTablePipeClassNotes?: BranchTablePipeClassNote[] | undefined;
    lastUpdatedRevisionId?: number | undefined;
    lastUpdatedRevision?: Revision;
}

export class BranchTablePipeClassNote implements IBranchTablePipeClassNote {
    id?: string;
    branchTablePipeClassId?: string;
    branchTablePipeClass?: BranchTablePipeClass;
    note?: string | undefined;
    type?: BranchTableNoteType;

    constructor(data?: IBranchTablePipeClassNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchTablePipeClassId = _data["branchTablePipeClassId"];
            this.branchTablePipeClass = _data["branchTablePipeClass"] ? BranchTablePipeClass.fromJS(_data["branchTablePipeClass"]) : <any>undefined;
            this.note = _data["note"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): BranchTablePipeClassNote {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTablePipeClassNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branchTablePipeClassId"] = this.branchTablePipeClassId;
        data["branchTablePipeClass"] = this.branchTablePipeClass ? this.branchTablePipeClass.toJSON() : <any>undefined;
        data["note"] = this.note;
        data["type"] = this.type;
        return data;
    }
}

export interface IBranchTablePipeClassNote {
    id?: string;
    branchTablePipeClassId?: string;
    branchTablePipeClass?: BranchTablePipeClass;
    note?: string | undefined;
    type?: BranchTableNoteType;
}

export class BusinessUnit implements IBusinessUnit {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
    updated?: Date;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    pipeClasses?: PipeClass[] | undefined;
    valves?: Valve[] | undefined;
    alwaysAvailableForEveryUser?: boolean;
    users?: User[] | undefined;

    constructor(data?: IBusinessUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.fromRevisionNonPipeClassId = _data["fromRevisionNonPipeClassId"];
            this.fromRevisionNonPipeClass = _data["fromRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["fromRevisionNonPipeClass"]) : <any>undefined;
            this.toRevisionNonPipeClassId = _data["toRevisionNonPipeClassId"];
            this.toRevisionNonPipeClass = _data["toRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["toRevisionNonPipeClass"]) : <any>undefined;
            if (Array.isArray(_data["pipeClasses"])) {
                this.pipeClasses = [] as any;
                for (let item of _data["pipeClasses"])
                    this.pipeClasses!.push(PipeClass.fromJS(item));
            }
            if (Array.isArray(_data["valves"])) {
                this.valves = [] as any;
                for (let item of _data["valves"])
                    this.valves!.push(Valve.fromJS(item));
            }
            this.alwaysAvailableForEveryUser = _data["alwaysAvailableForEveryUser"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BusinessUnit {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["fromRevisionNonPipeClassId"] = this.fromRevisionNonPipeClassId;
        data["fromRevisionNonPipeClass"] = this.fromRevisionNonPipeClass ? this.fromRevisionNonPipeClass.toJSON() : <any>undefined;
        data["toRevisionNonPipeClassId"] = this.toRevisionNonPipeClassId;
        data["toRevisionNonPipeClass"] = this.toRevisionNonPipeClass ? this.toRevisionNonPipeClass.toJSON() : <any>undefined;
        if (Array.isArray(this.pipeClasses)) {
            data["pipeClasses"] = [];
            for (let item of this.pipeClasses)
                data["pipeClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.valves)) {
            data["valves"] = [];
            for (let item of this.valves)
                data["valves"].push(item.toJSON());
        }
        data["alwaysAvailableForEveryUser"] = this.alwaysAvailableForEveryUser;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBusinessUnit {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
    updated?: Date;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    pipeClasses?: PipeClass[] | undefined;
    valves?: Valve[] | undefined;
    alwaysAvailableForEveryUser?: boolean;
    users?: User[] | undefined;
}

export enum CommentResolutionStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CommonNote implements ICommonNote {
    id?: string;
    codeId?: string | undefined;
    note?: string | undefined;
    isActive?: boolean;
    isArchived?: boolean;
    updated?: Date;
    fromRevisionNonPipeClassId?: number;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    components?: Component[] | undefined;
    componentsInPipeClass?: ComponentInPipeClass[] | undefined;
    pressureTemperatureTables?: PressureTemperatureTable[] | undefined;
    branchTables?: BranchTable[] | undefined;
    pipeClassRelations?: PipeClassPressureTemperatureTableRelation[] | undefined;
    pipeClasses?: PipeClass[] | undefined;
    branchTableLegends?: BranchTableLegend[] | undefined;
    branchTablePipeClasses?: BranchTablePipeClass[] | undefined;
    pipeClassProperties?: PipeClassProperty[] | undefined;
    pipeClassServices?: PipeClass[] | undefined;

    constructor(data?: ICommonNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.codeId = _data["codeId"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.isArchived = _data["isArchived"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.fromRevisionNonPipeClassId = _data["fromRevisionNonPipeClassId"];
            this.fromRevisionNonPipeClass = _data["fromRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["fromRevisionNonPipeClass"]) : <any>undefined;
            this.toRevisionNonPipeClassId = _data["toRevisionNonPipeClassId"];
            this.toRevisionNonPipeClass = _data["toRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["toRevisionNonPipeClass"]) : <any>undefined;
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(Component.fromJS(item));
            }
            if (Array.isArray(_data["componentsInPipeClass"])) {
                this.componentsInPipeClass = [] as any;
                for (let item of _data["componentsInPipeClass"])
                    this.componentsInPipeClass!.push(ComponentInPipeClass.fromJS(item));
            }
            if (Array.isArray(_data["pressureTemperatureTables"])) {
                this.pressureTemperatureTables = [] as any;
                for (let item of _data["pressureTemperatureTables"])
                    this.pressureTemperatureTables!.push(PressureTemperatureTable.fromJS(item));
            }
            if (Array.isArray(_data["branchTables"])) {
                this.branchTables = [] as any;
                for (let item of _data["branchTables"])
                    this.branchTables!.push(BranchTable.fromJS(item));
            }
            if (Array.isArray(_data["pipeClassRelations"])) {
                this.pipeClassRelations = [] as any;
                for (let item of _data["pipeClassRelations"])
                    this.pipeClassRelations!.push(PipeClassPressureTemperatureTableRelation.fromJS(item));
            }
            if (Array.isArray(_data["pipeClasses"])) {
                this.pipeClasses = [] as any;
                for (let item of _data["pipeClasses"])
                    this.pipeClasses!.push(PipeClass.fromJS(item));
            }
            if (Array.isArray(_data["branchTableLegends"])) {
                this.branchTableLegends = [] as any;
                for (let item of _data["branchTableLegends"])
                    this.branchTableLegends!.push(BranchTableLegend.fromJS(item));
            }
            if (Array.isArray(_data["branchTablePipeClasses"])) {
                this.branchTablePipeClasses = [] as any;
                for (let item of _data["branchTablePipeClasses"])
                    this.branchTablePipeClasses!.push(BranchTablePipeClass.fromJS(item));
            }
            if (Array.isArray(_data["pipeClassProperties"])) {
                this.pipeClassProperties = [] as any;
                for (let item of _data["pipeClassProperties"])
                    this.pipeClassProperties!.push(PipeClassProperty.fromJS(item));
            }
            if (Array.isArray(_data["pipeClassServices"])) {
                this.pipeClassServices = [] as any;
                for (let item of _data["pipeClassServices"])
                    this.pipeClassServices!.push(PipeClass.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommonNote {
        data = typeof data === 'object' ? data : {};
        let result = new CommonNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["codeId"] = this.codeId;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["isArchived"] = this.isArchived;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["fromRevisionNonPipeClassId"] = this.fromRevisionNonPipeClassId;
        data["fromRevisionNonPipeClass"] = this.fromRevisionNonPipeClass ? this.fromRevisionNonPipeClass.toJSON() : <any>undefined;
        data["toRevisionNonPipeClassId"] = this.toRevisionNonPipeClassId;
        data["toRevisionNonPipeClass"] = this.toRevisionNonPipeClass ? this.toRevisionNonPipeClass.toJSON() : <any>undefined;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        if (Array.isArray(this.componentsInPipeClass)) {
            data["componentsInPipeClass"] = [];
            for (let item of this.componentsInPipeClass)
                data["componentsInPipeClass"].push(item.toJSON());
        }
        if (Array.isArray(this.pressureTemperatureTables)) {
            data["pressureTemperatureTables"] = [];
            for (let item of this.pressureTemperatureTables)
                data["pressureTemperatureTables"].push(item.toJSON());
        }
        if (Array.isArray(this.branchTables)) {
            data["branchTables"] = [];
            for (let item of this.branchTables)
                data["branchTables"].push(item.toJSON());
        }
        if (Array.isArray(this.pipeClassRelations)) {
            data["pipeClassRelations"] = [];
            for (let item of this.pipeClassRelations)
                data["pipeClassRelations"].push(item.toJSON());
        }
        if (Array.isArray(this.pipeClasses)) {
            data["pipeClasses"] = [];
            for (let item of this.pipeClasses)
                data["pipeClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.branchTableLegends)) {
            data["branchTableLegends"] = [];
            for (let item of this.branchTableLegends)
                data["branchTableLegends"].push(item.toJSON());
        }
        if (Array.isArray(this.branchTablePipeClasses)) {
            data["branchTablePipeClasses"] = [];
            for (let item of this.branchTablePipeClasses)
                data["branchTablePipeClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.pipeClassProperties)) {
            data["pipeClassProperties"] = [];
            for (let item of this.pipeClassProperties)
                data["pipeClassProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.pipeClassServices)) {
            data["pipeClassServices"] = [];
            for (let item of this.pipeClassServices)
                data["pipeClassServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommonNote {
    id?: string;
    codeId?: string | undefined;
    note?: string | undefined;
    isActive?: boolean;
    isArchived?: boolean;
    updated?: Date;
    fromRevisionNonPipeClassId?: number;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    components?: Component[] | undefined;
    componentsInPipeClass?: ComponentInPipeClass[] | undefined;
    pressureTemperatureTables?: PressureTemperatureTable[] | undefined;
    branchTables?: BranchTable[] | undefined;
    pipeClassRelations?: PipeClassPressureTemperatureTableRelation[] | undefined;
    pipeClasses?: PipeClass[] | undefined;
    branchTableLegends?: BranchTableLegend[] | undefined;
    branchTablePipeClasses?: BranchTablePipeClass[] | undefined;
    pipeClassProperties?: PipeClassProperty[] | undefined;
    pipeClassServices?: PipeClass[] | undefined;
}

export class Component implements IComponent {
    id?: string;
    componentClassificationId?: string;
    componentClassification?: ComponentClassification;
    componentCode?: string | undefined;
    description?: string | undefined;
    fromRevisionNonPipeClassId?: number;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    isActive?: boolean;
    disabledPermanently?: boolean;
    notes?: CommonNote[] | undefined;
    componentComponentProperty?: ComponentComponentProperty[] | undefined;
    fromComponentId?: string | undefined;
    valves?: Valve[] | undefined;

    constructor(data?: IComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.componentClassificationId = _data["componentClassificationId"];
            this.componentClassification = _data["componentClassification"] ? ComponentClassification.fromJS(_data["componentClassification"]) : <any>undefined;
            this.componentCode = _data["componentCode"];
            this.description = _data["description"];
            this.fromRevisionNonPipeClassId = _data["fromRevisionNonPipeClassId"];
            this.fromRevisionNonPipeClass = _data["fromRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["fromRevisionNonPipeClass"]) : <any>undefined;
            this.toRevisionNonPipeClassId = _data["toRevisionNonPipeClassId"];
            this.toRevisionNonPipeClass = _data["toRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["toRevisionNonPipeClass"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.disabledPermanently = _data["disabledPermanently"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(CommonNote.fromJS(item));
            }
            if (Array.isArray(_data["componentComponentProperty"])) {
                this.componentComponentProperty = [] as any;
                for (let item of _data["componentComponentProperty"])
                    this.componentComponentProperty!.push(ComponentComponentProperty.fromJS(item));
            }
            this.fromComponentId = _data["fromComponentId"];
            if (Array.isArray(_data["valves"])) {
                this.valves = [] as any;
                for (let item of _data["valves"])
                    this.valves!.push(Valve.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Component {
        data = typeof data === 'object' ? data : {};
        let result = new Component();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["componentClassificationId"] = this.componentClassificationId;
        data["componentClassification"] = this.componentClassification ? this.componentClassification.toJSON() : <any>undefined;
        data["componentCode"] = this.componentCode;
        data["description"] = this.description;
        data["fromRevisionNonPipeClassId"] = this.fromRevisionNonPipeClassId;
        data["fromRevisionNonPipeClass"] = this.fromRevisionNonPipeClass ? this.fromRevisionNonPipeClass.toJSON() : <any>undefined;
        data["toRevisionNonPipeClassId"] = this.toRevisionNonPipeClassId;
        data["toRevisionNonPipeClass"] = this.toRevisionNonPipeClass ? this.toRevisionNonPipeClass.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["disabledPermanently"] = this.disabledPermanently;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (Array.isArray(this.componentComponentProperty)) {
            data["componentComponentProperty"] = [];
            for (let item of this.componentComponentProperty)
                data["componentComponentProperty"].push(item.toJSON());
        }
        data["fromComponentId"] = this.fromComponentId;
        if (Array.isArray(this.valves)) {
            data["valves"] = [];
            for (let item of this.valves)
                data["valves"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComponent {
    id?: string;
    componentClassificationId?: string;
    componentClassification?: ComponentClassification;
    componentCode?: string | undefined;
    description?: string | undefined;
    fromRevisionNonPipeClassId?: number;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    isActive?: boolean;
    disabledPermanently?: boolean;
    notes?: CommonNote[] | undefined;
    componentComponentProperty?: ComponentComponentProperty[] | undefined;
    fromComponentId?: string | undefined;
    valves?: Valve[] | undefined;
}

export class ComponentClassification implements IComponentClassification {
    id?: string;
    code?: string | undefined;
    componentTypeId!: string;
    componentType!: ComponentType;
    componentGroupId!: string;
    componentGroup!: ComponentGroup;

    constructor(data?: IComponentClassification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.componentType = new ComponentType();
            this.componentGroup = new ComponentGroup();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.componentTypeId = _data["componentTypeId"];
            this.componentType = _data["componentType"] ? ComponentType.fromJS(_data["componentType"]) : new ComponentType();
            this.componentGroupId = _data["componentGroupId"];
            this.componentGroup = _data["componentGroup"] ? ComponentGroup.fromJS(_data["componentGroup"]) : new ComponentGroup();
        }
    }

    static fromJS(data: any): ComponentClassification {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentClassification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["componentTypeId"] = this.componentTypeId;
        data["componentType"] = this.componentType ? this.componentType.toJSON() : <any>undefined;
        data["componentGroupId"] = this.componentGroupId;
        data["componentGroup"] = this.componentGroup ? this.componentGroup.toJSON() : <any>undefined;
        return data;
    }
}

export interface IComponentClassification {
    id?: string;
    code?: string | undefined;
    componentTypeId: string;
    componentType: ComponentType;
    componentGroupId: string;
    componentGroup: ComponentGroup;
}

export class ComponentComponentProperty implements IComponentComponentProperty {
    id?: string;
    componentsId?: string;
    componentPropertiesId?: string;
    component!: Component;
    componentProperty?: ComponentProperty;
    componentPropertyNotes?: ComponentPropertyNote[] | undefined;

    constructor(data?: IComponentComponentProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.component = new Component();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.componentsId = _data["componentsId"];
            this.componentPropertiesId = _data["componentPropertiesId"];
            this.component = _data["component"] ? Component.fromJS(_data["component"]) : new Component();
            this.componentProperty = _data["componentProperty"] ? ComponentProperty.fromJS(_data["componentProperty"]) : <any>undefined;
            if (Array.isArray(_data["componentPropertyNotes"])) {
                this.componentPropertyNotes = [] as any;
                for (let item of _data["componentPropertyNotes"])
                    this.componentPropertyNotes!.push(ComponentPropertyNote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComponentComponentProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentComponentProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["componentsId"] = this.componentsId;
        data["componentPropertiesId"] = this.componentPropertiesId;
        data["component"] = this.component ? this.component.toJSON() : <any>undefined;
        data["componentProperty"] = this.componentProperty ? this.componentProperty.toJSON() : <any>undefined;
        if (Array.isArray(this.componentPropertyNotes)) {
            data["componentPropertyNotes"] = [];
            for (let item of this.componentPropertyNotes)
                data["componentPropertyNotes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComponentComponentProperty {
    id?: string;
    componentsId?: string;
    componentPropertiesId?: string;
    component: Component;
    componentProperty?: ComponentProperty;
    componentPropertyNotes?: ComponentPropertyNote[] | undefined;
}

export class ComponentField implements IComponentField {
    id?: string;
    name?: string | undefined;
    label?: string | undefined;
    groups?: ComponentGroup[] | undefined;

    constructor(data?: IComponentField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.label = _data["label"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(ComponentGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComponentField {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["label"] = this.label;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComponentField {
    id?: string;
    name?: string | undefined;
    label?: string | undefined;
    groups?: ComponentGroup[] | undefined;
}

export class ComponentGroup implements IComponentGroup {
    id?: string;
    name!: string | undefined;
    fields?: ComponentField[] | undefined;
    readonly componentProperties?: ComponentProperty[] | undefined;

    constructor(data?: IComponentGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(ComponentField.fromJS(item));
            }
            if (Array.isArray(_data["componentProperties"])) {
                (<any>this).componentProperties = [] as any;
                for (let item of _data["componentProperties"])
                    (<any>this).componentProperties!.push(ComponentProperty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComponentGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        if (Array.isArray(this.componentProperties)) {
            data["componentProperties"] = [];
            for (let item of this.componentProperties)
                data["componentProperties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComponentGroup {
    id?: string;
    name: string | undefined;
    fields?: ComponentField[] | undefined;
    componentProperties?: ComponentProperty[] | undefined;
}

export class ComponentInPipeClass implements IComponentInPipeClass {
    id?: string;
    pipeClassId?: string;
    pipeClass?: PipeClass;
    componentId?: string;
    component?: Component;
    displayOrder?: number;
    commonNotes?: CommonNote[] | undefined;
    pipeClassDictionaryOverrides?: PipeClassDictionaryOverride[] | undefined;
    pipeClassFreeTextOverrides?: PipeClassFreeTextOverride[] | undefined;
    lastUpdatedRevisionId?: number | undefined;
    lastUpdatedRevision?: Revision;
    readonly componentInPipeClassProperties?: ComponentInPipeClassProperty[] | undefined;

    constructor(data?: IComponentInPipeClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pipeClassId = _data["pipeClassId"];
            this.pipeClass = _data["pipeClass"] ? PipeClass.fromJS(_data["pipeClass"]) : <any>undefined;
            this.componentId = _data["componentId"];
            this.component = _data["component"] ? Component.fromJS(_data["component"]) : <any>undefined;
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNote.fromJS(item));
            }
            if (Array.isArray(_data["pipeClassDictionaryOverrides"])) {
                this.pipeClassDictionaryOverrides = [] as any;
                for (let item of _data["pipeClassDictionaryOverrides"])
                    this.pipeClassDictionaryOverrides!.push(PipeClassDictionaryOverride.fromJS(item));
            }
            if (Array.isArray(_data["pipeClassFreeTextOverrides"])) {
                this.pipeClassFreeTextOverrides = [] as any;
                for (let item of _data["pipeClassFreeTextOverrides"])
                    this.pipeClassFreeTextOverrides!.push(PipeClassFreeTextOverride.fromJS(item));
            }
            this.lastUpdatedRevisionId = _data["lastUpdatedRevisionId"];
            this.lastUpdatedRevision = _data["lastUpdatedRevision"] ? Revision.fromJS(_data["lastUpdatedRevision"]) : <any>undefined;
            if (Array.isArray(_data["componentInPipeClassProperties"])) {
                (<any>this).componentInPipeClassProperties = [] as any;
                for (let item of _data["componentInPipeClassProperties"])
                    (<any>this).componentInPipeClassProperties!.push(ComponentInPipeClassProperty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComponentInPipeClass {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentInPipeClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pipeClassId"] = this.pipeClassId;
        data["pipeClass"] = this.pipeClass ? this.pipeClass.toJSON() : <any>undefined;
        data["componentId"] = this.componentId;
        data["component"] = this.component ? this.component.toJSON() : <any>undefined;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.pipeClassDictionaryOverrides)) {
            data["pipeClassDictionaryOverrides"] = [];
            for (let item of this.pipeClassDictionaryOverrides)
                data["pipeClassDictionaryOverrides"].push(item.toJSON());
        }
        if (Array.isArray(this.pipeClassFreeTextOverrides)) {
            data["pipeClassFreeTextOverrides"] = [];
            for (let item of this.pipeClassFreeTextOverrides)
                data["pipeClassFreeTextOverrides"].push(item.toJSON());
        }
        data["lastUpdatedRevisionId"] = this.lastUpdatedRevisionId;
        data["lastUpdatedRevision"] = this.lastUpdatedRevision ? this.lastUpdatedRevision.toJSON() : <any>undefined;
        if (Array.isArray(this.componentInPipeClassProperties)) {
            data["componentInPipeClassProperties"] = [];
            for (let item of this.componentInPipeClassProperties)
                data["componentInPipeClassProperties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComponentInPipeClass {
    id?: string;
    pipeClassId?: string;
    pipeClass?: PipeClass;
    componentId?: string;
    component?: Component;
    displayOrder?: number;
    commonNotes?: CommonNote[] | undefined;
    pipeClassDictionaryOverrides?: PipeClassDictionaryOverride[] | undefined;
    pipeClassFreeTextOverrides?: PipeClassFreeTextOverride[] | undefined;
    lastUpdatedRevisionId?: number | undefined;
    lastUpdatedRevision?: Revision;
    componentInPipeClassProperties?: ComponentInPipeClassProperty[] | undefined;
}

export class ComponentInPipeClassProperty implements IComponentInPipeClassProperty {
    id?: string;
    componentInPipeClassId?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    componentInPipeClass?: ComponentInPipeClass;

    constructor(data?: IComponentInPipeClassProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.componentInPipeClassId = _data["componentInPipeClassId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.componentInPipeClass = _data["componentInPipeClass"] ? ComponentInPipeClass.fromJS(_data["componentInPipeClass"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ComponentInPipeClassProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentInPipeClassProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["componentInPipeClassId"] = this.componentInPipeClassId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["componentInPipeClass"] = this.componentInPipeClass ? this.componentInPipeClass.toJSON() : <any>undefined;
        return data;
    }
}

export interface IComponentInPipeClassProperty {
    id?: string;
    componentInPipeClassId?: string;
    name?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    componentInPipeClass?: ComponentInPipeClass;
}

export class ComponentProperty implements IComponentProperty {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    dataType?: ComponentPropertyDataType;
    description?: string | undefined;
    isActive?: boolean;
    componentGroupId?: string | undefined;
    componentGroup?: ComponentGroup;
    code?: string | undefined;
    componentComponentProperty?: ComponentComponentProperty[] | undefined;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    readonly disabledPermanently?: boolean;

    constructor(data?: IComponentProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.dataType = _data["dataType"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.componentGroupId = _data["componentGroupId"];
            this.componentGroup = _data["componentGroup"] ? ComponentGroup.fromJS(_data["componentGroup"]) : <any>undefined;
            this.code = _data["code"];
            if (Array.isArray(_data["componentComponentProperty"])) {
                this.componentComponentProperty = [] as any;
                for (let item of _data["componentComponentProperty"])
                    this.componentComponentProperty!.push(ComponentComponentProperty.fromJS(item));
            }
            this.fromRevisionNonPipeClassId = _data["fromRevisionNonPipeClassId"];
            this.fromRevisionNonPipeClass = _data["fromRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["fromRevisionNonPipeClass"]) : <any>undefined;
            this.toRevisionNonPipeClassId = _data["toRevisionNonPipeClassId"];
            this.toRevisionNonPipeClass = _data["toRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["toRevisionNonPipeClass"]) : <any>undefined;
            (<any>this).disabledPermanently = _data["disabledPermanently"];
        }
    }

    static fromJS(data: any): ComponentProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["dataType"] = this.dataType;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["componentGroupId"] = this.componentGroupId;
        data["componentGroup"] = this.componentGroup ? this.componentGroup.toJSON() : <any>undefined;
        data["code"] = this.code;
        if (Array.isArray(this.componentComponentProperty)) {
            data["componentComponentProperty"] = [];
            for (let item of this.componentComponentProperty)
                data["componentComponentProperty"].push(item.toJSON());
        }
        data["fromRevisionNonPipeClassId"] = this.fromRevisionNonPipeClassId;
        data["fromRevisionNonPipeClass"] = this.fromRevisionNonPipeClass ? this.fromRevisionNonPipeClass.toJSON() : <any>undefined;
        data["toRevisionNonPipeClassId"] = this.toRevisionNonPipeClassId;
        data["toRevisionNonPipeClass"] = this.toRevisionNonPipeClass ? this.toRevisionNonPipeClass.toJSON() : <any>undefined;
        data["disabledPermanently"] = this.disabledPermanently;
        return data;
    }
}

export interface IComponentProperty {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    dataType?: ComponentPropertyDataType;
    description?: string | undefined;
    isActive?: boolean;
    componentGroupId?: string | undefined;
    componentGroup?: ComponentGroup;
    code?: string | undefined;
    componentComponentProperty?: ComponentComponentProperty[] | undefined;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    disabledPermanently?: boolean;
}

export class ComponentPropertyNote implements IComponentPropertyNote {
    id?: string;
    name?: string | undefined;
    note?: string | undefined;
    componentComponentPropertyId?: string;
    componentComponentProperty?: ComponentComponentProperty;

    constructor(data?: IComponentPropertyNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.note = _data["note"];
            this.componentComponentPropertyId = _data["componentComponentPropertyId"];
            this.componentComponentProperty = _data["componentComponentProperty"] ? ComponentComponentProperty.fromJS(_data["componentComponentProperty"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ComponentPropertyNote {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentPropertyNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["note"] = this.note;
        data["componentComponentPropertyId"] = this.componentComponentPropertyId;
        data["componentComponentProperty"] = this.componentComponentProperty ? this.componentComponentProperty.toJSON() : <any>undefined;
        return data;
    }
}

export interface IComponentPropertyNote {
    id?: string;
    name?: string | undefined;
    note?: string | undefined;
    componentComponentPropertyId?: string;
    componentComponentProperty?: ComponentComponentProperty;
}

export class ComponentType implements IComponentType {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    identifier?: string | undefined;

    constructor(data?: IComponentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): ComponentType {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IComponentType {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    identifier?: string | undefined;
}

export class PipeClass implements IPipeClass {
    id?: string;
    name?: string | undefined;
    fromRevisionId?: number;
    fromRevision?: Revision;
    toRevisionId?: number;
    toRevision?: Revision;
    designCode?: string | undefined;
    designCodeEdition?: string | undefined;
    pressureUnits?: string | undefined;
    temperatureUnits?: string | undefined;
    properties?: PipeClassProperty[] | undefined;
    notes?: PipeClassNote[] | undefined;
    service!: Service;
    serviceId?: string;
    serviceCommonNotes?: CommonNote[] | undefined;
    summaryTableLastUpdatedRevisionId?: number | undefined;
    summaryTableLastUpdatedRevision?: Revision;
    serviceDetails?: ServiceDetail[] | undefined;
    componentsInPipeClass?: ComponentInPipeClass[] | undefined;
    branchTablePipeClasses?: BranchTablePipeClass[] | undefined;
    branchTableLegends?: BranchTableLegend[] | undefined;
    pressureTemperatureTableRelations?: PipeClassPressureTemperatureTableRelation[] | undefined;
    businessUnits?: BusinessUnit[] | undefined;
    valves?: Valve[] | undefined;
    commonNotes?: CommonNote[] | undefined;
    previousPipeClass?: string | undefined;

    constructor(data?: IPipeClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.service = new Service();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fromRevisionId = _data["fromRevisionId"];
            this.fromRevision = _data["fromRevision"] ? Revision.fromJS(_data["fromRevision"]) : <any>undefined;
            this.toRevisionId = _data["toRevisionId"];
            this.toRevision = _data["toRevision"] ? Revision.fromJS(_data["toRevision"]) : <any>undefined;
            this.designCode = _data["designCode"];
            this.designCodeEdition = _data["designCodeEdition"];
            this.pressureUnits = _data["pressureUnits"];
            this.temperatureUnits = _data["temperatureUnits"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PipeClassProperty.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(PipeClassNote.fromJS(item));
            }
            this.service = _data["service"] ? Service.fromJS(_data["service"]) : new Service();
            this.serviceId = _data["serviceId"];
            if (Array.isArray(_data["serviceCommonNotes"])) {
                this.serviceCommonNotes = [] as any;
                for (let item of _data["serviceCommonNotes"])
                    this.serviceCommonNotes!.push(CommonNote.fromJS(item));
            }
            this.summaryTableLastUpdatedRevisionId = _data["summaryTableLastUpdatedRevisionId"];
            this.summaryTableLastUpdatedRevision = _data["summaryTableLastUpdatedRevision"] ? Revision.fromJS(_data["summaryTableLastUpdatedRevision"]) : <any>undefined;
            if (Array.isArray(_data["serviceDetails"])) {
                this.serviceDetails = [] as any;
                for (let item of _data["serviceDetails"])
                    this.serviceDetails!.push(ServiceDetail.fromJS(item));
            }
            if (Array.isArray(_data["componentsInPipeClass"])) {
                this.componentsInPipeClass = [] as any;
                for (let item of _data["componentsInPipeClass"])
                    this.componentsInPipeClass!.push(ComponentInPipeClass.fromJS(item));
            }
            if (Array.isArray(_data["branchTablePipeClasses"])) {
                this.branchTablePipeClasses = [] as any;
                for (let item of _data["branchTablePipeClasses"])
                    this.branchTablePipeClasses!.push(BranchTablePipeClass.fromJS(item));
            }
            if (Array.isArray(_data["branchTableLegends"])) {
                this.branchTableLegends = [] as any;
                for (let item of _data["branchTableLegends"])
                    this.branchTableLegends!.push(BranchTableLegend.fromJS(item));
            }
            if (Array.isArray(_data["pressureTemperatureTableRelations"])) {
                this.pressureTemperatureTableRelations = [] as any;
                for (let item of _data["pressureTemperatureTableRelations"])
                    this.pressureTemperatureTableRelations!.push(PipeClassPressureTemperatureTableRelation.fromJS(item));
            }
            if (Array.isArray(_data["businessUnits"])) {
                this.businessUnits = [] as any;
                for (let item of _data["businessUnits"])
                    this.businessUnits!.push(BusinessUnit.fromJS(item));
            }
            if (Array.isArray(_data["valves"])) {
                this.valves = [] as any;
                for (let item of _data["valves"])
                    this.valves!.push(Valve.fromJS(item));
            }
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNote.fromJS(item));
            }
            this.previousPipeClass = _data["previousPipeClass"];
        }
    }

    static fromJS(data: any): PipeClass {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fromRevisionId"] = this.fromRevisionId;
        data["fromRevision"] = this.fromRevision ? this.fromRevision.toJSON() : <any>undefined;
        data["toRevisionId"] = this.toRevisionId;
        data["toRevision"] = this.toRevision ? this.toRevision.toJSON() : <any>undefined;
        data["designCode"] = this.designCode;
        data["designCodeEdition"] = this.designCodeEdition;
        data["pressureUnits"] = this.pressureUnits;
        data["temperatureUnits"] = this.temperatureUnits;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["serviceId"] = this.serviceId;
        if (Array.isArray(this.serviceCommonNotes)) {
            data["serviceCommonNotes"] = [];
            for (let item of this.serviceCommonNotes)
                data["serviceCommonNotes"].push(item.toJSON());
        }
        data["summaryTableLastUpdatedRevisionId"] = this.summaryTableLastUpdatedRevisionId;
        data["summaryTableLastUpdatedRevision"] = this.summaryTableLastUpdatedRevision ? this.summaryTableLastUpdatedRevision.toJSON() : <any>undefined;
        if (Array.isArray(this.serviceDetails)) {
            data["serviceDetails"] = [];
            for (let item of this.serviceDetails)
                data["serviceDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.componentsInPipeClass)) {
            data["componentsInPipeClass"] = [];
            for (let item of this.componentsInPipeClass)
                data["componentsInPipeClass"].push(item.toJSON());
        }
        if (Array.isArray(this.branchTablePipeClasses)) {
            data["branchTablePipeClasses"] = [];
            for (let item of this.branchTablePipeClasses)
                data["branchTablePipeClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.branchTableLegends)) {
            data["branchTableLegends"] = [];
            for (let item of this.branchTableLegends)
                data["branchTableLegends"].push(item.toJSON());
        }
        if (Array.isArray(this.pressureTemperatureTableRelations)) {
            data["pressureTemperatureTableRelations"] = [];
            for (let item of this.pressureTemperatureTableRelations)
                data["pressureTemperatureTableRelations"].push(item.toJSON());
        }
        if (Array.isArray(this.businessUnits)) {
            data["businessUnits"] = [];
            for (let item of this.businessUnits)
                data["businessUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.valves)) {
            data["valves"] = [];
            for (let item of this.valves)
                data["valves"].push(item.toJSON());
        }
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        data["previousPipeClass"] = this.previousPipeClass;
        return data;
    }
}

export interface IPipeClass {
    id?: string;
    name?: string | undefined;
    fromRevisionId?: number;
    fromRevision?: Revision;
    toRevisionId?: number;
    toRevision?: Revision;
    designCode?: string | undefined;
    designCodeEdition?: string | undefined;
    pressureUnits?: string | undefined;
    temperatureUnits?: string | undefined;
    properties?: PipeClassProperty[] | undefined;
    notes?: PipeClassNote[] | undefined;
    service: Service;
    serviceId?: string;
    serviceCommonNotes?: CommonNote[] | undefined;
    summaryTableLastUpdatedRevisionId?: number | undefined;
    summaryTableLastUpdatedRevision?: Revision;
    serviceDetails?: ServiceDetail[] | undefined;
    componentsInPipeClass?: ComponentInPipeClass[] | undefined;
    branchTablePipeClasses?: BranchTablePipeClass[] | undefined;
    branchTableLegends?: BranchTableLegend[] | undefined;
    pressureTemperatureTableRelations?: PipeClassPressureTemperatureTableRelation[] | undefined;
    businessUnits?: BusinessUnit[] | undefined;
    valves?: Valve[] | undefined;
    commonNotes?: CommonNote[] | undefined;
    previousPipeClass?: string | undefined;
}

export class PipeClassDictionaryOverride implements IPipeClassDictionaryOverride {
    id?: string;
    componentInPipeClassId?: string;
    componentInPipeClass?: ComponentInPipeClass;
    componentPropertyId?: string;
    componentProperty?: ComponentProperty;
    value?: string | undefined;

    constructor(data?: IPipeClassDictionaryOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.componentInPipeClassId = _data["componentInPipeClassId"];
            this.componentInPipeClass = _data["componentInPipeClass"] ? ComponentInPipeClass.fromJS(_data["componentInPipeClass"]) : <any>undefined;
            this.componentPropertyId = _data["componentPropertyId"];
            this.componentProperty = _data["componentProperty"] ? ComponentProperty.fromJS(_data["componentProperty"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PipeClassDictionaryOverride {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassDictionaryOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["componentInPipeClassId"] = this.componentInPipeClassId;
        data["componentInPipeClass"] = this.componentInPipeClass ? this.componentInPipeClass.toJSON() : <any>undefined;
        data["componentPropertyId"] = this.componentPropertyId;
        data["componentProperty"] = this.componentProperty ? this.componentProperty.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IPipeClassDictionaryOverride {
    id?: string;
    componentInPipeClassId?: string;
    componentInPipeClass?: ComponentInPipeClass;
    componentPropertyId?: string;
    componentProperty?: ComponentProperty;
    value?: string | undefined;
}

export class PipeClassFreeTextOverride implements IPipeClassFreeTextOverride {
    id?: string;
    componentInPipeClassId?: string;
    componentInPipeClass?: ComponentInPipeClass;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IPipeClassFreeTextOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.componentInPipeClassId = _data["componentInPipeClassId"];
            this.componentInPipeClass = _data["componentInPipeClass"] ? ComponentInPipeClass.fromJS(_data["componentInPipeClass"]) : <any>undefined;
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PipeClassFreeTextOverride {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassFreeTextOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["componentInPipeClassId"] = this.componentInPipeClassId;
        data["componentInPipeClass"] = this.componentInPipeClass ? this.componentInPipeClass.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IPipeClassFreeTextOverride {
    id?: string;
    componentInPipeClassId?: string;
    componentInPipeClass?: ComponentInPipeClass;
    name?: string | undefined;
    value?: string | undefined;
}

export class PipeClassNote implements IPipeClassNote {
    id?: string;
    note?: string | undefined;
    pipeClassId?: string;
    pipeClass?: PipeClass;

    constructor(data?: IPipeClassNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
            this.pipeClassId = _data["pipeClassId"];
            this.pipeClass = _data["pipeClass"] ? PipeClass.fromJS(_data["pipeClass"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PipeClassNote {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        data["pipeClassId"] = this.pipeClassId;
        data["pipeClass"] = this.pipeClass ? this.pipeClass.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPipeClassNote {
    id?: string;
    note?: string | undefined;
    pipeClassId?: string;
    pipeClass?: PipeClass;
}

export class PipeClassPressureTemperatureTableRelation implements IPipeClassPressureTemperatureTableRelation {
    id?: string;
    pressureTemperatureTableId?: string;
    pressureTemperatureTable?: PressureTemperatureTable;
    pipeClassId?: string;
    pipeClass?: PipeClass;
    pipeClassPressureTemperatureTableRelationNotes?: PipeClassPressureTemperatureTableRelationNote[] | undefined;
    commonNotes?: CommonNote[] | undefined;
    lastUpdatedRevisionId?: number | undefined;
    lastUpdatedRevision?: Revision;

    constructor(data?: IPipeClassPressureTemperatureTableRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pressureTemperatureTableId = _data["pressureTemperatureTableId"];
            this.pressureTemperatureTable = _data["pressureTemperatureTable"] ? PressureTemperatureTable.fromJS(_data["pressureTemperatureTable"]) : <any>undefined;
            this.pipeClassId = _data["pipeClassId"];
            this.pipeClass = _data["pipeClass"] ? PipeClass.fromJS(_data["pipeClass"]) : <any>undefined;
            if (Array.isArray(_data["pipeClassPressureTemperatureTableRelationNotes"])) {
                this.pipeClassPressureTemperatureTableRelationNotes = [] as any;
                for (let item of _data["pipeClassPressureTemperatureTableRelationNotes"])
                    this.pipeClassPressureTemperatureTableRelationNotes!.push(PipeClassPressureTemperatureTableRelationNote.fromJS(item));
            }
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNote.fromJS(item));
            }
            this.lastUpdatedRevisionId = _data["lastUpdatedRevisionId"];
            this.lastUpdatedRevision = _data["lastUpdatedRevision"] ? Revision.fromJS(_data["lastUpdatedRevision"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PipeClassPressureTemperatureTableRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassPressureTemperatureTableRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pressureTemperatureTableId"] = this.pressureTemperatureTableId;
        data["pressureTemperatureTable"] = this.pressureTemperatureTable ? this.pressureTemperatureTable.toJSON() : <any>undefined;
        data["pipeClassId"] = this.pipeClassId;
        data["pipeClass"] = this.pipeClass ? this.pipeClass.toJSON() : <any>undefined;
        if (Array.isArray(this.pipeClassPressureTemperatureTableRelationNotes)) {
            data["pipeClassPressureTemperatureTableRelationNotes"] = [];
            for (let item of this.pipeClassPressureTemperatureTableRelationNotes)
                data["pipeClassPressureTemperatureTableRelationNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        data["lastUpdatedRevisionId"] = this.lastUpdatedRevisionId;
        data["lastUpdatedRevision"] = this.lastUpdatedRevision ? this.lastUpdatedRevision.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPipeClassPressureTemperatureTableRelation {
    id?: string;
    pressureTemperatureTableId?: string;
    pressureTemperatureTable?: PressureTemperatureTable;
    pipeClassId?: string;
    pipeClass?: PipeClass;
    pipeClassPressureTemperatureTableRelationNotes?: PipeClassPressureTemperatureTableRelationNote[] | undefined;
    commonNotes?: CommonNote[] | undefined;
    lastUpdatedRevisionId?: number | undefined;
    lastUpdatedRevision?: Revision;
}

export class PipeClassPressureTemperatureTableRelationNote implements IPipeClassPressureTemperatureTableRelationNote {
    id?: string;
    type?: PressureTemperatureTableNoteType;
    note?: string | undefined;
    pipeClassPressureTemperatureTableRelationId?: string;
    pipeClassPressureTemperatureTableRelation?: PipeClassPressureTemperatureTableRelation;

    constructor(data?: IPipeClassPressureTemperatureTableRelationNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.note = _data["note"];
            this.pipeClassPressureTemperatureTableRelationId = _data["pipeClassPressureTemperatureTableRelationId"];
            this.pipeClassPressureTemperatureTableRelation = _data["pipeClassPressureTemperatureTableRelation"] ? PipeClassPressureTemperatureTableRelation.fromJS(_data["pipeClassPressureTemperatureTableRelation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PipeClassPressureTemperatureTableRelationNote {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassPressureTemperatureTableRelationNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["note"] = this.note;
        data["pipeClassPressureTemperatureTableRelationId"] = this.pipeClassPressureTemperatureTableRelationId;
        data["pipeClassPressureTemperatureTableRelation"] = this.pipeClassPressureTemperatureTableRelation ? this.pipeClassPressureTemperatureTableRelation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPipeClassPressureTemperatureTableRelationNote {
    id?: string;
    type?: PressureTemperatureTableNoteType;
    note?: string | undefined;
    pipeClassPressureTemperatureTableRelationId?: string;
    pipeClassPressureTemperatureTableRelation?: PipeClassPressureTemperatureTableRelation;
}

export class PipeClassProperty implements IPipeClassProperty {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    pipeClassId?: string;
    pipeClass?: PipeClass;
    commonNotes?: CommonNote[] | undefined;

    constructor(data?: IPipeClassProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.pipeClassId = _data["pipeClassId"];
            this.pipeClass = _data["pipeClass"] ? PipeClass.fromJS(_data["pipeClass"]) : <any>undefined;
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PipeClassProperty {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["pipeClassId"] = this.pipeClassId;
        data["pipeClass"] = this.pipeClass ? this.pipeClass.toJSON() : <any>undefined;
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPipeClassProperty {
    id?: string;
    name?: string | undefined;
    value?: string | undefined;
    pipeClassId?: string;
    pipeClass?: PipeClass;
    commonNotes?: CommonNote[] | undefined;
}

export class PipingSearchResponse_1OfPipingSearchResultViewModel implements IPipingSearchResponse_1OfPipingSearchResultViewModel {
    totalResults?: number;
    results?: PipingSearchResultViewModel[] | undefined;
    pipingSearchFilters?: PipingSearchFilterModel[] | undefined;

    constructor(data?: IPipingSearchResponse_1OfPipingSearchResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalResults = _data["totalResults"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PipingSearchResultViewModel.fromJS(item));
            }
            if (Array.isArray(_data["pipingSearchFilters"])) {
                this.pipingSearchFilters = [] as any;
                for (let item of _data["pipingSearchFilters"])
                    this.pipingSearchFilters!.push(PipingSearchFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PipingSearchResponse_1OfPipingSearchResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipingSearchResponse_1OfPipingSearchResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalResults"] = this.totalResults;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.pipingSearchFilters)) {
            data["pipingSearchFilters"] = [];
            for (let item of this.pipingSearchFilters)
                data["pipingSearchFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPipingSearchResponse_1OfPipingSearchResultViewModel {
    totalResults?: number;
    results?: PipingSearchResultViewModel[] | undefined;
    pipingSearchFilters?: PipingSearchFilterModel[] | undefined;
}

export class PressureTemperatureCell implements IPressureTemperatureCell {
    id?: string;
    pressureTemperatureTableId?: string;
    pressureTemperatureTable?: PressureTemperatureTable;
    temperature?: number;
    pressure?: number;
    temperatureUnit?: string | undefined;
    pressureUnit?: string | undefined;
    isAsteriskRequired?: boolean;

    constructor(data?: IPressureTemperatureCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pressureTemperatureTableId = _data["pressureTemperatureTableId"];
            this.pressureTemperatureTable = _data["pressureTemperatureTable"] ? PressureTemperatureTable.fromJS(_data["pressureTemperatureTable"]) : <any>undefined;
            this.temperature = _data["temperature"];
            this.pressure = _data["pressure"];
            this.temperatureUnit = _data["temperatureUnit"];
            this.pressureUnit = _data["pressureUnit"];
            this.isAsteriskRequired = _data["isAsteriskRequired"];
        }
    }

    static fromJS(data: any): PressureTemperatureCell {
        data = typeof data === 'object' ? data : {};
        let result = new PressureTemperatureCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pressureTemperatureTableId"] = this.pressureTemperatureTableId;
        data["pressureTemperatureTable"] = this.pressureTemperatureTable ? this.pressureTemperatureTable.toJSON() : <any>undefined;
        data["temperature"] = this.temperature;
        data["pressure"] = this.pressure;
        data["temperatureUnit"] = this.temperatureUnit;
        data["pressureUnit"] = this.pressureUnit;
        data["isAsteriskRequired"] = this.isAsteriskRequired;
        return data;
    }
}

export interface IPressureTemperatureCell {
    id?: string;
    pressureTemperatureTableId?: string;
    pressureTemperatureTable?: PressureTemperatureTable;
    temperature?: number;
    pressure?: number;
    temperatureUnit?: string | undefined;
    pressureUnit?: string | undefined;
    isAsteriskRequired?: boolean;
}

export class PressureTemperatureTable implements IPressureTemperatureTable {
    id?: string;
    name?: string | undefined;
    pressureUnits?: string | undefined;
    temperatureUnits?: string | undefined;
    isActive?: boolean;
    cells?: PressureTemperatureCell[] | undefined;
    services?: Service[] | undefined;
    commonNotes?: CommonNote[] | undefined;
    tableNotes?: PressureTemperatureTableNote[] | undefined;
    pipeClassRelations?: PipeClassPressureTemperatureTableRelation[] | undefined;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;

    constructor(data?: IPressureTemperatureTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pressureUnits = _data["pressureUnits"];
            this.temperatureUnits = _data["temperatureUnits"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(PressureTemperatureCell.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(Service.fromJS(item));
            }
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNote.fromJS(item));
            }
            if (Array.isArray(_data["tableNotes"])) {
                this.tableNotes = [] as any;
                for (let item of _data["tableNotes"])
                    this.tableNotes!.push(PressureTemperatureTableNote.fromJS(item));
            }
            if (Array.isArray(_data["pipeClassRelations"])) {
                this.pipeClassRelations = [] as any;
                for (let item of _data["pipeClassRelations"])
                    this.pipeClassRelations!.push(PipeClassPressureTemperatureTableRelation.fromJS(item));
            }
            this.toRevisionNonPipeClassId = _data["toRevisionNonPipeClassId"];
            this.toRevisionNonPipeClass = _data["toRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["toRevisionNonPipeClass"]) : <any>undefined;
            this.fromRevisionNonPipeClassId = _data["fromRevisionNonPipeClassId"];
            this.fromRevisionNonPipeClass = _data["fromRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["fromRevisionNonPipeClass"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PressureTemperatureTable {
        data = typeof data === 'object' ? data : {};
        let result = new PressureTemperatureTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pressureUnits"] = this.pressureUnits;
        data["temperatureUnits"] = this.temperatureUnits;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item.toJSON());
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.tableNotes)) {
            data["tableNotes"] = [];
            for (let item of this.tableNotes)
                data["tableNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.pipeClassRelations)) {
            data["pipeClassRelations"] = [];
            for (let item of this.pipeClassRelations)
                data["pipeClassRelations"].push(item.toJSON());
        }
        data["toRevisionNonPipeClassId"] = this.toRevisionNonPipeClassId;
        data["toRevisionNonPipeClass"] = this.toRevisionNonPipeClass ? this.toRevisionNonPipeClass.toJSON() : <any>undefined;
        data["fromRevisionNonPipeClassId"] = this.fromRevisionNonPipeClassId;
        data["fromRevisionNonPipeClass"] = this.fromRevisionNonPipeClass ? this.fromRevisionNonPipeClass.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPressureTemperatureTable {
    id?: string;
    name?: string | undefined;
    pressureUnits?: string | undefined;
    temperatureUnits?: string | undefined;
    isActive?: boolean;
    cells?: PressureTemperatureCell[] | undefined;
    services?: Service[] | undefined;
    commonNotes?: CommonNote[] | undefined;
    tableNotes?: PressureTemperatureTableNote[] | undefined;
    pipeClassRelations?: PipeClassPressureTemperatureTableRelation[] | undefined;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
}

export class PressureTemperatureTableNote implements IPressureTemperatureTableNote {
    id?: string;
    type?: PressureTemperatureTableNoteType;
    note?: string | undefined;
    pressureTemperatureTableId?: string;
    pressureTemperatureTable?: PressureTemperatureTable;

    constructor(data?: IPressureTemperatureTableNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.note = _data["note"];
            this.pressureTemperatureTableId = _data["pressureTemperatureTableId"];
            this.pressureTemperatureTable = _data["pressureTemperatureTable"] ? PressureTemperatureTable.fromJS(_data["pressureTemperatureTable"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PressureTemperatureTableNote {
        data = typeof data === 'object' ? data : {};
        let result = new PressureTemperatureTableNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["note"] = this.note;
        data["pressureTemperatureTableId"] = this.pressureTemperatureTableId;
        data["pressureTemperatureTable"] = this.pressureTemperatureTable ? this.pressureTemperatureTable.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPressureTemperatureTableNote {
    id?: string;
    type?: PressureTemperatureTableNoteType;
    note?: string | undefined;
    pressureTemperatureTableId?: string;
    pressureTemperatureTable?: PressureTemperatureTable;
}

export class Release implements IRelease {
    id?: string;
    name?: string | undefined;
    creationDate?: Date | undefined;
    releaseDate?: Date | undefined;
    businessUnit?: BusinessUnit;
    businessUnitId?: string;
    component?: ReleaseComponent;
    application?: Application;
    applicationId?: string;
    specification?: Specification;
    specificationId?: string | undefined;
    status?: ReleaseStatus;
    authorOid?: string | undefined;
    readonly revisions?: Revision[] | undefined;
    linkedValveRelease?: Release;
    linkedValveReleaseId?: string | undefined;
    roles?: ReleaseRole[] | undefined;
    releaseObjects?: ReleaseObjectGroup[] | undefined;

    constructor(data?: IRelease) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            this.businessUnit = _data["businessUnit"] ? BusinessUnit.fromJS(_data["businessUnit"]) : <any>undefined;
            this.businessUnitId = _data["businessUnitId"];
            this.component = _data["component"];
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.specification = _data["specification"] ? Specification.fromJS(_data["specification"]) : <any>undefined;
            this.specificationId = _data["specificationId"];
            this.status = _data["status"];
            this.authorOid = _data["authorOid"];
            if (Array.isArray(_data["revisions"])) {
                (<any>this).revisions = [] as any;
                for (let item of _data["revisions"])
                    (<any>this).revisions!.push(Revision.fromJS(item));
            }
            this.linkedValveRelease = _data["linkedValveRelease"] ? Release.fromJS(_data["linkedValveRelease"]) : <any>undefined;
            this.linkedValveReleaseId = _data["linkedValveReleaseId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(ReleaseRole.fromJS(item));
            }
            if (Array.isArray(_data["releaseObjects"])) {
                this.releaseObjects = [] as any;
                for (let item of _data["releaseObjects"])
                    this.releaseObjects!.push(ReleaseObjectGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Release {
        data = typeof data === 'object' ? data : {};
        let result = new Release();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["businessUnit"] = this.businessUnit ? this.businessUnit.toJSON() : <any>undefined;
        data["businessUnitId"] = this.businessUnitId;
        data["component"] = this.component;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["specification"] = this.specification ? this.specification.toJSON() : <any>undefined;
        data["specificationId"] = this.specificationId;
        data["status"] = this.status;
        data["authorOid"] = this.authorOid;
        if (Array.isArray(this.revisions)) {
            data["revisions"] = [];
            for (let item of this.revisions)
                data["revisions"].push(item.toJSON());
        }
        data["linkedValveRelease"] = this.linkedValveRelease ? this.linkedValveRelease.toJSON() : <any>undefined;
        data["linkedValveReleaseId"] = this.linkedValveReleaseId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.releaseObjects)) {
            data["releaseObjects"] = [];
            for (let item of this.releaseObjects)
                data["releaseObjects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRelease {
    id?: string;
    name?: string | undefined;
    creationDate?: Date | undefined;
    releaseDate?: Date | undefined;
    businessUnit?: BusinessUnit;
    businessUnitId?: string;
    component?: ReleaseComponent;
    application?: Application;
    applicationId?: string;
    specification?: Specification;
    specificationId?: string | undefined;
    status?: ReleaseStatus;
    authorOid?: string | undefined;
    revisions?: Revision[] | undefined;
    linkedValveRelease?: Release;
    linkedValveReleaseId?: string | undefined;
    roles?: ReleaseRole[] | undefined;
    releaseObjects?: ReleaseObjectGroup[] | undefined;
}

export class ReleaseObjectGroup implements IReleaseObjectGroup {
    id?: string;
    newObject?: string;
    originalObject?: string;
    preservedDraftObject?: string | undefined;
    hasUserModifications?: boolean;
    release?: Release;
    releaseId?: string;
    action?: ReleaseSelectedObject;
    reviewStatus?: RevisionStatus;
    releaseObjectGroupRoles?: ReleaseObjectGroupRole[] | undefined;

    constructor(data?: IReleaseObjectGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newObject = _data["newObject"];
            this.originalObject = _data["originalObject"];
            this.preservedDraftObject = _data["preservedDraftObject"];
            this.hasUserModifications = _data["hasUserModifications"];
            this.release = _data["release"] ? Release.fromJS(_data["release"]) : <any>undefined;
            this.releaseId = _data["releaseId"];
            this.action = _data["action"];
            this.reviewStatus = _data["reviewStatus"];
            if (Array.isArray(_data["releaseObjectGroupRoles"])) {
                this.releaseObjectGroupRoles = [] as any;
                for (let item of _data["releaseObjectGroupRoles"])
                    this.releaseObjectGroupRoles!.push(ReleaseObjectGroupRole.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReleaseObjectGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseObjectGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newObject"] = this.newObject;
        data["originalObject"] = this.originalObject;
        data["preservedDraftObject"] = this.preservedDraftObject;
        data["hasUserModifications"] = this.hasUserModifications;
        data["release"] = this.release ? this.release.toJSON() : <any>undefined;
        data["releaseId"] = this.releaseId;
        data["action"] = this.action;
        data["reviewStatus"] = this.reviewStatus;
        if (Array.isArray(this.releaseObjectGroupRoles)) {
            data["releaseObjectGroupRoles"] = [];
            for (let item of this.releaseObjectGroupRoles)
                data["releaseObjectGroupRoles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReleaseObjectGroup {
    id?: string;
    newObject?: string;
    originalObject?: string;
    preservedDraftObject?: string | undefined;
    hasUserModifications?: boolean;
    release?: Release;
    releaseId?: string;
    action?: ReleaseSelectedObject;
    reviewStatus?: RevisionStatus;
    releaseObjectGroupRoles?: ReleaseObjectGroupRole[] | undefined;
}

export class ReleaseObjectGroupRole implements IReleaseObjectGroupRole {
    releaseObjectGroup?: ReleaseObjectGroup;
    releaseObjectGroupId?: string;
    releaseRole?: ReleaseRole;
    releaseRoleId?: string;
    approvalState!: ApprovalState;

    constructor(data?: IReleaseObjectGroupRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseObjectGroup = _data["releaseObjectGroup"] ? ReleaseObjectGroup.fromJS(_data["releaseObjectGroup"]) : <any>undefined;
            this.releaseObjectGroupId = _data["releaseObjectGroupId"];
            this.releaseRole = _data["releaseRole"] ? ReleaseRole.fromJS(_data["releaseRole"]) : <any>undefined;
            this.releaseRoleId = _data["releaseRoleId"];
            this.approvalState = _data["approvalState"];
        }
    }

    static fromJS(data: any): ReleaseObjectGroupRole {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseObjectGroupRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["releaseObjectGroup"] = this.releaseObjectGroup ? this.releaseObjectGroup.toJSON() : <any>undefined;
        data["releaseObjectGroupId"] = this.releaseObjectGroupId;
        data["releaseRole"] = this.releaseRole ? this.releaseRole.toJSON() : <any>undefined;
        data["releaseRoleId"] = this.releaseRoleId;
        data["approvalState"] = this.approvalState;
        return data;
    }
}

export interface IReleaseObjectGroupRole {
    releaseObjectGroup?: ReleaseObjectGroup;
    releaseObjectGroupId?: string;
    releaseRole?: ReleaseRole;
    releaseRoleId?: string;
    approvalState: ApprovalState;
}

export class ReleaseRole implements IReleaseRole {
    id?: string;
    release?: Release;
    releaseId?: string;
    user?: User;
    userId?: string;
    userRole?: UserType;

    constructor(data?: IReleaseRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.release = _data["release"] ? Release.fromJS(_data["release"]) : <any>undefined;
            this.releaseId = _data["releaseId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.userRole = _data["userRole"];
        }
    }

    static fromJS(data: any): ReleaseRole {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["release"] = this.release ? this.release.toJSON() : <any>undefined;
        data["releaseId"] = this.releaseId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["userRole"] = this.userRole;
        return data;
    }
}

export interface IReleaseRole {
    id?: string;
    release?: Release;
    releaseId?: string;
    user?: User;
    userId?: string;
    userRole?: UserType;
}

export class Revision implements IRevision {
    id?: number;
    name?: string | undefined;
    releaseId?: string | undefined;
    release?: Release;
    description?: string | undefined;
    status?: RevisionStatus;
    authorOid?: string;
    publishDate?: Date | undefined;
    pipeClasses?: PipeClass[] | undefined;
    valves?: Valve[] | undefined;
    readonly createdAt?: Date;
    updatedAt!: Date;
    roles?: Role[] | undefined;
    readonly disabledPermanently?: boolean;
    updatedByFile?: UploadedFile;
    updatedByFileId?: string | undefined;
    isInitial?: boolean;
    initialType?: InitialRevisionType;
    readonly releaseFullName?: string | undefined;

    constructor(data?: IRevision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.releaseId = _data["releaseId"];
            this.release = _data["release"] ? Release.fromJS(_data["release"]) : <any>undefined;
            this.description = _data["description"];
            this.status = _data["status"];
            this.authorOid = _data["authorOid"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["pipeClasses"])) {
                this.pipeClasses = [] as any;
                for (let item of _data["pipeClasses"])
                    this.pipeClasses!.push(PipeClass.fromJS(item));
            }
            if (Array.isArray(_data["valves"])) {
                this.valves = [] as any;
                for (let item of _data["valves"])
                    this.valves!.push(Valve.fromJS(item));
            }
            (<any>this).createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
            (<any>this).disabledPermanently = _data["disabledPermanently"];
            this.updatedByFile = _data["updatedByFile"] ? UploadedFile.fromJS(_data["updatedByFile"]) : <any>undefined;
            this.updatedByFileId = _data["updatedByFileId"];
            this.isInitial = _data["isInitial"];
            this.initialType = _data["initialType"];
            (<any>this).releaseFullName = _data["releaseFullName"];
        }
    }

    static fromJS(data: any): Revision {
        data = typeof data === 'object' ? data : {};
        let result = new Revision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["releaseId"] = this.releaseId;
        data["release"] = this.release ? this.release.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["status"] = this.status;
        data["authorOid"] = this.authorOid;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        if (Array.isArray(this.pipeClasses)) {
            data["pipeClasses"] = [];
            for (let item of this.pipeClasses)
                data["pipeClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.valves)) {
            data["valves"] = [];
            for (let item of this.valves)
                data["valves"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["disabledPermanently"] = this.disabledPermanently;
        data["updatedByFile"] = this.updatedByFile ? this.updatedByFile.toJSON() : <any>undefined;
        data["updatedByFileId"] = this.updatedByFileId;
        data["isInitial"] = this.isInitial;
        data["initialType"] = this.initialType;
        data["releaseFullName"] = this.releaseFullName;
        return data;
    }
}

export interface IRevision {
    id?: number;
    name?: string | undefined;
    releaseId?: string | undefined;
    release?: Release;
    description?: string | undefined;
    status?: RevisionStatus;
    authorOid?: string;
    publishDate?: Date | undefined;
    pipeClasses?: PipeClass[] | undefined;
    valves?: Valve[] | undefined;
    createdAt?: Date;
    updatedAt: Date;
    roles?: Role[] | undefined;
    disabledPermanently?: boolean;
    updatedByFile?: UploadedFile;
    updatedByFileId?: string | undefined;
    isInitial?: boolean;
    initialType?: InitialRevisionType;
    releaseFullName?: string | undefined;
}

export class RevisionNonPipeClass implements IRevisionNonPipeClass {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: RevisionStatus;
    authorOid?: string;
    publishDate?: Date | undefined;
    components?: Component[] | undefined;

    constructor(data?: IRevisionNonPipeClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.authorOid = _data["authorOid"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(Component.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevisionNonPipeClass {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionNonPipeClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["authorOid"] = this.authorOid;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRevisionNonPipeClass {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: RevisionStatus;
    authorOid?: string;
    publishDate?: Date | undefined;
    components?: Component[] | undefined;
}

export class Role implements IRole {
    id?: string;
    user?: User;
    revision?: Revision;
    userRole?: UserType;
    approvalState!: ApprovalState;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.revision = _data["revision"] ? Revision.fromJS(_data["revision"]) : <any>undefined;
            this.userRole = _data["userRole"];
            this.approvalState = _data["approvalState"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["revision"] = this.revision ? this.revision.toJSON() : <any>undefined;
        data["userRole"] = this.userRole;
        data["approvalState"] = this.approvalState;
        return data;
    }
}

export interface IRole {
    id?: string;
    user?: User;
    revision?: Revision;
    userRole?: UserType;
    approvalState: ApprovalState;
}

export class Service implements IService {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
    updated?: Date;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    pipeClasses?: PipeClass[] | undefined;
    pressureTemperatureTables?: PressureTemperatureTable[] | undefined;

    constructor(data?: IService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.fromRevisionNonPipeClassId = _data["fromRevisionNonPipeClassId"];
            this.fromRevisionNonPipeClass = _data["fromRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["fromRevisionNonPipeClass"]) : <any>undefined;
            this.toRevisionNonPipeClassId = _data["toRevisionNonPipeClassId"];
            this.toRevisionNonPipeClass = _data["toRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["toRevisionNonPipeClass"]) : <any>undefined;
            if (Array.isArray(_data["pipeClasses"])) {
                this.pipeClasses = [] as any;
                for (let item of _data["pipeClasses"])
                    this.pipeClasses!.push(PipeClass.fromJS(item));
            }
            if (Array.isArray(_data["pressureTemperatureTables"])) {
                this.pressureTemperatureTables = [] as any;
                for (let item of _data["pressureTemperatureTables"])
                    this.pressureTemperatureTables!.push(PressureTemperatureTable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Service {
        data = typeof data === 'object' ? data : {};
        let result = new Service();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["fromRevisionNonPipeClassId"] = this.fromRevisionNonPipeClassId;
        data["fromRevisionNonPipeClass"] = this.fromRevisionNonPipeClass ? this.fromRevisionNonPipeClass.toJSON() : <any>undefined;
        data["toRevisionNonPipeClassId"] = this.toRevisionNonPipeClassId;
        data["toRevisionNonPipeClass"] = this.toRevisionNonPipeClass ? this.toRevisionNonPipeClass.toJSON() : <any>undefined;
        if (Array.isArray(this.pipeClasses)) {
            data["pipeClasses"] = [];
            for (let item of this.pipeClasses)
                data["pipeClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.pressureTemperatureTables)) {
            data["pressureTemperatureTables"] = [];
            for (let item of this.pressureTemperatureTables)
                data["pressureTemperatureTables"].push(item.toJSON());
        }
        return data;
    }
}

export interface IService {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
    updated?: Date;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
    pipeClasses?: PipeClass[] | undefined;
    pressureTemperatureTables?: PressureTemperatureTable[] | undefined;
}

export class ServiceDetail implements IServiceDetail {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
    updated?: Date;
    pipeClasses?: PipeClass[] | undefined;
    fromRevisionNonPipeClassId?: number;
    toRevisionNonPipeClassId?: number;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClass?: RevisionNonPipeClass;

    constructor(data?: IServiceDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            if (Array.isArray(_data["pipeClasses"])) {
                this.pipeClasses = [] as any;
                for (let item of _data["pipeClasses"])
                    this.pipeClasses!.push(PipeClass.fromJS(item));
            }
            this.fromRevisionNonPipeClassId = _data["fromRevisionNonPipeClassId"];
            this.toRevisionNonPipeClassId = _data["toRevisionNonPipeClassId"];
            this.fromRevisionNonPipeClass = _data["fromRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["fromRevisionNonPipeClass"]) : <any>undefined;
            this.toRevisionNonPipeClass = _data["toRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["toRevisionNonPipeClass"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        if (Array.isArray(this.pipeClasses)) {
            data["pipeClasses"] = [];
            for (let item of this.pipeClasses)
                data["pipeClasses"].push(item.toJSON());
        }
        data["fromRevisionNonPipeClassId"] = this.fromRevisionNonPipeClassId;
        data["toRevisionNonPipeClassId"] = this.toRevisionNonPipeClassId;
        data["fromRevisionNonPipeClass"] = this.fromRevisionNonPipeClass ? this.fromRevisionNonPipeClass.toJSON() : <any>undefined;
        data["toRevisionNonPipeClass"] = this.toRevisionNonPipeClass ? this.toRevisionNonPipeClass.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceDetail {
    id?: string;
    name?: string | undefined;
    isActive?: boolean;
    updated?: Date;
    pipeClasses?: PipeClass[] | undefined;
    fromRevisionNonPipeClassId?: number;
    toRevisionNonPipeClassId?: number;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
}

export class Specification implements ISpecification {
    id?: string;
    name?: string | undefined;
    specificationNumber?: string | undefined;
    specificationTitle?: string | undefined;
    businessUnitId?: string;
    businessUnit?: BusinessUnit;
    applicationId?: string | undefined;
    application?: Application;
    type?: SpecificationType;
    isActive?: boolean;
    updated?: Date;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;

    constructor(data?: ISpecification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.specificationNumber = _data["specificationNumber"];
            this.specificationTitle = _data["specificationTitle"];
            this.businessUnitId = _data["businessUnitId"];
            this.businessUnit = _data["businessUnit"] ? BusinessUnit.fromJS(_data["businessUnit"]) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : <any>undefined;
            this.type = _data["type"];
            this.isActive = _data["isActive"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.fromRevisionNonPipeClassId = _data["fromRevisionNonPipeClassId"];
            this.fromRevisionNonPipeClass = _data["fromRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["fromRevisionNonPipeClass"]) : <any>undefined;
            this.toRevisionNonPipeClassId = _data["toRevisionNonPipeClassId"];
            this.toRevisionNonPipeClass = _data["toRevisionNonPipeClass"] ? RevisionNonPipeClass.fromJS(_data["toRevisionNonPipeClass"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Specification {
        data = typeof data === 'object' ? data : {};
        let result = new Specification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["specificationNumber"] = this.specificationNumber;
        data["specificationTitle"] = this.specificationTitle;
        data["businessUnitId"] = this.businessUnitId;
        data["businessUnit"] = this.businessUnit ? this.businessUnit.toJSON() : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["fromRevisionNonPipeClassId"] = this.fromRevisionNonPipeClassId;
        data["fromRevisionNonPipeClass"] = this.fromRevisionNonPipeClass ? this.fromRevisionNonPipeClass.toJSON() : <any>undefined;
        data["toRevisionNonPipeClassId"] = this.toRevisionNonPipeClassId;
        data["toRevisionNonPipeClass"] = this.toRevisionNonPipeClass ? this.toRevisionNonPipeClass.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISpecification {
    id?: string;
    name?: string | undefined;
    specificationNumber?: string | undefined;
    specificationTitle?: string | undefined;
    businessUnitId?: string;
    businessUnit?: BusinessUnit;
    applicationId?: string | undefined;
    application?: Application;
    type?: SpecificationType;
    isActive?: boolean;
    updated?: Date;
    fromRevisionNonPipeClassId?: number | undefined;
    fromRevisionNonPipeClass?: RevisionNonPipeClass;
    toRevisionNonPipeClassId?: number | undefined;
    toRevisionNonPipeClass?: RevisionNonPipeClass;
}

export class UploadedFile implements IUploadedFile {
    id?: string;
    module?: UploadedFileModule;
    originalFileName?: string | undefined;
    blobPath?: string | undefined;
    mimeType?: string | undefined;
    uploadedAt?: Date;
    uploadedById?: string | undefined;
    uploadedBy?: User;
    status?: ProcessStatus;
    message?: string | undefined;
    updatedRevisions?: Revision[] | undefined;
    parentFile?: UploadedFile;
    parentFileId?: string | undefined;
    parentFileType?: ParentFileType;

    constructor(data?: IUploadedFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.module = _data["module"];
            this.originalFileName = _data["originalFileName"];
            this.blobPath = _data["blobPath"];
            this.mimeType = _data["mimeType"];
            this.uploadedAt = _data["uploadedAt"] ? new Date(_data["uploadedAt"].toString()) : <any>undefined;
            this.uploadedById = _data["uploadedById"];
            this.uploadedBy = _data["uploadedBy"] ? User.fromJS(_data["uploadedBy"]) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["updatedRevisions"])) {
                this.updatedRevisions = [] as any;
                for (let item of _data["updatedRevisions"])
                    this.updatedRevisions!.push(Revision.fromJS(item));
            }
            this.parentFile = _data["parentFile"] ? UploadedFile.fromJS(_data["parentFile"]) : <any>undefined;
            this.parentFileId = _data["parentFileId"];
            this.parentFileType = _data["parentFileType"];
        }
    }

    static fromJS(data: any): UploadedFile {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["module"] = this.module;
        data["originalFileName"] = this.originalFileName;
        data["blobPath"] = this.blobPath;
        data["mimeType"] = this.mimeType;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : <any>undefined;
        data["uploadedById"] = this.uploadedById;
        data["uploadedBy"] = this.uploadedBy ? this.uploadedBy.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.updatedRevisions)) {
            data["updatedRevisions"] = [];
            for (let item of this.updatedRevisions)
                data["updatedRevisions"].push(item.toJSON());
        }
        data["parentFile"] = this.parentFile ? this.parentFile.toJSON() : <any>undefined;
        data["parentFileId"] = this.parentFileId;
        data["parentFileType"] = this.parentFileType;
        return data;
    }
}

export interface IUploadedFile {
    id?: string;
    module?: UploadedFileModule;
    originalFileName?: string | undefined;
    blobPath?: string | undefined;
    mimeType?: string | undefined;
    uploadedAt?: Date;
    uploadedById?: string | undefined;
    uploadedBy?: User;
    status?: ProcessStatus;
    message?: string | undefined;
    updatedRevisions?: Revision[] | undefined;
    parentFile?: UploadedFile;
    parentFileId?: string | undefined;
    parentFileType?: ParentFileType;
}

export class User implements IUser {
    id?: string;
    givenName?: string | undefined;
    surname?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    jobTitle?: string | undefined;
    locationFacilityCode?: string | undefined;
    officeLocation?: string | undefined;
    workerWorkCompanyName?: string | undefined;
    roles?: Role[] | undefined;
    businessUnits?: BusinessUnit[] | undefined;
    accessUpdated?: Date;
    lastAttemptUpdateFromGraphTime?: Date | undefined;
    lastSuccessfulUpdateFromGraphTime?: Date | undefined;
    readonly lastAttemptUpdateFromGraphWasSuccessful?: boolean | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.department = _data["department"];
            this.jobTitle = _data["jobTitle"];
            this.locationFacilityCode = _data["locationFacilityCode"];
            this.officeLocation = _data["officeLocation"];
            this.workerWorkCompanyName = _data["workerWorkCompanyName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
            if (Array.isArray(_data["businessUnits"])) {
                this.businessUnits = [] as any;
                for (let item of _data["businessUnits"])
                    this.businessUnits!.push(BusinessUnit.fromJS(item));
            }
            this.accessUpdated = _data["accessUpdated"] ? new Date(_data["accessUpdated"].toString()) : <any>undefined;
            this.lastAttemptUpdateFromGraphTime = _data["lastAttemptUpdateFromGraphTime"] ? new Date(_data["lastAttemptUpdateFromGraphTime"].toString()) : <any>undefined;
            this.lastSuccessfulUpdateFromGraphTime = _data["lastSuccessfulUpdateFromGraphTime"] ? new Date(_data["lastSuccessfulUpdateFromGraphTime"].toString()) : <any>undefined;
            (<any>this).lastAttemptUpdateFromGraphWasSuccessful = _data["lastAttemptUpdateFromGraphWasSuccessful"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["department"] = this.department;
        data["jobTitle"] = this.jobTitle;
        data["locationFacilityCode"] = this.locationFacilityCode;
        data["officeLocation"] = this.officeLocation;
        data["workerWorkCompanyName"] = this.workerWorkCompanyName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.businessUnits)) {
            data["businessUnits"] = [];
            for (let item of this.businessUnits)
                data["businessUnits"].push(item.toJSON());
        }
        data["accessUpdated"] = this.accessUpdated ? this.accessUpdated.toISOString() : <any>undefined;
        data["lastAttemptUpdateFromGraphTime"] = this.lastAttemptUpdateFromGraphTime ? this.lastAttemptUpdateFromGraphTime.toISOString() : <any>undefined;
        data["lastSuccessfulUpdateFromGraphTime"] = this.lastSuccessfulUpdateFromGraphTime ? this.lastSuccessfulUpdateFromGraphTime.toISOString() : <any>undefined;
        data["lastAttemptUpdateFromGraphWasSuccessful"] = this.lastAttemptUpdateFromGraphWasSuccessful;
        return data;
    }
}

export interface IUser {
    id?: string;
    givenName?: string | undefined;
    surname?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    jobTitle?: string | undefined;
    locationFacilityCode?: string | undefined;
    officeLocation?: string | undefined;
    workerWorkCompanyName?: string | undefined;
    roles?: Role[] | undefined;
    businessUnits?: BusinessUnit[] | undefined;
    accessUpdated?: Date;
    lastAttemptUpdateFromGraphTime?: Date | undefined;
    lastSuccessfulUpdateFromGraphTime?: Date | undefined;
    lastAttemptUpdateFromGraphWasSuccessful?: boolean | undefined;
}

export enum UserType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class Valve implements IValve {
    id?: string;
    tag?: string | undefined;
    pipeClasses?: PipeClass[] | undefined;
    components?: Component[] | undefined;
    fromValveId?: string | undefined;
    fromRevisionId?: number;
    fromRevision?: Revision;
    toRevisionId?: number;
    toRevision?: Revision;
    businessUnits?: BusinessUnit[] | undefined;

    constructor(data?: IValve) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tag = _data["tag"];
            if (Array.isArray(_data["pipeClasses"])) {
                this.pipeClasses = [] as any;
                for (let item of _data["pipeClasses"])
                    this.pipeClasses!.push(PipeClass.fromJS(item));
            }
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(Component.fromJS(item));
            }
            this.fromValveId = _data["fromValveId"];
            this.fromRevisionId = _data["fromRevisionId"];
            this.fromRevision = _data["fromRevision"] ? Revision.fromJS(_data["fromRevision"]) : <any>undefined;
            this.toRevisionId = _data["toRevisionId"];
            this.toRevision = _data["toRevision"] ? Revision.fromJS(_data["toRevision"]) : <any>undefined;
            if (Array.isArray(_data["businessUnits"])) {
                this.businessUnits = [] as any;
                for (let item of _data["businessUnits"])
                    this.businessUnits!.push(BusinessUnit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Valve {
        data = typeof data === 'object' ? data : {};
        let result = new Valve();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tag"] = this.tag;
        if (Array.isArray(this.pipeClasses)) {
            data["pipeClasses"] = [];
            for (let item of this.pipeClasses)
                data["pipeClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        data["fromValveId"] = this.fromValveId;
        data["fromRevisionId"] = this.fromRevisionId;
        data["fromRevision"] = this.fromRevision ? this.fromRevision.toJSON() : <any>undefined;
        data["toRevisionId"] = this.toRevisionId;
        data["toRevision"] = this.toRevision ? this.toRevision.toJSON() : <any>undefined;
        if (Array.isArray(this.businessUnits)) {
            data["businessUnits"] = [];
            for (let item of this.businessUnits)
                data["businessUnits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValve {
    id?: string;
    tag?: string | undefined;
    pipeClasses?: PipeClass[] | undefined;
    components?: Component[] | undefined;
    fromValveId?: string | undefined;
    fromRevisionId?: number;
    fromRevision?: Revision;
    toRevisionId?: number;
    toRevision?: Revision;
    businessUnits?: BusinessUnit[] | undefined;
}

export class AddReleaseCommentReplyRequest implements IAddReleaseCommentReplyRequest {
    content!: string;
    authorName?: string | undefined;

    constructor(data?: IAddReleaseCommentReplyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.authorName = _data["authorName"];
        }
    }

    static fromJS(data: any): AddReleaseCommentReplyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddReleaseCommentReplyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["authorName"] = this.authorName;
        return data;
    }
}

export interface IAddReleaseCommentReplyRequest {
    content: string;
    authorName?: string | undefined;
}

export class AddReplyRequest implements IAddReplyRequest {
    content!: string;
    authorName?: string | undefined;
    displayOrder?: number;

    constructor(data?: IAddReplyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.authorName = _data["authorName"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): AddReplyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddReplyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["authorName"] = this.authorName;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IAddReplyRequest {
    content: string;
    authorName?: string | undefined;
    displayOrder?: number;
}

export class AdditionalPipeClassProperty implements IAdditionalPipeClassProperty {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IAdditionalPipeClassProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AdditionalPipeClassProperty {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalPipeClassProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IAdditionalPipeClassProperty {
    name?: string | undefined;
    value?: string | undefined;
}

export class ApplicationViewModel implements IApplicationViewModel {
    id?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    updated?: Date;
    isActive?: boolean | undefined;
    isReferenced?: boolean | undefined;

    constructor(data?: IApplicationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isReferenced = _data["isReferenced"];
        }
    }

    static fromJS(data: any): ApplicationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isReferenced"] = this.isReferenced;
        return data;
    }
}

export interface IApplicationViewModel {
    id?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    updated?: Date;
    isActive?: boolean | undefined;
    isReferenced?: boolean | undefined;
}

export class BranchTableCellViewModel implements IBranchTableCellViewModel {
    id?: string;
    branchTableId?: string;
    branchSize?: number;
    headerSize?: number;
    branchTableCode?: BranchTableCodeViewModel[] | undefined;

    constructor(data?: IBranchTableCellViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchTableId = _data["branchTableId"];
            this.branchSize = _data["branchSize"];
            this.headerSize = _data["headerSize"];
            if (Array.isArray(_data["branchTableCode"])) {
                this.branchTableCode = [] as any;
                for (let item of _data["branchTableCode"])
                    this.branchTableCode!.push(BranchTableCodeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchTableCellViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTableCellViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branchTableId"] = this.branchTableId;
        data["branchSize"] = this.branchSize;
        data["headerSize"] = this.headerSize;
        if (Array.isArray(this.branchTableCode)) {
            data["branchTableCode"] = [];
            for (let item of this.branchTableCode)
                data["branchTableCode"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchTableCellViewModel {
    id?: string;
    branchTableId?: string;
    branchSize?: number;
    headerSize?: number;
    branchTableCode?: BranchTableCodeViewModel[] | undefined;
}

export class BranchTableCodeViewModel implements IBranchTableCodeViewModel {
    id?: string;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    commonNotes?: CommonNoteViewModel[] | undefined;
    relationCommonNotes?: CommonNoteViewModel[] | undefined;
    fromRevisionId?: number;
    toRevisionId?: number;

    constructor(data?: IBranchTableCodeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["relationCommonNotes"])) {
                this.relationCommonNotes = [] as any;
                for (let item of _data["relationCommonNotes"])
                    this.relationCommonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
            this.fromRevisionId = _data["fromRevisionId"];
            this.toRevisionId = _data["toRevisionId"];
        }
    }

    static fromJS(data: any): BranchTableCodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTableCodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.relationCommonNotes)) {
            data["relationCommonNotes"] = [];
            for (let item of this.relationCommonNotes)
                data["relationCommonNotes"].push(item.toJSON());
        }
        data["fromRevisionId"] = this.fromRevisionId;
        data["toRevisionId"] = this.toRevisionId;
        return data;
    }
}

export interface IBranchTableCodeViewModel {
    id?: string;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    commonNotes?: CommonNoteViewModel[] | undefined;
    relationCommonNotes?: CommonNoteViewModel[] | undefined;
    fromRevisionId?: number;
    toRevisionId?: number;
}

export class BranchTableNoteViewModel implements IBranchTableNoteViewModel {
    type?: string | undefined;
    note?: string | undefined;

    constructor(data?: IBranchTableNoteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): BranchTableNoteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTableNoteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["note"] = this.note;
        return data;
    }
}

export interface IBranchTableNoteViewModel {
    type?: string | undefined;
    note?: string | undefined;
}

export class BranchTablePipeClassViewModel implements IBranchTablePipeClassViewModel {
    pipeClassId?: string;
    freeTextNote?: string | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    relationAdditionalNotes?: BranchTableNoteViewModel[] | undefined;

    constructor(data?: IBranchTablePipeClassViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pipeClassId = _data["pipeClassId"];
            this.freeTextNote = _data["freeTextNote"];
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["relationAdditionalNotes"])) {
                this.relationAdditionalNotes = [] as any;
                for (let item of _data["relationAdditionalNotes"])
                    this.relationAdditionalNotes!.push(BranchTableNoteViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchTablePipeClassViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTablePipeClassViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipeClassId"] = this.pipeClassId;
        data["freeTextNote"] = this.freeTextNote;
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.relationAdditionalNotes)) {
            data["relationAdditionalNotes"] = [];
            for (let item of this.relationAdditionalNotes)
                data["relationAdditionalNotes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchTablePipeClassViewModel {
    pipeClassId?: string;
    freeTextNote?: string | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    relationAdditionalNotes?: BranchTableNoteViewModel[] | undefined;
}

export class BranchTableValidationResult implements IBranchTableValidationResult {
    isCurrent?: boolean;
    latestVersion?: BranchTableViewModel;
    message?: string | undefined;

    constructor(data?: IBranchTableValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCurrent = _data["isCurrent"];
            this.latestVersion = _data["latestVersion"] ? BranchTableViewModel.fromJS(_data["latestVersion"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BranchTableValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTableValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCurrent"] = this.isCurrent;
        data["latestVersion"] = this.latestVersion ? this.latestVersion.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IBranchTableValidationResult {
    isCurrent?: boolean;
    latestVersion?: BranchTableViewModel;
    message?: string | undefined;
}

export class BranchTableViewModel implements IBranchTableViewModel {
    branchTableId?: string;
    name?: string | undefined;
    type?: string | undefined;
    isActive?: boolean;
    cells?: BranchTableCellViewModel[] | undefined;
    codes?: BranchTableCodeViewModel[] | undefined;
    pipeClassIds?: string[] | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    branchTablePipeClassViewModels?: BranchTablePipeClassViewModel[] | undefined;
    isReferenced?: boolean | undefined;
    lastUpdatedRevision?: string | undefined;
    changed?: boolean;
    relationAdditionalNotes?: BranchTableNoteViewModel[] | undefined;
    relationCommonNotes?: CommonNoteViewModel[] | undefined;

    constructor(data?: IBranchTableViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchTableId = _data["branchTableId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(BranchTableCellViewModel.fromJS(item));
            }
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(BranchTableCodeViewModel.fromJS(item));
            }
            if (Array.isArray(_data["pipeClassIds"])) {
                this.pipeClassIds = [] as any;
                for (let item of _data["pipeClassIds"])
                    this.pipeClassIds!.push(item);
            }
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["branchTablePipeClassViewModels"])) {
                this.branchTablePipeClassViewModels = [] as any;
                for (let item of _data["branchTablePipeClassViewModels"])
                    this.branchTablePipeClassViewModels!.push(BranchTablePipeClassViewModel.fromJS(item));
            }
            this.isReferenced = _data["isReferenced"];
            this.lastUpdatedRevision = _data["lastUpdatedRevision"];
            this.changed = _data["changed"];
            if (Array.isArray(_data["relationAdditionalNotes"])) {
                this.relationAdditionalNotes = [] as any;
                for (let item of _data["relationAdditionalNotes"])
                    this.relationAdditionalNotes!.push(BranchTableNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["relationCommonNotes"])) {
                this.relationCommonNotes = [] as any;
                for (let item of _data["relationCommonNotes"])
                    this.relationCommonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchTableViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTableViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchTableId"] = this.branchTableId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item.toJSON());
        }
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item.toJSON());
        }
        if (Array.isArray(this.pipeClassIds)) {
            data["pipeClassIds"] = [];
            for (let item of this.pipeClassIds)
                data["pipeClassIds"].push(item);
        }
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.branchTablePipeClassViewModels)) {
            data["branchTablePipeClassViewModels"] = [];
            for (let item of this.branchTablePipeClassViewModels)
                data["branchTablePipeClassViewModels"].push(item.toJSON());
        }
        data["isReferenced"] = this.isReferenced;
        data["lastUpdatedRevision"] = this.lastUpdatedRevision;
        data["changed"] = this.changed;
        if (Array.isArray(this.relationAdditionalNotes)) {
            data["relationAdditionalNotes"] = [];
            for (let item of this.relationAdditionalNotes)
                data["relationAdditionalNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.relationCommonNotes)) {
            data["relationCommonNotes"] = [];
            for (let item of this.relationCommonNotes)
                data["relationCommonNotes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchTableViewModel {
    branchTableId?: string;
    name?: string | undefined;
    type?: string | undefined;
    isActive?: boolean;
    cells?: BranchTableCellViewModel[] | undefined;
    codes?: BranchTableCodeViewModel[] | undefined;
    pipeClassIds?: string[] | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    branchTablePipeClassViewModels?: BranchTablePipeClassViewModel[] | undefined;
    isReferenced?: boolean | undefined;
    lastUpdatedRevision?: string | undefined;
    changed?: boolean;
    relationAdditionalNotes?: BranchTableNoteViewModel[] | undefined;
    relationCommonNotes?: CommonNoteViewModel[] | undefined;
}

export class BusinessUnitViewModel implements IBusinessUnitViewModel {
    id?: string;
    name?: string | undefined;
    updated?: Date;
    isActive?: boolean | undefined;
    isReferenced?: boolean | undefined;
    alwaysAvailableForEveryUser?: boolean;

    constructor(data?: IBusinessUnitViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isReferenced = _data["isReferenced"];
            this.alwaysAvailableForEveryUser = _data["alwaysAvailableForEveryUser"];
        }
    }

    static fromJS(data: any): BusinessUnitViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessUnitViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isReferenced"] = this.isReferenced;
        data["alwaysAvailableForEveryUser"] = this.alwaysAvailableForEveryUser;
        return data;
    }
}

export interface IBusinessUnitViewModel {
    id?: string;
    name?: string | undefined;
    updated?: Date;
    isActive?: boolean | undefined;
    isReferenced?: boolean | undefined;
    alwaysAvailableForEveryUser?: boolean;
}

export class CloneDraftPipeClassRequest implements ICloneDraftPipeClassRequest {
    sourcePipeClassId?: string;
    newPipeClassName?: string | undefined;
    targetBusinessUnit?: string | undefined;
    targetApplication?: string | undefined;
    releaseId?: string;

    constructor(data?: ICloneDraftPipeClassRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourcePipeClassId = _data["sourcePipeClassId"];
            this.newPipeClassName = _data["newPipeClassName"];
            this.targetBusinessUnit = _data["targetBusinessUnit"];
            this.targetApplication = _data["targetApplication"];
            this.releaseId = _data["releaseId"];
        }
    }

    static fromJS(data: any): CloneDraftPipeClassRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneDraftPipeClassRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourcePipeClassId"] = this.sourcePipeClassId;
        data["newPipeClassName"] = this.newPipeClassName;
        data["targetBusinessUnit"] = this.targetBusinessUnit;
        data["targetApplication"] = this.targetApplication;
        data["releaseId"] = this.releaseId;
        return data;
    }
}

export interface ICloneDraftPipeClassRequest {
    sourcePipeClassId?: string;
    newPipeClassName?: string | undefined;
    targetBusinessUnit?: string | undefined;
    targetApplication?: string | undefined;
    releaseId?: string;
}

export class CloneDraftValveRequest implements ICloneDraftValveRequest {
    sourceValveId?: string;
    targetBusinessUnit?: string | undefined;
    targetApplication?: string | undefined;
    releaseId?: string;

    constructor(data?: ICloneDraftValveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceValveId = _data["sourceValveId"];
            this.targetBusinessUnit = _data["targetBusinessUnit"];
            this.targetApplication = _data["targetApplication"];
            this.releaseId = _data["releaseId"];
        }
    }

    static fromJS(data: any): CloneDraftValveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneDraftValveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceValveId"] = this.sourceValveId;
        data["targetBusinessUnit"] = this.targetBusinessUnit;
        data["targetApplication"] = this.targetApplication;
        data["releaseId"] = this.releaseId;
        return data;
    }
}

export interface ICloneDraftValveRequest {
    sourceValveId?: string;
    targetBusinessUnit?: string | undefined;
    targetApplication?: string | undefined;
    releaseId?: string;
}

export class CloneValveWithDetailsRequest implements ICloneValveWithDetailsRequest {
    sourceValveId?: string;
    tag?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    size?: string | undefined;
    type?: string | undefined;
    shortDescription?: string | undefined;
    pipeClassDescription?: string | undefined;
    componentProperties?: ComponentPropertyViewModel[] | undefined;
    freeFieldPropertyName?: string | undefined;
    freeFieldPropertyValue?: string | undefined;
    releaseId?: string;

    constructor(data?: ICloneValveWithDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceValveId = _data["sourceValveId"];
            this.tag = _data["tag"];
            this.businessUnit = _data["businessUnit"];
            this.application = _data["application"];
            this.size = _data["size"];
            this.type = _data["type"];
            this.shortDescription = _data["shortDescription"];
            this.pipeClassDescription = _data["pipeClassDescription"];
            if (Array.isArray(_data["componentProperties"])) {
                this.componentProperties = [] as any;
                for (let item of _data["componentProperties"])
                    this.componentProperties!.push(ComponentPropertyViewModel.fromJS(item));
            }
            this.freeFieldPropertyName = _data["freeFieldPropertyName"];
            this.freeFieldPropertyValue = _data["freeFieldPropertyValue"];
            this.releaseId = _data["releaseId"];
        }
    }

    static fromJS(data: any): CloneValveWithDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneValveWithDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceValveId"] = this.sourceValveId;
        data["tag"] = this.tag;
        data["businessUnit"] = this.businessUnit;
        data["application"] = this.application;
        data["size"] = this.size;
        data["type"] = this.type;
        data["shortDescription"] = this.shortDescription;
        data["pipeClassDescription"] = this.pipeClassDescription;
        if (Array.isArray(this.componentProperties)) {
            data["componentProperties"] = [];
            for (let item of this.componentProperties)
                data["componentProperties"].push(item.toJSON());
        }
        data["freeFieldPropertyName"] = this.freeFieldPropertyName;
        data["freeFieldPropertyValue"] = this.freeFieldPropertyValue;
        data["releaseId"] = this.releaseId;
        return data;
    }
}

export interface ICloneValveWithDetailsRequest {
    sourceValveId?: string;
    tag?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    size?: string | undefined;
    type?: string | undefined;
    shortDescription?: string | undefined;
    pipeClassDescription?: string | undefined;
    componentProperties?: ComponentPropertyViewModel[] | undefined;
    freeFieldPropertyName?: string | undefined;
    freeFieldPropertyValue?: string | undefined;
    releaseId?: string;
}

export class CommentViewModel implements ICommentViewModel {
    id?: string;
    pipeClassId?: string | undefined;
    revisionId?: number;
    contextType?: string | undefined;
    parentCommentId?: string | undefined;
    authorName?: string | undefined;
    authorId?: string | undefined;
    authorRole?: UserType;
    content?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date | undefined;
    updatedById?: string | undefined;
    displayOrder?: number;
    resolutionStatus?: CommentResolutionStatus;
    replies?: CommentViewModel[] | undefined;

    constructor(data?: ICommentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pipeClassId = _data["pipeClassId"];
            this.revisionId = _data["revisionId"];
            this.contextType = _data["contextType"];
            this.parentCommentId = _data["parentCommentId"];
            this.authorName = _data["authorName"];
            this.authorId = _data["authorId"];
            this.authorRole = _data["authorRole"];
            this.content = _data["content"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.updatedById = _data["updatedById"];
            this.displayOrder = _data["displayOrder"];
            this.resolutionStatus = _data["resolutionStatus"];
            if (Array.isArray(_data["replies"])) {
                this.replies = [] as any;
                for (let item of _data["replies"])
                    this.replies!.push(CommentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pipeClassId"] = this.pipeClassId;
        data["revisionId"] = this.revisionId;
        data["contextType"] = this.contextType;
        data["parentCommentId"] = this.parentCommentId;
        data["authorName"] = this.authorName;
        data["authorId"] = this.authorId;
        data["authorRole"] = this.authorRole;
        data["content"] = this.content;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["updatedById"] = this.updatedById;
        data["displayOrder"] = this.displayOrder;
        data["resolutionStatus"] = this.resolutionStatus;
        if (Array.isArray(this.replies)) {
            data["replies"] = [];
            for (let item of this.replies)
                data["replies"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommentViewModel {
    id?: string;
    pipeClassId?: string | undefined;
    revisionId?: number;
    contextType?: string | undefined;
    parentCommentId?: string | undefined;
    authorName?: string | undefined;
    authorId?: string | undefined;
    authorRole?: UserType;
    content?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date | undefined;
    updatedById?: string | undefined;
    displayOrder?: number;
    resolutionStatus?: CommentResolutionStatus;
    replies?: CommentViewModel[] | undefined;
}

export class CommonNoteViewModel implements ICommonNoteViewModel {
    noteId?: string;
    codeId?: string | undefined;
    note?: string | undefined;
    isActive?: boolean;
    updated?: Date | undefined;
    isArchived?: boolean | undefined;
    isReferenced?: boolean | undefined;

    constructor(data?: ICommonNoteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteId = _data["noteId"];
            this.codeId = _data["codeId"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.isArchived = _data["isArchived"];
            this.isReferenced = _data["isReferenced"];
        }
    }

    static fromJS(data: any): CommonNoteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommonNoteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteId"] = this.noteId;
        data["codeId"] = this.codeId;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["isArchived"] = this.isArchived;
        data["isReferenced"] = this.isReferenced;
        return data;
    }
}

export interface ICommonNoteViewModel {
    noteId?: string;
    codeId?: string | undefined;
    note?: string | undefined;
    isActive?: boolean;
    updated?: Date | undefined;
    isArchived?: boolean | undefined;
    isReferenced?: boolean | undefined;
}

export class ComponentCatalogSearchViewModel implements IComponentCatalogSearchViewModel {
    componentId?: string | undefined;
    componentClassificationId?: string | undefined;
    componentCode?: string | undefined;
    fromRevisionId?: number | undefined;
    toRevisionId?: number | undefined;
    group?: string | undefined;
    type?: string | undefined;
    description?: string | undefined;
    material?: string | undefined;
    astm?: string | undefined;
    construction?: string | undefined;
    designStandard?: string | undefined;
    scH1RAT?: string | undefined;
    scH2?: string | undefined;
    ends?: string | undefined;
    specialRequirements?: string | undefined;
    usedIn?: string | undefined;
    isActive?: boolean;
    isReferenced?: boolean;
    hasPipeClasses?: boolean;
    pipeClassReferences?: PipeClassReferenceViewModel[] | undefined;

    constructor(data?: IComponentCatalogSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.componentClassificationId = _data["componentClassificationId"];
            this.componentCode = _data["componentCode"];
            this.fromRevisionId = _data["fromRevisionId"];
            this.toRevisionId = _data["toRevisionId"];
            this.group = _data["group"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.material = _data["material"];
            this.astm = _data["astm"];
            this.construction = _data["construction"];
            this.designStandard = _data["designStandard"];
            this.scH1RAT = _data["scH1RAT"];
            this.scH2 = _data["scH2"];
            this.ends = _data["ends"];
            this.specialRequirements = _data["specialRequirements"];
            this.usedIn = _data["usedIn"];
            this.isActive = _data["isActive"];
            this.isReferenced = _data["isReferenced"];
            this.hasPipeClasses = _data["hasPipeClasses"];
            if (Array.isArray(_data["pipeClassReferences"])) {
                this.pipeClassReferences = [] as any;
                for (let item of _data["pipeClassReferences"])
                    this.pipeClassReferences!.push(PipeClassReferenceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComponentCatalogSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentCatalogSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["componentClassificationId"] = this.componentClassificationId;
        data["componentCode"] = this.componentCode;
        data["fromRevisionId"] = this.fromRevisionId;
        data["toRevisionId"] = this.toRevisionId;
        data["group"] = this.group;
        data["type"] = this.type;
        data["description"] = this.description;
        data["material"] = this.material;
        data["astm"] = this.astm;
        data["construction"] = this.construction;
        data["designStandard"] = this.designStandard;
        data["scH1RAT"] = this.scH1RAT;
        data["scH2"] = this.scH2;
        data["ends"] = this.ends;
        data["specialRequirements"] = this.specialRequirements;
        data["usedIn"] = this.usedIn;
        data["isActive"] = this.isActive;
        data["isReferenced"] = this.isReferenced;
        data["hasPipeClasses"] = this.hasPipeClasses;
        if (Array.isArray(this.pipeClassReferences)) {
            data["pipeClassReferences"] = [];
            for (let item of this.pipeClassReferences)
                data["pipeClassReferences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComponentCatalogSearchViewModel {
    componentId?: string | undefined;
    componentClassificationId?: string | undefined;
    componentCode?: string | undefined;
    fromRevisionId?: number | undefined;
    toRevisionId?: number | undefined;
    group?: string | undefined;
    type?: string | undefined;
    description?: string | undefined;
    material?: string | undefined;
    astm?: string | undefined;
    construction?: string | undefined;
    designStandard?: string | undefined;
    scH1RAT?: string | undefined;
    scH2?: string | undefined;
    ends?: string | undefined;
    specialRequirements?: string | undefined;
    usedIn?: string | undefined;
    isActive?: boolean;
    isReferenced?: boolean;
    hasPipeClasses?: boolean;
    pipeClassReferences?: PipeClassReferenceViewModel[] | undefined;
}

export class ComponentGroupPropertiesViewModel implements IComponentGroupPropertiesViewModel {
    componentGroupName?: string | undefined;
    componentProperties?: string[] | undefined;

    constructor(data?: IComponentGroupPropertiesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentGroupName = _data["componentGroupName"];
            if (Array.isArray(_data["componentProperties"])) {
                this.componentProperties = [] as any;
                for (let item of _data["componentProperties"])
                    this.componentProperties!.push(item);
            }
        }
    }

    static fromJS(data: any): ComponentGroupPropertiesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentGroupPropertiesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentGroupName"] = this.componentGroupName;
        if (Array.isArray(this.componentProperties)) {
            data["componentProperties"] = [];
            for (let item of this.componentProperties)
                data["componentProperties"].push(item);
        }
        return data;
    }
}

export interface IComponentGroupPropertiesViewModel {
    componentGroupName?: string | undefined;
    componentProperties?: string[] | undefined;
}

export class ComponentGroupViewModel implements IComponentGroupViewModel {
    id?: string;
    name?: string | undefined;

    constructor(data?: IComponentGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ComponentGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IComponentGroupViewModel {
    id?: string;
    name?: string | undefined;
}

export class ComponentPropertyNoteViewModel implements IComponentPropertyNoteViewModel {
    id?: string;
    name?: string | undefined;
    note?: string | undefined;

    constructor(data?: IComponentPropertyNoteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ComponentPropertyNoteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentPropertyNoteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["note"] = this.note;
        return data;
    }
}

export interface IComponentPropertyNoteViewModel {
    id?: string;
    name?: string | undefined;
    note?: string | undefined;
}

export class ComponentPropertyViewModel implements IComponentPropertyViewModel {
    id?: string;
    componentIds?: string[] | undefined;
    componentGroupId?: string;
    name?: string | undefined;
    value?: string | undefined;
    dataType?: ComponentPropertyDataType;
    code?: string | undefined;
    displayOrder?: number;
    notes?: ComponentPropertyNoteViewModel[] | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: IComponentPropertyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [] as any;
                for (let item of _data["componentIds"])
                    this.componentIds!.push(item);
            }
            this.componentGroupId = _data["componentGroupId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.dataType = _data["dataType"];
            this.code = _data["code"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(ComponentPropertyNoteViewModel.fromJS(item));
            }
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ComponentPropertyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentPropertyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        data["componentGroupId"] = this.componentGroupId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["dataType"] = this.dataType;
        data["code"] = this.code;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IComponentPropertyViewModel {
    id?: string;
    componentIds?: string[] | undefined;
    componentGroupId?: string;
    name?: string | undefined;
    value?: string | undefined;
    dataType?: ComponentPropertyDataType;
    code?: string | undefined;
    displayOrder?: number;
    notes?: ComponentPropertyNoteViewModel[] | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export class ComponentValidationResult implements IComponentValidationResult {
    componentId?: string;
    isCurrent?: boolean;
    latestVersion?: ComponentViewModel;
    message?: string | undefined;

    constructor(data?: IComponentValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.isCurrent = _data["isCurrent"];
            this.latestVersion = _data["latestVersion"] ? ComponentViewModel.fromJS(_data["latestVersion"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ComponentValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["isCurrent"] = this.isCurrent;
        data["latestVersion"] = this.latestVersion ? this.latestVersion.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IComponentValidationResult {
    componentId?: string;
    isCurrent?: boolean;
    latestVersion?: ComponentViewModel;
    message?: string | undefined;
}

export class ComponentViewModel implements IComponentViewModel {
    componentId?: string;
    componentClassificationId?: string;
    group?: string | undefined;
    type?: string | undefined;
    typeCode?: string | undefined;
    code?: string | undefined;
    notes?: string | undefined;
    nps?: string | undefined;
    npsFrom?: string | undefined;
    npsTo?: string | undefined;
    schRat?: string | undefined;
    sch2?: string | undefined;
    material?: string | undefined;
    astm?: string | undefined;
    construction?: string | undefined;
    designStandard?: string | undefined;
    specialRequirements?: string | undefined;
    end?: string | undefined;
    description?: string | undefined;
    fromRevisionId?: number;
    toRevisionId?: number;
    isActive?: boolean;
    isReferenced?: boolean | undefined;
    isArchived?: boolean | undefined;

    constructor(data?: IComponentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.componentClassificationId = _data["componentClassificationId"];
            this.group = _data["group"];
            this.type = _data["type"];
            this.typeCode = _data["typeCode"];
            this.code = _data["code"];
            this.notes = _data["notes"];
            this.nps = _data["nps"];
            this.npsFrom = _data["npsFrom"];
            this.npsTo = _data["npsTo"];
            this.schRat = _data["schRat"];
            this.sch2 = _data["sch2"];
            this.material = _data["material"];
            this.astm = _data["astm"];
            this.construction = _data["construction"];
            this.designStandard = _data["designStandard"];
            this.specialRequirements = _data["specialRequirements"];
            this.end = _data["end"];
            this.description = _data["description"];
            this.fromRevisionId = _data["fromRevisionId"];
            this.toRevisionId = _data["toRevisionId"];
            this.isActive = _data["isActive"];
            this.isReferenced = _data["isReferenced"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): ComponentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["componentClassificationId"] = this.componentClassificationId;
        data["group"] = this.group;
        data["type"] = this.type;
        data["typeCode"] = this.typeCode;
        data["code"] = this.code;
        data["notes"] = this.notes;
        data["nps"] = this.nps;
        data["npsFrom"] = this.npsFrom;
        data["npsTo"] = this.npsTo;
        data["schRat"] = this.schRat;
        data["sch2"] = this.sch2;
        data["material"] = this.material;
        data["astm"] = this.astm;
        data["construction"] = this.construction;
        data["designStandard"] = this.designStandard;
        data["specialRequirements"] = this.specialRequirements;
        data["end"] = this.end;
        data["description"] = this.description;
        data["fromRevisionId"] = this.fromRevisionId;
        data["toRevisionId"] = this.toRevisionId;
        data["isActive"] = this.isActive;
        data["isReferenced"] = this.isReferenced;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IComponentViewModel {
    componentId?: string;
    componentClassificationId?: string;
    group?: string | undefined;
    type?: string | undefined;
    typeCode?: string | undefined;
    code?: string | undefined;
    notes?: string | undefined;
    nps?: string | undefined;
    npsFrom?: string | undefined;
    npsTo?: string | undefined;
    schRat?: string | undefined;
    sch2?: string | undefined;
    material?: string | undefined;
    astm?: string | undefined;
    construction?: string | undefined;
    designStandard?: string | undefined;
    specialRequirements?: string | undefined;
    end?: string | undefined;
    description?: string | undefined;
    fromRevisionId?: number;
    toRevisionId?: number;
    isActive?: boolean;
    isReferenced?: boolean | undefined;
    isArchived?: boolean | undefined;
}

export class ComponentsInPipeClassViewModel implements IComponentsInPipeClassViewModel {
    id?: string;
    component?: ComponentViewModel;
    commonNotes?: CommonNoteViewModel[] | undefined;
    displayOrder?: number;
    lastUpdatedRevision?: string | undefined;
    changed?: boolean;

    constructor(data?: IComponentsInPipeClassViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.component = _data["component"] ? ComponentViewModel.fromJS(_data["component"]) : <any>undefined;
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
            this.displayOrder = _data["displayOrder"];
            this.lastUpdatedRevision = _data["lastUpdatedRevision"];
            this.changed = _data["changed"];
        }
    }

    static fromJS(data: any): ComponentsInPipeClassViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentsInPipeClassViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["component"] = this.component ? this.component.toJSON() : <any>undefined;
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        data["displayOrder"] = this.displayOrder;
        data["lastUpdatedRevision"] = this.lastUpdatedRevision;
        data["changed"] = this.changed;
        return data;
    }
}

export interface IComponentsInPipeClassViewModel {
    id?: string;
    component?: ComponentViewModel;
    commonNotes?: CommonNoteViewModel[] | undefined;
    displayOrder?: number;
    lastUpdatedRevision?: string | undefined;
    changed?: boolean;
}

export class ConsolidationMappingViewModel implements IConsolidationMappingViewModel {
    consolidationMappingRecordId?: string;
    originalValue!: string;
    mappedValue!: string;
    pipingObjectType!: PipingObjectType;
    mappingFieldType!: ConsolidationMappingFieldType;

    constructor(data?: IConsolidationMappingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consolidationMappingRecordId = _data["consolidationMappingRecordId"];
            this.originalValue = _data["originalValue"];
            this.mappedValue = _data["mappedValue"];
            this.pipingObjectType = _data["pipingObjectType"];
            this.mappingFieldType = _data["mappingFieldType"];
        }
    }

    static fromJS(data: any): ConsolidationMappingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConsolidationMappingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consolidationMappingRecordId"] = this.consolidationMappingRecordId;
        data["originalValue"] = this.originalValue;
        data["mappedValue"] = this.mappedValue;
        data["pipingObjectType"] = this.pipingObjectType;
        data["mappingFieldType"] = this.mappingFieldType;
        return data;
    }
}

export interface IConsolidationMappingViewModel {
    consolidationMappingRecordId?: string;
    originalValue: string;
    mappedValue: string;
    pipingObjectType: PipingObjectType;
    mappingFieldType: ConsolidationMappingFieldType;
}

export class CreateCommentRequest implements ICreateCommentRequest {
    pipeClassId!: string;
    revisionId!: number;
    contextType!: string;
    parentCommentId?: string | undefined;
    content!: string;
    authorName?: string | undefined;
    displayOrder?: number;

    constructor(data?: ICreateCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pipeClassId = _data["pipeClassId"];
            this.revisionId = _data["revisionId"];
            this.contextType = _data["contextType"];
            this.parentCommentId = _data["parentCommentId"];
            this.content = _data["content"];
            this.authorName = _data["authorName"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreateCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipeClassId"] = this.pipeClassId;
        data["revisionId"] = this.revisionId;
        data["contextType"] = this.contextType;
        data["parentCommentId"] = this.parentCommentId;
        data["content"] = this.content;
        data["authorName"] = this.authorName;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface ICreateCommentRequest {
    pipeClassId: string;
    revisionId: number;
    contextType: string;
    parentCommentId?: string | undefined;
    content: string;
    authorName?: string | undefined;
    displayOrder?: number;
}

export class CreatePipeClassRequest implements ICreatePipeClassRequest {
    name?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    serviceId?: string;
    releaseId?: string;

    constructor(data?: ICreatePipeClassRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.businessUnit = _data["businessUnit"];
            this.application = _data["application"];
            this.serviceId = _data["serviceId"];
            this.releaseId = _data["releaseId"];
        }
    }

    static fromJS(data: any): CreatePipeClassRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePipeClassRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["businessUnit"] = this.businessUnit;
        data["application"] = this.application;
        data["serviceId"] = this.serviceId;
        data["releaseId"] = this.releaseId;
        return data;
    }
}

export interface ICreatePipeClassRequest {
    name?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    serviceId?: string;
    releaseId?: string;
}

export class CreateReleaseCommentRequest implements ICreateReleaseCommentRequest {
    releaseId!: string;
    content!: string;
    authorName?: string | undefined;
    displayOrder?: number;

    constructor(data?: ICreateReleaseCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseId = _data["releaseId"];
            this.content = _data["content"];
            this.authorName = _data["authorName"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreateReleaseCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReleaseCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["releaseId"] = this.releaseId;
        data["content"] = this.content;
        data["authorName"] = this.authorName;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface ICreateReleaseCommentRequest {
    releaseId: string;
    content: string;
    authorName?: string | undefined;
    displayOrder?: number;
}

export class CreateValveRequest implements ICreateValveRequest {
    tag?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    size?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    rev?: string | undefined;
    shortDescription?: string | undefined;
    pipeClassDescription?: string | undefined;
    componentProperties?: ComponentPropertyViewModel[] | undefined;
    freeFieldPropertyName?: string | undefined;
    freeFieldPropertyValue?: string | undefined;
    isShortDescriptionManuallyOverridden?: boolean;
    previousValve?: string | undefined;
    releaseId?: string;

    constructor(data?: ICreateValveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"];
            this.businessUnit = _data["businessUnit"];
            this.application = _data["application"];
            this.size = _data["size"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.rev = _data["rev"];
            this.shortDescription = _data["shortDescription"];
            this.pipeClassDescription = _data["pipeClassDescription"];
            if (Array.isArray(_data["componentProperties"])) {
                this.componentProperties = [] as any;
                for (let item of _data["componentProperties"])
                    this.componentProperties!.push(ComponentPropertyViewModel.fromJS(item));
            }
            this.freeFieldPropertyName = _data["freeFieldPropertyName"];
            this.freeFieldPropertyValue = _data["freeFieldPropertyValue"];
            this.isShortDescriptionManuallyOverridden = _data["isShortDescriptionManuallyOverridden"];
            this.previousValve = _data["previousValve"];
            this.releaseId = _data["releaseId"];
        }
    }

    static fromJS(data: any): CreateValveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateValveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["businessUnit"] = this.businessUnit;
        data["application"] = this.application;
        data["size"] = this.size;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["rev"] = this.rev;
        data["shortDescription"] = this.shortDescription;
        data["pipeClassDescription"] = this.pipeClassDescription;
        if (Array.isArray(this.componentProperties)) {
            data["componentProperties"] = [];
            for (let item of this.componentProperties)
                data["componentProperties"].push(item.toJSON());
        }
        data["freeFieldPropertyName"] = this.freeFieldPropertyName;
        data["freeFieldPropertyValue"] = this.freeFieldPropertyValue;
        data["isShortDescriptionManuallyOverridden"] = this.isShortDescriptionManuallyOverridden;
        data["previousValve"] = this.previousValve;
        data["releaseId"] = this.releaseId;
        return data;
    }
}

export interface ICreateValveRequest {
    tag?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    size?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    rev?: string | undefined;
    shortDescription?: string | undefined;
    pipeClassDescription?: string | undefined;
    componentProperties?: ComponentPropertyViewModel[] | undefined;
    freeFieldPropertyName?: string | undefined;
    freeFieldPropertyValue?: string | undefined;
    isShortDescriptionManuallyOverridden?: boolean;
    previousValve?: string | undefined;
    releaseId?: string;
}

export class PagedResultViewModel_1OfConsolidationMappingViewModel implements IPagedResultViewModel_1OfConsolidationMappingViewModel {
    items?: ConsolidationMappingViewModel[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IPagedResultViewModel_1OfConsolidationMappingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConsolidationMappingViewModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PagedResultViewModel_1OfConsolidationMappingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultViewModel_1OfConsolidationMappingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPagedResultViewModel_1OfConsolidationMappingViewModel {
    items?: ConsolidationMappingViewModel[] | undefined;
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class DocumentCleanupItemViewModel implements IDocumentCleanupItemViewModel {
    jobId?: string;
    documentVersionId?: string;
    uploadedFileId?: string;
    originalFileName?: string | undefined;
    blobPath?: string | undefined;
    uploadedFileModule?: UploadedFileModule;
    cleanupStatus?: DocumentCleanupStatus;
    cleanupReason?: DocumentCleanupReason;
    cleanupRequestedUtc?: Date | undefined;
    cleanupEligibleAfterUtc?: Date | undefined;
    cleanupAttemptCount?: number;
    lastCleanupError?: string | undefined;
    cleanupCompletedUtc?: Date | undefined;
    isCurrent?: boolean;
    jobState?: DocumentUploadJobState;
    uploadedFileStatus?: ProcessStatus;
    referencedByCommittedRecord?: boolean;
    safetyDecision?: DocumentCleanupSafetyDecisionViewModel;

    constructor(data?: IDocumentCleanupItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.documentVersionId = _data["documentVersionId"];
            this.uploadedFileId = _data["uploadedFileId"];
            this.originalFileName = _data["originalFileName"];
            this.blobPath = _data["blobPath"];
            this.uploadedFileModule = _data["uploadedFileModule"];
            this.cleanupStatus = _data["cleanupStatus"];
            this.cleanupReason = _data["cleanupReason"];
            this.cleanupRequestedUtc = _data["cleanupRequestedUtc"] ? new Date(_data["cleanupRequestedUtc"].toString()) : <any>undefined;
            this.cleanupEligibleAfterUtc = _data["cleanupEligibleAfterUtc"] ? new Date(_data["cleanupEligibleAfterUtc"].toString()) : <any>undefined;
            this.cleanupAttemptCount = _data["cleanupAttemptCount"];
            this.lastCleanupError = _data["lastCleanupError"];
            this.cleanupCompletedUtc = _data["cleanupCompletedUtc"] ? new Date(_data["cleanupCompletedUtc"].toString()) : <any>undefined;
            this.isCurrent = _data["isCurrent"];
            this.jobState = _data["jobState"];
            this.uploadedFileStatus = _data["uploadedFileStatus"];
            this.referencedByCommittedRecord = _data["referencedByCommittedRecord"];
            this.safetyDecision = _data["safetyDecision"] ? DocumentCleanupSafetyDecisionViewModel.fromJS(_data["safetyDecision"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentCleanupItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCleanupItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["documentVersionId"] = this.documentVersionId;
        data["uploadedFileId"] = this.uploadedFileId;
        data["originalFileName"] = this.originalFileName;
        data["blobPath"] = this.blobPath;
        data["uploadedFileModule"] = this.uploadedFileModule;
        data["cleanupStatus"] = this.cleanupStatus;
        data["cleanupReason"] = this.cleanupReason;
        data["cleanupRequestedUtc"] = this.cleanupRequestedUtc ? this.cleanupRequestedUtc.toISOString() : <any>undefined;
        data["cleanupEligibleAfterUtc"] = this.cleanupEligibleAfterUtc ? this.cleanupEligibleAfterUtc.toISOString() : <any>undefined;
        data["cleanupAttemptCount"] = this.cleanupAttemptCount;
        data["lastCleanupError"] = this.lastCleanupError;
        data["cleanupCompletedUtc"] = this.cleanupCompletedUtc ? this.cleanupCompletedUtc.toISOString() : <any>undefined;
        data["isCurrent"] = this.isCurrent;
        data["jobState"] = this.jobState;
        data["uploadedFileStatus"] = this.uploadedFileStatus;
        data["referencedByCommittedRecord"] = this.referencedByCommittedRecord;
        data["safetyDecision"] = this.safetyDecision ? this.safetyDecision.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocumentCleanupItemViewModel {
    jobId?: string;
    documentVersionId?: string;
    uploadedFileId?: string;
    originalFileName?: string | undefined;
    blobPath?: string | undefined;
    uploadedFileModule?: UploadedFileModule;
    cleanupStatus?: DocumentCleanupStatus;
    cleanupReason?: DocumentCleanupReason;
    cleanupRequestedUtc?: Date | undefined;
    cleanupEligibleAfterUtc?: Date | undefined;
    cleanupAttemptCount?: number;
    lastCleanupError?: string | undefined;
    cleanupCompletedUtc?: Date | undefined;
    isCurrent?: boolean;
    jobState?: DocumentUploadJobState;
    uploadedFileStatus?: ProcessStatus;
    referencedByCommittedRecord?: boolean;
    safetyDecision?: DocumentCleanupSafetyDecisionViewModel;
}

export class DocumentCleanupPageViewModel implements IDocumentCleanupPageViewModel {
    items?: DocumentCleanupItemViewModel[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    scanLimitReached?: boolean;

    constructor(data?: IDocumentCleanupPageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentCleanupItemViewModel.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.scanLimitReached = _data["scanLimitReached"];
        }
    }

    static fromJS(data: any): DocumentCleanupPageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCleanupPageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["scanLimitReached"] = this.scanLimitReached;
        return data;
    }
}

export interface IDocumentCleanupPageViewModel {
    items?: DocumentCleanupItemViewModel[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    scanLimitReached?: boolean;
}

export class DocumentCleanupSafetyDecisionViewModel implements IDocumentCleanupSafetyDecisionViewModel {
    canDelete?: boolean;
    decisionCode?: string | undefined;
    message?: string | undefined;

    constructor(data?: IDocumentCleanupSafetyDecisionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canDelete = _data["canDelete"];
            this.decisionCode = _data["decisionCode"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DocumentCleanupSafetyDecisionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCleanupSafetyDecisionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canDelete"] = this.canDelete;
        data["decisionCode"] = this.decisionCode;
        data["message"] = this.message;
        return data;
    }
}

export interface IDocumentCleanupSafetyDecisionViewModel {
    canDelete?: boolean;
    decisionCode?: string | undefined;
    message?: string | undefined;
}

export class DocumentCleanupSummaryViewModel implements IDocumentCleanupSummaryViewModel {
    waitingForRetention?: number;
    ready?: number;
    inProgress?: number;
    retryableFailed?: number;
    preserved?: number;
    completed?: number;

    constructor(data?: IDocumentCleanupSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waitingForRetention = _data["waitingForRetention"];
            this.ready = _data["ready"];
            this.inProgress = _data["inProgress"];
            this.retryableFailed = _data["retryableFailed"];
            this.preserved = _data["preserved"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): DocumentCleanupSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCleanupSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waitingForRetention"] = this.waitingForRetention;
        data["ready"] = this.ready;
        data["inProgress"] = this.inProgress;
        data["retryableFailed"] = this.retryableFailed;
        data["preserved"] = this.preserved;
        data["completed"] = this.completed;
        return data;
    }
}

export interface IDocumentCleanupSummaryViewModel {
    waitingForRetention?: number;
    ready?: number;
    inProgress?: number;
    retryableFailed?: number;
    preserved?: number;
    completed?: number;
}

export class DocumentIndexColumnViewModel implements IDocumentIndexColumnViewModel {
    key?: string | undefined;
    header?: string | undefined;
    isRequired?: boolean;

    constructor(data?: IDocumentIndexColumnViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.header = _data["header"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): DocumentIndexColumnViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentIndexColumnViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["header"] = this.header;
        data["isRequired"] = this.isRequired;
        return data;
    }
}

export interface IDocumentIndexColumnViewModel {
    key?: string | undefined;
    header?: string | undefined;
    isRequired?: boolean;
}

export class DocumentIndexRowViewModel implements IDocumentIndexRowViewModel {
    rowId?: number;
    values?: string[] | undefined;

    constructor(data?: IDocumentIndexRowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowId = _data["rowId"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentIndexRowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentIndexRowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowId"] = this.rowId;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IDocumentIndexRowViewModel {
    rowId?: number;
    values?: string[] | undefined;
}

export enum DocumentUploadCommitFailureReason {
    ValidationErrors = 0,
    FilesNotReady = 1,
    UploadChanged = 2,
    Failed = 3,
    UnreferencedFilesNeedDecision = 4,
}

export class DocumentUploadCommitFailureViewModel implements IDocumentUploadCommitFailureViewModel {
    reason?: DocumentUploadCommitFailureReason;
    message?: string | undefined;
    validation?: DocumentUploadValidationViewModel;
    notReadyFiles?: DocumentUploadFileViewModel[] | undefined;
    unreferencedFiles?: DocumentUploadFileViewModel[] | undefined;

    constructor(data?: IDocumentUploadCommitFailureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.message = _data["message"];
            this.validation = _data["validation"] ? DocumentUploadValidationViewModel.fromJS(_data["validation"]) : <any>undefined;
            if (Array.isArray(_data["notReadyFiles"])) {
                this.notReadyFiles = [] as any;
                for (let item of _data["notReadyFiles"])
                    this.notReadyFiles!.push(DocumentUploadFileViewModel.fromJS(item));
            }
            if (Array.isArray(_data["unreferencedFiles"])) {
                this.unreferencedFiles = [] as any;
                for (let item of _data["unreferencedFiles"])
                    this.unreferencedFiles!.push(DocumentUploadFileViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentUploadCommitFailureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadCommitFailureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["message"] = this.message;
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        if (Array.isArray(this.notReadyFiles)) {
            data["notReadyFiles"] = [];
            for (let item of this.notReadyFiles)
                data["notReadyFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.unreferencedFiles)) {
            data["unreferencedFiles"] = [];
            for (let item of this.unreferencedFiles)
                data["unreferencedFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentUploadCommitFailureViewModel {
    reason?: DocumentUploadCommitFailureReason;
    message?: string | undefined;
    validation?: DocumentUploadValidationViewModel;
    notReadyFiles?: DocumentUploadFileViewModel[] | undefined;
    unreferencedFiles?: DocumentUploadFileViewModel[] | undefined;
}

export class DocumentUploadCommitRequest implements IDocumentUploadCommitRequest {
    discardUnreferencedUploadedFiles?: boolean;
    unreferencedFileNames?: string[] | undefined;

    constructor(data?: IDocumentUploadCommitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discardUnreferencedUploadedFiles = _data["discardUnreferencedUploadedFiles"];
            if (Array.isArray(_data["unreferencedFileNames"])) {
                this.unreferencedFileNames = [] as any;
                for (let item of _data["unreferencedFileNames"])
                    this.unreferencedFileNames!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentUploadCommitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadCommitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discardUnreferencedUploadedFiles"] = this.discardUnreferencedUploadedFiles;
        if (Array.isArray(this.unreferencedFileNames)) {
            data["unreferencedFileNames"] = [];
            for (let item of this.unreferencedFileNames)
                data["unreferencedFileNames"].push(item);
        }
        return data;
    }
}

export interface IDocumentUploadCommitRequest {
    discardUnreferencedUploadedFiles?: boolean;
    unreferencedFileNames?: string[] | undefined;
}

export class DocumentUploadCommitResultViewModel implements IDocumentUploadCommitResultViewModel {
    jobId?: string;
    createdRecordIds?: string[] | undefined;
    status?: DocumentUploadStatusViewModel;

    constructor(data?: IDocumentUploadCommitResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            if (Array.isArray(_data["createdRecordIds"])) {
                this.createdRecordIds = [] as any;
                for (let item of _data["createdRecordIds"])
                    this.createdRecordIds!.push(item);
            }
            this.status = _data["status"] ? DocumentUploadStatusViewModel.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentUploadCommitResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadCommitResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        if (Array.isArray(this.createdRecordIds)) {
            data["createdRecordIds"] = [];
            for (let item of this.createdRecordIds)
                data["createdRecordIds"].push(item);
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocumentUploadCommitResultViewModel {
    jobId?: string;
    createdRecordIds?: string[] | undefined;
    status?: DocumentUploadStatusViewModel;
}

export class DocumentUploadDiagnosticCheckViewModel implements IDocumentUploadDiagnosticCheckViewModel {
    name?: string | undefined;
    isOk?: boolean;
    message?: string | undefined;

    constructor(data?: IDocumentUploadDiagnosticCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isOk = _data["isOk"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DocumentUploadDiagnosticCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadDiagnosticCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isOk"] = this.isOk;
        data["message"] = this.message;
        return data;
    }
}

export interface IDocumentUploadDiagnosticCheckViewModel {
    name?: string | undefined;
    isOk?: boolean;
    message?: string | undefined;
}

export class DocumentUploadDiagnosticsViewModel implements IDocumentUploadDiagnosticsViewModel {
    isHealthy?: boolean;
    checks?: DocumentUploadDiagnosticCheckViewModel[] | undefined;
    queueName?: string | undefined;
    instanceId?: string | undefined;
    lastConsumedProbeId?: string | undefined;
    lastConsumedProbeUtc?: Date | undefined;
    lastConsumedProbeByInstance?: string | undefined;
    consecutiveQueueFailures?: number;
    lastQueueFailure?: string | undefined;
    lastQueueFailureUtc?: Date | undefined;
    lastSuccessfulQueueReadUtc?: Date | undefined;
    lastMaintenanceUtc?: Date | undefined;
    messagesCompleted?: number;
    messagesGivenUp?: number;
    probesConsumed?: number;
    cleanup?: DocumentCleanupSummaryViewModel;

    constructor(data?: IDocumentUploadDiagnosticsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isHealthy = _data["isHealthy"];
            if (Array.isArray(_data["checks"])) {
                this.checks = [] as any;
                for (let item of _data["checks"])
                    this.checks!.push(DocumentUploadDiagnosticCheckViewModel.fromJS(item));
            }
            this.queueName = _data["queueName"];
            this.instanceId = _data["instanceId"];
            this.lastConsumedProbeId = _data["lastConsumedProbeId"];
            this.lastConsumedProbeUtc = _data["lastConsumedProbeUtc"] ? new Date(_data["lastConsumedProbeUtc"].toString()) : <any>undefined;
            this.lastConsumedProbeByInstance = _data["lastConsumedProbeByInstance"];
            this.consecutiveQueueFailures = _data["consecutiveQueueFailures"];
            this.lastQueueFailure = _data["lastQueueFailure"];
            this.lastQueueFailureUtc = _data["lastQueueFailureUtc"] ? new Date(_data["lastQueueFailureUtc"].toString()) : <any>undefined;
            this.lastSuccessfulQueueReadUtc = _data["lastSuccessfulQueueReadUtc"] ? new Date(_data["lastSuccessfulQueueReadUtc"].toString()) : <any>undefined;
            this.lastMaintenanceUtc = _data["lastMaintenanceUtc"] ? new Date(_data["lastMaintenanceUtc"].toString()) : <any>undefined;
            this.messagesCompleted = _data["messagesCompleted"];
            this.messagesGivenUp = _data["messagesGivenUp"];
            this.probesConsumed = _data["probesConsumed"];
            this.cleanup = _data["cleanup"] ? DocumentCleanupSummaryViewModel.fromJS(_data["cleanup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentUploadDiagnosticsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadDiagnosticsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHealthy"] = this.isHealthy;
        if (Array.isArray(this.checks)) {
            data["checks"] = [];
            for (let item of this.checks)
                data["checks"].push(item.toJSON());
        }
        data["queueName"] = this.queueName;
        data["instanceId"] = this.instanceId;
        data["lastConsumedProbeId"] = this.lastConsumedProbeId;
        data["lastConsumedProbeUtc"] = this.lastConsumedProbeUtc ? this.lastConsumedProbeUtc.toISOString() : <any>undefined;
        data["lastConsumedProbeByInstance"] = this.lastConsumedProbeByInstance;
        data["consecutiveQueueFailures"] = this.consecutiveQueueFailures;
        data["lastQueueFailure"] = this.lastQueueFailure;
        data["lastQueueFailureUtc"] = this.lastQueueFailureUtc ? this.lastQueueFailureUtc.toISOString() : <any>undefined;
        data["lastSuccessfulQueueReadUtc"] = this.lastSuccessfulQueueReadUtc ? this.lastSuccessfulQueueReadUtc.toISOString() : <any>undefined;
        data["lastMaintenanceUtc"] = this.lastMaintenanceUtc ? this.lastMaintenanceUtc.toISOString() : <any>undefined;
        data["messagesCompleted"] = this.messagesCompleted;
        data["messagesGivenUp"] = this.messagesGivenUp;
        data["probesConsumed"] = this.probesConsumed;
        data["cleanup"] = this.cleanup ? this.cleanup.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocumentUploadDiagnosticsViewModel {
    isHealthy?: boolean;
    checks?: DocumentUploadDiagnosticCheckViewModel[] | undefined;
    queueName?: string | undefined;
    instanceId?: string | undefined;
    lastConsumedProbeId?: string | undefined;
    lastConsumedProbeUtc?: Date | undefined;
    lastConsumedProbeByInstance?: string | undefined;
    consecutiveQueueFailures?: number;
    lastQueueFailure?: string | undefined;
    lastQueueFailureUtc?: Date | undefined;
    lastSuccessfulQueueReadUtc?: Date | undefined;
    lastMaintenanceUtc?: Date | undefined;
    messagesCompleted?: number;
    messagesGivenUp?: number;
    probesConsumed?: number;
    cleanup?: DocumentCleanupSummaryViewModel;
}

export enum DocumentUploadFileState {
    Missing = 0,
    Uploaded = 2,
    Failed = 3,
    Rejected = 4,
}

export class DocumentUploadFileViewModel implements IDocumentUploadFileViewModel {
    fileName?: string | undefined;
    sizeInBytes?: number;
    state?: DocumentUploadFileState;
    message?: string | undefined;

    constructor(data?: IDocumentUploadFileViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.state = _data["state"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DocumentUploadFileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadFileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["sizeInBytes"] = this.sizeInBytes;
        data["state"] = this.state;
        data["message"] = this.message;
        return data;
    }
}

export interface IDocumentUploadFileViewModel {
    fileName?: string | undefined;
    sizeInBytes?: number;
    state?: DocumentUploadFileState;
    message?: string | undefined;
}

export enum DocumentUploadIssueSeverity {
    Warning = 0,
    Error = 1,
    Information = 2,
}

export class DocumentUploadIssueViewModel implements IDocumentUploadIssueViewModel {
    severity?: DocumentUploadIssueSeverity;
    message?: string | undefined;
    rowId?: number | undefined;
    columnKey?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IDocumentUploadIssueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.severity = _data["severity"];
            this.message = _data["message"];
            this.rowId = _data["rowId"];
            this.columnKey = _data["columnKey"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): DocumentUploadIssueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadIssueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["severity"] = this.severity;
        data["message"] = this.message;
        data["rowId"] = this.rowId;
        data["columnKey"] = this.columnKey;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IDocumentUploadIssueViewModel {
    severity?: DocumentUploadIssueSeverity;
    message?: string | undefined;
    rowId?: number | undefined;
    columnKey?: string | undefined;
    fileName?: string | undefined;
}

export enum DocumentUploadJobState {
    Preview = 0,
    Committing = 1,
    Completed = 2,
    Discarded = 3,
    Expired = 4,
    Failed = 5,
}

export class DocumentUploadPreviewViewModel implements IDocumentUploadPreviewViewModel {
    jobId?: string;
    type?: ShareLinkClass;
    indexFileName?: string | undefined;
    columns?: DocumentIndexColumnViewModel[] | undefined;
    rows?: DocumentIndexRowViewModel[] | undefined;
    validation?: DocumentUploadValidationViewModel;
    status?: DocumentUploadStatusViewModel;
    canCommit?: boolean;

    constructor(data?: IDocumentUploadPreviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.type = _data["type"];
            this.indexFileName = _data["indexFileName"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(DocumentIndexColumnViewModel.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DocumentIndexRowViewModel.fromJS(item));
            }
            this.validation = _data["validation"] ? DocumentUploadValidationViewModel.fromJS(_data["validation"]) : <any>undefined;
            this.status = _data["status"] ? DocumentUploadStatusViewModel.fromJS(_data["status"]) : <any>undefined;
            this.canCommit = _data["canCommit"];
        }
    }

    static fromJS(data: any): DocumentUploadPreviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadPreviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["type"] = this.type;
        data["indexFileName"] = this.indexFileName;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["canCommit"] = this.canCommit;
        return data;
    }
}

export interface IDocumentUploadPreviewViewModel {
    jobId?: string;
    type?: ShareLinkClass;
    indexFileName?: string | undefined;
    columns?: DocumentIndexColumnViewModel[] | undefined;
    rows?: DocumentIndexRowViewModel[] | undefined;
    validation?: DocumentUploadValidationViewModel;
    status?: DocumentUploadStatusViewModel;
    canCommit?: boolean;
}

export enum DocumentUploadProbeOutcome {
    QueueUnreachable = 0,
    EnqueueFailed = 1,
    NotYetObserved = 2,
    Consumed = 3,
}

export class DocumentUploadProbeResultViewModel implements IDocumentUploadProbeResultViewModel {
    probeId?: string | undefined;
    outcome?: DocumentUploadProbeOutcome;
    message?: string | undefined;
    queueName?: string | undefined;
    queueReachable?: boolean;
    probeEnqueued?: boolean;
    probeConsumed?: boolean;
    receivedByInstance?: string | undefined;
    consumedByInstance?: string | undefined;
    enqueuedUtc?: Date | undefined;
    consumedUtc?: Date | undefined;
    waitedMilliseconds?: number;

    constructor(data?: IDocumentUploadProbeResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.probeId = _data["probeId"];
            this.outcome = _data["outcome"];
            this.message = _data["message"];
            this.queueName = _data["queueName"];
            this.queueReachable = _data["queueReachable"];
            this.probeEnqueued = _data["probeEnqueued"];
            this.probeConsumed = _data["probeConsumed"];
            this.receivedByInstance = _data["receivedByInstance"];
            this.consumedByInstance = _data["consumedByInstance"];
            this.enqueuedUtc = _data["enqueuedUtc"] ? new Date(_data["enqueuedUtc"].toString()) : <any>undefined;
            this.consumedUtc = _data["consumedUtc"] ? new Date(_data["consumedUtc"].toString()) : <any>undefined;
            this.waitedMilliseconds = _data["waitedMilliseconds"];
        }
    }

    static fromJS(data: any): DocumentUploadProbeResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadProbeResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["probeId"] = this.probeId;
        data["outcome"] = this.outcome;
        data["message"] = this.message;
        data["queueName"] = this.queueName;
        data["queueReachable"] = this.queueReachable;
        data["probeEnqueued"] = this.probeEnqueued;
        data["probeConsumed"] = this.probeConsumed;
        data["receivedByInstance"] = this.receivedByInstance;
        data["consumedByInstance"] = this.consumedByInstance;
        data["enqueuedUtc"] = this.enqueuedUtc ? this.enqueuedUtc.toISOString() : <any>undefined;
        data["consumedUtc"] = this.consumedUtc ? this.consumedUtc.toISOString() : <any>undefined;
        data["waitedMilliseconds"] = this.waitedMilliseconds;
        return data;
    }
}

export interface IDocumentUploadProbeResultViewModel {
    probeId?: string | undefined;
    outcome?: DocumentUploadProbeOutcome;
    message?: string | undefined;
    queueName?: string | undefined;
    queueReachable?: boolean;
    probeEnqueued?: boolean;
    probeConsumed?: boolean;
    receivedByInstance?: string | undefined;
    consumedByInstance?: string | undefined;
    enqueuedUtc?: Date | undefined;
    consumedUtc?: Date | undefined;
    waitedMilliseconds?: number;
}

export class DocumentUploadStatusViewModel implements IDocumentUploadStatusViewModel {
    jobId?: string;
    state?: DocumentUploadJobState;
    files?: DocumentUploadFileViewModel[] | undefined;
    totalFiles?: number;
    completedFiles?: number;
    completedBytes?: number;
    areAllFilesUploaded?: boolean;
    createdRecordIds?: string[] | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IDocumentUploadStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.state = _data["state"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(DocumentUploadFileViewModel.fromJS(item));
            }
            this.totalFiles = _data["totalFiles"];
            this.completedFiles = _data["completedFiles"];
            this.completedBytes = _data["completedBytes"];
            this.areAllFilesUploaded = _data["areAllFilesUploaded"];
            if (Array.isArray(_data["createdRecordIds"])) {
                this.createdRecordIds = [] as any;
                for (let item of _data["createdRecordIds"])
                    this.createdRecordIds!.push(item);
            }
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): DocumentUploadStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["state"] = this.state;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["totalFiles"] = this.totalFiles;
        data["completedFiles"] = this.completedFiles;
        data["completedBytes"] = this.completedBytes;
        data["areAllFilesUploaded"] = this.areAllFilesUploaded;
        if (Array.isArray(this.createdRecordIds)) {
            data["createdRecordIds"] = [];
            for (let item of this.createdRecordIds)
                data["createdRecordIds"].push(item);
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IDocumentUploadStatusViewModel {
    jobId?: string;
    state?: DocumentUploadJobState;
    files?: DocumentUploadFileViewModel[] | undefined;
    totalFiles?: number;
    completedFiles?: number;
    completedBytes?: number;
    areAllFilesUploaded?: boolean;
    createdRecordIds?: string[] | undefined;
    errorMessage?: string | undefined;
}

export class DocumentUploadUpdateViewModel implements IDocumentUploadUpdateViewModel {
    validation?: DocumentUploadValidationViewModel;
    status?: DocumentUploadStatusViewModel;
    canCommit?: boolean;
    results?: DocumentUploadFileViewModel[] | undefined;

    constructor(data?: IDocumentUploadUpdateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validation = _data["validation"] ? DocumentUploadValidationViewModel.fromJS(_data["validation"]) : <any>undefined;
            this.status = _data["status"] ? DocumentUploadStatusViewModel.fromJS(_data["status"]) : <any>undefined;
            this.canCommit = _data["canCommit"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DocumentUploadFileViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentUploadUpdateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadUpdateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["canCommit"] = this.canCommit;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentUploadUpdateViewModel {
    validation?: DocumentUploadValidationViewModel;
    status?: DocumentUploadStatusViewModel;
    canCommit?: boolean;
    results?: DocumentUploadFileViewModel[] | undefined;
}

export class DocumentUploadValidationViewModel implements IDocumentUploadValidationViewModel {
    issues?: DocumentUploadIssueViewModel[] | undefined;
    errorCount?: number;
    warningCount?: number;
    ignoredRowCount?: number;

    constructor(data?: IDocumentUploadValidationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(DocumentUploadIssueViewModel.fromJS(item));
            }
            this.errorCount = _data["errorCount"];
            this.warningCount = _data["warningCount"];
            this.ignoredRowCount = _data["ignoredRowCount"];
        }
    }

    static fromJS(data: any): DocumentUploadValidationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadValidationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        data["errorCount"] = this.errorCount;
        data["warningCount"] = this.warningCount;
        data["ignoredRowCount"] = this.ignoredRowCount;
        return data;
    }
}

export interface IDocumentUploadValidationViewModel {
    issues?: DocumentUploadIssueViewModel[] | undefined;
    errorCount?: number;
    warningCount?: number;
    ignoredRowCount?: number;
}

export class UpdateDocumentIndexRowsRequest implements IUpdateDocumentIndexRowsRequest {
    rows?: DocumentIndexRowViewModel[] | undefined;

    constructor(data?: IUpdateDocumentIndexRowsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DocumentIndexRowViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDocumentIndexRowsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentIndexRowsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateDocumentIndexRowsRequest {
    rows?: DocumentIndexRowViewModel[] | undefined;
}

export class DesignCodeViewModel implements IDesignCodeViewModel {
    value?: string | undefined;
    edition?: string | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;

    constructor(data?: IDesignCodeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.edition = _data["edition"];
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DesignCodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DesignCodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["edition"] = this.edition;
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDesignCodeViewModel {
    value?: string | undefined;
    edition?: string | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
}

export class RatingClassViewModel implements IRatingClassViewModel {
    value?: string | undefined;
    edition?: string | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;

    constructor(data?: IRatingClassViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.edition = _data["edition"];
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RatingClassViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RatingClassViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["edition"] = this.edition;
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRatingClassViewModel {
    value?: string | undefined;
    edition?: string | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
}

export class TemperatureRangeViewModel implements ITemperatureRangeViewModel {
    temperatureUnit?: string | undefined;
    minimum?: string | undefined;
    maximum?: string | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    range?: string | undefined;

    constructor(data?: ITemperatureRangeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temperatureUnit = _data["temperatureUnit"];
            this.minimum = _data["minimum"];
            this.maximum = _data["maximum"];
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
            this.range = _data["range"];
        }
    }

    static fromJS(data: any): TemperatureRangeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureRangeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperatureUnit"] = this.temperatureUnit;
        data["minimum"] = this.minimum;
        data["maximum"] = this.maximum;
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        data["range"] = this.range;
        return data;
    }
}

export interface ITemperatureRangeViewModel {
    temperatureUnit?: string | undefined;
    minimum?: string | undefined;
    maximum?: string | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    range?: string | undefined;
}

export class PipeClassNameAvailabilityViewModel implements IPipeClassNameAvailabilityViewModel {
    existsInSameBusinessUnit?: boolean;
    existsInDifferentBusinessUnit?: boolean;

    constructor(data?: IPipeClassNameAvailabilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.existsInSameBusinessUnit = _data["existsInSameBusinessUnit"];
            this.existsInDifferentBusinessUnit = _data["existsInDifferentBusinessUnit"];
        }
    }

    static fromJS(data: any): PipeClassNameAvailabilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassNameAvailabilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existsInSameBusinessUnit"] = this.existsInSameBusinessUnit;
        data["existsInDifferentBusinessUnit"] = this.existsInDifferentBusinessUnit;
        return data;
    }
}

export interface IPipeClassNameAvailabilityViewModel {
    existsInSameBusinessUnit?: boolean;
    existsInDifferentBusinessUnit?: boolean;
}

export class PipeClassNoteViewModel implements IPipeClassNoteViewModel {
    id?: string;
    note?: string | undefined;

    constructor(data?: IPipeClassNoteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PipeClassNoteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassNoteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        return data;
    }
}

export interface IPipeClassNoteViewModel {
    id?: string;
    note?: string | undefined;
}

export class PipeClassPropertyViewModel implements IPipeClassPropertyViewModel {
    name?: string | undefined;
    value?: string | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;

    constructor(data?: IPipeClassPropertyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PipeClassPropertyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassPropertyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPipeClassPropertyViewModel {
    name?: string | undefined;
    value?: string | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
}

export class PipeClassReferenceViewModel implements IPipeClassReferenceViewModel {
    id?: string;
    name?: string | undefined;

    constructor(data?: IPipeClassReferenceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PipeClassReferenceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassReferenceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPipeClassReferenceViewModel {
    id?: string;
    name?: string | undefined;
}

export class PipeClassSummaryPropertyDictionaryViewModel implements IPipeClassSummaryPropertyDictionaryViewModel {
    id?: string;
    propertyName?: string | undefined;
    value?: string | undefined;
    isActive?: boolean;
    created?: Date;
    updated?: Date;

    constructor(data?: IPipeClassSummaryPropertyDictionaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.propertyName = _data["propertyName"];
            this.value = _data["value"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PipeClassSummaryPropertyDictionaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassSummaryPropertyDictionaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["propertyName"] = this.propertyName;
        data["value"] = this.value;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPipeClassSummaryPropertyDictionaryViewModel {
    id?: string;
    propertyName?: string | undefined;
    value?: string | undefined;
    isActive?: boolean;
    created?: Date;
    updated?: Date;
}

export class PipeClassViewModel implements IPipeClassViewModel {
    id!: string;
    name?: string | undefined;
    service!: ServiceViewModel;
    serviceDetails?: ServiceDetailViewModel[] | undefined;
    ratingClass?: RatingClassViewModel;
    temperatureRange?: TemperatureRangeViewModel;
    nominalCorrosionAllowance?: PipeClassPropertyViewModel;
    valveTrim?: PipeClassPropertyViewModel;
    material?: PipeClassPropertyViewModel;
    designCode?: DesignCodeViewModel;
    stressRelief?: PipeClassPropertyViewModel;
    examination?: PipeClassPropertyViewModel;
    limitedBy?: PipeClassPropertyViewModel;
    businessUnits?: string[] | undefined;
    application?: string | undefined;
    applicationShortName?: string | undefined;
    sizeRange?: string | undefined;
    publishDate?: Date | undefined;
    temperatureUnits?: string | undefined;
    pressureUnits?: string | undefined;
    relatedVersions?: string | undefined;
    fromRevision?: SimpleRevisionViewModel;
    releaseObjectGroup?: ReleaseObjectGroupViewModel;
    summaryTableLastUpdatedRevision?: string | undefined;
    summaryTableChanged?: boolean;
    release?: string | undefined;
    pressureTemperatureTables?: PressureTemperatureTableViewModel[] | undefined;
    componentsInPipeClass?: ComponentsInPipeClassViewModel[] | undefined;
    branchTables?: BranchTableViewModel[] | undefined;
    additionalPipeClassProperties?: AdditionalPipeClassProperty[] | undefined;
    valves?: ValveViewModel[] | undefined;
    customNotes?: PipeClassNoteViewModel[] | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    previousPipeClass?: string | undefined;
    isArchived?: boolean | undefined;
    isDraft?: boolean | undefined;
    isRetired?: boolean | undefined;
    readonly isCurrent?: boolean | undefined;

    constructor(data?: IPipeClassViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.service = new ServiceViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.service = _data["service"] ? ServiceViewModel.fromJS(_data["service"]) : new ServiceViewModel();
            if (Array.isArray(_data["serviceDetails"])) {
                this.serviceDetails = [] as any;
                for (let item of _data["serviceDetails"])
                    this.serviceDetails!.push(ServiceDetailViewModel.fromJS(item));
            }
            this.ratingClass = _data["ratingClass"] ? RatingClassViewModel.fromJS(_data["ratingClass"]) : <any>undefined;
            this.temperatureRange = _data["temperatureRange"] ? TemperatureRangeViewModel.fromJS(_data["temperatureRange"]) : <any>undefined;
            this.nominalCorrosionAllowance = _data["nominalCorrosionAllowance"] ? PipeClassPropertyViewModel.fromJS(_data["nominalCorrosionAllowance"]) : <any>undefined;
            this.valveTrim = _data["valveTrim"] ? PipeClassPropertyViewModel.fromJS(_data["valveTrim"]) : <any>undefined;
            this.material = _data["material"] ? PipeClassPropertyViewModel.fromJS(_data["material"]) : <any>undefined;
            this.designCode = _data["designCode"] ? DesignCodeViewModel.fromJS(_data["designCode"]) : <any>undefined;
            this.stressRelief = _data["stressRelief"] ? PipeClassPropertyViewModel.fromJS(_data["stressRelief"]) : <any>undefined;
            this.examination = _data["examination"] ? PipeClassPropertyViewModel.fromJS(_data["examination"]) : <any>undefined;
            this.limitedBy = _data["limitedBy"] ? PipeClassPropertyViewModel.fromJS(_data["limitedBy"]) : <any>undefined;
            if (Array.isArray(_data["businessUnits"])) {
                this.businessUnits = [] as any;
                for (let item of _data["businessUnits"])
                    this.businessUnits!.push(item);
            }
            this.application = _data["application"];
            this.applicationShortName = _data["applicationShortName"];
            this.sizeRange = _data["sizeRange"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.temperatureUnits = _data["temperatureUnits"];
            this.pressureUnits = _data["pressureUnits"];
            this.relatedVersions = _data["relatedVersions"];
            this.fromRevision = _data["fromRevision"] ? SimpleRevisionViewModel.fromJS(_data["fromRevision"]) : <any>undefined;
            this.releaseObjectGroup = _data["releaseObjectGroup"] ? ReleaseObjectGroupViewModel.fromJS(_data["releaseObjectGroup"]) : <any>undefined;
            this.summaryTableLastUpdatedRevision = _data["summaryTableLastUpdatedRevision"];
            this.summaryTableChanged = _data["summaryTableChanged"];
            this.release = _data["release"];
            if (Array.isArray(_data["pressureTemperatureTables"])) {
                this.pressureTemperatureTables = [] as any;
                for (let item of _data["pressureTemperatureTables"])
                    this.pressureTemperatureTables!.push(PressureTemperatureTableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["componentsInPipeClass"])) {
                this.componentsInPipeClass = [] as any;
                for (let item of _data["componentsInPipeClass"])
                    this.componentsInPipeClass!.push(ComponentsInPipeClassViewModel.fromJS(item));
            }
            if (Array.isArray(_data["branchTables"])) {
                this.branchTables = [] as any;
                for (let item of _data["branchTables"])
                    this.branchTables!.push(BranchTableViewModel.fromJS(item));
            }
            if (Array.isArray(_data["additionalPipeClassProperties"])) {
                this.additionalPipeClassProperties = [] as any;
                for (let item of _data["additionalPipeClassProperties"])
                    this.additionalPipeClassProperties!.push(AdditionalPipeClassProperty.fromJS(item));
            }
            if (Array.isArray(_data["valves"])) {
                this.valves = [] as any;
                for (let item of _data["valves"])
                    this.valves!.push(ValveViewModel.fromJS(item));
            }
            if (Array.isArray(_data["customNotes"])) {
                this.customNotes = [] as any;
                for (let item of _data["customNotes"])
                    this.customNotes!.push(PipeClassNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
            this.previousPipeClass = _data["previousPipeClass"];
            this.isArchived = _data["isArchived"];
            this.isDraft = _data["isDraft"];
            this.isRetired = _data["isRetired"];
            (<any>this).isCurrent = _data["isCurrent"];
        }
    }

    static fromJS(data: any): PipeClassViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipeClassViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        if (Array.isArray(this.serviceDetails)) {
            data["serviceDetails"] = [];
            for (let item of this.serviceDetails)
                data["serviceDetails"].push(item.toJSON());
        }
        data["ratingClass"] = this.ratingClass ? this.ratingClass.toJSON() : <any>undefined;
        data["temperatureRange"] = this.temperatureRange ? this.temperatureRange.toJSON() : <any>undefined;
        data["nominalCorrosionAllowance"] = this.nominalCorrosionAllowance ? this.nominalCorrosionAllowance.toJSON() : <any>undefined;
        data["valveTrim"] = this.valveTrim ? this.valveTrim.toJSON() : <any>undefined;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["designCode"] = this.designCode ? this.designCode.toJSON() : <any>undefined;
        data["stressRelief"] = this.stressRelief ? this.stressRelief.toJSON() : <any>undefined;
        data["examination"] = this.examination ? this.examination.toJSON() : <any>undefined;
        data["limitedBy"] = this.limitedBy ? this.limitedBy.toJSON() : <any>undefined;
        if (Array.isArray(this.businessUnits)) {
            data["businessUnits"] = [];
            for (let item of this.businessUnits)
                data["businessUnits"].push(item);
        }
        data["application"] = this.application;
        data["applicationShortName"] = this.applicationShortName;
        data["sizeRange"] = this.sizeRange;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["temperatureUnits"] = this.temperatureUnits;
        data["pressureUnits"] = this.pressureUnits;
        data["relatedVersions"] = this.relatedVersions;
        data["fromRevision"] = this.fromRevision ? this.fromRevision.toJSON() : <any>undefined;
        data["releaseObjectGroup"] = this.releaseObjectGroup ? this.releaseObjectGroup.toJSON() : <any>undefined;
        data["summaryTableLastUpdatedRevision"] = this.summaryTableLastUpdatedRevision;
        data["summaryTableChanged"] = this.summaryTableChanged;
        data["release"] = this.release;
        if (Array.isArray(this.pressureTemperatureTables)) {
            data["pressureTemperatureTables"] = [];
            for (let item of this.pressureTemperatureTables)
                data["pressureTemperatureTables"].push(item.toJSON());
        }
        if (Array.isArray(this.componentsInPipeClass)) {
            data["componentsInPipeClass"] = [];
            for (let item of this.componentsInPipeClass)
                data["componentsInPipeClass"].push(item.toJSON());
        }
        if (Array.isArray(this.branchTables)) {
            data["branchTables"] = [];
            for (let item of this.branchTables)
                data["branchTables"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalPipeClassProperties)) {
            data["additionalPipeClassProperties"] = [];
            for (let item of this.additionalPipeClassProperties)
                data["additionalPipeClassProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.valves)) {
            data["valves"] = [];
            for (let item of this.valves)
                data["valves"].push(item.toJSON());
        }
        if (Array.isArray(this.customNotes)) {
            data["customNotes"] = [];
            for (let item of this.customNotes)
                data["customNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        data["previousPipeClass"] = this.previousPipeClass;
        data["isArchived"] = this.isArchived;
        data["isDraft"] = this.isDraft;
        data["isRetired"] = this.isRetired;
        data["isCurrent"] = this.isCurrent;
        return data;
    }
}

export interface IPipeClassViewModel {
    id: string;
    name?: string | undefined;
    service: ServiceViewModel;
    serviceDetails?: ServiceDetailViewModel[] | undefined;
    ratingClass?: RatingClassViewModel;
    temperatureRange?: TemperatureRangeViewModel;
    nominalCorrosionAllowance?: PipeClassPropertyViewModel;
    valveTrim?: PipeClassPropertyViewModel;
    material?: PipeClassPropertyViewModel;
    designCode?: DesignCodeViewModel;
    stressRelief?: PipeClassPropertyViewModel;
    examination?: PipeClassPropertyViewModel;
    limitedBy?: PipeClassPropertyViewModel;
    businessUnits?: string[] | undefined;
    application?: string | undefined;
    applicationShortName?: string | undefined;
    sizeRange?: string | undefined;
    publishDate?: Date | undefined;
    temperatureUnits?: string | undefined;
    pressureUnits?: string | undefined;
    relatedVersions?: string | undefined;
    fromRevision?: SimpleRevisionViewModel;
    releaseObjectGroup?: ReleaseObjectGroupViewModel;
    summaryTableLastUpdatedRevision?: string | undefined;
    summaryTableChanged?: boolean;
    release?: string | undefined;
    pressureTemperatureTables?: PressureTemperatureTableViewModel[] | undefined;
    componentsInPipeClass?: ComponentsInPipeClassViewModel[] | undefined;
    branchTables?: BranchTableViewModel[] | undefined;
    additionalPipeClassProperties?: AdditionalPipeClassProperty[] | undefined;
    valves?: ValveViewModel[] | undefined;
    customNotes?: PipeClassNoteViewModel[] | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    previousPipeClass?: string | undefined;
    isArchived?: boolean | undefined;
    isDraft?: boolean | undefined;
    isRetired?: boolean | undefined;
    isCurrent?: boolean | undefined;
}

export class PipingRevisionViewModel implements IPipingRevisionViewModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: RevisionStatus;
    authorOid?: string;
    authorName?: string | undefined;
    publishDate?: Date;
    version?: string | undefined;
    creationDate?: Date | undefined;
    lastUpdateDate?: Date | undefined;
    specificationCode?: string | undefined;
    pipeClasses?: PipeClassViewModel[] | undefined;
    valves?: ValveViewModel[] | undefined;
    components?: ComponentViewModel[] | undefined;
    roles?: RoleViewModel[] | undefined;

    constructor(data?: IPipingRevisionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.authorOid = _data["authorOid"];
            this.authorName = _data["authorName"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.version = _data["version"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.lastUpdateDate = _data["lastUpdateDate"] ? new Date(_data["lastUpdateDate"].toString()) : <any>undefined;
            this.specificationCode = _data["specificationCode"];
            if (Array.isArray(_data["pipeClasses"])) {
                this.pipeClasses = [] as any;
                for (let item of _data["pipeClasses"])
                    this.pipeClasses!.push(PipeClassViewModel.fromJS(item));
            }
            if (Array.isArray(_data["valves"])) {
                this.valves = [] as any;
                for (let item of _data["valves"])
                    this.valves!.push(ValveViewModel.fromJS(item));
            }
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ComponentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PipingRevisionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipingRevisionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["authorOid"] = this.authorOid;
        data["authorName"] = this.authorName;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["version"] = this.version;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["lastUpdateDate"] = this.lastUpdateDate ? this.lastUpdateDate.toISOString() : <any>undefined;
        data["specificationCode"] = this.specificationCode;
        if (Array.isArray(this.pipeClasses)) {
            data["pipeClasses"] = [];
            for (let item of this.pipeClasses)
                data["pipeClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.valves)) {
            data["valves"] = [];
            for (let item of this.valves)
                data["valves"].push(item.toJSON());
        }
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPipingRevisionViewModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: RevisionStatus;
    authorOid?: string;
    authorName?: string | undefined;
    publishDate?: Date;
    version?: string | undefined;
    creationDate?: Date | undefined;
    lastUpdateDate?: Date | undefined;
    specificationCode?: string | undefined;
    pipeClasses?: PipeClassViewModel[] | undefined;
    valves?: ValveViewModel[] | undefined;
    components?: ComponentViewModel[] | undefined;
    roles?: RoleViewModel[] | undefined;
}

export class PipingSearchFilterModel implements IPipingSearchFilterModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    filterCategory?: PipingFilterCategory;

    constructor(data?: IPipingSearchFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterDisplayName = _data["filterDisplayName"];
            this.filterPropertyName = _data["filterPropertyName"];
            this.filterType = _data["filterType"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.filterCategory = _data["filterCategory"];
        }
    }

    static fromJS(data: any): PipingSearchFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipingSearchFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterDisplayName"] = this.filterDisplayName;
        data["filterPropertyName"] = this.filterPropertyName;
        data["filterType"] = this.filterType;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["filterCategory"] = this.filterCategory;
        return data;
    }
}

export interface IPipingSearchFilterModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    filterCategory?: PipingFilterCategory;
}

export class PipingSearchFilterViewModel implements IPipingSearchFilterViewModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    filterTypeDisplayName?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    filterCategory?: PipingFilterCategory;

    constructor(data?: IPipingSearchFilterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterDisplayName = _data["filterDisplayName"];
            this.filterPropertyName = _data["filterPropertyName"];
            this.filterType = _data["filterType"];
            this.filterTypeDisplayName = _data["filterTypeDisplayName"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.filterCategory = _data["filterCategory"];
        }
    }

    static fromJS(data: any): PipingSearchFilterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipingSearchFilterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterDisplayName"] = this.filterDisplayName;
        data["filterPropertyName"] = this.filterPropertyName;
        data["filterType"] = this.filterType;
        data["filterTypeDisplayName"] = this.filterTypeDisplayName;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["filterCategory"] = this.filterCategory;
        return data;
    }
}

export interface IPipingSearchFilterViewModel {
    filterDisplayName?: string | undefined;
    filterPropertyName?: string | undefined;
    filterType?: string | undefined;
    filterTypeDisplayName?: string | undefined;
    displayOrder?: number;
    options?: string[] | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    filterCategory?: PipingFilterCategory;
}

export class PipingSearchResultViewModel implements IPipingSearchResultViewModel {
    score?: number | undefined;
    objectType?: string | undefined;
    pipe?: PipeClassViewModel;
    valve?: ValveViewModel;

    constructor(data?: IPipingSearchResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            this.objectType = _data["objectType"];
            this.pipe = _data["pipe"] ? PipeClassViewModel.fromJS(_data["pipe"]) : <any>undefined;
            this.valve = _data["valve"] ? ValveViewModel.fromJS(_data["valve"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PipingSearchResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipingSearchResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["objectType"] = this.objectType;
        data["pipe"] = this.pipe ? this.pipe.toJSON() : <any>undefined;
        data["valve"] = this.valve ? this.valve.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPipingSearchResultViewModel {
    score?: number | undefined;
    objectType?: string | undefined;
    pipe?: PipeClassViewModel;
    valve?: ValveViewModel;
}

export class PressureTemperatureCellViewModel implements IPressureTemperatureCellViewModel {
    id?: string;
    pressureTemperatureTableId?: string;
    temperature?: number;
    pressure?: number;
    temperatureUnit?: string | undefined;
    pressureUnit?: string | undefined;
    isAsteriskRequired?: boolean;
    readonly isInternationalSystem?: boolean;
    readonly isUSCustomary?: boolean;
    readonly pressureIsInBar?: boolean;
    readonly pressureIsInKPa?: boolean;
    readonly pressureIsInPsi?: boolean;
    readonly tempIsInCelsius?: boolean;
    readonly tempIsInFahrenheit?: boolean;

    constructor(data?: IPressureTemperatureCellViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pressureTemperatureTableId = _data["pressureTemperatureTableId"];
            this.temperature = _data["temperature"];
            this.pressure = _data["pressure"];
            this.temperatureUnit = _data["temperatureUnit"];
            this.pressureUnit = _data["pressureUnit"];
            this.isAsteriskRequired = _data["isAsteriskRequired"];
            (<any>this).isInternationalSystem = _data["isInternationalSystem"];
            (<any>this).isUSCustomary = _data["isUSCustomary"];
            (<any>this).pressureIsInBar = _data["pressureIsInBar"];
            (<any>this).pressureIsInKPa = _data["pressureIsInKPa"];
            (<any>this).pressureIsInPsi = _data["pressureIsInPsi"];
            (<any>this).tempIsInCelsius = _data["tempIsInCelsius"];
            (<any>this).tempIsInFahrenheit = _data["tempIsInFahrenheit"];
        }
    }

    static fromJS(data: any): PressureTemperatureCellViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PressureTemperatureCellViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pressureTemperatureTableId"] = this.pressureTemperatureTableId;
        data["temperature"] = this.temperature;
        data["pressure"] = this.pressure;
        data["temperatureUnit"] = this.temperatureUnit;
        data["pressureUnit"] = this.pressureUnit;
        data["isAsteriskRequired"] = this.isAsteriskRequired;
        data["isInternationalSystem"] = this.isInternationalSystem;
        data["isUSCustomary"] = this.isUSCustomary;
        data["pressureIsInBar"] = this.pressureIsInBar;
        data["pressureIsInKPa"] = this.pressureIsInKPa;
        data["pressureIsInPsi"] = this.pressureIsInPsi;
        data["tempIsInCelsius"] = this.tempIsInCelsius;
        data["tempIsInFahrenheit"] = this.tempIsInFahrenheit;
        return data;
    }
}

export interface IPressureTemperatureCellViewModel {
    id?: string;
    pressureTemperatureTableId?: string;
    temperature?: number;
    pressure?: number;
    temperatureUnit?: string | undefined;
    pressureUnit?: string | undefined;
    isAsteriskRequired?: boolean;
    isInternationalSystem?: boolean;
    isUSCustomary?: boolean;
    pressureIsInBar?: boolean;
    pressureIsInKPa?: boolean;
    pressureIsInPsi?: boolean;
    tempIsInCelsius?: boolean;
    tempIsInFahrenheit?: boolean;
}

export class PressureTemperatureTableNoteViewModel implements IPressureTemperatureTableNoteViewModel {
    type?: string | undefined;
    note?: string | undefined;

    constructor(data?: IPressureTemperatureTableNoteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PressureTemperatureTableNoteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PressureTemperatureTableNoteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["note"] = this.note;
        return data;
    }
}

export interface IPressureTemperatureTableNoteViewModel {
    type?: string | undefined;
    note?: string | undefined;
}

export class PressureTemperatureTableValidationResult implements IPressureTemperatureTableValidationResult {
    isCurrent?: boolean;
    latestVersion?: PressureTemperatureTableViewModel;
    message?: string | undefined;

    constructor(data?: IPressureTemperatureTableValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCurrent = _data["isCurrent"];
            this.latestVersion = _data["latestVersion"] ? PressureTemperatureTableViewModel.fromJS(_data["latestVersion"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PressureTemperatureTableValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new PressureTemperatureTableValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCurrent"] = this.isCurrent;
        data["latestVersion"] = this.latestVersion ? this.latestVersion.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IPressureTemperatureTableValidationResult {
    isCurrent?: boolean;
    latestVersion?: PressureTemperatureTableViewModel;
    message?: string | undefined;
}

export class PressureTemperatureTableViewModel implements IPressureTemperatureTableViewModel {
    id?: string;
    name?: string | undefined;
    pressureUnits?: string | undefined;
    temperatureUnits?: string | undefined;
    isActive?: boolean;
    cells?: PressureTemperatureCellViewModel[] | undefined;
    services?: ServiceViewModel[] | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    relationCommonNotes?: CommonNoteViewModel[] | undefined;
    pipeClassIds?: string[] | undefined;
    additionalNotes?: PressureTemperatureTableNoteViewModel[] | undefined;
    relationAdditionalNotes?: PressureTemperatureTableNoteViewModel[] | undefined;
    testNotes?: PressureTemperatureTableNoteViewModel[] | undefined;
    relationTestNotes?: PressureTemperatureTableNoteViewModel[] | undefined;
    isReferenced?: boolean | undefined;
    fromRevision?: SimpleRevisionViewModel;
    lastUpdatedRevision?: string | undefined;
    changed?: boolean;

    constructor(data?: IPressureTemperatureTableViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pressureUnits = _data["pressureUnits"];
            this.temperatureUnits = _data["temperatureUnits"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(PressureTemperatureCellViewModel.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceViewModel.fromJS(item));
            }
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["relationCommonNotes"])) {
                this.relationCommonNotes = [] as any;
                for (let item of _data["relationCommonNotes"])
                    this.relationCommonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["pipeClassIds"])) {
                this.pipeClassIds = [] as any;
                for (let item of _data["pipeClassIds"])
                    this.pipeClassIds!.push(item);
            }
            if (Array.isArray(_data["additionalNotes"])) {
                this.additionalNotes = [] as any;
                for (let item of _data["additionalNotes"])
                    this.additionalNotes!.push(PressureTemperatureTableNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["relationAdditionalNotes"])) {
                this.relationAdditionalNotes = [] as any;
                for (let item of _data["relationAdditionalNotes"])
                    this.relationAdditionalNotes!.push(PressureTemperatureTableNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["testNotes"])) {
                this.testNotes = [] as any;
                for (let item of _data["testNotes"])
                    this.testNotes!.push(PressureTemperatureTableNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["relationTestNotes"])) {
                this.relationTestNotes = [] as any;
                for (let item of _data["relationTestNotes"])
                    this.relationTestNotes!.push(PressureTemperatureTableNoteViewModel.fromJS(item));
            }
            this.isReferenced = _data["isReferenced"];
            this.fromRevision = _data["fromRevision"] ? SimpleRevisionViewModel.fromJS(_data["fromRevision"]) : <any>undefined;
            this.lastUpdatedRevision = _data["lastUpdatedRevision"];
            this.changed = _data["changed"];
        }
    }

    static fromJS(data: any): PressureTemperatureTableViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PressureTemperatureTableViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pressureUnits"] = this.pressureUnits;
        data["temperatureUnits"] = this.temperatureUnits;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item.toJSON());
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.relationCommonNotes)) {
            data["relationCommonNotes"] = [];
            for (let item of this.relationCommonNotes)
                data["relationCommonNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.pipeClassIds)) {
            data["pipeClassIds"] = [];
            for (let item of this.pipeClassIds)
                data["pipeClassIds"].push(item);
        }
        if (Array.isArray(this.additionalNotes)) {
            data["additionalNotes"] = [];
            for (let item of this.additionalNotes)
                data["additionalNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.relationAdditionalNotes)) {
            data["relationAdditionalNotes"] = [];
            for (let item of this.relationAdditionalNotes)
                data["relationAdditionalNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.testNotes)) {
            data["testNotes"] = [];
            for (let item of this.testNotes)
                data["testNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.relationTestNotes)) {
            data["relationTestNotes"] = [];
            for (let item of this.relationTestNotes)
                data["relationTestNotes"].push(item.toJSON());
        }
        data["isReferenced"] = this.isReferenced;
        data["fromRevision"] = this.fromRevision ? this.fromRevision.toJSON() : <any>undefined;
        data["lastUpdatedRevision"] = this.lastUpdatedRevision;
        data["changed"] = this.changed;
        return data;
    }
}

export interface IPressureTemperatureTableViewModel {
    id?: string;
    name?: string | undefined;
    pressureUnits?: string | undefined;
    temperatureUnits?: string | undefined;
    isActive?: boolean;
    cells?: PressureTemperatureCellViewModel[] | undefined;
    services?: ServiceViewModel[] | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    relationCommonNotes?: CommonNoteViewModel[] | undefined;
    pipeClassIds?: string[] | undefined;
    additionalNotes?: PressureTemperatureTableNoteViewModel[] | undefined;
    relationAdditionalNotes?: PressureTemperatureTableNoteViewModel[] | undefined;
    testNotes?: PressureTemperatureTableNoteViewModel[] | undefined;
    relationTestNotes?: PressureTemperatureTableNoteViewModel[] | undefined;
    isReferenced?: boolean | undefined;
    fromRevision?: SimpleRevisionViewModel;
    lastUpdatedRevision?: string | undefined;
    changed?: boolean;
}

export class ReleaseCommentViewModel implements IReleaseCommentViewModel {
    id?: string;
    releaseId?: string;
    parentCommentId?: string | undefined;
    authorName?: string | undefined;
    authorId?: string | undefined;
    authorRole?: UserType;
    content?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date | undefined;
    updatedById?: string | undefined;
    displayOrder?: number;
    resolutionStatus?: CommentResolutionStatus;
    replies?: ReleaseCommentViewModel[] | undefined;

    constructor(data?: IReleaseCommentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.releaseId = _data["releaseId"];
            this.parentCommentId = _data["parentCommentId"];
            this.authorName = _data["authorName"];
            this.authorId = _data["authorId"];
            this.authorRole = _data["authorRole"];
            this.content = _data["content"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.updatedById = _data["updatedById"];
            this.displayOrder = _data["displayOrder"];
            this.resolutionStatus = _data["resolutionStatus"];
            if (Array.isArray(_data["replies"])) {
                this.replies = [] as any;
                for (let item of _data["replies"])
                    this.replies!.push(ReleaseCommentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReleaseCommentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseCommentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["releaseId"] = this.releaseId;
        data["parentCommentId"] = this.parentCommentId;
        data["authorName"] = this.authorName;
        data["authorId"] = this.authorId;
        data["authorRole"] = this.authorRole;
        data["content"] = this.content;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["updatedById"] = this.updatedById;
        data["displayOrder"] = this.displayOrder;
        data["resolutionStatus"] = this.resolutionStatus;
        if (Array.isArray(this.replies)) {
            data["replies"] = [];
            for (let item of this.replies)
                data["replies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReleaseCommentViewModel {
    id?: string;
    releaseId?: string;
    parentCommentId?: string | undefined;
    authorName?: string | undefined;
    authorId?: string | undefined;
    authorRole?: UserType;
    content?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date | undefined;
    updatedById?: string | undefined;
    displayOrder?: number;
    resolutionStatus?: CommentResolutionStatus;
    replies?: ReleaseCommentViewModel[] | undefined;
}

export class CreateReleaseWizardOptionsViewModel implements ICreateReleaseWizardOptionsViewModel {
    businessUnits?: BusinessUnitViewModel[] | undefined;
    applications?: ApplicationViewModel[] | undefined;
    specifications?: SpecificationViewModel[] | undefined;

    constructor(data?: ICreateReleaseWizardOptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["businessUnits"])) {
                this.businessUnits = [] as any;
                for (let item of _data["businessUnits"])
                    this.businessUnits!.push(BusinessUnitViewModel.fromJS(item));
            }
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(ApplicationViewModel.fromJS(item));
            }
            if (Array.isArray(_data["specifications"])) {
                this.specifications = [] as any;
                for (let item of _data["specifications"])
                    this.specifications!.push(SpecificationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateReleaseWizardOptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReleaseWizardOptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.businessUnits)) {
            data["businessUnits"] = [];
            for (let item of this.businessUnits)
                data["businessUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        if (Array.isArray(this.specifications)) {
            data["specifications"] = [];
            for (let item of this.specifications)
                data["specifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateReleaseWizardOptionsViewModel {
    businessUnits?: BusinessUnitViewModel[] | undefined;
    applications?: ApplicationViewModel[] | undefined;
    specifications?: SpecificationViewModel[] | undefined;
}

export class CreateReleaseWizardViewModel implements ICreateReleaseWizardViewModel {
    businessUnitId?: string;
    applicationId?: string;
    specificationId?: string | undefined;
    name?: string | undefined;
    revision?: string | undefined;
    component?: ReleaseComponent;
    linkedValveReleaseId?: string | undefined;
    description?: string | undefined;
    creatorOid?: string;
    releaseOwners?: string[] | undefined;
    internalReviewers?: string[] | undefined;
    contributors?: string[] | undefined;

    constructor(data?: ICreateReleaseWizardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessUnitId = _data["businessUnitId"];
            this.applicationId = _data["applicationId"];
            this.specificationId = _data["specificationId"];
            this.name = _data["name"];
            this.revision = _data["revision"];
            this.component = _data["component"];
            this.linkedValveReleaseId = _data["linkedValveReleaseId"];
            this.description = _data["description"];
            this.creatorOid = _data["creatorOid"];
            if (Array.isArray(_data["releaseOwners"])) {
                this.releaseOwners = [] as any;
                for (let item of _data["releaseOwners"])
                    this.releaseOwners!.push(item);
            }
            if (Array.isArray(_data["internalReviewers"])) {
                this.internalReviewers = [] as any;
                for (let item of _data["internalReviewers"])
                    this.internalReviewers!.push(item);
            }
            if (Array.isArray(_data["contributors"])) {
                this.contributors = [] as any;
                for (let item of _data["contributors"])
                    this.contributors!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateReleaseWizardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReleaseWizardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessUnitId"] = this.businessUnitId;
        data["applicationId"] = this.applicationId;
        data["specificationId"] = this.specificationId;
        data["name"] = this.name;
        data["revision"] = this.revision;
        data["component"] = this.component;
        data["linkedValveReleaseId"] = this.linkedValveReleaseId;
        data["description"] = this.description;
        data["creatorOid"] = this.creatorOid;
        if (Array.isArray(this.releaseOwners)) {
            data["releaseOwners"] = [];
            for (let item of this.releaseOwners)
                data["releaseOwners"].push(item);
        }
        if (Array.isArray(this.internalReviewers)) {
            data["internalReviewers"] = [];
            for (let item of this.internalReviewers)
                data["internalReviewers"].push(item);
        }
        if (Array.isArray(this.contributors)) {
            data["contributors"] = [];
            for (let item of this.contributors)
                data["contributors"].push(item);
        }
        return data;
    }
}

export interface ICreateReleaseWizardViewModel {
    businessUnitId?: string;
    applicationId?: string;
    specificationId?: string | undefined;
    name?: string | undefined;
    revision?: string | undefined;
    component?: ReleaseComponent;
    linkedValveReleaseId?: string | undefined;
    description?: string | undefined;
    creatorOid?: string;
    releaseOwners?: string[] | undefined;
    internalReviewers?: string[] | undefined;
    contributors?: string[] | undefined;
}

export class AcknowledgeValidationItemDto implements IAcknowledgeValidationItemDto {
    validationCode?: string | undefined;
    subjectId?: string | undefined;
    notes?: string | undefined;
    actorOid?: string;

    constructor(data?: IAcknowledgeValidationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationCode = _data["validationCode"];
            this.subjectId = _data["subjectId"];
            this.notes = _data["notes"];
            this.actorOid = _data["actorOid"];
        }
    }

    static fromJS(data: any): AcknowledgeValidationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcknowledgeValidationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationCode"] = this.validationCode;
        data["subjectId"] = this.subjectId;
        data["notes"] = this.notes;
        data["actorOid"] = this.actorOid;
        return data;
    }
}

export interface IAcknowledgeValidationItemDto {
    validationCode?: string | undefined;
    subjectId?: string | undefined;
    notes?: string | undefined;
    actorOid?: string;
}

export class BulkInactiveComponentRequestDto implements IBulkInactiveComponentRequestDto {
    componentIds?: string[] | undefined;
    actorOid?: string;

    constructor(data?: IBulkInactiveComponentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [] as any;
                for (let item of _data["componentIds"])
                    this.componentIds!.push(item);
            }
            this.actorOid = _data["actorOid"];
        }
    }

    static fromJS(data: any): BulkInactiveComponentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkInactiveComponentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        data["actorOid"] = this.actorOid;
        return data;
    }
}

export interface IBulkInactiveComponentRequestDto {
    componentIds?: string[] | undefined;
    actorOid?: string;
}

export class ComponentActivationRequestDto implements IComponentActivationRequestDto {
    componentId?: string;
    actorOid?: string;

    constructor(data?: IComponentActivationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.actorOid = _data["actorOid"];
        }
    }

    static fromJS(data: any): ComponentActivationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentActivationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["actorOid"] = this.actorOid;
        return data;
    }
}

export interface IComponentActivationRequestDto {
    componentId?: string;
    actorOid?: string;
}

export class ComponentReleaseAsIsRequestDto implements IComponentReleaseAsIsRequestDto {
    componentId?: string;
    actorOid?: string;

    constructor(data?: IComponentReleaseAsIsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.actorOid = _data["actorOid"];
        }
    }

    static fromJS(data: any): ComponentReleaseAsIsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentReleaseAsIsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["actorOid"] = this.actorOid;
        return data;
    }
}

export interface IComponentReleaseAsIsRequestDto {
    componentId?: string;
    actorOid?: string;
}

export class ComponentRemovalRequestDto implements IComponentRemovalRequestDto {
    componentId?: string;
    actorOid?: string;

    constructor(data?: IComponentRemovalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.actorOid = _data["actorOid"];
        }
    }

    static fromJS(data: any): ComponentRemovalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentRemovalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["actorOid"] = this.actorOid;
        return data;
    }
}

export interface IComponentRemovalRequestDto {
    componentId?: string;
    actorOid?: string;
}

export class ComponentReplacementRequestDto implements IComponentReplacementRequestDto {
    componentId?: string;
    replacementComponentId?: string;
    actorOid?: string;

    constructor(data?: IComponentReplacementRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.replacementComponentId = _data["replacementComponentId"];
            this.actorOid = _data["actorOid"];
        }
    }

    static fromJS(data: any): ComponentReplacementRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentReplacementRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["replacementComponentId"] = this.replacementComponentId;
        data["actorOid"] = this.actorOid;
        return data;
    }
}

export interface IComponentReplacementRequestDto {
    componentId?: string;
    replacementComponentId?: string;
    actorOid?: string;
}

export class ExecuteReleaseRequestDto implements IExecuteReleaseRequestDto {
    attributes?: ReleaseAttributesDto;
    acknowledgedValidationCodes?: string[] | undefined;
    actorOid?: string;

    constructor(data?: IExecuteReleaseRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"] ? ReleaseAttributesDto.fromJS(_data["attributes"]) : <any>undefined;
            if (Array.isArray(_data["acknowledgedValidationCodes"])) {
                this.acknowledgedValidationCodes = [] as any;
                for (let item of _data["acknowledgedValidationCodes"])
                    this.acknowledgedValidationCodes!.push(item);
            }
            this.actorOid = _data["actorOid"];
        }
    }

    static fromJS(data: any): ExecuteReleaseRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteReleaseRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes ? this.attributes.toJSON() : <any>undefined;
        if (Array.isArray(this.acknowledgedValidationCodes)) {
            data["acknowledgedValidationCodes"] = [];
            for (let item of this.acknowledgedValidationCodes)
                data["acknowledgedValidationCodes"].push(item);
        }
        data["actorOid"] = this.actorOid;
        return data;
    }
}

export interface IExecuteReleaseRequestDto {
    attributes?: ReleaseAttributesDto;
    acknowledgedValidationCodes?: string[] | undefined;
    actorOid?: string;
}

export class FinalCheckSectionSummary implements IFinalCheckSectionSummary {
    hasBlockingErrors?: boolean;
    hasUnacknowledgedWarnings?: boolean;
    totalItems?: number;
    resolvedItems?: number;

    constructor(data?: IFinalCheckSectionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasBlockingErrors = _data["hasBlockingErrors"];
            this.hasUnacknowledgedWarnings = _data["hasUnacknowledgedWarnings"];
            this.totalItems = _data["totalItems"];
            this.resolvedItems = _data["resolvedItems"];
        }
    }

    static fromJS(data: any): FinalCheckSectionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new FinalCheckSectionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasBlockingErrors"] = this.hasBlockingErrors;
        data["hasUnacknowledgedWarnings"] = this.hasUnacknowledgedWarnings;
        data["totalItems"] = this.totalItems;
        data["resolvedItems"] = this.resolvedItems;
        return data;
    }
}

export interface IFinalCheckSectionSummary {
    hasBlockingErrors?: boolean;
    hasUnacknowledgedWarnings?: boolean;
    totalItems?: number;
    resolvedItems?: number;
}

export class InactiveComponentGroupDto implements IInactiveComponentGroupDto {
    componentId?: string;
    componentCode?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    resolutionAction?: InactiveComponentResolutionAction;
    decidedByOid?: string | undefined;
    decidedAt?: Date | undefined;
    replacementComponentId?: string | undefined;
    replacementComponentCode?: string | undefined;
    pipeClasses?: InactiveComponentPipeClassRefDto[] | undefined;

    constructor(data?: IInactiveComponentGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.componentCode = _data["componentCode"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.resolutionAction = _data["resolutionAction"];
            this.decidedByOid = _data["decidedByOid"];
            this.decidedAt = _data["decidedAt"] ? new Date(_data["decidedAt"].toString()) : <any>undefined;
            this.replacementComponentId = _data["replacementComponentId"];
            this.replacementComponentCode = _data["replacementComponentCode"];
            if (Array.isArray(_data["pipeClasses"])) {
                this.pipeClasses = [] as any;
                for (let item of _data["pipeClasses"])
                    this.pipeClasses!.push(InactiveComponentPipeClassRefDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InactiveComponentGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new InactiveComponentGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["componentCode"] = this.componentCode;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["resolutionAction"] = this.resolutionAction;
        data["decidedByOid"] = this.decidedByOid;
        data["decidedAt"] = this.decidedAt ? this.decidedAt.toISOString() : <any>undefined;
        data["replacementComponentId"] = this.replacementComponentId;
        data["replacementComponentCode"] = this.replacementComponentCode;
        if (Array.isArray(this.pipeClasses)) {
            data["pipeClasses"] = [];
            for (let item of this.pipeClasses)
                data["pipeClasses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInactiveComponentGroupDto {
    componentId?: string;
    componentCode?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    resolutionAction?: InactiveComponentResolutionAction;
    decidedByOid?: string | undefined;
    decidedAt?: Date | undefined;
    replacementComponentId?: string | undefined;
    replacementComponentCode?: string | undefined;
    pipeClasses?: InactiveComponentPipeClassRefDto[] | undefined;
}

export class InactiveComponentPipeClassRefDto implements IInactiveComponentPipeClassRefDto {
    componentInPipeClassId?: string;
    pipeClassCloneId?: string;
    pipeClassId?: string;
    pipeClassName?: string | undefined;

    constructor(data?: IInactiveComponentPipeClassRefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentInPipeClassId = _data["componentInPipeClassId"];
            this.pipeClassCloneId = _data["pipeClassCloneId"];
            this.pipeClassId = _data["pipeClassId"];
            this.pipeClassName = _data["pipeClassName"];
        }
    }

    static fromJS(data: any): InactiveComponentPipeClassRefDto {
        data = typeof data === 'object' ? data : {};
        let result = new InactiveComponentPipeClassRefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentInPipeClassId"] = this.componentInPipeClassId;
        data["pipeClassCloneId"] = this.pipeClassCloneId;
        data["pipeClassId"] = this.pipeClassId;
        data["pipeClassName"] = this.pipeClassName;
        return data;
    }
}

export interface IInactiveComponentPipeClassRefDto {
    componentInPipeClassId?: string;
    pipeClassCloneId?: string;
    pipeClassId?: string;
    pipeClassName?: string | undefined;
}

export class InactiveComponentProceedWithoutUpdatesRequestDto implements IInactiveComponentProceedWithoutUpdatesRequestDto {
    acknowledged?: boolean;
    actorOid?: string;
    notes?: string | undefined;

    constructor(data?: IInactiveComponentProceedWithoutUpdatesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acknowledged = _data["acknowledged"];
            this.actorOid = _data["actorOid"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): InactiveComponentProceedWithoutUpdatesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InactiveComponentProceedWithoutUpdatesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acknowledged"] = this.acknowledged;
        data["actorOid"] = this.actorOid;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IInactiveComponentProceedWithoutUpdatesRequestDto {
    acknowledged?: boolean;
    actorOid?: string;
    notes?: string | undefined;
}

export class InactiveComponentsValidationDto implements IInactiveComponentsValidationDto {
    components?: InactiveComponentGroupDto[] | undefined;
    readonly hasUnresolved?: boolean;
    proceedWithoutUpdates?: boolean;
    proceedWithoutUpdatesByOid?: string | undefined;
    proceedWithoutUpdatesAt?: Date | undefined;
    sectionItems?: ValidationItemDto[] | undefined;

    constructor(data?: IInactiveComponentsValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(InactiveComponentGroupDto.fromJS(item));
            }
            (<any>this).hasUnresolved = _data["hasUnresolved"];
            this.proceedWithoutUpdates = _data["proceedWithoutUpdates"];
            this.proceedWithoutUpdatesByOid = _data["proceedWithoutUpdatesByOid"];
            this.proceedWithoutUpdatesAt = _data["proceedWithoutUpdatesAt"] ? new Date(_data["proceedWithoutUpdatesAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["sectionItems"])) {
                this.sectionItems = [] as any;
                for (let item of _data["sectionItems"])
                    this.sectionItems!.push(ValidationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InactiveComponentsValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InactiveComponentsValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        data["hasUnresolved"] = this.hasUnresolved;
        data["proceedWithoutUpdates"] = this.proceedWithoutUpdates;
        data["proceedWithoutUpdatesByOid"] = this.proceedWithoutUpdatesByOid;
        data["proceedWithoutUpdatesAt"] = this.proceedWithoutUpdatesAt ? this.proceedWithoutUpdatesAt.toISOString() : <any>undefined;
        if (Array.isArray(this.sectionItems)) {
            data["sectionItems"] = [];
            for (let item of this.sectionItems)
                data["sectionItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInactiveComponentsValidationDto {
    components?: InactiveComponentGroupDto[] | undefined;
    hasUnresolved?: boolean;
    proceedWithoutUpdates?: boolean;
    proceedWithoutUpdatesByOid?: string | undefined;
    proceedWithoutUpdatesAt?: Date | undefined;
    sectionItems?: ValidationItemDto[] | undefined;
}

export class PipingClassStatusRowDto implements IPipingClassStatusRowDto {
    pipeClassId?: string;
    pipeClassCloneId?: string;
    pipeClassName?: string | undefined;
    action?: ReleaseSelectedObject;
    currentStatus?: RevisionStatus;
    items?: ValidationItemDto[] | undefined;

    constructor(data?: IPipingClassStatusRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pipeClassId = _data["pipeClassId"];
            this.pipeClassCloneId = _data["pipeClassCloneId"];
            this.pipeClassName = _data["pipeClassName"];
            this.action = _data["action"];
            this.currentStatus = _data["currentStatus"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ValidationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PipingClassStatusRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PipingClassStatusRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipeClassId"] = this.pipeClassId;
        data["pipeClassCloneId"] = this.pipeClassCloneId;
        data["pipeClassName"] = this.pipeClassName;
        data["action"] = this.action;
        data["currentStatus"] = this.currentStatus;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPipingClassStatusRowDto {
    pipeClassId?: string;
    pipeClassCloneId?: string;
    pipeClassName?: string | undefined;
    action?: ReleaseSelectedObject;
    currentStatus?: RevisionStatus;
    items?: ValidationItemDto[] | undefined;
}

export class PipingClassStatusValidationDto implements IPipingClassStatusValidationDto {
    nonReviewClasses?: PipingClassStatusRowDto[] | undefined;
    modifyClasses?: PipingClassStatusRowDto[] | undefined;
    releaseAsIsClasses?: PipingClassStatusRowDto[] | undefined;
    retiredClasses?: PipingClassStatusRowDto[] | undefined;
    sectionItems?: ValidationItemDto[] | undefined;

    constructor(data?: IPipingClassStatusValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nonReviewClasses"])) {
                this.nonReviewClasses = [] as any;
                for (let item of _data["nonReviewClasses"])
                    this.nonReviewClasses!.push(PipingClassStatusRowDto.fromJS(item));
            }
            if (Array.isArray(_data["modifyClasses"])) {
                this.modifyClasses = [] as any;
                for (let item of _data["modifyClasses"])
                    this.modifyClasses!.push(PipingClassStatusRowDto.fromJS(item));
            }
            if (Array.isArray(_data["releaseAsIsClasses"])) {
                this.releaseAsIsClasses = [] as any;
                for (let item of _data["releaseAsIsClasses"])
                    this.releaseAsIsClasses!.push(PipingClassStatusRowDto.fromJS(item));
            }
            if (Array.isArray(_data["retiredClasses"])) {
                this.retiredClasses = [] as any;
                for (let item of _data["retiredClasses"])
                    this.retiredClasses!.push(PipingClassStatusRowDto.fromJS(item));
            }
            if (Array.isArray(_data["sectionItems"])) {
                this.sectionItems = [] as any;
                for (let item of _data["sectionItems"])
                    this.sectionItems!.push(ValidationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PipingClassStatusValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PipingClassStatusValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nonReviewClasses)) {
            data["nonReviewClasses"] = [];
            for (let item of this.nonReviewClasses)
                data["nonReviewClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.modifyClasses)) {
            data["modifyClasses"] = [];
            for (let item of this.modifyClasses)
                data["modifyClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.releaseAsIsClasses)) {
            data["releaseAsIsClasses"] = [];
            for (let item of this.releaseAsIsClasses)
                data["releaseAsIsClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.retiredClasses)) {
            data["retiredClasses"] = [];
            for (let item of this.retiredClasses)
                data["retiredClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.sectionItems)) {
            data["sectionItems"] = [];
            for (let item of this.sectionItems)
                data["sectionItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPipingClassStatusValidationDto {
    nonReviewClasses?: PipingClassStatusRowDto[] | undefined;
    modifyClasses?: PipingClassStatusRowDto[] | undefined;
    releaseAsIsClasses?: PipingClassStatusRowDto[] | undefined;
    retiredClasses?: PipingClassStatusRowDto[] | undefined;
    sectionItems?: ValidationItemDto[] | undefined;
}

export class ReleaseAttributesDto implements IReleaseAttributesDto {
    releaseId?: string;
    name?: string | undefined;
    revision?: string | undefined;
    description?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    component?: string | undefined;
    sectionItems?: ValidationItemDto[] | undefined;

    constructor(data?: IReleaseAttributesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseId = _data["releaseId"];
            this.name = _data["name"];
            this.revision = _data["revision"];
            this.description = _data["description"];
            this.businessUnit = _data["businessUnit"];
            this.application = _data["application"];
            this.component = _data["component"];
            if (Array.isArray(_data["sectionItems"])) {
                this.sectionItems = [] as any;
                for (let item of _data["sectionItems"])
                    this.sectionItems!.push(ValidationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReleaseAttributesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseAttributesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["releaseId"] = this.releaseId;
        data["name"] = this.name;
        data["revision"] = this.revision;
        data["description"] = this.description;
        data["businessUnit"] = this.businessUnit;
        data["application"] = this.application;
        data["component"] = this.component;
        if (Array.isArray(this.sectionItems)) {
            data["sectionItems"] = [];
            for (let item of this.sectionItems)
                data["sectionItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReleaseAttributesDto {
    releaseId?: string;
    name?: string | undefined;
    revision?: string | undefined;
    description?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    component?: string | undefined;
    sectionItems?: ValidationItemDto[] | undefined;
}

export class ReleaseFinalChecksSummaryDto implements IReleaseFinalChecksSummaryDto {
    releaseId?: string;
    canPublish?: boolean;
    generalDetails?: FinalCheckSectionSummary;
    valveStatus?: FinalCheckSectionSummary;
    valveDescriptions?: FinalCheckSectionSummary;
    inactiveComponents?: FinalCheckSectionSummary;
    pipingClassStatus?: FinalCheckSectionSummary;
    releaseAttributes?: FinalCheckSectionSummary;

    constructor(data?: IReleaseFinalChecksSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseId = _data["releaseId"];
            this.canPublish = _data["canPublish"];
            this.generalDetails = _data["generalDetails"] ? FinalCheckSectionSummary.fromJS(_data["generalDetails"]) : <any>undefined;
            this.valveStatus = _data["valveStatus"] ? FinalCheckSectionSummary.fromJS(_data["valveStatus"]) : <any>undefined;
            this.valveDescriptions = _data["valveDescriptions"] ? FinalCheckSectionSummary.fromJS(_data["valveDescriptions"]) : <any>undefined;
            this.inactiveComponents = _data["inactiveComponents"] ? FinalCheckSectionSummary.fromJS(_data["inactiveComponents"]) : <any>undefined;
            this.pipingClassStatus = _data["pipingClassStatus"] ? FinalCheckSectionSummary.fromJS(_data["pipingClassStatus"]) : <any>undefined;
            this.releaseAttributes = _data["releaseAttributes"] ? FinalCheckSectionSummary.fromJS(_data["releaseAttributes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReleaseFinalChecksSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseFinalChecksSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["releaseId"] = this.releaseId;
        data["canPublish"] = this.canPublish;
        data["generalDetails"] = this.generalDetails ? this.generalDetails.toJSON() : <any>undefined;
        data["valveStatus"] = this.valveStatus ? this.valveStatus.toJSON() : <any>undefined;
        data["valveDescriptions"] = this.valveDescriptions ? this.valveDescriptions.toJSON() : <any>undefined;
        data["inactiveComponents"] = this.inactiveComponents ? this.inactiveComponents.toJSON() : <any>undefined;
        data["pipingClassStatus"] = this.pipingClassStatus ? this.pipingClassStatus.toJSON() : <any>undefined;
        data["releaseAttributes"] = this.releaseAttributes ? this.releaseAttributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReleaseFinalChecksSummaryDto {
    releaseId?: string;
    canPublish?: boolean;
    generalDetails?: FinalCheckSectionSummary;
    valveStatus?: FinalCheckSectionSummary;
    valveDescriptions?: FinalCheckSectionSummary;
    inactiveComponents?: FinalCheckSectionSummary;
    pipingClassStatus?: FinalCheckSectionSummary;
    releaseAttributes?: FinalCheckSectionSummary;
}

export class ValidationItemDto implements IValidationItemDto {
    code?: string | undefined;
    message?: string | undefined;
    severity?: ValidationSeverity;
    isResolved?: boolean;
    subjectId?: string | undefined;
    subjectName?: string | undefined;

    constructor(data?: IValidationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.severity = _data["severity"];
            this.isResolved = _data["isResolved"];
            this.subjectId = _data["subjectId"];
            this.subjectName = _data["subjectName"];
        }
    }

    static fromJS(data: any): ValidationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["severity"] = this.severity;
        data["isResolved"] = this.isResolved;
        data["subjectId"] = this.subjectId;
        data["subjectName"] = this.subjectName;
        return data;
    }
}

export interface IValidationItemDto {
    code?: string | undefined;
    message?: string | undefined;
    severity?: ValidationSeverity;
    isResolved?: boolean;
    subjectId?: string | undefined;
    subjectName?: string | undefined;
}

export class ValveActivationRequestDto implements IValveActivationRequestDto {
    valveId?: string;
    actorOid?: string;

    constructor(data?: IValveActivationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valveId = _data["valveId"];
            this.actorOid = _data["actorOid"];
        }
    }

    static fromJS(data: any): ValveActivationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveActivationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveId"] = this.valveId;
        data["actorOid"] = this.actorOid;
        return data;
    }
}

export interface IValveActivationRequestDto {
    valveId?: string;
    actorOid?: string;
}

export class ValveDescriptionBulkChoiceRequestDto implements IValveDescriptionBulkChoiceRequestDto {
    chosenOption?: ValveDescriptionChoiceOption;
    actorOid?: string;

    constructor(data?: IValveDescriptionBulkChoiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chosenOption = _data["chosenOption"];
            this.actorOid = _data["actorOid"];
        }
    }

    static fromJS(data: any): ValveDescriptionBulkChoiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveDescriptionBulkChoiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chosenOption"] = this.chosenOption;
        data["actorOid"] = this.actorOid;
        return data;
    }
}

export interface IValveDescriptionBulkChoiceRequestDto {
    chosenOption?: ValveDescriptionChoiceOption;
    actorOid?: string;
}

export class ValveDescriptionChoiceRequestDto implements IValveDescriptionChoiceRequestDto {
    valveId?: string;
    pipeClassId?: string | undefined;
    pipeClassIds?: string[] | undefined;
    chosenOption?: ValveDescriptionChoiceOption;
    editedValue?: string | undefined;
    actorOid?: string;

    constructor(data?: IValveDescriptionChoiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valveId = _data["valveId"];
            this.pipeClassId = _data["pipeClassId"];
            if (Array.isArray(_data["pipeClassIds"])) {
                this.pipeClassIds = [] as any;
                for (let item of _data["pipeClassIds"])
                    this.pipeClassIds!.push(item);
            }
            this.chosenOption = _data["chosenOption"];
            this.editedValue = _data["editedValue"];
            this.actorOid = _data["actorOid"];
        }
    }

    static fromJS(data: any): ValveDescriptionChoiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveDescriptionChoiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveId"] = this.valveId;
        data["pipeClassId"] = this.pipeClassId;
        if (Array.isArray(this.pipeClassIds)) {
            data["pipeClassIds"] = [];
            for (let item of this.pipeClassIds)
                data["pipeClassIds"].push(item);
        }
        data["chosenOption"] = this.chosenOption;
        data["editedValue"] = this.editedValue;
        data["actorOid"] = this.actorOid;
        return data;
    }
}

export interface IValveDescriptionChoiceRequestDto {
    valveId?: string;
    pipeClassId?: string | undefined;
    pipeClassIds?: string[] | undefined;
    chosenOption?: ValveDescriptionChoiceOption;
    editedValue?: string | undefined;
    actorOid?: string;
}

export class ValveDescriptionRowDto implements IValveDescriptionRowDto {
    valveId?: string;
    valveTag?: string | undefined;
    pipeClassId?: string | undefined;
    pipeClassIds?: string[] | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    descriptionMismatch?: boolean;
    pipeClassAction?: ReleaseSelectedObject;
    chosenOption?: ValveDescriptionChoiceOption;
    editedValue?: string | undefined;

    constructor(data?: IValveDescriptionRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valveId = _data["valveId"];
            this.valveTag = _data["valveTag"];
            this.pipeClassId = _data["pipeClassId"];
            if (Array.isArray(_data["pipeClassIds"])) {
                this.pipeClassIds = [] as any;
                for (let item of _data["pipeClassIds"])
                    this.pipeClassIds!.push(item);
            }
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.descriptionMismatch = _data["descriptionMismatch"];
            this.pipeClassAction = _data["pipeClassAction"];
            this.chosenOption = _data["chosenOption"];
            this.editedValue = _data["editedValue"];
        }
    }

    static fromJS(data: any): ValveDescriptionRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveDescriptionRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveId"] = this.valveId;
        data["valveTag"] = this.valveTag;
        data["pipeClassId"] = this.pipeClassId;
        if (Array.isArray(this.pipeClassIds)) {
            data["pipeClassIds"] = [];
            for (let item of this.pipeClassIds)
                data["pipeClassIds"].push(item);
        }
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["descriptionMismatch"] = this.descriptionMismatch;
        data["pipeClassAction"] = this.pipeClassAction;
        data["chosenOption"] = this.chosenOption;
        data["editedValue"] = this.editedValue;
        return data;
    }
}

export interface IValveDescriptionRowDto {
    valveId?: string;
    valveTag?: string | undefined;
    pipeClassId?: string | undefined;
    pipeClassIds?: string[] | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    descriptionMismatch?: boolean;
    pipeClassAction?: ReleaseSelectedObject;
    chosenOption?: ValveDescriptionChoiceOption;
    editedValue?: string | undefined;
}

export class ValveDescriptionValidationDto implements IValveDescriptionValidationDto {
    modifyClassValves?: ValveDescriptionRowDto[] | undefined;
    releaseAsIsClassValves?: ValveDescriptionRowDto[] | undefined;
    retireClassValves?: ValveDescriptionRowDto[] | undefined;
    sectionItems?: ValidationItemDto[] | undefined;

    constructor(data?: IValveDescriptionValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["modifyClassValves"])) {
                this.modifyClassValves = [] as any;
                for (let item of _data["modifyClassValves"])
                    this.modifyClassValves!.push(ValveDescriptionRowDto.fromJS(item));
            }
            if (Array.isArray(_data["releaseAsIsClassValves"])) {
                this.releaseAsIsClassValves = [] as any;
                for (let item of _data["releaseAsIsClassValves"])
                    this.releaseAsIsClassValves!.push(ValveDescriptionRowDto.fromJS(item));
            }
            if (Array.isArray(_data["retireClassValves"])) {
                this.retireClassValves = [] as any;
                for (let item of _data["retireClassValves"])
                    this.retireClassValves!.push(ValveDescriptionRowDto.fromJS(item));
            }
            if (Array.isArray(_data["sectionItems"])) {
                this.sectionItems = [] as any;
                for (let item of _data["sectionItems"])
                    this.sectionItems!.push(ValidationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValveDescriptionValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveDescriptionValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modifyClassValves)) {
            data["modifyClassValves"] = [];
            for (let item of this.modifyClassValves)
                data["modifyClassValves"].push(item.toJSON());
        }
        if (Array.isArray(this.releaseAsIsClassValves)) {
            data["releaseAsIsClassValves"] = [];
            for (let item of this.releaseAsIsClassValves)
                data["releaseAsIsClassValves"].push(item.toJSON());
        }
        if (Array.isArray(this.retireClassValves)) {
            data["retireClassValves"] = [];
            for (let item of this.retireClassValves)
                data["retireClassValves"].push(item.toJSON());
        }
        if (Array.isArray(this.sectionItems)) {
            data["sectionItems"] = [];
            for (let item of this.sectionItems)
                data["sectionItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValveDescriptionValidationDto {
    modifyClassValves?: ValveDescriptionRowDto[] | undefined;
    releaseAsIsClassValves?: ValveDescriptionRowDto[] | undefined;
    retireClassValves?: ValveDescriptionRowDto[] | undefined;
    sectionItems?: ValidationItemDto[] | undefined;
}

export class ValveProceedWithoutUpdatesRequestDto implements IValveProceedWithoutUpdatesRequestDto {
    acknowledged?: boolean;
    actorOid?: string;
    notes?: string | undefined;

    constructor(data?: IValveProceedWithoutUpdatesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acknowledged = _data["acknowledged"];
            this.actorOid = _data["actorOid"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): ValveProceedWithoutUpdatesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveProceedWithoutUpdatesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acknowledged"] = this.acknowledged;
        data["actorOid"] = this.actorOid;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IValveProceedWithoutUpdatesRequestDto {
    acknowledged?: boolean;
    actorOid?: string;
    notes?: string | undefined;
}

export class ValveStatusRowDto implements IValveStatusRowDto {
    valveId?: string;
    valveTag?: string | undefined;
    pipeClassId?: string;
    pipeClassName?: string | undefined;
    pipeClassAction?: ReleaseSelectedObject;
    valveStatus?: RevisionStatus;
    severity?: ValidationSeverity;
    message?: string | undefined;
    requiresUserConfirmation?: boolean;
    isAcknowledgedByUser?: boolean;
    isInDraft?: boolean;
    isRetired?: boolean;
    isOutsideSelectedValveRelease?: boolean;
    isDisabled?: boolean;
    valveComponentId?: string;
    componentInPipeClassId?: string;
    hasNewerVersion?: boolean;
    latestPublishedValveId?: string | undefined;
    latestPublishedValveTag?: string | undefined;
    newerVersionIsUnpublished?: boolean;
    canUpdateToLatestVersion?: boolean;
    actingReleaseAction?: ReleaseSelectedObject;

    constructor(data?: IValveStatusRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valveId = _data["valveId"];
            this.valveTag = _data["valveTag"];
            this.pipeClassId = _data["pipeClassId"];
            this.pipeClassName = _data["pipeClassName"];
            this.pipeClassAction = _data["pipeClassAction"];
            this.valveStatus = _data["valveStatus"];
            this.severity = _data["severity"];
            this.message = _data["message"];
            this.requiresUserConfirmation = _data["requiresUserConfirmation"];
            this.isAcknowledgedByUser = _data["isAcknowledgedByUser"];
            this.isInDraft = _data["isInDraft"];
            this.isRetired = _data["isRetired"];
            this.isOutsideSelectedValveRelease = _data["isOutsideSelectedValveRelease"];
            this.isDisabled = _data["isDisabled"];
            this.valveComponentId = _data["valveComponentId"];
            this.componentInPipeClassId = _data["componentInPipeClassId"];
            this.hasNewerVersion = _data["hasNewerVersion"];
            this.latestPublishedValveId = _data["latestPublishedValveId"];
            this.latestPublishedValveTag = _data["latestPublishedValveTag"];
            this.newerVersionIsUnpublished = _data["newerVersionIsUnpublished"];
            this.canUpdateToLatestVersion = _data["canUpdateToLatestVersion"];
            this.actingReleaseAction = _data["actingReleaseAction"];
        }
    }

    static fromJS(data: any): ValveStatusRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveStatusRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveId"] = this.valveId;
        data["valveTag"] = this.valveTag;
        data["pipeClassId"] = this.pipeClassId;
        data["pipeClassName"] = this.pipeClassName;
        data["pipeClassAction"] = this.pipeClassAction;
        data["valveStatus"] = this.valveStatus;
        data["severity"] = this.severity;
        data["message"] = this.message;
        data["requiresUserConfirmation"] = this.requiresUserConfirmation;
        data["isAcknowledgedByUser"] = this.isAcknowledgedByUser;
        data["isInDraft"] = this.isInDraft;
        data["isRetired"] = this.isRetired;
        data["isOutsideSelectedValveRelease"] = this.isOutsideSelectedValveRelease;
        data["isDisabled"] = this.isDisabled;
        data["valveComponentId"] = this.valveComponentId;
        data["componentInPipeClassId"] = this.componentInPipeClassId;
        data["hasNewerVersion"] = this.hasNewerVersion;
        data["latestPublishedValveId"] = this.latestPublishedValveId;
        data["latestPublishedValveTag"] = this.latestPublishedValveTag;
        data["newerVersionIsUnpublished"] = this.newerVersionIsUnpublished;
        data["canUpdateToLatestVersion"] = this.canUpdateToLatestVersion;
        data["actingReleaseAction"] = this.actingReleaseAction;
        return data;
    }
}

export interface IValveStatusRowDto {
    valveId?: string;
    valveTag?: string | undefined;
    pipeClassId?: string;
    pipeClassName?: string | undefined;
    pipeClassAction?: ReleaseSelectedObject;
    valveStatus?: RevisionStatus;
    severity?: ValidationSeverity;
    message?: string | undefined;
    requiresUserConfirmation?: boolean;
    isAcknowledgedByUser?: boolean;
    isInDraft?: boolean;
    isRetired?: boolean;
    isOutsideSelectedValveRelease?: boolean;
    isDisabled?: boolean;
    valveComponentId?: string;
    componentInPipeClassId?: string;
    hasNewerVersion?: boolean;
    latestPublishedValveId?: string | undefined;
    latestPublishedValveTag?: string | undefined;
    newerVersionIsUnpublished?: boolean;
    canUpdateToLatestVersion?: boolean;
    actingReleaseAction?: ReleaseSelectedObject;
}

export class ValveStatusValidationDto implements IValveStatusValidationDto {
    modifyClassValves?: ValveStatusRowDto[] | undefined;
    releaseAsIsClassValves?: ValveStatusRowDto[] | undefined;
    retireClassValves?: ValveStatusRowDto[] | undefined;
    sectionItems?: ValidationItemDto[] | undefined;
    requiresProceedWithoutUpdates?: boolean;
    proceedWithoutUpdates?: boolean;
    proceedWithoutUpdatesByOid?: string | undefined;
    proceedWithoutUpdatesAt?: Date | undefined;
    updatableToLatestVersionCount?: number;

    constructor(data?: IValveStatusValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["modifyClassValves"])) {
                this.modifyClassValves = [] as any;
                for (let item of _data["modifyClassValves"])
                    this.modifyClassValves!.push(ValveStatusRowDto.fromJS(item));
            }
            if (Array.isArray(_data["releaseAsIsClassValves"])) {
                this.releaseAsIsClassValves = [] as any;
                for (let item of _data["releaseAsIsClassValves"])
                    this.releaseAsIsClassValves!.push(ValveStatusRowDto.fromJS(item));
            }
            if (Array.isArray(_data["retireClassValves"])) {
                this.retireClassValves = [] as any;
                for (let item of _data["retireClassValves"])
                    this.retireClassValves!.push(ValveStatusRowDto.fromJS(item));
            }
            if (Array.isArray(_data["sectionItems"])) {
                this.sectionItems = [] as any;
                for (let item of _data["sectionItems"])
                    this.sectionItems!.push(ValidationItemDto.fromJS(item));
            }
            this.requiresProceedWithoutUpdates = _data["requiresProceedWithoutUpdates"];
            this.proceedWithoutUpdates = _data["proceedWithoutUpdates"];
            this.proceedWithoutUpdatesByOid = _data["proceedWithoutUpdatesByOid"];
            this.proceedWithoutUpdatesAt = _data["proceedWithoutUpdatesAt"] ? new Date(_data["proceedWithoutUpdatesAt"].toString()) : <any>undefined;
            this.updatableToLatestVersionCount = _data["updatableToLatestVersionCount"];
        }
    }

    static fromJS(data: any): ValveStatusValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveStatusValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modifyClassValves)) {
            data["modifyClassValves"] = [];
            for (let item of this.modifyClassValves)
                data["modifyClassValves"].push(item.toJSON());
        }
        if (Array.isArray(this.releaseAsIsClassValves)) {
            data["releaseAsIsClassValves"] = [];
            for (let item of this.releaseAsIsClassValves)
                data["releaseAsIsClassValves"].push(item.toJSON());
        }
        if (Array.isArray(this.retireClassValves)) {
            data["retireClassValves"] = [];
            for (let item of this.retireClassValves)
                data["retireClassValves"].push(item.toJSON());
        }
        if (Array.isArray(this.sectionItems)) {
            data["sectionItems"] = [];
            for (let item of this.sectionItems)
                data["sectionItems"].push(item.toJSON());
        }
        data["requiresProceedWithoutUpdates"] = this.requiresProceedWithoutUpdates;
        data["proceedWithoutUpdates"] = this.proceedWithoutUpdates;
        data["proceedWithoutUpdatesByOid"] = this.proceedWithoutUpdatesByOid;
        data["proceedWithoutUpdatesAt"] = this.proceedWithoutUpdatesAt ? this.proceedWithoutUpdatesAt.toISOString() : <any>undefined;
        data["updatableToLatestVersionCount"] = this.updatableToLatestVersionCount;
        return data;
    }
}

export interface IValveStatusValidationDto {
    modifyClassValves?: ValveStatusRowDto[] | undefined;
    releaseAsIsClassValves?: ValveStatusRowDto[] | undefined;
    retireClassValves?: ValveStatusRowDto[] | undefined;
    sectionItems?: ValidationItemDto[] | undefined;
    requiresProceedWithoutUpdates?: boolean;
    proceedWithoutUpdates?: boolean;
    proceedWithoutUpdatesByOid?: string | undefined;
    proceedWithoutUpdatesAt?: Date | undefined;
    updatableToLatestVersionCount?: number;
}

export class ValveVersionUpdateRequestDto implements IValveVersionUpdateRequestDto {
    valveIds?: string[] | undefined;
    actorOid?: string;

    constructor(data?: IValveVersionUpdateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["valveIds"])) {
                this.valveIds = [] as any;
                for (let item of _data["valveIds"])
                    this.valveIds!.push(item);
            }
            this.actorOid = _data["actorOid"];
        }
    }

    static fromJS(data: any): ValveVersionUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveVersionUpdateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.valveIds)) {
            data["valveIds"] = [];
            for (let item of this.valveIds)
                data["valveIds"].push(item);
        }
        data["actorOid"] = this.actorOid;
        return data;
    }
}

export interface IValveVersionUpdateRequestDto {
    valveIds?: string[] | undefined;
    actorOid?: string;
}

export class ValveVersionUpdateResultDto implements IValveVersionUpdateResultDto {
    updatedValveCount?: number;
    updatedPipeClassCount?: number;
    skipped?: ValveVersionUpdateSkipDto[] | undefined;
    valveStatus?: ValveStatusValidationDto;

    constructor(data?: IValveVersionUpdateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedValveCount = _data["updatedValveCount"];
            this.updatedPipeClassCount = _data["updatedPipeClassCount"];
            if (Array.isArray(_data["skipped"])) {
                this.skipped = [] as any;
                for (let item of _data["skipped"])
                    this.skipped!.push(ValveVersionUpdateSkipDto.fromJS(item));
            }
            this.valveStatus = _data["valveStatus"] ? ValveStatusValidationDto.fromJS(_data["valveStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValveVersionUpdateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveVersionUpdateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedValveCount"] = this.updatedValveCount;
        data["updatedPipeClassCount"] = this.updatedPipeClassCount;
        if (Array.isArray(this.skipped)) {
            data["skipped"] = [];
            for (let item of this.skipped)
                data["skipped"].push(item.toJSON());
        }
        data["valveStatus"] = this.valveStatus ? this.valveStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValveVersionUpdateResultDto {
    updatedValveCount?: number;
    updatedPipeClassCount?: number;
    skipped?: ValveVersionUpdateSkipDto[] | undefined;
    valveStatus?: ValveStatusValidationDto;
}

export class ValveVersionUpdateSkipDto implements IValveVersionUpdateSkipDto {
    valveId?: string;
    valveTag?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IValveVersionUpdateSkipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valveId = _data["valveId"];
            this.valveTag = _data["valveTag"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ValveVersionUpdateSkipDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValveVersionUpdateSkipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveId"] = this.valveId;
        data["valveTag"] = this.valveTag;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IValveVersionUpdateSkipDto {
    valveId?: string;
    valveTag?: string | undefined;
    reason?: string | undefined;
}

export class ReleaseDetailViewModel implements IReleaseDetailViewModel {
    id?: string;
    name?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    component?: ReleaseComponent;
    status?: ReleaseStatus;
    creationDate?: Date | undefined;
    author?: string | undefined;
    authorOid?: string | undefined;
    readonly objectCount?: number;
    roles?: ReleaseRoleViewModel[] | undefined;
    objects?: ReleaseObjectGroupViewModel[] | undefined;

    constructor(data?: IReleaseDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.businessUnit = _data["businessUnit"];
            this.application = _data["application"];
            this.component = _data["component"];
            this.status = _data["status"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.author = _data["author"];
            this.authorOid = _data["authorOid"];
            (<any>this).objectCount = _data["objectCount"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(ReleaseRoleViewModel.fromJS(item));
            }
            if (Array.isArray(_data["objects"])) {
                this.objects = [] as any;
                for (let item of _data["objects"])
                    this.objects!.push(ReleaseObjectGroupViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReleaseDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["businessUnit"] = this.businessUnit;
        data["application"] = this.application;
        data["component"] = this.component;
        data["status"] = this.status;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["author"] = this.author;
        data["authorOid"] = this.authorOid;
        data["objectCount"] = this.objectCount;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.objects)) {
            data["objects"] = [];
            for (let item of this.objects)
                data["objects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReleaseDetailViewModel {
    id?: string;
    name?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    component?: ReleaseComponent;
    status?: ReleaseStatus;
    creationDate?: Date | undefined;
    author?: string | undefined;
    authorOid?: string | undefined;
    objectCount?: number;
    roles?: ReleaseRoleViewModel[] | undefined;
    objects?: ReleaseObjectGroupViewModel[] | undefined;
}

export class ReleaseForDashboardViewModel implements IReleaseForDashboardViewModel {
    id?: string;
    name?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    component?: string | undefined;
    revision?: string | undefined;
    quantity?: number;
    definition?: string | undefined;
    creationDate?: Date | undefined;
    releaseDate?: Date | undefined;
    author?: string | undefined;
    authorOid?: string | undefined;
    canCurrentUserOpen?: boolean;
    readonly status?: string | undefined;
    statusCode?: ReleaseStatus;

    constructor(data?: IReleaseForDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.businessUnit = _data["businessUnit"];
            this.application = _data["application"];
            this.component = _data["component"];
            this.revision = _data["revision"];
            this.quantity = _data["quantity"];
            this.definition = _data["definition"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            this.author = _data["author"];
            this.authorOid = _data["authorOid"];
            this.canCurrentUserOpen = _data["canCurrentUserOpen"];
            (<any>this).status = _data["status"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): ReleaseForDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseForDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["businessUnit"] = this.businessUnit;
        data["application"] = this.application;
        data["component"] = this.component;
        data["revision"] = this.revision;
        data["quantity"] = this.quantity;
        data["definition"] = this.definition;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["author"] = this.author;
        data["authorOid"] = this.authorOid;
        data["canCurrentUserOpen"] = this.canCurrentUserOpen;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface IReleaseForDashboardViewModel {
    id?: string;
    name?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
    component?: string | undefined;
    revision?: string | undefined;
    quantity?: number;
    definition?: string | undefined;
    creationDate?: Date | undefined;
    releaseDate?: Date | undefined;
    author?: string | undefined;
    authorOid?: string | undefined;
    canCurrentUserOpen?: boolean;
    status?: string | undefined;
    statusCode?: ReleaseStatus;
}

export class ReleaseObjectGroupRoleViewModel implements IReleaseObjectGroupRoleViewModel {
    releaseRoleId?: string;
    userRole?: UserType;
    userId?: string;
    userDisplayName?: string | undefined;
    approvalState?: ApprovalState;

    constructor(data?: IReleaseObjectGroupRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseRoleId = _data["releaseRoleId"];
            this.userRole = _data["userRole"];
            this.userId = _data["userId"];
            this.userDisplayName = _data["userDisplayName"];
            this.approvalState = _data["approvalState"];
        }
    }

    static fromJS(data: any): ReleaseObjectGroupRoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseObjectGroupRoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["releaseRoleId"] = this.releaseRoleId;
        data["userRole"] = this.userRole;
        data["userId"] = this.userId;
        data["userDisplayName"] = this.userDisplayName;
        data["approvalState"] = this.approvalState;
        return data;
    }
}

export interface IReleaseObjectGroupRoleViewModel {
    releaseRoleId?: string;
    userRole?: UserType;
    userId?: string;
    userDisplayName?: string | undefined;
    approvalState?: ApprovalState;
}

export class ReleaseObjectGroupViewModel implements IReleaseObjectGroupViewModel {
    id?: string;
    objectName?: string | undefined;
    originalObjectId?: string;
    newObjectId?: string;
    action?: ReleaseSelectedObject;
    hasPreservedDraft?: boolean;
    restorePreviousDraft?: boolean | undefined;
    releaseId?: string | undefined;
    releaseStatus?: ReleaseStatus;
    roles?: ReleaseObjectGroupRoleViewModel[] | undefined;
    reviewStatus?: RevisionStatus;
    hasComments?: boolean;
    lastRevisionName?: string | undefined;

    constructor(data?: IReleaseObjectGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectName = _data["objectName"];
            this.originalObjectId = _data["originalObjectId"];
            this.newObjectId = _data["newObjectId"];
            this.action = _data["action"];
            this.hasPreservedDraft = _data["hasPreservedDraft"];
            this.restorePreviousDraft = _data["restorePreviousDraft"];
            this.releaseId = _data["releaseId"];
            this.releaseStatus = _data["releaseStatus"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(ReleaseObjectGroupRoleViewModel.fromJS(item));
            }
            this.reviewStatus = _data["reviewStatus"];
            this.hasComments = _data["hasComments"];
            this.lastRevisionName = _data["lastRevisionName"];
        }
    }

    static fromJS(data: any): ReleaseObjectGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseObjectGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectName"] = this.objectName;
        data["originalObjectId"] = this.originalObjectId;
        data["newObjectId"] = this.newObjectId;
        data["action"] = this.action;
        data["hasPreservedDraft"] = this.hasPreservedDraft;
        data["restorePreviousDraft"] = this.restorePreviousDraft;
        data["releaseId"] = this.releaseId;
        data["releaseStatus"] = this.releaseStatus;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["reviewStatus"] = this.reviewStatus;
        data["hasComments"] = this.hasComments;
        data["lastRevisionName"] = this.lastRevisionName;
        return data;
    }
}

export interface IReleaseObjectGroupViewModel {
    id?: string;
    objectName?: string | undefined;
    originalObjectId?: string;
    newObjectId?: string;
    action?: ReleaseSelectedObject;
    hasPreservedDraft?: boolean;
    restorePreviousDraft?: boolean | undefined;
    releaseId?: string | undefined;
    releaseStatus?: ReleaseStatus;
    roles?: ReleaseObjectGroupRoleViewModel[] | undefined;
    reviewStatus?: RevisionStatus;
    hasComments?: boolean;
    lastRevisionName?: string | undefined;
}

export class ReleaseRoleViewModel implements IReleaseRoleViewModel {
    id?: string;
    userId?: string;
    userRole?: UserType;
    userDisplayName?: string | undefined;
    userEmail?: string | undefined;

    constructor(data?: IReleaseRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userRole = _data["userRole"];
            this.userDisplayName = _data["userDisplayName"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): ReleaseRoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseRoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userRole"] = this.userRole;
        data["userDisplayName"] = this.userDisplayName;
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export interface IReleaseRoleViewModel {
    id?: string;
    userId?: string;
    userRole?: UserType;
    userDisplayName?: string | undefined;
    userEmail?: string | undefined;
}

export class ValveReleaseLookupViewModel implements IValveReleaseLookupViewModel {
    id?: string;
    name?: string | undefined;

    constructor(data?: IValveReleaseLookupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ValveReleaseLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValveReleaseLookupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IValveReleaseLookupViewModel {
    id?: string;
    name?: string | undefined;
}

export class ReleaseViewModel implements IReleaseViewModel {
    version?: string | undefined;
    application?: string | undefined;
    specificationCode?: string | undefined;
    businessUnit?: string | undefined;
    revision?: SimpleRevisionViewModel;

    constructor(data?: IReleaseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.application = _data["application"];
            this.specificationCode = _data["specificationCode"];
            this.businessUnit = _data["businessUnit"];
            this.revision = _data["revision"] ? SimpleRevisionViewModel.fromJS(_data["revision"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReleaseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["application"] = this.application;
        data["specificationCode"] = this.specificationCode;
        data["businessUnit"] = this.businessUnit;
        data["revision"] = this.revision ? this.revision.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReleaseViewModel {
    version?: string | undefined;
    application?: string | undefined;
    specificationCode?: string | undefined;
    businessUnit?: string | undefined;
    revision?: SimpleRevisionViewModel;
}

export class RetirePipeClassRequest implements IRetirePipeClassRequest {
    reason?: string | undefined;

    constructor(data?: IRetirePipeClassRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): RetirePipeClassRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RetirePipeClassRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }
}

export interface IRetirePipeClassRequest {
    reason?: string | undefined;
}

export class RevisionCreateViewModel implements IRevisionCreateViewModel {
    pipeClasses?: RevisionCreationSubjectViewModel[] | undefined;
    valves?: RevisionCreationSubjectViewModel[] | undefined;
    generalDescription!: string | undefined;
    authors?: string[] | undefined;
    internalReviewers?: string[] | undefined;
    externalReviewers?: string[] | undefined;

    constructor(data?: IRevisionCreateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pipeClasses"])) {
                this.pipeClasses = [] as any;
                for (let item of _data["pipeClasses"])
                    this.pipeClasses!.push(RevisionCreationSubjectViewModel.fromJS(item));
            }
            if (Array.isArray(_data["valves"])) {
                this.valves = [] as any;
                for (let item of _data["valves"])
                    this.valves!.push(RevisionCreationSubjectViewModel.fromJS(item));
            }
            this.generalDescription = _data["generalDescription"];
            if (Array.isArray(_data["authors"])) {
                this.authors = [] as any;
                for (let item of _data["authors"])
                    this.authors!.push(item);
            }
            if (Array.isArray(_data["internalReviewers"])) {
                this.internalReviewers = [] as any;
                for (let item of _data["internalReviewers"])
                    this.internalReviewers!.push(item);
            }
            if (Array.isArray(_data["externalReviewers"])) {
                this.externalReviewers = [] as any;
                for (let item of _data["externalReviewers"])
                    this.externalReviewers!.push(item);
            }
        }
    }

    static fromJS(data: any): RevisionCreateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionCreateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pipeClasses)) {
            data["pipeClasses"] = [];
            for (let item of this.pipeClasses)
                data["pipeClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.valves)) {
            data["valves"] = [];
            for (let item of this.valves)
                data["valves"].push(item.toJSON());
        }
        data["generalDescription"] = this.generalDescription;
        if (Array.isArray(this.authors)) {
            data["authors"] = [];
            for (let item of this.authors)
                data["authors"].push(item);
        }
        if (Array.isArray(this.internalReviewers)) {
            data["internalReviewers"] = [];
            for (let item of this.internalReviewers)
                data["internalReviewers"].push(item);
        }
        if (Array.isArray(this.externalReviewers)) {
            data["externalReviewers"] = [];
            for (let item of this.externalReviewers)
                data["externalReviewers"].push(item);
        }
        return data;
    }
}

export interface IRevisionCreateViewModel {
    pipeClasses?: RevisionCreationSubjectViewModel[] | undefined;
    valves?: RevisionCreationSubjectViewModel[] | undefined;
    generalDescription: string | undefined;
    authors?: string[] | undefined;
    internalReviewers?: string[] | undefined;
    externalReviewers?: string[] | undefined;
}

export class RevisionCreationSubjectViewModel implements IRevisionCreationSubjectViewModel {
    id!: string;
    revisionName!: string | undefined;
    application?: string | undefined;

    constructor(data?: IRevisionCreationSubjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.revisionName = _data["revisionName"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): RevisionCreationSubjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionCreationSubjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["revisionName"] = this.revisionName;
        data["application"] = this.application;
        return data;
    }
}

export interface IRevisionCreationSubjectViewModel {
    id: string;
    revisionName: string | undefined;
    application?: string | undefined;
}

export class RoleViewModel implements IRoleViewModel {
    id?: string;
    userId!: string;
    revisionId!: number;
    userRole!: UserType;
    approvalState!: ApprovalState;
    objectId?: string | undefined;
    userDisplayName?: string | undefined;
    userEmail?: string | undefined;

    constructor(data?: IRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.revisionId = _data["revisionId"];
            this.userRole = _data["userRole"];
            this.approvalState = _data["approvalState"];
            this.objectId = _data["objectId"];
            this.userDisplayName = _data["userDisplayName"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): RoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["revisionId"] = this.revisionId;
        data["userRole"] = this.userRole;
        data["approvalState"] = this.approvalState;
        data["objectId"] = this.objectId;
        data["userDisplayName"] = this.userDisplayName;
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export interface IRoleViewModel {
    id?: string;
    userId: string;
    revisionId: number;
    userRole: UserType;
    approvalState: ApprovalState;
    objectId?: string | undefined;
    userDisplayName?: string | undefined;
    userEmail?: string | undefined;
}

export class SaveCommentsRequest implements ISaveCommentsRequest {
    pipeClassId!: string;
    revisionId!: number;
    contextType!: string;
    comments?: CommentViewModel[] | undefined;

    constructor(data?: ISaveCommentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pipeClassId = _data["pipeClassId"];
            this.revisionId = _data["revisionId"];
            this.contextType = _data["contextType"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveCommentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCommentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipeClassId"] = this.pipeClassId;
        data["revisionId"] = this.revisionId;
        data["contextType"] = this.contextType;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveCommentsRequest {
    pipeClassId: string;
    revisionId: number;
    contextType: string;
    comments?: CommentViewModel[] | undefined;
}

export class ServiceDetailViewModel implements IServiceDetailViewModel {
    id?: string;
    name?: string | undefined;
    updated?: Date;
    isActive?: boolean | undefined;
    isReferenced?: boolean | undefined;

    constructor(data?: IServiceDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isReferenced = _data["isReferenced"];
        }
    }

    static fromJS(data: any): ServiceDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isReferenced"] = this.isReferenced;
        return data;
    }
}

export interface IServiceDetailViewModel {
    id?: string;
    name?: string | undefined;
    updated?: Date;
    isActive?: boolean | undefined;
    isReferenced?: boolean | undefined;
}

export class ServiceViewModel implements IServiceViewModel {
    id?: string;
    name?: string | undefined;
    updated?: Date;
    isActive?: boolean | undefined;
    isReferenced?: boolean | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;

    constructor(data?: IServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isReferenced = _data["isReferenced"];
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isReferenced"] = this.isReferenced;
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceViewModel {
    id?: string;
    name?: string | undefined;
    updated?: Date;
    isActive?: boolean | undefined;
    isReferenced?: boolean | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
}

export class SimpleRevisionViewModel implements ISimpleRevisionViewModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: RevisionStatus;
    authorOid?: string;
    authorName?: string | undefined;
    publishDate?: Date;
    version?: string | undefined;
    creationDate?: Date | undefined;
    lastUpdateDate?: Date | undefined;
    specificationCode?: string | undefined;

    constructor(data?: ISimpleRevisionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.authorOid = _data["authorOid"];
            this.authorName = _data["authorName"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.version = _data["version"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.lastUpdateDate = _data["lastUpdateDate"] ? new Date(_data["lastUpdateDate"].toString()) : <any>undefined;
            this.specificationCode = _data["specificationCode"];
        }
    }

    static fromJS(data: any): SimpleRevisionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleRevisionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["authorOid"] = this.authorOid;
        data["authorName"] = this.authorName;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["version"] = this.version;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["lastUpdateDate"] = this.lastUpdateDate ? this.lastUpdateDate.toISOString() : <any>undefined;
        data["specificationCode"] = this.specificationCode;
        return data;
    }
}

export interface ISimpleRevisionViewModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: RevisionStatus;
    authorOid?: string;
    authorName?: string | undefined;
    publishDate?: Date;
    version?: string | undefined;
    creationDate?: Date | undefined;
    lastUpdateDate?: Date | undefined;
    specificationCode?: string | undefined;
}

export class SpecificationViewModel implements ISpecificationViewModel {
    id?: string;
    name?: string | undefined;
    specificationNumber?: string | undefined;
    specificationTitle?: string | undefined;
    businessUnitId?: string;
    businessUnitName?: string | undefined;
    applicationId?: string | undefined;
    applicationName?: string | undefined;
    type?: SpecificationType;
    updated?: Date;
    isActive?: boolean | undefined;
    isReferenced?: boolean | undefined;

    constructor(data?: ISpecificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.specificationNumber = _data["specificationNumber"];
            this.specificationTitle = _data["specificationTitle"];
            this.businessUnitId = _data["businessUnitId"];
            this.businessUnitName = _data["businessUnitName"];
            this.applicationId = _data["applicationId"];
            this.applicationName = _data["applicationName"];
            this.type = _data["type"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isReferenced = _data["isReferenced"];
        }
    }

    static fromJS(data: any): SpecificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpecificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["specificationNumber"] = this.specificationNumber;
        data["specificationTitle"] = this.specificationTitle;
        data["businessUnitId"] = this.businessUnitId;
        data["businessUnitName"] = this.businessUnitName;
        data["applicationId"] = this.applicationId;
        data["applicationName"] = this.applicationName;
        data["type"] = this.type;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isReferenced"] = this.isReferenced;
        return data;
    }
}

export interface ISpecificationViewModel {
    id?: string;
    name?: string | undefined;
    specificationNumber?: string | undefined;
    specificationTitle?: string | undefined;
    businessUnitId?: string;
    businessUnitName?: string | undefined;
    applicationId?: string | undefined;
    applicationName?: string | undefined;
    type?: SpecificationType;
    updated?: Date;
    isActive?: boolean | undefined;
    isReferenced?: boolean | undefined;
}

export class UpdateCommentRequest implements IUpdateCommentRequest {
    id!: string;
    content!: string;
    resolutionStatus?: CommentResolutionStatus;

    constructor(data?: IUpdateCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.resolutionStatus = _data["resolutionStatus"];
        }
    }

    static fromJS(data: any): UpdateCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["resolutionStatus"] = this.resolutionStatus;
        return data;
    }
}

export interface IUpdateCommentRequest {
    id: string;
    content: string;
    resolutionStatus?: CommentResolutionStatus;
}

export class UpdateCommentResolutionStatusRequest implements IUpdateCommentResolutionStatusRequest {
    resolutionStatus!: CommentResolutionStatus;

    constructor(data?: IUpdateCommentResolutionStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resolutionStatus = _data["resolutionStatus"];
        }
    }

    static fromJS(data: any): UpdateCommentResolutionStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommentResolutionStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resolutionStatus"] = this.resolutionStatus;
        return data;
    }
}

export interface IUpdateCommentResolutionStatusRequest {
    resolutionStatus: CommentResolutionStatus;
}

export class UpdateReleaseCommentRequest implements IUpdateReleaseCommentRequest {
    id!: string;
    content!: string;
    resolutionStatus?: CommentResolutionStatus;

    constructor(data?: IUpdateReleaseCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.resolutionStatus = _data["resolutionStatus"];
        }
    }

    static fromJS(data: any): UpdateReleaseCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReleaseCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["resolutionStatus"] = this.resolutionStatus;
        return data;
    }
}

export interface IUpdateReleaseCommentRequest {
    id: string;
    content: string;
    resolutionStatus?: CommentResolutionStatus;
}

export class UpdateReleaseCommentResolutionStatusRequest implements IUpdateReleaseCommentResolutionStatusRequest {
    resolutionStatus!: CommentResolutionStatus;

    constructor(data?: IUpdateReleaseCommentResolutionStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resolutionStatus = _data["resolutionStatus"];
        }
    }

    static fromJS(data: any): UpdateReleaseCommentResolutionStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReleaseCommentResolutionStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resolutionStatus"] = this.resolutionStatus;
        return data;
    }
}

export interface IUpdateReleaseCommentResolutionStatusRequest {
    resolutionStatus: CommentResolutionStatus;
}

export class UsedIn implements IUsedIn {
    pipeClassId?: string;
    pipeClassName?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;

    constructor(data?: IUsedIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pipeClassId = _data["pipeClassId"];
            this.pipeClassName = _data["pipeClassName"];
            this.businessUnit = _data["businessUnit"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): UsedIn {
        data = typeof data === 'object' ? data : {};
        let result = new UsedIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipeClassId"] = this.pipeClassId;
        data["pipeClassName"] = this.pipeClassName;
        data["businessUnit"] = this.businessUnit;
        data["application"] = this.application;
        return data;
    }
}

export interface IUsedIn {
    pipeClassId?: string;
    pipeClassName?: string | undefined;
    businessUnit?: string | undefined;
    application?: string | undefined;
}

export class UpdateUserBusinessUnitAccessRequest implements IUpdateUserBusinessUnitAccessRequest {
    businessUnitIds?: string[] | undefined;
    expectedAccessUpdated?: Date;

    constructor(data?: IUpdateUserBusinessUnitAccessRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["businessUnitIds"])) {
                this.businessUnitIds = [] as any;
                for (let item of _data["businessUnitIds"])
                    this.businessUnitIds!.push(item);
            }
            this.expectedAccessUpdated = _data["expectedAccessUpdated"] ? new Date(_data["expectedAccessUpdated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateUserBusinessUnitAccessRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserBusinessUnitAccessRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.businessUnitIds)) {
            data["businessUnitIds"] = [];
            for (let item of this.businessUnitIds)
                data["businessUnitIds"].push(item);
        }
        data["expectedAccessUpdated"] = this.expectedAccessUpdated ? this.expectedAccessUpdated.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateUserBusinessUnitAccessRequest {
    businessUnitIds?: string[] | undefined;
    expectedAccessUpdated?: Date;
}

export class UserBusinessUnitAccessViewModel implements IUserBusinessUnitAccessViewModel {
    businessUnitId?: string;
    name?: string | undefined;
    isMandatory?: boolean;
    isAssigned?: boolean;

    constructor(data?: IUserBusinessUnitAccessViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessUnitId = _data["businessUnitId"];
            this.name = _data["name"];
            this.isMandatory = _data["isMandatory"];
            this.isAssigned = _data["isAssigned"];
        }
    }

    static fromJS(data: any): UserBusinessUnitAccessViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserBusinessUnitAccessViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessUnitId"] = this.businessUnitId;
        data["name"] = this.name;
        data["isMandatory"] = this.isMandatory;
        data["isAssigned"] = this.isAssigned;
        return data;
    }
}

export interface IUserBusinessUnitAccessViewModel {
    businessUnitId?: string;
    name?: string | undefined;
    isMandatory?: boolean;
    isAssigned?: boolean;
}

export class UserDetailsViewModel implements IUserDetailsViewModel {
    id?: string;
    givenName?: string | undefined;
    surname?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    jobTitle?: string | undefined;
    locationFacilityCode?: string | undefined;
    officeLocation?: string | undefined;
    workerWorkCompanyName?: string | undefined;
    businessUnits?: UserBusinessUnitAccessViewModel[] | undefined;
    readonly businessUnitsAsString?: string | undefined;
    accessUpdated?: Date;

    constructor(data?: IUserDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.department = _data["department"];
            this.jobTitle = _data["jobTitle"];
            this.locationFacilityCode = _data["locationFacilityCode"];
            this.officeLocation = _data["officeLocation"];
            this.workerWorkCompanyName = _data["workerWorkCompanyName"];
            if (Array.isArray(_data["businessUnits"])) {
                this.businessUnits = [] as any;
                for (let item of _data["businessUnits"])
                    this.businessUnits!.push(UserBusinessUnitAccessViewModel.fromJS(item));
            }
            (<any>this).businessUnitsAsString = _data["businessUnitsAsString"];
            this.accessUpdated = _data["accessUpdated"] ? new Date(_data["accessUpdated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["department"] = this.department;
        data["jobTitle"] = this.jobTitle;
        data["locationFacilityCode"] = this.locationFacilityCode;
        data["officeLocation"] = this.officeLocation;
        data["workerWorkCompanyName"] = this.workerWorkCompanyName;
        if (Array.isArray(this.businessUnits)) {
            data["businessUnits"] = [];
            for (let item of this.businessUnits)
                data["businessUnits"].push(item.toJSON());
        }
        data["businessUnitsAsString"] = this.businessUnitsAsString;
        data["accessUpdated"] = this.accessUpdated ? this.accessUpdated.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserDetailsViewModel {
    id?: string;
    givenName?: string | undefined;
    surname?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    jobTitle?: string | undefined;
    locationFacilityCode?: string | undefined;
    officeLocation?: string | undefined;
    workerWorkCompanyName?: string | undefined;
    businessUnits?: UserBusinessUnitAccessViewModel[] | undefined;
    businessUnitsAsString?: string | undefined;
    accessUpdated?: Date;
}

export class UserOidReconciliationViewModel implements IUserOidReconciliationViewModel {
    storedId?: string;
    email?: string | undefined;
    foundOids?: string[] | undefined;
    readonly isMismatched?: boolean;

    constructor(data?: IUserOidReconciliationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storedId = _data["storedId"];
            this.email = _data["email"];
            if (Array.isArray(_data["foundOids"])) {
                this.foundOids = [] as any;
                for (let item of _data["foundOids"])
                    this.foundOids!.push(item);
            }
            (<any>this).isMismatched = _data["isMismatched"];
        }
    }

    static fromJS(data: any): UserOidReconciliationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserOidReconciliationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storedId"] = this.storedId;
        data["email"] = this.email;
        if (Array.isArray(this.foundOids)) {
            data["foundOids"] = [];
            for (let item of this.foundOids)
                data["foundOids"].push(item);
        }
        data["isMismatched"] = this.isMismatched;
        return data;
    }
}

export interface IUserOidReconciliationViewModel {
    storedId?: string;
    email?: string | undefined;
    foundOids?: string[] | undefined;
    isMismatched?: boolean;
}

export class UserViewModel implements IUserViewModel {
    id?: string;
    givenName?: string | undefined;
    surname?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;

    constructor(data?: IUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        return data;
    }
}

export interface IUserViewModel {
    id?: string;
    givenName?: string | undefined;
    surname?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
}

export class ValveComponentPropertyViewModel implements IValveComponentPropertyViewModel {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IValveComponentPropertyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ValveComponentPropertyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValveComponentPropertyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IValveComponentPropertyViewModel {
    name?: string | undefined;
    value?: string | undefined;
}

export class ValveValidationResult implements IValveValidationResult {
    valveId?: string;
    isCurrent?: boolean;
    latestVersion?: ValveViewModel;
    latestPublishedVersion?: ValveViewModel;
    message?: string | undefined;

    constructor(data?: IValveValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valveId = _data["valveId"];
            this.isCurrent = _data["isCurrent"];
            this.latestVersion = _data["latestVersion"] ? ValveViewModel.fromJS(_data["latestVersion"]) : <any>undefined;
            this.latestPublishedVersion = _data["latestPublishedVersion"] ? ValveViewModel.fromJS(_data["latestPublishedVersion"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ValveValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValveValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveId"] = this.valveId;
        data["isCurrent"] = this.isCurrent;
        data["latestVersion"] = this.latestVersion ? this.latestVersion.toJSON() : <any>undefined;
        data["latestPublishedVersion"] = this.latestPublishedVersion ? this.latestPublishedVersion.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IValveValidationResult {
    valveId?: string;
    isCurrent?: boolean;
    latestVersion?: ValveViewModel;
    latestPublishedVersion?: ValveViewModel;
    message?: string | undefined;
}

export class ValveViewModel implements IValveViewModel {
    id?: string;
    tag?: string | undefined;
    businessUnits?: string[] | undefined;
    pipeClassNames?: string[] | undefined;
    pipeClassIds?: string[] | undefined;
    componentType?: ComponentType;
    componentTypeString?: string | undefined;
    valveType?: ComponentType;
    valveSubType?: string | undefined;
    size?: string | undefined;
    class?: string | undefined;
    nps?: string | undefined;
    rating?: string | undefined;
    ratingClass?: string | undefined;
    ends?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    isShortDescriptionManuallyOverridden?: boolean;
    pipeClassDescription?: string | undefined;
    body?: string | undefined;
    trim?: string | undefined;
    application?: string | undefined;
    applicationShortName?: string | undefined;
    componentProperties?: ComponentPropertyViewModel[] | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    fromRevision?: SimpleRevisionViewModel;
    releaseObjectGroup?: ReleaseObjectGroupViewModel;
    usedIns?: UsedIn[] | undefined;
    isReferenced?: boolean | undefined;
    isArchived?: boolean | undefined;
    isDraft?: boolean | undefined;
    isRetired?: boolean | undefined;
    publishDate?: Date | undefined;
    authorName?: string | undefined;
    componentInPipeClassId?: string | undefined;
    displayOrder?: number;
    components?: ComponentViewModel[] | undefined;
    changed?: boolean;
    lastUpdatedRevision?: string | undefined;
    freeFieldPropertyName?: string | undefined;
    freeFieldPropertyValue?: string | undefined;
    previousValve?: string | undefined;
    release?: string | undefined;
    readonly hiddenPropertiesFromReport?: string[] | undefined;
    readonly isCurrent?: boolean | undefined;

    constructor(data?: IValveViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tag = _data["tag"];
            if (Array.isArray(_data["businessUnits"])) {
                this.businessUnits = [] as any;
                for (let item of _data["businessUnits"])
                    this.businessUnits!.push(item);
            }
            if (Array.isArray(_data["pipeClassNames"])) {
                this.pipeClassNames = [] as any;
                for (let item of _data["pipeClassNames"])
                    this.pipeClassNames!.push(item);
            }
            if (Array.isArray(_data["pipeClassIds"])) {
                this.pipeClassIds = [] as any;
                for (let item of _data["pipeClassIds"])
                    this.pipeClassIds!.push(item);
            }
            this.componentType = _data["componentType"] ? ComponentType.fromJS(_data["componentType"]) : <any>undefined;
            this.componentTypeString = _data["componentTypeString"];
            this.valveType = _data["valveType"] ? ComponentType.fromJS(_data["valveType"]) : <any>undefined;
            this.valveSubType = _data["valveSubType"];
            this.size = _data["size"];
            this.class = _data["class"];
            this.nps = _data["nps"];
            this.rating = _data["rating"];
            this.ratingClass = _data["ratingClass"];
            this.ends = _data["ends"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.isShortDescriptionManuallyOverridden = _data["isShortDescriptionManuallyOverridden"];
            this.pipeClassDescription = _data["pipeClassDescription"];
            this.body = _data["body"];
            this.trim = _data["trim"];
            this.application = _data["application"];
            this.applicationShortName = _data["applicationShortName"];
            if (Array.isArray(_data["componentProperties"])) {
                this.componentProperties = [] as any;
                for (let item of _data["componentProperties"])
                    this.componentProperties!.push(ComponentPropertyViewModel.fromJS(item));
            }
            if (Array.isArray(_data["commonNotes"])) {
                this.commonNotes = [] as any;
                for (let item of _data["commonNotes"])
                    this.commonNotes!.push(CommonNoteViewModel.fromJS(item));
            }
            this.fromRevision = _data["fromRevision"] ? SimpleRevisionViewModel.fromJS(_data["fromRevision"]) : <any>undefined;
            this.releaseObjectGroup = _data["releaseObjectGroup"] ? ReleaseObjectGroupViewModel.fromJS(_data["releaseObjectGroup"]) : <any>undefined;
            if (Array.isArray(_data["usedIns"])) {
                this.usedIns = [] as any;
                for (let item of _data["usedIns"])
                    this.usedIns!.push(UsedIn.fromJS(item));
            }
            this.isReferenced = _data["isReferenced"];
            this.isArchived = _data["isArchived"];
            this.isDraft = _data["isDraft"];
            this.isRetired = _data["isRetired"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.authorName = _data["authorName"];
            this.componentInPipeClassId = _data["componentInPipeClassId"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ComponentViewModel.fromJS(item));
            }
            this.changed = _data["changed"];
            this.lastUpdatedRevision = _data["lastUpdatedRevision"];
            this.freeFieldPropertyName = _data["freeFieldPropertyName"];
            this.freeFieldPropertyValue = _data["freeFieldPropertyValue"];
            this.previousValve = _data["previousValve"];
            this.release = _data["release"];
            if (Array.isArray(_data["hiddenPropertiesFromReport"])) {
                (<any>this).hiddenPropertiesFromReport = [] as any;
                for (let item of _data["hiddenPropertiesFromReport"])
                    (<any>this).hiddenPropertiesFromReport!.push(item);
            }
            (<any>this).isCurrent = _data["isCurrent"];
        }
    }

    static fromJS(data: any): ValveViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValveViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tag"] = this.tag;
        if (Array.isArray(this.businessUnits)) {
            data["businessUnits"] = [];
            for (let item of this.businessUnits)
                data["businessUnits"].push(item);
        }
        if (Array.isArray(this.pipeClassNames)) {
            data["pipeClassNames"] = [];
            for (let item of this.pipeClassNames)
                data["pipeClassNames"].push(item);
        }
        if (Array.isArray(this.pipeClassIds)) {
            data["pipeClassIds"] = [];
            for (let item of this.pipeClassIds)
                data["pipeClassIds"].push(item);
        }
        data["componentType"] = this.componentType ? this.componentType.toJSON() : <any>undefined;
        data["componentTypeString"] = this.componentTypeString;
        data["valveType"] = this.valveType ? this.valveType.toJSON() : <any>undefined;
        data["valveSubType"] = this.valveSubType;
        data["size"] = this.size;
        data["class"] = this.class;
        data["nps"] = this.nps;
        data["rating"] = this.rating;
        data["ratingClass"] = this.ratingClass;
        data["ends"] = this.ends;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["isShortDescriptionManuallyOverridden"] = this.isShortDescriptionManuallyOverridden;
        data["pipeClassDescription"] = this.pipeClassDescription;
        data["body"] = this.body;
        data["trim"] = this.trim;
        data["application"] = this.application;
        data["applicationShortName"] = this.applicationShortName;
        if (Array.isArray(this.componentProperties)) {
            data["componentProperties"] = [];
            for (let item of this.componentProperties)
                data["componentProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.commonNotes)) {
            data["commonNotes"] = [];
            for (let item of this.commonNotes)
                data["commonNotes"].push(item.toJSON());
        }
        data["fromRevision"] = this.fromRevision ? this.fromRevision.toJSON() : <any>undefined;
        data["releaseObjectGroup"] = this.releaseObjectGroup ? this.releaseObjectGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.usedIns)) {
            data["usedIns"] = [];
            for (let item of this.usedIns)
                data["usedIns"].push(item.toJSON());
        }
        data["isReferenced"] = this.isReferenced;
        data["isArchived"] = this.isArchived;
        data["isDraft"] = this.isDraft;
        data["isRetired"] = this.isRetired;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["authorName"] = this.authorName;
        data["componentInPipeClassId"] = this.componentInPipeClassId;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        data["changed"] = this.changed;
        data["lastUpdatedRevision"] = this.lastUpdatedRevision;
        data["freeFieldPropertyName"] = this.freeFieldPropertyName;
        data["freeFieldPropertyValue"] = this.freeFieldPropertyValue;
        data["previousValve"] = this.previousValve;
        data["release"] = this.release;
        if (Array.isArray(this.hiddenPropertiesFromReport)) {
            data["hiddenPropertiesFromReport"] = [];
            for (let item of this.hiddenPropertiesFromReport)
                data["hiddenPropertiesFromReport"].push(item);
        }
        data["isCurrent"] = this.isCurrent;
        return data;
    }
}

export interface IValveViewModel {
    id?: string;
    tag?: string | undefined;
    businessUnits?: string[] | undefined;
    pipeClassNames?: string[] | undefined;
    pipeClassIds?: string[] | undefined;
    componentType?: ComponentType;
    componentTypeString?: string | undefined;
    valveType?: ComponentType;
    valveSubType?: string | undefined;
    size?: string | undefined;
    class?: string | undefined;
    nps?: string | undefined;
    rating?: string | undefined;
    ratingClass?: string | undefined;
    ends?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    isShortDescriptionManuallyOverridden?: boolean;
    pipeClassDescription?: string | undefined;
    body?: string | undefined;
    trim?: string | undefined;
    application?: string | undefined;
    applicationShortName?: string | undefined;
    componentProperties?: ComponentPropertyViewModel[] | undefined;
    commonNotes?: CommonNoteViewModel[] | undefined;
    fromRevision?: SimpleRevisionViewModel;
    releaseObjectGroup?: ReleaseObjectGroupViewModel;
    usedIns?: UsedIn[] | undefined;
    isReferenced?: boolean | undefined;
    isArchived?: boolean | undefined;
    isDraft?: boolean | undefined;
    isRetired?: boolean | undefined;
    publishDate?: Date | undefined;
    authorName?: string | undefined;
    componentInPipeClassId?: string | undefined;
    displayOrder?: number;
    components?: ComponentViewModel[] | undefined;
    changed?: boolean;
    lastUpdatedRevision?: string | undefined;
    freeFieldPropertyName?: string | undefined;
    freeFieldPropertyValue?: string | undefined;
    previousValve?: string | undefined;
    release?: string | undefined;
    hiddenPropertiesFromReport?: string[] | undefined;
    isCurrent?: boolean | undefined;
}

export class WorkspaceEntryPipingViewModel implements IWorkspaceEntryPipingViewModel {
    id?: string;
    userOid?: string;
    pipeClassId?: string;
    pipeClass?: PipeClassViewModel;

    constructor(data?: IWorkspaceEntryPipingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userOid = _data["userOid"];
            this.pipeClassId = _data["pipeClassId"];
            this.pipeClass = _data["pipeClass"] ? PipeClassViewModel.fromJS(_data["pipeClass"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkspaceEntryPipingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceEntryPipingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userOid"] = this.userOid;
        data["pipeClassId"] = this.pipeClassId;
        data["pipeClass"] = this.pipeClass ? this.pipeClass.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkspaceEntryPipingViewModel {
    id?: string;
    userOid?: string;
    pipeClassId?: string;
    pipeClass?: PipeClassViewModel;
}

export class WorkspaceEntryValveViewModel implements IWorkspaceEntryValveViewModel {
    id?: string;
    userOid?: string;
    valveId?: string;
    valve?: ValveViewModel;

    constructor(data?: IWorkspaceEntryValveViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userOid = _data["userOid"];
            this.valveId = _data["valveId"];
            this.valve = _data["valve"] ? ValveViewModel.fromJS(_data["valve"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkspaceEntryValveViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceEntryValveViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userOid"] = this.userOid;
        data["valveId"] = this.valveId;
        data["valve"] = this.valve ? this.valve.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkspaceEntryValveViewModel {
    id?: string;
    userOid?: string;
    valveId?: string;
    valve?: ValveViewModel;
}

export class WorkspaceViewModel implements IWorkspaceViewModel {
    pipingEntries?: WorkspaceEntryPipingViewModel[] | undefined;
    valveEntries?: WorkspaceEntryValveViewModel[] | undefined;

    constructor(data?: IWorkspaceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pipingEntries"])) {
                this.pipingEntries = [] as any;
                for (let item of _data["pipingEntries"])
                    this.pipingEntries!.push(WorkspaceEntryPipingViewModel.fromJS(item));
            }
            if (Array.isArray(_data["valveEntries"])) {
                this.valveEntries = [] as any;
                for (let item of _data["valveEntries"])
                    this.valveEntries!.push(WorkspaceEntryValveViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkspaceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pipingEntries)) {
            data["pipingEntries"] = [];
            for (let item of this.pipingEntries)
                data["pipingEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.valveEntries)) {
            data["valveEntries"] = [];
            for (let item of this.valveEntries)
                data["valveEntries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorkspaceViewModel {
    pipingEntries?: WorkspaceEntryPipingViewModel[] | undefined;
    valveEntries?: WorkspaceEntryValveViewModel[] | undefined;
}

export class Tuple_2OfStringAndString implements ITuple_2OfStringAndString {
    item1?: string | undefined;
    item2?: string | undefined;

    constructor(data?: ITuple_2OfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"];
            this.item2 = _data["item2"];
        }
    }

    static fromJS(data: any): Tuple_2OfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new Tuple_2OfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data;
    }
}

export interface ITuple_2OfStringAndString {
    item1?: string | undefined;
    item2?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}